var ANSWERS = (function () {
	"use strict";
	var e =
		"undefined" != typeof globalThis
			? globalThis
			: "undefined" != typeof window
			? window
			: "undefined" != typeof global
			? global
			: "undefined" != typeof self
			? self
			: {};
	function t(e) {
		return e &&
			e.__esModule &&
			Object.prototype.hasOwnProperty.call(e, "default")
			? e.default
			: e;
	}
	function r(e, t) {
		return e((t = { exports: {} }), t.exports), t.exports;
	}
	function n(e) {
		return (e && e.default) || e;
	}
	var i = function (e) {
			return e && e.Math == Math && e;
		},
		o =
			i("object" == typeof globalThis && globalThis) ||
			i("object" == typeof window && window) ||
			i("object" == typeof self && self) ||
			i("object" == typeof e && e) ||
			(function () {
				return this;
			})() ||
			Function("return this")(),
		a = function (e) {
			try {
				return !!e();
			} catch (e) {
				return !0;
			}
		},
		s = !a(function () {
			return (
				7 !=
				Object.defineProperty({}, 1, {
					get: function () {
						return 7;
					}
				})[1]
			);
		}),
		c = {}.propertyIsEnumerable,
		u = Object.getOwnPropertyDescriptor,
		l = {
			f:
				u && !c.call({ 1: 2 }, 1)
					? function (e) {
							var t = u(this, e);
							return !!t && t.enumerable;
					  }
					: c
		},
		f = function (e, t) {
			return {
				enumerable: !(1 & e),
				configurable: !(2 & e),
				writable: !(4 & e),
				value: t
			};
		},
		h = {}.toString,
		p = function (e) {
			return h.call(e).slice(8, -1);
		},
		d = "".split,
		v = a(function () {
			return !Object("z").propertyIsEnumerable(0);
		})
			? function (e) {
					return "String" == p(e) ? d.call(e, "") : Object(e);
			  }
			: Object,
		m = function (e) {
			if (null == e) throw TypeError("Can't call method on " + e);
			return e;
		},
		g = function (e) {
			return v(m(e));
		},
		y = function (e) {
			return "object" == typeof e ? null !== e : "function" == typeof e;
		},
		_ = function (e, t) {
			if (!y(e)) return e;
			var r, n;
			if (t && "function" == typeof (r = e.toString) && !y((n = r.call(e))))
				return n;
			if ("function" == typeof (r = e.valueOf) && !y((n = r.call(e)))) return n;
			if (!t && "function" == typeof (r = e.toString) && !y((n = r.call(e))))
				return n;
			throw TypeError("Can't convert object to primitive value");
		},
		b = {}.hasOwnProperty,
		w = function (e, t) {
			return b.call(e, t);
		},
		S = o.document,
		k = y(S) && y(S.createElement),
		x = function (e) {
			return k ? S.createElement(e) : {};
		},
		M =
			!s &&
			!a(function () {
				return (
					7 !=
					Object.defineProperty(x("div"), "a", {
						get: function () {
							return 7;
						}
					}).a
				);
			}),
		A = Object.getOwnPropertyDescriptor,
		E = {
			f: s
				? A
				: function (e, t) {
						if (((e = g(e)), (t = _(t, !0)), M))
							try {
								return A(e, t);
							} catch (e) {}
						if (w(e, t)) return f(!l.f.call(e, t), e[t]);
				  }
		},
		C = /#|\.prototype\./,
		I = function (e, t) {
			var r = O[T(e)];
			return r == F || (r != R && ("function" == typeof t ? a(t) : !!t));
		},
		T = (I.normalize = function (e) {
			return String(e).replace(C, ".").toLowerCase();
		}),
		O = (I.data = {}),
		R = (I.NATIVE = "N"),
		F = (I.POLYFILL = "P"),
		L = I,
		j = {},
		N = function (e) {
			if ("function" != typeof e)
				throw TypeError(String(e) + " is not a function");
			return e;
		},
		P = function (e, t, r) {
			if ((N(e), void 0 === t)) return e;
			switch (r) {
				case 0:
					return function () {
						return e.call(t);
					};
				case 1:
					return function (r) {
						return e.call(t, r);
					};
				case 2:
					return function (r, n) {
						return e.call(t, r, n);
					};
				case 3:
					return function (r, n, i) {
						return e.call(t, r, n, i);
					};
			}
			return function () {
				return e.apply(t, arguments);
			};
		},
		q = function (e) {
			if (!y(e)) throw TypeError(String(e) + " is not an object");
			return e;
		},
		D = Object.defineProperty,
		B = {
			f: s
				? D
				: function (e, t, r) {
						if ((q(e), (t = _(t, !0)), q(r), M))
							try {
								return D(e, t, r);
							} catch (e) {}
						if ("get" in r || "set" in r)
							throw TypeError("Accessors not supported");
						return "value" in r && (e[t] = r.value), e;
				  }
		},
		U = s
			? function (e, t, r) {
					return B.f(e, t, f(1, r));
			  }
			: function (e, t, r) {
					return (e[t] = r), e;
			  },
		V = E.f,
		H = function (e) {
			var t = function (t, r, n) {
				if (this instanceof e) {
					switch (arguments.length) {
						case 0:
							return new e();
						case 1:
							return new e(t);
						case 2:
							return new e(t, r);
					}
					return new e(t, r, n);
				}
				return e.apply(this, arguments);
			};
			return (t.prototype = e.prototype), t;
		},
		z = function (e, t) {
			var r,
				n,
				i,
				a,
				s,
				c,
				u,
				l,
				f = e.target,
				h = e.global,
				p = e.stat,
				d = e.proto,
				v = h ? o : p ? o[f] : (o[f] || {}).prototype,
				m = h ? j : j[f] || (j[f] = {}),
				g = m.prototype;
			for (i in t)
				(r = !L(h ? i : f + (p ? "." : "#") + i, e.forced) && v && w(v, i)),
					(s = m[i]),
					r && (c = e.noTargetGet ? (l = V(v, i)) && l.value : v[i]),
					(a = r && c ? c : t[i]),
					(r && typeof s == typeof a) ||
						((u =
							e.bind && r
								? P(a, o)
								: e.wrap && r
								? H(a)
								: d && "function" == typeof a
								? P(Function.call, a)
								: a),
						(e.sham || (a && a.sham) || (s && s.sham)) && U(u, "sham", !0),
						(m[i] = u),
						d &&
							(w(j, (n = f + "Prototype")) || U(j, n, {}),
							(j[n][i] = a),
							e.real && g && !g[i] && U(g, i, a)));
		},
		K =
			"\t\n\v\f\r Â áš€â€€â€â€‚â€ƒâ€„â€…â€†â€‡â€ˆâ€‰â€Šâ€¯âŸã€€\u2028\u2029\ufeff",
		Z = "[" + K + "]",
		Q = RegExp("^" + Z + Z + "*"),
		W = RegExp(Z + Z + "*$"),
		G = function (e) {
			return function (t) {
				var r = String(m(t));
				return (
					1 & e && (r = r.replace(Q, "")), 2 & e && (r = r.replace(W, "")), r
				);
			};
		},
		$ = { start: G(1), end: G(2), trim: G(3) },
		J = $.trim,
		Y = o.parseFloat,
		X =
			1 / Y(K + "-0") != -1 / 0
				? function (e) {
						var t = J(String(e)),
							r = Y(t);
						return 0 === r && "-" == t.charAt(0) ? -0 : r;
				  }
				: Y;
	z({ global: !0, forced: parseFloat != X }, { parseFloat: X });
	var ee = j.parseFloat,
		te = Math.ceil,
		re = Math.floor,
		ne = function (e) {
			return isNaN((e = +e)) ? 0 : (e > 0 ? re : te)(e);
		},
		ie = function (e) {
			return function (t, r) {
				var n,
					i,
					o = String(m(t)),
					a = ne(r),
					s = o.length;
				return a < 0 || a >= s
					? e
						? ""
						: void 0
					: (n = o.charCodeAt(a)) < 55296 ||
					  n > 56319 ||
					  a + 1 === s ||
					  (i = o.charCodeAt(a + 1)) < 56320 ||
					  i > 57343
					? e
						? o.charAt(a)
						: n
					: e
					? o.slice(a, a + 2)
					: i - 56320 + ((n - 55296) << 10) + 65536;
			};
		},
		oe = { codeAt: ie(!1), charAt: ie(!0) },
		ae =
			o["__core-js_shared__"] ||
			(function (e, t) {
				try {
					U(o, e, t);
				} catch (r) {
					o[e] = t;
				}
				return t;
			})("__core-js_shared__", {}),
		se = Function.toString;
	"function" != typeof ae.inspectSource &&
		(ae.inspectSource = function (e) {
			return se.call(e);
		});
	var ce,
		ue,
		le,
		fe = ae.inspectSource,
		he = o.WeakMap,
		pe = "function" == typeof he && /native code/.test(fe(he)),
		de = r(function (e) {
			(e.exports = function (e, t) {
				return ae[e] || (ae[e] = void 0 !== t ? t : {});
			})("versions", []).push({
				version: "3.9.1",
				mode: "pure",
				copyright: "Â© 2021 Denis Pushkarev (zloirock.ru)"
			});
		}),
		ve = 0,
		me = Math.random(),
		ge = function (e) {
			return (
				"Symbol(" +
				String(void 0 === e ? "" : e) +
				")_" +
				(++ve + me).toString(36)
			);
		},
		ye = de("keys"),
		_e = function (e) {
			return ye[e] || (ye[e] = ge(e));
		},
		be = {},
		we = o.WeakMap;
	if (pe) {
		var Se = ae.state || (ae.state = new we()),
			ke = Se.get,
			xe = Se.has,
			Me = Se.set;
		(ce = function (e, t) {
			return (t.facade = e), Me.call(Se, e, t), t;
		}),
			(ue = function (e) {
				return ke.call(Se, e) || {};
			}),
			(le = function (e) {
				return xe.call(Se, e);
			});
	} else {
		var Ae = _e("state");
		(be[Ae] = !0),
			(ce = function (e, t) {
				return (t.facade = e), U(e, Ae, t), t;
			}),
			(ue = function (e) {
				return w(e, Ae) ? e[Ae] : {};
			}),
			(le = function (e) {
				return w(e, Ae);
			});
	}
	var Ee,
		Ce,
		Ie = {
			set: ce,
			get: ue,
			has: le,
			enforce: function (e) {
				return le(e) ? ue(e) : ce(e, {});
			},
			getterFor: function (e) {
				return function (t) {
					var r;
					if (!y(t) || (r = ue(t)).type !== e)
						throw TypeError("Incompatible receiver, " + e + " required");
					return r;
				};
			}
		},
		Te = function (e) {
			return Object(m(e));
		},
		Oe = !a(function () {
			function e() {}
			return (
				(e.prototype.constructor = null),
				Object.getPrototypeOf(new e()) !== e.prototype
			);
		}),
		Re = _e("IE_PROTO"),
		Fe = Object.prototype,
		Le = Oe
			? Object.getPrototypeOf
			: function (e) {
					return (
						(e = Te(e)),
						w(e, Re)
							? e[Re]
							: "function" == typeof e.constructor && e instanceof e.constructor
							? e.constructor.prototype
							: e instanceof Object
							? Fe
							: null
					);
			  },
		je = "process" == p(o.process),
		Ne = function (e) {
			return "function" == typeof e ? e : void 0;
		},
		Pe = function (e, t) {
			return arguments.length < 2
				? Ne(j[e]) || Ne(o[e])
				: (j[e] && j[e][t]) || (o[e] && o[e][t]);
		},
		qe = Pe("navigator", "userAgent") || "",
		De = o.process,
		Be = De && De.versions,
		Ue = Be && Be.v8;
	Ue
		? (Ce = (Ee = Ue.split("."))[0] + Ee[1])
		: qe &&
		  (!(Ee = qe.match(/Edge\/(\d+)/)) || Ee[1] >= 74) &&
		  (Ee = qe.match(/Chrome\/(\d+)/)) &&
		  (Ce = Ee[1]);
	var Ve,
		He,
		ze,
		Ke = Ce && +Ce,
		Ze =
			!!Object.getOwnPropertySymbols &&
			!a(function () {
				return !Symbol.sham && (je ? 38 === Ke : Ke > 37 && Ke < 41);
			}),
		Qe = Ze && !Symbol.sham && "symbol" == typeof Symbol.iterator,
		We = de("wks"),
		Ge = o.Symbol,
		$e = Qe ? Ge : (Ge && Ge.withoutSetter) || ge,
		Je = function (e) {
			return (
				(w(We, e) && (Ze || "string" == typeof We[e])) ||
					(Ze && w(Ge, e) ? (We[e] = Ge[e]) : (We[e] = $e("Symbol." + e))),
				We[e]
			);
		},
		Ye = Je("iterator"),
		Xe = !1;
	[].keys &&
		("next" in (ze = [].keys())
			? (He = Le(Le(ze))) !== Object.prototype && (Ve = He)
			: (Xe = !0));
	var et =
		null == Ve ||
		a(function () {
			var e = {};
			return Ve[Ye].call(e) !== e;
		});
	et && (Ve = {}),
		et &&
			!w(Ve, Ye) &&
			U(Ve, Ye, function () {
				return this;
			});
	var tt,
		rt = { IteratorPrototype: Ve, BUGGY_SAFARI_ITERATORS: Xe },
		nt = Math.min,
		it = function (e) {
			return e > 0 ? nt(ne(e), 9007199254740991) : 0;
		},
		ot = Math.max,
		at = Math.min,
		st = function (e, t) {
			var r = ne(e);
			return r < 0 ? ot(r + t, 0) : at(r, t);
		},
		ct = function (e) {
			return function (t, r, n) {
				var i,
					o = g(t),
					a = it(o.length),
					s = st(n, a);
				if (e && r != r) {
					for (; a > s; ) if ((i = o[s++]) != i) return !0;
				} else
					for (; a > s; s++)
						if ((e || s in o) && o[s] === r) return e || s || 0;
				return !e && -1;
			};
		},
		ut = { includes: ct(!0), indexOf: ct(!1) },
		lt = ut.indexOf,
		ft = function (e, t) {
			var r,
				n = g(e),
				i = 0,
				o = [];
			for (r in n) !w(be, r) && w(n, r) && o.push(r);
			for (; t.length > i; ) w(n, (r = t[i++])) && (~lt(o, r) || o.push(r));
			return o;
		},
		ht = [
			"constructor",
			"hasOwnProperty",
			"isPrototypeOf",
			"propertyIsEnumerable",
			"toLocaleString",
			"toString",
			"valueOf"
		],
		pt =
			Object.keys ||
			function (e) {
				return ft(e, ht);
			},
		dt = s
			? Object.defineProperties
			: function (e, t) {
					q(e);
					for (var r, n = pt(t), i = n.length, o = 0; i > o; )
						B.f(e, (r = n[o++]), t[r]);
					return e;
			  },
		vt = Pe("document", "documentElement"),
		mt = _e("IE_PROTO"),
		gt = function () {},
		yt = function (e) {
			return "<script>" + e + "</script>";
		},
		_t = function () {
			try {
				tt = document.domain && new ActiveXObject("htmlfile");
			} catch (e) {}
			var e, t;
			_t = tt
				? (function (e) {
						e.write(yt("")), e.close();
						var t = e.parentWindow.Object;
						return (e = null), t;
				  })(tt)
				: (((t = x("iframe")).style.display = "none"),
				  vt.appendChild(t),
				  (t.src = String("javascript:")),
				  (e = t.contentWindow.document).open(),
				  e.write(yt("document.F=Object")),
				  e.close(),
				  e.F);
			for (var r = ht.length; r--; ) delete _t.prototype[ht[r]];
			return _t();
		};
	be[mt] = !0;
	var bt =
			Object.create ||
			function (e, t) {
				var r;
				return (
					null !== e
						? ((gt.prototype = q(e)),
						  (r = new gt()),
						  (gt.prototype = null),
						  (r[mt] = e))
						: (r = _t()),
					void 0 === t ? r : dt(r, t)
				);
			},
		wt = {};
	wt[Je("toStringTag")] = "z";
	var St = "[object z]" === String(wt),
		kt = Je("toStringTag"),
		xt =
			"Arguments" ==
			p(
				(function () {
					return arguments;
				})()
			),
		Mt = St
			? p
			: function (e) {
					var t, r, n;
					return void 0 === e
						? "Undefined"
						: null === e
						? "Null"
						: "string" ==
						  typeof (r = (function (e, t) {
								try {
									return e[t];
								} catch (e) {}
						  })((t = Object(e)), kt))
						? r
						: xt
						? p(t)
						: "Object" == (n = p(t)) && "function" == typeof t.callee
						? "Arguments"
						: n;
			  },
		At = St
			? {}.toString
			: function () {
					return "[object " + Mt(this) + "]";
			  },
		Et = B.f,
		Ct = Je("toStringTag"),
		It = function (e, t, r, n) {
			if (e) {
				var i = r ? e : e.prototype;
				w(i, Ct) || Et(i, Ct, { configurable: !0, value: t }),
					n && !St && U(i, "toString", At);
			}
		},
		Tt = {},
		Ot = rt.IteratorPrototype,
		Rt = function () {
			return this;
		},
		Ft = function (e, t, r) {
			var n = t + " Iterator";
			return (
				(e.prototype = bt(Ot, { next: f(1, r) })),
				It(e, n, !1, !0),
				(Tt[n] = Rt),
				e
			);
		},
		Lt =
			Object.setPrototypeOf ||
			("__proto__" in {}
				? (function () {
						var e,
							t = !1,
							r = {};
						try {
							(e = Object.getOwnPropertyDescriptor(
								Object.prototype,
								"__proto__"
							).set).call(r, []),
								(t = r instanceof Array);
						} catch (e) {}
						return function (r, n) {
							return (
								q(r),
								(function (e) {
									if (!y(e) && null !== e)
										throw TypeError(
											"Can't set " + String(e) + " as a prototype"
										);
								})(n),
								t ? e.call(r, n) : (r.__proto__ = n),
								r
							);
						};
				  })()
				: void 0),
		jt = function (e, t, r, n) {
			n && n.enumerable ? (e[t] = r) : U(e, t, r);
		},
		Nt = rt.IteratorPrototype,
		Pt = rt.BUGGY_SAFARI_ITERATORS,
		qt = Je("iterator"),
		Dt = function () {
			return this;
		},
		Bt = function (e, t, r, n, i, o, a) {
			Ft(r, t, n);
			var s,
				c,
				u,
				l = function (e) {
					if (e === i && v) return v;
					if (!Pt && e in p) return p[e];
					switch (e) {
						case "keys":
						case "values":
						case "entries":
							return function () {
								return new r(this, e);
							};
					}
					return function () {
						return new r(this);
					};
				},
				f = t + " Iterator",
				h = !1,
				p = e.prototype,
				d = p[qt] || p["@@iterator"] || (i && p[i]),
				v = (!Pt && d) || l(i),
				m = ("Array" == t && p.entries) || d;
			if (
				(m &&
					((s = Le(m.call(new e()))),
					Nt !== Object.prototype &&
						s.next &&
						(It(s, f, !0, !0), (Tt[f] = Dt))),
				"values" == i &&
					d &&
					"values" !== d.name &&
					((h = !0),
					(v = function () {
						return d.call(this);
					})),
				a && p[qt] !== v && U(p, qt, v),
				(Tt[t] = v),
				i)
			)
				if (
					((c = {
						values: l("values"),
						keys: o ? v : l("keys"),
						entries: l("entries")
					}),
					a)
				)
					for (u in c) (Pt || h || !(u in p)) && jt(p, u, c[u]);
				else z({ target: t, proto: !0, forced: Pt || h }, c);
			return c;
		},
		Ut = oe.charAt,
		Vt = Ie.set,
		Ht = Ie.getterFor("String Iterator");
	Bt(
		String,
		"String",
		function (e) {
			Vt(this, { type: "String Iterator", string: String(e), index: 0 });
		},
		function () {
			var e,
				t = Ht(this),
				r = t.string,
				n = t.index;
			return n >= r.length
				? { value: void 0, done: !0 }
				: ((e = Ut(r, n)), (t.index += e.length), { value: e, done: !1 });
		}
	);
	var zt = Je("iterator"),
		Kt = !a(function () {
			var e = new URL("b?a=1&b=2&c=3", "http://a"),
				t = e.searchParams,
				r = "";
			return (
				(e.pathname = "c%20d"),
				t.forEach(function (e, n) {
					t.delete("b"), (r += n + e);
				}),
				!e.toJSON ||
					!t.sort ||
					"http://a/c%20d?a=1&c=3" !== e.href ||
					"3" !== t.get("c") ||
					"a=1" !== String(new URLSearchParams("?a=1")) ||
					!t[zt] ||
					"a" !== new URL("https://a@b").username ||
					"b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") ||
					"xn--e1aybc" !== new URL("http://Ñ‚ÐµÑÑ‚").host ||
					"#%D0%B1" !== new URL("http://a#Ð±").hash ||
					"a1c3" !== r ||
					"x" !== new URL("http://x", void 0).host
			);
		}),
		Zt = function (e, t, r) {
			if (!(e instanceof t))
				throw TypeError("Incorrect " + (r ? r + " " : "") + "invocation");
			return e;
		},
		Qt = { f: Object.getOwnPropertySymbols },
		Wt = Object.assign,
		Gt = Object.defineProperty,
		$t =
			!Wt ||
			a(function () {
				if (
					s &&
					1 !==
						Wt(
							{ b: 1 },
							Wt(
								Gt({}, "a", {
									enumerable: !0,
									get: function () {
										Gt(this, "b", { value: 3, enumerable: !1 });
									}
								}),
								{ b: 2 }
							)
						).b
				)
					return !0;
				var e = {},
					t = {},
					r = Symbol();
				return (
					(e[r] = 7),
					"abcdefghijklmnopqrst".split("").forEach(function (e) {
						t[e] = e;
					}),
					7 != Wt({}, e)[r] || "abcdefghijklmnopqrst" != pt(Wt({}, t)).join("")
				);
			})
				? function (e, t) {
						for (
							var r = Te(e), n = arguments.length, i = 1, o = Qt.f, a = l.f;
							n > i;

						)
							for (
								var c,
									u = v(arguments[i++]),
									f = o ? pt(u).concat(o(u)) : pt(u),
									h = f.length,
									p = 0;
								h > p;

							)
								(c = f[p++]), (s && !a.call(u, c)) || (r[c] = u[c]);
						return r;
				  }
				: Wt,
		Jt = function (e) {
			var t = e.return;
			if (void 0 !== t) return q(t.call(e)).value;
		},
		Yt = function (e, t, r, n) {
			try {
				return n ? t(q(r)[0], r[1]) : t(r);
			} catch (t) {
				throw (Jt(e), t);
			}
		},
		Xt = Je("iterator"),
		er = Array.prototype,
		tr = function (e) {
			return void 0 !== e && (Tt.Array === e || er[Xt] === e);
		},
		rr = function (e, t, r) {
			var n = _(t);
			n in e ? B.f(e, n, f(0, r)) : (e[n] = r);
		},
		nr = Je("iterator"),
		ir = function (e) {
			if (null != e) return e[nr] || e["@@iterator"] || Tt[Mt(e)];
		},
		or = function (e) {
			var t,
				r,
				n,
				i,
				o,
				a,
				s = Te(e),
				c = "function" == typeof this ? this : Array,
				u = arguments.length,
				l = u > 1 ? arguments[1] : void 0,
				f = void 0 !== l,
				h = ir(s),
				p = 0;
			if (
				(f && (l = P(l, u > 2 ? arguments[2] : void 0, 2)),
				null == h || (c == Array && tr(h)))
			)
				for (r = new c((t = it(s.length))); t > p; p++)
					(a = f ? l(s[p], p) : s[p]), rr(r, p, a);
			else
				for (o = (i = h.call(s)).next, r = new c(); !(n = o.call(i)).done; p++)
					(a = f ? Yt(i, l, [n.value, p], !0) : n.value), rr(r, p, a);
			return (r.length = p), r;
		},
		ar = /[^\0-\u007E]/,
		sr = /[.\u3002\uFF0E\uFF61]/g,
		cr = "Overflow: input needs wider integers to process",
		ur = Math.floor,
		lr = String.fromCharCode,
		fr = function (e) {
			return e + 22 + 75 * (e < 26);
		},
		hr = function (e, t, r) {
			var n = 0;
			for (e = r ? ur(e / 700) : e >> 1, e += ur(e / t); e > 455; n += 36)
				e = ur(e / 35);
			return ur(n + (36 * e) / (e + 38));
		},
		pr = function (e) {
			var t,
				r,
				n = [],
				i = (e = (function (e) {
					for (var t = [], r = 0, n = e.length; r < n; ) {
						var i = e.charCodeAt(r++);
						if (i >= 55296 && i <= 56319 && r < n) {
							var o = e.charCodeAt(r++);
							56320 == (64512 & o)
								? t.push(((1023 & i) << 10) + (1023 & o) + 65536)
								: (t.push(i), r--);
						} else t.push(i);
					}
					return t;
				})(e)).length,
				o = 128,
				a = 0,
				s = 72;
			for (t = 0; t < e.length; t++) (r = e[t]) < 128 && n.push(lr(r));
			var c = n.length,
				u = c;
			for (c && n.push("-"); u < i; ) {
				var l = 2147483647;
				for (t = 0; t < e.length; t++) (r = e[t]) >= o && r < l && (l = r);
				var f = u + 1;
				if (l - o > ur((2147483647 - a) / f)) throw RangeError(cr);
				for (a += (l - o) * f, o = l, t = 0; t < e.length; t++) {
					if ((r = e[t]) < o && ++a > 2147483647) throw RangeError(cr);
					if (r == o) {
						for (var h = a, p = 36; ; p += 36) {
							var d = p <= s ? 1 : p >= s + 26 ? 26 : p - s;
							if (h < d) break;
							var v = h - d,
								m = 36 - d;
							n.push(lr(fr(d + (v % m)))), (h = ur(v / m));
						}
						n.push(lr(fr(h))), (s = hr(a, f, u == c)), (a = 0), ++u;
					}
				}
				++a, ++o;
			}
			return n.join("");
		},
		dr = Ie.set,
		vr = Ie.getterFor("Array Iterator");
	Bt(
		Array,
		"Array",
		function (e, t) {
			dr(this, { type: "Array Iterator", target: g(e), index: 0, kind: t });
		},
		function () {
			var e = vr(this),
				t = e.target,
				r = e.kind,
				n = e.index++;
			return !t || n >= t.length
				? ((e.target = void 0), { value: void 0, done: !0 })
				: "keys" == r
				? { value: n, done: !1 }
				: "values" == r
				? { value: t[n], done: !1 }
				: { value: [n, t[n]], done: !1 };
		},
		"values"
	);
	Tt.Arguments = Tt.Array;
	var mr = function (e, t, r) {
			for (var n in t)
				r && r.unsafe && e[n] ? (e[n] = t[n]) : jt(e, n, t[n], r);
			return e;
		},
		gr = function (e) {
			var t = ir(e);
			if ("function" != typeof t)
				throw TypeError(String(e) + " is not iterable");
			return q(t.call(e));
		},
		yr = Pe("fetch"),
		_r = Pe("Headers"),
		br = Je("iterator"),
		wr = Ie.set,
		Sr = Ie.getterFor("URLSearchParams"),
		kr = Ie.getterFor("URLSearchParamsIterator"),
		xr = /\+/g,
		Mr = Array(4),
		Ar = function (e) {
			return (
				Mr[e - 1] || (Mr[e - 1] = RegExp("((?:%[\\da-f]{2}){" + e + "})", "gi"))
			);
		},
		Er = function (e) {
			try {
				return decodeURIComponent(e);
			} catch (t) {
				return e;
			}
		},
		Cr = function (e) {
			var t = e.replace(xr, " "),
				r = 4;
			try {
				return decodeURIComponent(t);
			} catch (e) {
				for (; r; ) t = t.replace(Ar(r--), Er);
				return t;
			}
		},
		Ir = /[!'()~]|%20/g,
		Tr = {
			"!": "%21",
			"'": "%27",
			"(": "%28",
			")": "%29",
			"~": "%7E",
			"%20": "+"
		},
		Or = function (e) {
			return Tr[e];
		},
		Rr = function (e) {
			return encodeURIComponent(e).replace(Ir, Or);
		},
		Fr = function (e, t) {
			if (t)
				for (var r, n, i = t.split("&"), o = 0; o < i.length; )
					(r = i[o++]).length &&
						((n = r.split("=")),
						e.push({ key: Cr(n.shift()), value: Cr(n.join("=")) }));
		},
		Lr = function (e) {
			(this.entries.length = 0), Fr(this.entries, e);
		},
		jr = function (e, t) {
			if (e < t) throw TypeError("Not enough arguments");
		},
		Nr = Ft(
			function (e, t) {
				wr(this, {
					type: "URLSearchParamsIterator",
					iterator: gr(Sr(e).entries),
					kind: t
				});
			},
			"Iterator",
			function () {
				var e = kr(this),
					t = e.kind,
					r = e.iterator.next(),
					n = r.value;
				return (
					r.done ||
						(r.value =
							"keys" === t
								? n.key
								: "values" === t
								? n.value
								: [n.key, n.value]),
					r
				);
			}
		),
		Pr = function () {
			Zt(this, Pr, "URLSearchParams");
			var e,
				t,
				r,
				n,
				i,
				o,
				a,
				s,
				c,
				u = arguments.length > 0 ? arguments[0] : void 0,
				l = this,
				f = [];
			if (
				(wr(l, {
					type: "URLSearchParams",
					entries: f,
					updateURL: function () {},
					updateSearchParams: Lr
				}),
				void 0 !== u)
			)
				if (y(u))
					if ("function" == typeof (e = ir(u)))
						for (r = (t = e.call(u)).next; !(n = r.call(t)).done; ) {
							if (
								(a = (o = (i = gr(q(n.value))).next).call(i)).done ||
								(s = o.call(i)).done ||
								!o.call(i).done
							)
								throw TypeError("Expected sequence with length 2");
							f.push({ key: a.value + "", value: s.value + "" });
						}
					else for (c in u) w(u, c) && f.push({ key: c, value: u[c] + "" });
				else
					Fr(
						f,
						"string" == typeof u
							? "?" === u.charAt(0)
								? u.slice(1)
								: u
							: u + ""
					);
		},
		qr = Pr.prototype;
	mr(
		qr,
		{
			append: function (e, t) {
				jr(arguments.length, 2);
				var r = Sr(this);
				r.entries.push({ key: e + "", value: t + "" }), r.updateURL();
			},
			delete: function (e) {
				jr(arguments.length, 1);
				for (var t = Sr(this), r = t.entries, n = e + "", i = 0; i < r.length; )
					r[i].key === n ? r.splice(i, 1) : i++;
				t.updateURL();
			},
			get: function (e) {
				jr(arguments.length, 1);
				for (var t = Sr(this).entries, r = e + "", n = 0; n < t.length; n++)
					if (t[n].key === r) return t[n].value;
				return null;
			},
			getAll: function (e) {
				jr(arguments.length, 1);
				for (
					var t = Sr(this).entries, r = e + "", n = [], i = 0;
					i < t.length;
					i++
				)
					t[i].key === r && n.push(t[i].value);
				return n;
			},
			has: function (e) {
				jr(arguments.length, 1);
				for (var t = Sr(this).entries, r = e + "", n = 0; n < t.length; )
					if (t[n++].key === r) return !0;
				return !1;
			},
			set: function (e, t) {
				jr(arguments.length, 1);
				for (
					var r,
						n = Sr(this),
						i = n.entries,
						o = !1,
						a = e + "",
						s = t + "",
						c = 0;
					c < i.length;
					c++
				)
					(r = i[c]).key === a &&
						(o ? i.splice(c--, 1) : ((o = !0), (r.value = s)));
				o || i.push({ key: a, value: s }), n.updateURL();
			},
			sort: function () {
				var e,
					t,
					r,
					n = Sr(this),
					i = n.entries,
					o = i.slice();
				for (i.length = 0, r = 0; r < o.length; r++) {
					for (e = o[r], t = 0; t < r; t++)
						if (i[t].key > e.key) {
							i.splice(t, 0, e);
							break;
						}
					t === r && i.push(e);
				}
				n.updateURL();
			},
			forEach: function (e) {
				for (
					var t,
						r = Sr(this).entries,
						n = P(e, arguments.length > 1 ? arguments[1] : void 0, 3),
						i = 0;
					i < r.length;

				)
					n((t = r[i++]).value, t.key, this);
			},
			keys: function () {
				return new Nr(this, "keys");
			},
			values: function () {
				return new Nr(this, "values");
			},
			entries: function () {
				return new Nr(this, "entries");
			}
		},
		{ enumerable: !0 }
	),
		jt(qr, br, qr.entries),
		jt(
			qr,
			"toString",
			function () {
				for (var e, t = Sr(this).entries, r = [], n = 0; n < t.length; )
					(e = t[n++]), r.push(Rr(e.key) + "=" + Rr(e.value));
				return r.join("&");
			},
			{ enumerable: !0 }
		),
		It(Pr, "URLSearchParams"),
		z({ global: !0, forced: !Kt }, { URLSearchParams: Pr }),
		Kt ||
			"function" != typeof yr ||
			"function" != typeof _r ||
			z(
				{ global: !0, enumerable: !0, forced: !0 },
				{
					fetch: function (e) {
						var t,
							r,
							n,
							i = [e];
						return (
							arguments.length > 1 &&
								(y((t = arguments[1])) &&
									((r = t.body),
									"URLSearchParams" === Mt(r) &&
										((n = t.headers ? new _r(t.headers) : new _r()).has(
											"content-type"
										) ||
											n.set(
												"content-type",
												"application/x-www-form-urlencoded;charset=UTF-8"
											),
										(t = bt(t, { body: f(0, String(r)), headers: f(0, n) })))),
								i.push(t)),
							yr.apply(this, i)
						);
					}
				}
			);
	var Dr,
		Br = { URLSearchParams: Pr, getState: Sr },
		Ur = oe.codeAt,
		Vr = o.URL,
		Hr = Br.URLSearchParams,
		zr = Br.getState,
		Kr = Ie.set,
		Zr = Ie.getterFor("URL"),
		Qr = Math.floor,
		Wr = Math.pow,
		Gr = /[A-Za-z]/,
		$r = /[\d+-.A-Za-z]/,
		Jr = /\d/,
		Yr = /^(0x|0X)/,
		Xr = /^[0-7]+$/,
		en = /^\d+$/,
		tn = /^[\dA-Fa-f]+$/,
		rn = /[\u0000\t\u000A\u000D #%/:?@[\\]]/,
		nn = /[\u0000\t\u000A\u000D #/:?@[\\]]/,
		on = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g,
		an = /[\t\u000A\u000D]/g,
		sn = function (e, t) {
			var r, n, i;
			if ("[" == t.charAt(0)) {
				if ("]" != t.charAt(t.length - 1)) return "Invalid host";
				if (!(r = un(t.slice(1, -1)))) return "Invalid host";
				e.host = r;
			} else if (gn(e)) {
				if (
					((t = (function (e) {
						var t,
							r,
							n = [],
							i = e.toLowerCase().replace(sr, ".").split(".");
						for (t = 0; t < i.length; t++)
							(r = i[t]), n.push(ar.test(r) ? "xn--" + pr(r) : r);
						return n.join(".");
					})(t)),
					rn.test(t))
				)
					return "Invalid host";
				if (null === (r = cn(t))) return "Invalid host";
				e.host = r;
			} else {
				if (nn.test(t)) return "Invalid host";
				for (r = "", n = or(t), i = 0; i < n.length; i++) r += vn(n[i], fn);
				e.host = r;
			}
		},
		cn = function (e) {
			var t,
				r,
				n,
				i,
				o,
				a,
				s,
				c = e.split(".");
			if ((c.length && "" == c[c.length - 1] && c.pop(), (t = c.length) > 4))
				return e;
			for (r = [], n = 0; n < t; n++) {
				if ("" == (i = c[n])) return e;
				if (
					((o = 10),
					i.length > 1 &&
						"0" == i.charAt(0) &&
						((o = Yr.test(i) ? 16 : 8), (i = i.slice(8 == o ? 1 : 2))),
					"" === i)
				)
					a = 0;
				else {
					if (!(10 == o ? en : 8 == o ? Xr : tn).test(i)) return e;
					a = parseInt(i, o);
				}
				r.push(a);
			}
			for (n = 0; n < t; n++)
				if (((a = r[n]), n == t - 1)) {
					if (a >= Wr(256, 5 - t)) return null;
				} else if (a > 255) return null;
			for (s = r.pop(), n = 0; n < r.length; n++) s += r[n] * Wr(256, 3 - n);
			return s;
		},
		un = function (e) {
			var t,
				r,
				n,
				i,
				o,
				a,
				s,
				c = [0, 0, 0, 0, 0, 0, 0, 0],
				u = 0,
				l = null,
				f = 0,
				h = function () {
					return e.charAt(f);
				};
			if (":" == h()) {
				if (":" != e.charAt(1)) return;
				(f += 2), (l = ++u);
			}
			for (; h(); ) {
				if (8 == u) return;
				if (":" != h()) {
					for (t = r = 0; r < 4 && tn.test(h()); )
						(t = 16 * t + parseInt(h(), 16)), f++, r++;
					if ("." == h()) {
						if (0 == r) return;
						if (((f -= r), u > 6)) return;
						for (n = 0; h(); ) {
							if (((i = null), n > 0)) {
								if (!("." == h() && n < 4)) return;
								f++;
							}
							if (!Jr.test(h())) return;
							for (; Jr.test(h()); ) {
								if (((o = parseInt(h(), 10)), null === i)) i = o;
								else {
									if (0 == i) return;
									i = 10 * i + o;
								}
								if (i > 255) return;
								f++;
							}
							(c[u] = 256 * c[u] + i), (2 != ++n && 4 != n) || u++;
						}
						if (4 != n) return;
						break;
					}
					if (":" == h()) {
						if ((f++, !h())) return;
					} else if (h()) return;
					c[u++] = t;
				} else {
					if (null !== l) return;
					f++, (l = ++u);
				}
			}
			if (null !== l)
				for (a = u - l, u = 7; 0 != u && a > 0; )
					(s = c[u]), (c[u--] = c[l + a - 1]), (c[l + --a] = s);
			else if (8 != u) return;
			return c;
		},
		ln = function (e) {
			var t, r, n, i;
			if ("number" == typeof e) {
				for (t = [], r = 0; r < 4; r++) t.unshift(e % 256), (e = Qr(e / 256));
				return t.join(".");
			}
			if ("object" == typeof e) {
				for (
					t = "",
						n = (function (e) {
							for (var t = null, r = 1, n = null, i = 0, o = 0; o < 8; o++)
								0 !== e[o]
									? (i > r && ((t = n), (r = i)), (n = null), (i = 0))
									: (null === n && (n = o), ++i);
							return i > r && ((t = n), (r = i)), t;
						})(e),
						r = 0;
					r < 8;
					r++
				)
					(i && 0 === e[r]) ||
						(i && (i = !1),
						n === r
							? ((t += r ? ":" : "::"), (i = !0))
							: ((t += e[r].toString(16)), r < 7 && (t += ":")));
				return "[" + t + "]";
			}
			return e;
		},
		fn = {},
		hn = $t({}, fn, { " ": 1, '"': 1, "<": 1, ">": 1, "`": 1 }),
		pn = $t({}, hn, { "#": 1, "?": 1, "{": 1, "}": 1 }),
		dn = $t({}, pn, {
			"/": 1,
			":": 1,
			";": 1,
			"=": 1,
			"@": 1,
			"[": 1,
			"\\": 1,
			"]": 1,
			"^": 1,
			"|": 1
		}),
		vn = function (e, t) {
			var r = Ur(e, 0);
			return r > 32 && r < 127 && !w(t, e) ? e : encodeURIComponent(e);
		},
		mn = { ftp: 21, file: null, http: 80, https: 443, ws: 80, wss: 443 },
		gn = function (e) {
			return w(mn, e.scheme);
		},
		yn = function (e) {
			return "" != e.username || "" != e.password;
		},
		_n = function (e) {
			return !e.host || e.cannotBeABaseURL || "file" == e.scheme;
		},
		bn = function (e, t) {
			var r;
			return (
				2 == e.length &&
				Gr.test(e.charAt(0)) &&
				(":" == (r = e.charAt(1)) || (!t && "|" == r))
			);
		},
		wn = function (e) {
			var t;
			return (
				e.length > 1 &&
				bn(e.slice(0, 2)) &&
				(2 == e.length ||
					"/" === (t = e.charAt(2)) ||
					"\\" === t ||
					"?" === t ||
					"#" === t)
			);
		},
		Sn = function (e) {
			var t = e.path,
				r = t.length;
			!r || ("file" == e.scheme && 1 == r && bn(t[0], !0)) || t.pop();
		},
		kn = function (e) {
			return "." === e || "%2e" === e.toLowerCase();
		},
		xn = {},
		Mn = {},
		An = {},
		En = {},
		Cn = {},
		In = {},
		Tn = {},
		On = {},
		Rn = {},
		Fn = {},
		Ln = {},
		jn = {},
		Nn = {},
		Pn = {},
		qn = {},
		Dn = {},
		Bn = {},
		Un = {},
		Vn = {},
		Hn = {},
		zn = {},
		Kn = function (e, t, r, n) {
			var i,
				o,
				a,
				s,
				c,
				u = r || xn,
				l = 0,
				f = "",
				h = !1,
				p = !1,
				d = !1;
			for (
				r ||
					((e.scheme = ""),
					(e.username = ""),
					(e.password = ""),
					(e.host = null),
					(e.port = null),
					(e.path = []),
					(e.query = null),
					(e.fragment = null),
					(e.cannotBeABaseURL = !1),
					(t = t.replace(on, ""))),
					t = t.replace(an, ""),
					i = or(t);
				l <= i.length;

			) {
				switch (((o = i[l]), u)) {
					case xn:
						if (!o || !Gr.test(o)) {
							if (r) return "Invalid scheme";
							u = An;
							continue;
						}
						(f += o.toLowerCase()), (u = Mn);
						break;
					case Mn:
						if (o && ($r.test(o) || "+" == o || "-" == o || "." == o))
							f += o.toLowerCase();
						else {
							if (":" != o) {
								if (r) return "Invalid scheme";
								(f = ""), (u = An), (l = 0);
								continue;
							}
							if (
								r &&
								(gn(e) != w(mn, f) ||
									("file" == f && (yn(e) || null !== e.port)) ||
									("file" == e.scheme && !e.host))
							)
								return;
							if (((e.scheme = f), r))
								return void (
									gn(e) &&
									mn[e.scheme] == e.port &&
									(e.port = null)
								);
							(f = ""),
								"file" == e.scheme
									? (u = Pn)
									: gn(e) && n && n.scheme == e.scheme
									? (u = En)
									: gn(e)
									? (u = On)
									: "/" == i[l + 1]
									? ((u = Cn), l++)
									: ((e.cannotBeABaseURL = !0), e.path.push(""), (u = Vn));
						}
						break;
					case An:
						if (!n || (n.cannotBeABaseURL && "#" != o)) return "Invalid scheme";
						if (n.cannotBeABaseURL && "#" == o) {
							(e.scheme = n.scheme),
								(e.path = n.path.slice()),
								(e.query = n.query),
								(e.fragment = ""),
								(e.cannotBeABaseURL = !0),
								(u = zn);
							break;
						}
						u = "file" == n.scheme ? Pn : In;
						continue;
					case En:
						if ("/" != o || "/" != i[l + 1]) {
							u = In;
							continue;
						}
						(u = Rn), l++;
						break;
					case Cn:
						if ("/" == o) {
							u = Fn;
							break;
						}
						u = Un;
						continue;
					case In:
						if (((e.scheme = n.scheme), o == Dr))
							(e.username = n.username),
								(e.password = n.password),
								(e.host = n.host),
								(e.port = n.port),
								(e.path = n.path.slice()),
								(e.query = n.query);
						else if ("/" == o || ("\\" == o && gn(e))) u = Tn;
						else if ("?" == o)
							(e.username = n.username),
								(e.password = n.password),
								(e.host = n.host),
								(e.port = n.port),
								(e.path = n.path.slice()),
								(e.query = ""),
								(u = Hn);
						else {
							if ("#" != o) {
								(e.username = n.username),
									(e.password = n.password),
									(e.host = n.host),
									(e.port = n.port),
									(e.path = n.path.slice()),
									e.path.pop(),
									(u = Un);
								continue;
							}
							(e.username = n.username),
								(e.password = n.password),
								(e.host = n.host),
								(e.port = n.port),
								(e.path = n.path.slice()),
								(e.query = n.query),
								(e.fragment = ""),
								(u = zn);
						}
						break;
					case Tn:
						if (!gn(e) || ("/" != o && "\\" != o)) {
							if ("/" != o) {
								(e.username = n.username),
									(e.password = n.password),
									(e.host = n.host),
									(e.port = n.port),
									(u = Un);
								continue;
							}
							u = Fn;
						} else u = Rn;
						break;
					case On:
						if (((u = Rn), "/" != o || "/" != f.charAt(l + 1))) continue;
						l++;
						break;
					case Rn:
						if ("/" != o && "\\" != o) {
							u = Fn;
							continue;
						}
						break;
					case Fn:
						if ("@" == o) {
							h && (f = "%40" + f), (h = !0), (a = or(f));
							for (var v = 0; v < a.length; v++) {
								var m = a[v];
								if (":" != m || d) {
									var g = vn(m, dn);
									d ? (e.password += g) : (e.username += g);
								} else d = !0;
							}
							f = "";
						} else if (
							o == Dr ||
							"/" == o ||
							"?" == o ||
							"#" == o ||
							("\\" == o && gn(e))
						) {
							if (h && "" == f) return "Invalid authority";
							(l -= or(f).length + 1), (f = ""), (u = Ln);
						} else f += o;
						break;
					case Ln:
					case jn:
						if (r && "file" == e.scheme) {
							u = Dn;
							continue;
						}
						if (":" != o || p) {
							if (
								o == Dr ||
								"/" == o ||
								"?" == o ||
								"#" == o ||
								("\\" == o && gn(e))
							) {
								if (gn(e) && "" == f) return "Invalid host";
								if (r && "" == f && (yn(e) || null !== e.port)) return;
								if ((s = sn(e, f))) return s;
								if (((f = ""), (u = Bn), r)) return;
								continue;
							}
							"[" == o ? (p = !0) : "]" == o && (p = !1), (f += o);
						} else {
							if ("" == f) return "Invalid host";
							if ((s = sn(e, f))) return s;
							if (((f = ""), (u = Nn), r == jn)) return;
						}
						break;
					case Nn:
						if (!Jr.test(o)) {
							if (
								o == Dr ||
								"/" == o ||
								"?" == o ||
								"#" == o ||
								("\\" == o && gn(e)) ||
								r
							) {
								if ("" != f) {
									var y = parseInt(f, 10);
									if (y > 65535) return "Invalid port";
									(e.port = gn(e) && y === mn[e.scheme] ? null : y), (f = "");
								}
								if (r) return;
								u = Bn;
								continue;
							}
							return "Invalid port";
						}
						f += o;
						break;
					case Pn:
						if (((e.scheme = "file"), "/" == o || "\\" == o)) u = qn;
						else {
							if (!n || "file" != n.scheme) {
								u = Un;
								continue;
							}
							if (o == Dr)
								(e.host = n.host),
									(e.path = n.path.slice()),
									(e.query = n.query);
							else if ("?" == o)
								(e.host = n.host),
									(e.path = n.path.slice()),
									(e.query = ""),
									(u = Hn);
							else {
								if ("#" != o) {
									wn(i.slice(l).join("")) ||
										((e.host = n.host), (e.path = n.path.slice()), Sn(e)),
										(u = Un);
									continue;
								}
								(e.host = n.host),
									(e.path = n.path.slice()),
									(e.query = n.query),
									(e.fragment = ""),
									(u = zn);
							}
						}
						break;
					case qn:
						if ("/" == o || "\\" == o) {
							u = Dn;
							break;
						}
						n &&
							"file" == n.scheme &&
							!wn(i.slice(l).join("")) &&
							(bn(n.path[0], !0) ? e.path.push(n.path[0]) : (e.host = n.host)),
							(u = Un);
						continue;
					case Dn:
						if (o == Dr || "/" == o || "\\" == o || "?" == o || "#" == o) {
							if (!r && bn(f)) u = Un;
							else if ("" == f) {
								if (((e.host = ""), r)) return;
								u = Bn;
							} else {
								if ((s = sn(e, f))) return s;
								if (("localhost" == e.host && (e.host = ""), r)) return;
								(f = ""), (u = Bn);
							}
							continue;
						}
						f += o;
						break;
					case Bn:
						if (gn(e)) {
							if (((u = Un), "/" != o && "\\" != o)) continue;
						} else if (r || "?" != o)
							if (r || "#" != o) {
								if (o != Dr && ((u = Un), "/" != o)) continue;
							} else (e.fragment = ""), (u = zn);
						else (e.query = ""), (u = Hn);
						break;
					case Un:
						if (
							o == Dr ||
							"/" == o ||
							("\\" == o && gn(e)) ||
							(!r && ("?" == o || "#" == o))
						) {
							if (
								(".." === (c = (c = f).toLowerCase()) ||
								"%2e." === c ||
								".%2e" === c ||
								"%2e%2e" === c
									? (Sn(e), "/" == o || ("\\" == o && gn(e)) || e.path.push(""))
									: kn(f)
									? "/" == o || ("\\" == o && gn(e)) || e.path.push("")
									: ("file" == e.scheme &&
											!e.path.length &&
											bn(f) &&
											(e.host && (e.host = ""), (f = f.charAt(0) + ":")),
									  e.path.push(f)),
								(f = ""),
								"file" == e.scheme && (o == Dr || "?" == o || "#" == o))
							)
								for (; e.path.length > 1 && "" === e.path[0]; ) e.path.shift();
							"?" == o
								? ((e.query = ""), (u = Hn))
								: "#" == o && ((e.fragment = ""), (u = zn));
						} else f += vn(o, pn);
						break;
					case Vn:
						"?" == o
							? ((e.query = ""), (u = Hn))
							: "#" == o
							? ((e.fragment = ""), (u = zn))
							: o != Dr && (e.path[0] += vn(o, fn));
						break;
					case Hn:
						r || "#" != o
							? o != Dr &&
							  ("'" == o && gn(e)
									? (e.query += "%27")
									: (e.query += "#" == o ? "%23" : vn(o, fn)))
							: ((e.fragment = ""), (u = zn));
						break;
					case zn:
						o != Dr && (e.fragment += vn(o, hn));
				}
				l++;
			}
		},
		Zn = function (e) {
			var t,
				r,
				n = Zt(this, Zn, "URL"),
				i = arguments.length > 1 ? arguments[1] : void 0,
				o = String(e),
				a = Kr(n, { type: "URL" });
			if (void 0 !== i)
				if (i instanceof Zn) t = Zr(i);
				else if ((r = Kn((t = {}), String(i)))) throw TypeError(r);
			if ((r = Kn(a, o, null, t))) throw TypeError(r);
			var c = (a.searchParams = new Hr()),
				u = zr(c);
			u.updateSearchParams(a.query),
				(u.updateURL = function () {
					a.query = String(c) || null;
				}),
				s ||
					((n.href = Wn.call(n)),
					(n.origin = Gn.call(n)),
					(n.protocol = $n.call(n)),
					(n.username = Jn.call(n)),
					(n.password = Yn.call(n)),
					(n.host = Xn.call(n)),
					(n.hostname = ei.call(n)),
					(n.port = ti.call(n)),
					(n.pathname = ri.call(n)),
					(n.search = ni.call(n)),
					(n.searchParams = ii.call(n)),
					(n.hash = oi.call(n)));
		},
		Qn = Zn.prototype,
		Wn = function () {
			var e = Zr(this),
				t = e.scheme,
				r = e.username,
				n = e.password,
				i = e.host,
				o = e.port,
				a = e.path,
				s = e.query,
				c = e.fragment,
				u = t + ":";
			return (
				null !== i
					? ((u += "//"),
					  yn(e) && (u += r + (n ? ":" + n : "") + "@"),
					  (u += ln(i)),
					  null !== o && (u += ":" + o))
					: "file" == t && (u += "//"),
				(u += e.cannotBeABaseURL ? a[0] : a.length ? "/" + a.join("/") : ""),
				null !== s && (u += "?" + s),
				null !== c && (u += "#" + c),
				u
			);
		},
		Gn = function () {
			var e = Zr(this),
				t = e.scheme,
				r = e.port;
			if ("blob" == t)
				try {
					return new URL(t.path[0]).origin;
				} catch (e) {
					return "null";
				}
			return "file" != t && gn(e)
				? t + "://" + ln(e.host) + (null !== r ? ":" + r : "")
				: "null";
		},
		$n = function () {
			return Zr(this).scheme + ":";
		},
		Jn = function () {
			return Zr(this).username;
		},
		Yn = function () {
			return Zr(this).password;
		},
		Xn = function () {
			var e = Zr(this),
				t = e.host,
				r = e.port;
			return null === t ? "" : null === r ? ln(t) : ln(t) + ":" + r;
		},
		ei = function () {
			var e = Zr(this).host;
			return null === e ? "" : ln(e);
		},
		ti = function () {
			var e = Zr(this).port;
			return null === e ? "" : String(e);
		},
		ri = function () {
			var e = Zr(this),
				t = e.path;
			return e.cannotBeABaseURL ? t[0] : t.length ? "/" + t.join("/") : "";
		},
		ni = function () {
			var e = Zr(this).query;
			return e ? "?" + e : "";
		},
		ii = function () {
			return Zr(this).searchParams;
		},
		oi = function () {
			var e = Zr(this).fragment;
			return e ? "#" + e : "";
		},
		ai = function (e, t) {
			return { get: e, set: t, configurable: !0, enumerable: !0 };
		};
	if (
		(s &&
			dt(Qn, {
				href: ai(Wn, function (e) {
					var t = Zr(this),
						r = String(e),
						n = Kn(t, r);
					if (n) throw TypeError(n);
					zr(t.searchParams).updateSearchParams(t.query);
				}),
				origin: ai(Gn),
				protocol: ai($n, function (e) {
					var t = Zr(this);
					Kn(t, String(e) + ":", xn);
				}),
				username: ai(Jn, function (e) {
					var t = Zr(this),
						r = or(String(e));
					if (!_n(t)) {
						t.username = "";
						for (var n = 0; n < r.length; n++) t.username += vn(r[n], dn);
					}
				}),
				password: ai(Yn, function (e) {
					var t = Zr(this),
						r = or(String(e));
					if (!_n(t)) {
						t.password = "";
						for (var n = 0; n < r.length; n++) t.password += vn(r[n], dn);
					}
				}),
				host: ai(Xn, function (e) {
					var t = Zr(this);
					t.cannotBeABaseURL || Kn(t, String(e), Ln);
				}),
				hostname: ai(ei, function (e) {
					var t = Zr(this);
					t.cannotBeABaseURL || Kn(t, String(e), jn);
				}),
				port: ai(ti, function (e) {
					var t = Zr(this);
					_n(t) || ("" == (e = String(e)) ? (t.port = null) : Kn(t, e, Nn));
				}),
				pathname: ai(ri, function (e) {
					var t = Zr(this);
					t.cannotBeABaseURL || ((t.path = []), Kn(t, e + "", Bn));
				}),
				search: ai(ni, function (e) {
					var t = Zr(this);
					"" == (e = String(e))
						? (t.query = null)
						: ("?" == e.charAt(0) && (e = e.slice(1)),
						  (t.query = ""),
						  Kn(t, e, Hn)),
						zr(t.searchParams).updateSearchParams(t.query);
				}),
				searchParams: ai(ii),
				hash: ai(oi, function (e) {
					var t = Zr(this);
					"" != (e = String(e))
						? ("#" == e.charAt(0) && (e = e.slice(1)),
						  (t.fragment = ""),
						  Kn(t, e, zn))
						: (t.fragment = null);
				})
			}),
		jt(
			Qn,
			"toJSON",
			function () {
				return Wn.call(this);
			},
			{ enumerable: !0 }
		),
		jt(
			Qn,
			"toString",
			function () {
				return Wn.call(this);
			},
			{ enumerable: !0 }
		),
		Vr)
	) {
		var si = Vr.createObjectURL,
			ci = Vr.revokeObjectURL;
		si &&
			jt(Zn, "createObjectURL", function (e) {
				return si.apply(Vr, arguments);
			}),
			ci &&
				jt(Zn, "revokeObjectURL", function (e) {
					return ci.apply(Vr, arguments);
				});
	}
	It(Zn, "URL"), z({ global: !0, forced: !Kt, sham: !s }, { URL: Zn });
	var ui = j.URL,
		li = function (e, t) {
			(this.stopped = e), (this.result = t);
		},
		fi = function (e, t, r) {
			var n,
				i,
				o,
				a,
				s,
				c,
				u,
				l = r && r.that,
				f = !(!r || !r.AS_ENTRIES),
				h = !(!r || !r.IS_ITERATOR),
				p = !(!r || !r.INTERRUPTED),
				d = P(t, l, 1 + f + p),
				v = function (e) {
					return n && Jt(n), new li(!0, e);
				},
				m = function (e) {
					return f
						? (q(e), p ? d(e[0], e[1], v) : d(e[0], e[1]))
						: p
						? d(e, v)
						: d(e);
				};
			if (h) n = e;
			else {
				if ("function" != typeof (i = ir(e)))
					throw TypeError("Target is not iterable");
				if (tr(i)) {
					for (o = 0, a = it(e.length); a > o; o++)
						if ((s = m(e[o])) && s instanceof li) return s;
					return new li(!1);
				}
				n = i.call(e);
			}
			for (c = n.next; !(u = c.call(n)).done; ) {
				try {
					s = m(u.value);
				} catch (e) {
					throw (Jt(n), e);
				}
				if ("object" == typeof s && s && s instanceof li) return s;
			}
			return new li(!1);
		},
		hi = function (e, t) {
			var r = this;
			if (!(r instanceof hi)) return new hi(e, t);
			Lt && (r = Lt(new Error(void 0), Le(r))),
				void 0 !== t && U(r, "message", String(t));
			var n = [];
			return fi(e, n.push, { that: n }), U(r, "errors", n), r;
		};
	(hi.prototype = bt(Error.prototype, {
		constructor: f(5, hi),
		message: f(5, ""),
		name: f(5, "AggregateError")
	})),
		z({ global: !0 }, { AggregateError: hi });
	var pi = o.Promise,
		di = Je("species"),
		vi = function (e) {
			var t = Pe(e),
				r = B.f;
			s &&
				t &&
				!t[di] &&
				r(t, di, {
					configurable: !0,
					get: function () {
						return this;
					}
				});
		},
		mi = Je("iterator"),
		gi = !1;
	try {
		var yi = 0,
			_i = {
				next: function () {
					return { done: !!yi++ };
				},
				return: function () {
					gi = !0;
				}
			};
		(_i[mi] = function () {
			return this;
		}),
			Array.from(_i, function () {
				throw 2;
			});
	} catch (e) {}
	var bi,
		wi,
		Si,
		ki = function (e, t) {
			if (!t && !gi) return !1;
			var r = !1;
			try {
				var n = {};
				(n[mi] = function () {
					return {
						next: function () {
							return { done: (r = !0) };
						}
					};
				}),
					e(n);
			} catch (e) {}
			return r;
		},
		xi = Je("species"),
		Mi = function (e, t) {
			var r,
				n = q(e).constructor;
			return void 0 === n || null == (r = q(n)[xi]) ? t : N(r);
		},
		Ai = /(iphone|ipod|ipad).*applewebkit/i.test(qe),
		Ei = o.location,
		Ci = o.setImmediate,
		Ii = o.clearImmediate,
		Ti = o.process,
		Oi = o.MessageChannel,
		Ri = o.Dispatch,
		Fi = 0,
		Li = {},
		ji = function (e) {
			if (Li.hasOwnProperty(e)) {
				var t = Li[e];
				delete Li[e], t();
			}
		},
		Ni = function (e) {
			return function () {
				ji(e);
			};
		},
		Pi = function (e) {
			ji(e.data);
		},
		qi = function (e) {
			o.postMessage(e + "", Ei.protocol + "//" + Ei.host);
		};
	(Ci && Ii) ||
		((Ci = function (e) {
			for (var t = [], r = 1; arguments.length > r; ) t.push(arguments[r++]);
			return (
				(Li[++Fi] = function () {
					("function" == typeof e ? e : Function(e)).apply(void 0, t);
				}),
				bi(Fi),
				Fi
			);
		}),
		(Ii = function (e) {
			delete Li[e];
		}),
		je
			? (bi = function (e) {
					Ti.nextTick(Ni(e));
			  })
			: Ri && Ri.now
			? (bi = function (e) {
					Ri.now(Ni(e));
			  })
			: Oi && !Ai
			? ((Si = (wi = new Oi()).port2),
			  (wi.port1.onmessage = Pi),
			  (bi = P(Si.postMessage, Si, 1)))
			: o.addEventListener &&
			  "function" == typeof postMessage &&
			  !o.importScripts &&
			  Ei &&
			  "file:" !== Ei.protocol &&
			  !a(qi)
			? ((bi = qi), o.addEventListener("message", Pi, !1))
			: (bi =
					"onreadystatechange" in x("script")
						? function (e) {
								vt.appendChild(x("script")).onreadystatechange = function () {
									vt.removeChild(this), ji(e);
								};
						  }
						: function (e) {
								setTimeout(Ni(e), 0);
						  }));
	var Di,
		Bi,
		Ui,
		Vi,
		Hi,
		zi,
		Ki,
		Zi,
		Qi = { set: Ci, clear: Ii },
		Wi = /web0s(?!.*chrome)/i.test(qe),
		Gi = E.f,
		$i = Qi.set,
		Ji = o.MutationObserver || o.WebKitMutationObserver,
		Yi = o.document,
		Xi = o.process,
		eo = o.Promise,
		to = Gi(o, "queueMicrotask"),
		ro = to && to.value;
	ro ||
		((Di = function () {
			var e, t;
			for (je && (e = Xi.domain) && e.exit(); Bi; ) {
				(t = Bi.fn), (Bi = Bi.next);
				try {
					t();
				} catch (e) {
					throw (Bi ? Vi() : (Ui = void 0), e);
				}
			}
			(Ui = void 0), e && e.enter();
		}),
		Ai || je || Wi || !Ji || !Yi
			? eo && eo.resolve
				? ((Ki = eo.resolve(void 0)),
				  (Zi = Ki.then),
				  (Vi = function () {
						Zi.call(Ki, Di);
				  }))
				: (Vi = je
						? function () {
								Xi.nextTick(Di);
						  }
						: function () {
								$i.call(o, Di);
						  })
			: ((Hi = !0),
			  (zi = Yi.createTextNode("")),
			  new Ji(Di).observe(zi, { characterData: !0 }),
			  (Vi = function () {
					zi.data = Hi = !Hi;
			  })));
	var no,
		io,
		oo,
		ao =
			ro ||
			function (e) {
				var t = { fn: e, next: void 0 };
				Ui && (Ui.next = t), Bi || ((Bi = t), Vi()), (Ui = t);
			},
		so = function (e) {
			var t, r;
			(this.promise = new e(function (e, n) {
				if (void 0 !== t || void 0 !== r)
					throw TypeError("Bad Promise constructor");
				(t = e), (r = n);
			})),
				(this.resolve = N(t)),
				(this.reject = N(r));
		},
		co = {
			f: function (e) {
				return new so(e);
			}
		},
		uo = function (e, t) {
			if ((q(e), y(t) && t.constructor === e)) return t;
			var r = co.f(e);
			return (0, r.resolve)(t), r.promise;
		},
		lo = function (e) {
			try {
				return { error: !1, value: e() };
			} catch (e) {
				return { error: !0, value: e };
			}
		},
		fo = Qi.set,
		ho = Je("species"),
		po = "Promise",
		vo = Ie.get,
		mo = Ie.set,
		go = Ie.getterFor(po),
		yo = pi,
		_o = o.TypeError,
		bo = o.document,
		wo = o.process,
		So = (Pe("fetch"), co.f),
		ko = So,
		xo = !!(bo && bo.createEvent && o.dispatchEvent),
		Mo = "function" == typeof PromiseRejectionEvent,
		Ao = L(po, function () {
			if (!(fe(yo) !== String(yo))) {
				if (66 === Ke) return !0;
				if (!je && !Mo) return !0;
			}
			if (!yo.prototype.finally) return !0;
			if (Ke >= 51 && /native code/.test(yo)) return !1;
			var e = yo.resolve(1),
				t = function (e) {
					e(
						function () {},
						function () {}
					);
				};
			return (
				((e.constructor = {})[ho] = t), !(e.then(function () {}) instanceof t)
			);
		}),
		Eo =
			Ao ||
			!ki(function (e) {
				yo.all(e).catch(function () {});
			}),
		Co = function (e) {
			var t;
			return !(!y(e) || "function" != typeof (t = e.then)) && t;
		},
		Io = function (e, t) {
			if (!e.notified) {
				e.notified = !0;
				var r = e.reactions;
				ao(function () {
					for (var n = e.value, i = 1 == e.state, o = 0; r.length > o; ) {
						var a,
							s,
							c,
							u = r[o++],
							l = i ? u.ok : u.fail,
							f = u.resolve,
							h = u.reject,
							p = u.domain;
						try {
							l
								? (i || (2 === e.rejection && Fo(e), (e.rejection = 1)),
								  !0 === l
										? (a = n)
										: (p && p.enter(), (a = l(n)), p && (p.exit(), (c = !0))),
								  a === u.promise
										? h(_o("Promise-chain cycle"))
										: (s = Co(a))
										? s.call(a, f, h)
										: f(a))
								: h(n);
						} catch (e) {
							p && !c && p.exit(), h(e);
						}
					}
					(e.reactions = []), (e.notified = !1), t && !e.rejection && Oo(e);
				});
			}
		},
		To = function (e, t, r) {
			var n, i;
			xo
				? (((n = bo.createEvent("Event")).promise = t),
				  (n.reason = r),
				  n.initEvent(e, !1, !0),
				  o.dispatchEvent(n))
				: (n = { promise: t, reason: r }),
				!Mo && (i = o["on" + e])
					? i(n)
					: "unhandledrejection" === e &&
					  (function (e, t) {
							var r = o.console;
							r &&
								r.error &&
								(1 === arguments.length ? r.error(e) : r.error(e, t));
					  })("Unhandled promise rejection", r);
		},
		Oo = function (e) {
			fo.call(o, function () {
				var t,
					r = e.facade,
					n = e.value;
				if (
					Ro(e) &&
					((t = lo(function () {
						je
							? wo.emit("unhandledRejection", n, r)
							: To("unhandledrejection", r, n);
					})),
					(e.rejection = je || Ro(e) ? 2 : 1),
					t.error)
				)
					throw t.value;
			});
		},
		Ro = function (e) {
			return 1 !== e.rejection && !e.parent;
		},
		Fo = function (e) {
			fo.call(o, function () {
				var t = e.facade;
				je
					? wo.emit("rejectionHandled", t)
					: To("rejectionhandled", t, e.value);
			});
		},
		Lo = function (e, t, r) {
			return function (n) {
				e(t, n, r);
			};
		},
		jo = function (e, t, r) {
			e.done ||
				((e.done = !0), r && (e = r), (e.value = t), (e.state = 2), Io(e, !0));
		},
		No = function (e, t, r) {
			if (!e.done) {
				(e.done = !0), r && (e = r);
				try {
					if (e.facade === t) throw _o("Promise can't be resolved itself");
					var n = Co(t);
					n
						? ao(function () {
								var r = { done: !1 };
								try {
									n.call(t, Lo(No, r, e), Lo(jo, r, e));
								} catch (t) {
									jo(r, t, e);
								}
						  })
						: ((e.value = t), (e.state = 1), Io(e, !1));
				} catch (t) {
					jo({ done: !1 }, t, e);
				}
			}
		};
	Ao &&
		((yo = function (e) {
			Zt(this, yo, po), N(e), no.call(this);
			var t = vo(this);
			try {
				e(Lo(No, t), Lo(jo, t));
			} catch (e) {
				jo(t, e);
			}
		}),
		((no = function (e) {
			mo(this, {
				type: po,
				done: !1,
				notified: !1,
				parent: !1,
				reactions: [],
				rejection: !1,
				state: 0,
				value: void 0
			});
		}).prototype = mr(yo.prototype, {
			then: function (e, t) {
				var r = go(this),
					n = So(Mi(this, yo));
				return (
					(n.ok = "function" != typeof e || e),
					(n.fail = "function" == typeof t && t),
					(n.domain = je ? wo.domain : void 0),
					(r.parent = !0),
					r.reactions.push(n),
					0 != r.state && Io(r, !1),
					n.promise
				);
			},
			catch: function (e) {
				return this.then(void 0, e);
			}
		})),
		(io = function () {
			var e = new no(),
				t = vo(e);
			(this.promise = e), (this.resolve = Lo(No, t)), (this.reject = Lo(jo, t));
		}),
		(co.f = So = function (e) {
			return e === yo || e === oo ? new io(e) : ko(e);
		})),
		z({ global: !0, wrap: !0, forced: Ao }, { Promise: yo }),
		It(yo, po, !1, !0),
		vi(po),
		(oo = Pe(po)),
		z(
			{ target: po, stat: !0, forced: Ao },
			{
				reject: function (e) {
					var t = So(this);
					return t.reject.call(void 0, e), t.promise;
				}
			}
		),
		z(
			{ target: po, stat: !0, forced: !0 },
			{
				resolve: function (e) {
					return uo(this === oo ? yo : this, e);
				}
			}
		),
		z(
			{ target: po, stat: !0, forced: Eo },
			{
				all: function (e) {
					var t = this,
						r = So(t),
						n = r.resolve,
						i = r.reject,
						o = lo(function () {
							var r = N(t.resolve),
								o = [],
								a = 0,
								s = 1;
							fi(e, function (e) {
								var c = a++,
									u = !1;
								o.push(void 0),
									s++,
									r.call(t, e).then(function (e) {
										u || ((u = !0), (o[c] = e), --s || n(o));
									}, i);
							}),
								--s || n(o);
						});
					return o.error && i(o.value), r.promise;
				},
				race: function (e) {
					var t = this,
						r = So(t),
						n = r.reject,
						i = lo(function () {
							var i = N(t.resolve);
							fi(e, function (e) {
								i.call(t, e).then(r.resolve, n);
							});
						});
					return i.error && n(i.value), r.promise;
				}
			}
		),
		z(
			{ target: "Promise", stat: !0 },
			{
				allSettled: function (e) {
					var t = this,
						r = co.f(t),
						n = r.resolve,
						i = r.reject,
						o = lo(function () {
							var r = N(t.resolve),
								i = [],
								o = 0,
								a = 1;
							fi(e, function (e) {
								var s = o++,
									c = !1;
								i.push(void 0),
									a++,
									r.call(t, e).then(
										function (e) {
											c ||
												((c = !0),
												(i[s] = { status: "fulfilled", value: e }),
												--a || n(i));
										},
										function (e) {
											c ||
												((c = !0),
												(i[s] = { status: "rejected", reason: e }),
												--a || n(i));
										}
									);
							}),
								--a || n(i);
						});
					return o.error && i(o.value), r.promise;
				}
			}
		);
	z(
		{ target: "Promise", stat: !0 },
		{
			any: function (e) {
				var t = this,
					r = co.f(t),
					n = r.resolve,
					i = r.reject,
					o = lo(function () {
						var r = N(t.resolve),
							o = [],
							a = 0,
							s = 1,
							c = !1;
						fi(e, function (e) {
							var u = a++,
								l = !1;
							o.push(void 0),
								s++,
								r.call(t, e).then(
									function (e) {
										l || c || ((c = !0), n(e));
									},
									function (e) {
										l ||
											c ||
											((l = !0),
											(o[u] = e),
											--s ||
												i(
													new (Pe("AggregateError"))(
														o,
														"No one promise resolved"
													)
												));
									}
								);
						}),
							--s ||
								i(new (Pe("AggregateError"))(o, "No one promise resolved"));
					});
				return o.error && i(o.value), r.promise;
			}
		}
	);
	var Po =
		!!pi &&
		a(function () {
			pi.prototype.finally.call({ then: function () {} }, function () {});
		});
	z(
		{ target: "Promise", proto: !0, real: !0, forced: Po },
		{
			finally: function (e) {
				var t = Mi(this, Pe("Promise")),
					r = "function" == typeof e;
				return this.then(
					r
						? function (r) {
								return uo(t, e()).then(function () {
									return r;
								});
						  }
						: e,
					r
						? function (r) {
								return uo(t, e()).then(function () {
									throw r;
								});
						  }
						: e
				);
			}
		}
	);
	var qo = Je("toStringTag");
	for (var Do in {
		CSSRuleList: 0,
		CSSStyleDeclaration: 0,
		CSSValueList: 0,
		ClientRectList: 0,
		DOMRectList: 0,
		DOMStringList: 0,
		DOMTokenList: 1,
		DataTransferItemList: 0,
		FileList: 0,
		HTMLAllCollection: 0,
		HTMLCollection: 0,
		HTMLFormElement: 0,
		HTMLSelectElement: 0,
		MediaList: 0,
		MimeTypeArray: 0,
		NamedNodeMap: 0,
		NodeList: 1,
		PaintRequestList: 0,
		Plugin: 0,
		PluginArray: 0,
		SVGLengthList: 0,
		SVGNumberList: 0,
		SVGPathSegList: 0,
		SVGPointList: 0,
		SVGStringList: 0,
		SVGTransformList: 0,
		SourceBufferList: 0,
		StyleSheetList: 0,
		TextTrackCueList: 0,
		TextTrackList: 0,
		TouchList: 0
	}) {
		var Bo = o[Do],
			Uo = Bo && Bo.prototype;
		Uo && Mt(Uo) !== qo && U(Uo, qo, Do), (Tt[Do] = Tt.Array);
	}
	var Vo = j.Promise,
		Ho = Pe("JSON", "stringify"),
		zo = /[\uD800-\uDFFF]/g,
		Ko = /^[\uD800-\uDBFF]$/,
		Zo = /^[\uDC00-\uDFFF]$/,
		Qo = function (e, t, r) {
			var n = r.charAt(t - 1),
				i = r.charAt(t + 1);
			return (Ko.test(e) && !Zo.test(i)) || (Zo.test(e) && !Ko.test(n))
				? "\\u" + e.charCodeAt(0).toString(16)
				: e;
		},
		Wo = a(function () {
			return (
				'"\\udf06\\ud834"' !== Ho("\udf06\ud834") ||
				'"\\udead"' !== Ho("\udead")
			);
		});
	Ho &&
		z(
			{ target: "JSON", stat: !0, forced: Wo },
			{
				stringify: function (e, t, r) {
					var n = Ho.apply(null, arguments);
					return "string" == typeof n ? n.replace(zo, Qo) : n;
				}
			}
		),
		j.JSON || (j.JSON = { stringify: JSON.stringify });
	var Go = function (e, t, r) {
			return j.JSON.stringify.apply(null, arguments);
		},
		$o = ut.includes;
	z(
		{ target: "Array", proto: !0 },
		{
			includes: function (e) {
				return $o(this, e, arguments.length > 1 ? arguments[1] : void 0);
			}
		}
	);
	var Jo = function (e) {
			return j[e + "Prototype"];
		},
		Yo = Jo("Array").includes,
		Xo = Je("match"),
		ea = function (e) {
			if (
				(function (e) {
					var t;
					return y(e) && (void 0 !== (t = e[Xo]) ? !!t : "RegExp" == p(e));
				})(e)
			)
				throw TypeError("The method doesn't accept regular expressions");
			return e;
		},
		ta = Je("match"),
		ra = function (e) {
			var t = /./;
			try {
				"/./"[e](t);
			} catch (r) {
				try {
					return (t[ta] = !1), "/./"[e](t);
				} catch (e) {}
			}
			return !1;
		};
	z(
		{ target: "String", proto: !0, forced: !ra("includes") },
		{
			includes: function (e) {
				return !!~String(m(this)).indexOf(
					ea(e),
					arguments.length > 1 ? arguments[1] : void 0
				);
			}
		}
	);
	var na = Jo("String").includes,
		ia = Array.prototype,
		oa = String.prototype,
		aa = function (e) {
			var t = e.includes;
			return e === ia || (e instanceof Array && t === ia.includes)
				? Yo
				: "string" == typeof e ||
				  e === oa ||
				  (e instanceof String && t === oa.includes)
				? na
				: t;
		};
	z(
		{ target: "Object", stat: !0, forced: Object.assign !== $t },
		{ assign: $t }
	);
	var sa = j.Object.assign,
		ca = t(
			r(function (e) {
				function t() {
					return (
						(e.exports = t =
							sa ||
							function (e) {
								for (var t = 1; t < arguments.length; t++) {
									var r = arguments[t];
									for (var n in r)
										Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
								}
								return e;
							}),
						(e.exports.default = e.exports),
						(e.exports.__esModule = !0),
						t.apply(this, arguments)
					);
				}
				(e.exports = t),
					(e.exports.default = e.exports),
					(e.exports.__esModule = !0);
			})
		);
	z(
		{ target: "Object", stat: !0 },
		{
			fromEntries: function (e) {
				var t = {};
				return (
					fi(
						e,
						function (e, r) {
							rr(t, e, r);
						},
						{ AS_ENTRIES: !0 }
					),
					t
				);
			}
		}
	);
	var ua = j.Object.fromEntries;
	z(
		{ target: "Object", stat: !0, forced: !s, sham: !s },
		{ defineProperty: B.f }
	);
	var la = r(function (e) {
			var t = j.Object,
				r = (e.exports = function (e, r, n) {
					return t.defineProperty(e, r, n);
				});
			t.defineProperty.sham && (r.sham = !0);
		}),
		fa = la;
	z(
		{ target: "Object", stat: !0, forced: !s, sham: !s },
		{ defineProperties: dt }
	);
	var ha = r(function (e) {
			var t = j.Object,
				r = (e.exports = function (e, r) {
					return t.defineProperties(e, r);
				});
			t.defineProperties.sham && (r.sham = !0);
		}),
		pa = ht.concat("length", "prototype"),
		da = {
			f:
				Object.getOwnPropertyNames ||
				function (e) {
					return ft(e, pa);
				}
		},
		va =
			Pe("Reflect", "ownKeys") ||
			function (e) {
				var t = da.f(q(e)),
					r = Qt.f;
				return r ? t.concat(r(e)) : t;
			};
	z(
		{ target: "Object", stat: !0, sham: !s },
		{
			getOwnPropertyDescriptors: function (e) {
				for (
					var t, r, n = g(e), i = E.f, o = va(n), a = {}, s = 0;
					o.length > s;

				)
					void 0 !== (r = i(n, (t = o[s++]))) && rr(a, t, r);
				return a;
			}
		}
	);
	var ma = j.Object.getOwnPropertyDescriptors,
		ga =
			Array.isArray ||
			function (e) {
				return "Array" == p(e);
			},
		ya = Je("species"),
		_a = function (e, t) {
			var r;
			return (
				ga(e) &&
					("function" != typeof (r = e.constructor) ||
					(r !== Array && !ga(r.prototype))
						? y(r) && null === (r = r[ya]) && (r = void 0)
						: (r = void 0)),
				new (void 0 === r ? Array : r)(0 === t ? 0 : t)
			);
		},
		ba = [].push,
		wa = function (e) {
			var t = 1 == e,
				r = 2 == e,
				n = 3 == e,
				i = 4 == e,
				o = 6 == e,
				a = 7 == e,
				s = 5 == e || o;
			return function (c, u, l, f) {
				for (
					var h,
						p,
						d = Te(c),
						m = v(d),
						g = P(u, l, 3),
						y = it(m.length),
						_ = 0,
						b = f || _a,
						w = t ? b(c, y) : r || a ? b(c, 0) : void 0;
					y > _;
					_++
				)
					if ((s || _ in m) && ((p = g((h = m[_]), _, d)), e))
						if (t) w[_] = p;
						else if (p)
							switch (e) {
								case 3:
									return !0;
								case 5:
									return h;
								case 6:
									return _;
								case 2:
									ba.call(w, h);
							}
						else
							switch (e) {
								case 4:
									return !1;
								case 7:
									ba.call(w, h);
							}
				return o ? -1 : n || i ? i : w;
			};
		},
		Sa = {
			forEach: wa(0),
			map: wa(1),
			filter: wa(2),
			some: wa(3),
			every: wa(4),
			find: wa(5),
			findIndex: wa(6),
			filterOut: wa(7)
		},
		ka = function (e, t) {
			var r = [][e];
			return (
				!!r &&
				a(function () {
					r.call(
						null,
						t ||
							function () {
								throw 1;
							},
						1
					);
				})
			);
		},
		xa = Sa.forEach,
		Ma = ka("forEach")
			? [].forEach
			: function (e) {
					return xa(this, e, arguments.length > 1 ? arguments[1] : void 0);
			  };
	z({ target: "Array", proto: !0, forced: [].forEach != Ma }, { forEach: Ma });
	var Aa = Jo("Array").forEach,
		Ea = Array.prototype,
		Ca = { DOMTokenList: !0, NodeList: !0 },
		Ia = function (e) {
			var t = e.forEach;
			return e === Ea ||
				(e instanceof Array && t === Ea.forEach) ||
				Ca.hasOwnProperty(Mt(e))
				? Aa
				: t;
		},
		Ta = E.f,
		Oa = a(function () {
			Ta(1);
		});
	z(
		{ target: "Object", stat: !0, forced: !s || Oa, sham: !s },
		{
			getOwnPropertyDescriptor: function (e, t) {
				return Ta(g(e), t);
			}
		}
	);
	var Ra = r(function (e) {
			var t = j.Object,
				r = (e.exports = function (e, r) {
					return t.getOwnPropertyDescriptor(e, r);
				});
			t.getOwnPropertyDescriptor.sham && (r.sham = !0);
		}),
		Fa = Je("species"),
		La = function (e) {
			return (
				Ke >= 51 ||
				!a(function () {
					var t = [];
					return (
						((t.constructor = {})[Fa] = function () {
							return { foo: 1 };
						}),
						1 !== t[e](Boolean).foo
					);
				})
			);
		},
		ja = Sa.filter,
		Na = La("filter");
	z(
		{ target: "Array", proto: !0, forced: !Na },
		{
			filter: function (e) {
				return ja(this, e, arguments.length > 1 ? arguments[1] : void 0);
			}
		}
	);
	var Pa = Jo("Array").filter,
		qa = Array.prototype,
		Da = function (e) {
			var t = e.filter;
			return e === qa || (e instanceof Array && t === qa.filter) ? Pa : t;
		},
		Ba = da.f,
		Ua = {}.toString,
		Va =
			"object" == typeof window && window && Object.getOwnPropertyNames
				? Object.getOwnPropertyNames(window)
				: [],
		Ha = {
			f: function (e) {
				return Va && "[object Window]" == Ua.call(e)
					? (function (e) {
							try {
								return Ba(e);
							} catch (e) {
								return Va.slice();
							}
					  })(e)
					: Ba(g(e));
			}
		},
		za = { f: Je },
		Ka = B.f,
		Za = function (e) {
			var t = j.Symbol || (j.Symbol = {});
			w(t, e) || Ka(t, e, { value: za.f(e) });
		},
		Qa = Sa.forEach,
		Wa = _e("hidden"),
		Ga = Je("toPrimitive"),
		$a = Ie.set,
		Ja = Ie.getterFor("Symbol"),
		Ya = Object.prototype,
		Xa = o.Symbol,
		es = Pe("JSON", "stringify"),
		ts = E.f,
		rs = B.f,
		ns = Ha.f,
		is = l.f,
		os = de("symbols"),
		as = de("op-symbols"),
		ss = de("string-to-symbol-registry"),
		cs = de("symbol-to-string-registry"),
		us = de("wks"),
		ls = o.QObject,
		fs = !ls || !ls.prototype || !ls.prototype.findChild,
		hs =
			s &&
			a(function () {
				return (
					7 !=
					bt(
						rs({}, "a", {
							get: function () {
								return rs(this, "a", { value: 7 }).a;
							}
						})
					).a
				);
			})
				? function (e, t, r) {
						var n = ts(Ya, t);
						n && delete Ya[t], rs(e, t, r), n && e !== Ya && rs(Ya, t, n);
				  }
				: rs,
		ps = function (e, t) {
			var r = (os[e] = bt(Xa.prototype));
			return (
				$a(r, { type: "Symbol", tag: e, description: t }),
				s || (r.description = t),
				r
			);
		},
		ds = Qe
			? function (e) {
					return "symbol" == typeof e;
			  }
			: function (e) {
					return Object(e) instanceof Xa;
			  },
		vs = function (e, t, r) {
			e === Ya && vs(as, t, r), q(e);
			var n = _(t, !0);
			return (
				q(r),
				w(os, n)
					? (r.enumerable
							? (w(e, Wa) && e[Wa][n] && (e[Wa][n] = !1),
							  (r = bt(r, { enumerable: f(0, !1) })))
							: (w(e, Wa) || rs(e, Wa, f(1, {})), (e[Wa][n] = !0)),
					  hs(e, n, r))
					: rs(e, n, r)
			);
		},
		ms = function (e, t) {
			q(e);
			var r = g(t),
				n = pt(r).concat(bs(r));
			return (
				Qa(n, function (t) {
					(s && !gs.call(r, t)) || vs(e, t, r[t]);
				}),
				e
			);
		},
		gs = function (e) {
			var t = _(e, !0),
				r = is.call(this, t);
			return (
				!(this === Ya && w(os, t) && !w(as, t)) &&
				(!(r || !w(this, t) || !w(os, t) || (w(this, Wa) && this[Wa][t])) || r)
			);
		},
		ys = function (e, t) {
			var r = g(e),
				n = _(t, !0);
			if (r !== Ya || !w(os, n) || w(as, n)) {
				var i = ts(r, n);
				return (
					!i || !w(os, n) || (w(r, Wa) && r[Wa][n]) || (i.enumerable = !0), i
				);
			}
		},
		_s = function (e) {
			var t = ns(g(e)),
				r = [];
			return (
				Qa(t, function (e) {
					w(os, e) || w(be, e) || r.push(e);
				}),
				r
			);
		},
		bs = function (e) {
			var t = e === Ya,
				r = ns(t ? as : g(e)),
				n = [];
			return (
				Qa(r, function (e) {
					!w(os, e) || (t && !w(Ya, e)) || n.push(os[e]);
				}),
				n
			);
		};
	if (
		(Ze ||
			(jt(
				(Xa = function () {
					if (this instanceof Xa)
						throw TypeError("Symbol is not a constructor");
					var e =
							arguments.length && void 0 !== arguments[0]
								? String(arguments[0])
								: void 0,
						t = ge(e),
						r = function (e) {
							this === Ya && r.call(as, e),
								w(this, Wa) && w(this[Wa], t) && (this[Wa][t] = !1),
								hs(this, t, f(1, e));
						};
					return s && fs && hs(Ya, t, { configurable: !0, set: r }), ps(t, e);
				}).prototype,
				"toString",
				function () {
					return Ja(this).tag;
				}
			),
			jt(Xa, "withoutSetter", function (e) {
				return ps(ge(e), e);
			}),
			(l.f = gs),
			(B.f = vs),
			(E.f = ys),
			(da.f = Ha.f = _s),
			(Qt.f = bs),
			(za.f = function (e) {
				return ps(Je(e), e);
			}),
			s &&
				rs(Xa.prototype, "description", {
					configurable: !0,
					get: function () {
						return Ja(this).description;
					}
				})),
		z({ global: !0, wrap: !0, forced: !Ze, sham: !Ze }, { Symbol: Xa }),
		Qa(pt(us), function (e) {
			Za(e);
		}),
		z(
			{ target: "Symbol", stat: !0, forced: !Ze },
			{
				for: function (e) {
					var t = String(e);
					if (w(ss, t)) return ss[t];
					var r = Xa(t);
					return (ss[t] = r), (cs[r] = t), r;
				},
				keyFor: function (e) {
					if (!ds(e)) throw TypeError(e + " is not a symbol");
					if (w(cs, e)) return cs[e];
				},
				useSetter: function () {
					fs = !0;
				},
				useSimple: function () {
					fs = !1;
				}
			}
		),
		z(
			{ target: "Object", stat: !0, forced: !Ze, sham: !s },
			{
				create: function (e, t) {
					return void 0 === t ? bt(e) : ms(bt(e), t);
				},
				defineProperty: vs,
				defineProperties: ms,
				getOwnPropertyDescriptor: ys
			}
		),
		z(
			{ target: "Object", stat: !0, forced: !Ze },
			{ getOwnPropertyNames: _s, getOwnPropertySymbols: bs }
		),
		z(
			{
				target: "Object",
				stat: !0,
				forced: a(function () {
					Qt.f(1);
				})
			},
			{
				getOwnPropertySymbols: function (e) {
					return Qt.f(Te(e));
				}
			}
		),
		es)
	) {
		var ws =
			!Ze ||
			a(function () {
				var e = Xa();
				return (
					"[null]" != es([e]) || "{}" != es({ a: e }) || "{}" != es(Object(e))
				);
			});
		z(
			{ target: "JSON", stat: !0, forced: ws },
			{
				stringify: function (e, t, r) {
					for (var n, i = [e], o = 1; arguments.length > o; )
						i.push(arguments[o++]);
					if (((n = t), (y(t) || void 0 !== e) && !ds(e)))
						return (
							ga(t) ||
								(t = function (e, t) {
									if (
										("function" == typeof n && (t = n.call(this, e, t)), !ds(t))
									)
										return t;
								}),
							(i[1] = t),
							es.apply(null, i)
						);
				}
			}
		);
	}
	Xa.prototype[Ga] || U(Xa.prototype, Ga, Xa.prototype.valueOf),
		It(Xa, "Symbol"),
		(be[Wa] = !0);
	var Ss = j.Object.getOwnPropertySymbols,
		ks = a(function () {
			pt(1);
		});
	z(
		{ target: "Object", stat: !0, forced: ks },
		{
			keys: function (e) {
				return pt(Te(e));
			}
		}
	);
	var xs = j.Object.keys,
		Ms = xs;
	z({ target: "Array", stat: !0 }, { isArray: ga });
	var As = j.Array.isArray,
		Es = Sa.map,
		Cs = La("map");
	z(
		{ target: "Array", proto: !0, forced: !Cs },
		{
			map: function (e) {
				return Es(this, e, arguments.length > 1 ? arguments[1] : void 0);
			}
		}
	);
	var Is = Jo("Array").map,
		Ts = Array.prototype,
		Os = function (e) {
			var t = e.map;
			return e === Ts || (e instanceof Array && t === Ts.map) ? Is : t;
		},
		Rs = function (e) {
			return function (t, r, n, i) {
				N(r);
				var o = Te(t),
					a = v(o),
					s = it(o.length),
					c = e ? s - 1 : 0,
					u = e ? -1 : 1;
				if (n < 2)
					for (;;) {
						if (c in a) {
							(i = a[c]), (c += u);
							break;
						}
						if (((c += u), e ? c < 0 : s <= c))
							throw TypeError("Reduce of empty array with no initial value");
					}
				for (; e ? c >= 0 : s > c; c += u) c in a && (i = r(i, a[c], c, o));
				return i;
			};
		},
		Fs = { left: Rs(!1), right: Rs(!0) }.left,
		Ls = ka("reduce");
	z(
		{ target: "Array", proto: !0, forced: !Ls || (!je && Ke > 79 && Ke < 83) },
		{
			reduce: function (e) {
				return Fs(
					this,
					e,
					arguments.length,
					arguments.length > 1 ? arguments[1] : void 0
				);
			}
		}
	);
	var js = Jo("Array").reduce,
		Ns = Array.prototype,
		Ps = function (e) {
			var t = e.reduce;
			return e === Ns || (e instanceof Array && t === Ns.reduce) ? js : t;
		},
		qs = la,
		Ds = t(
			r(function (e) {
				(e.exports = function (e, t, r) {
					return (
						t in e
							? qs(e, t, {
									value: r,
									enumerable: !0,
									configurable: !0,
									writable: !0
							  })
							: (e[t] = r),
						e
					);
				}),
					(e.exports.default = e.exports),
					(e.exports.__esModule = !0);
			})
		);
	z({ target: "Object", stat: !0, sham: !s }, { create: bt });
	var Bs = j.Object,
		Us = function (e, t) {
			return Bs.create(e, t);
		},
		Vs = Us,
		Hs = r(function (e, t) {
			fa(t, "__esModule", { value: !0 }), (t.AnswersCore = void 0);
			var r = (function () {
				function e(e, t, r) {
					(this.searchService = e),
						(this.questionSubmissionService = t),
						(this.autoCompleteService = r);
				}
				var t = e.prototype;
				return (
					(t.universalSearch = function (e) {
						return this.searchService.universalSearch(e);
					}),
					(t.verticalSearch = function (e) {
						return this.searchService.verticalSearch(e);
					}),
					(t.submitQuestion = function (e) {
						return this.questionSubmissionService.submitQuestion(e);
					}),
					(t.universalAutocomplete = function (e) {
						return this.autoCompleteService.universalAutocomplete(e);
					}),
					(t.verticalAutocomplete = function (e) {
						return this.autoCompleteService.verticalAutocomplete(e);
					}),
					(t.filterSearch = function (e) {
						return this.autoCompleteService.filterSearch(e);
					}),
					e
				);
			})();
			t.AnswersCore = r;
		});
	t(Hs);
	Hs.AnswersCore;
	var zs = r(function (e) {
			!(function (e) {
				var t = Object.prototype,
					r = t.hasOwnProperty,
					n = "function" == typeof Symbol ? Symbol : {},
					i = n.iterator || "@@iterator",
					o = n.asyncIterator || "@@asyncIterator",
					a = n.toStringTag || "@@toStringTag";
				function s(e, t, r, n) {
					var i = t && t.prototype instanceof l ? t : l,
						o = Object.create(i.prototype),
						a = new S(n || []);
					return (
						(o._invoke = (function (e, t, r) {
							var n = "suspendedStart";
							return function (i, o) {
								if ("executing" === n)
									throw new Error("Generator is already running");
								if ("completed" === n) {
									if ("throw" === i) throw o;
									return x();
								}
								for (r.method = i, r.arg = o; ; ) {
									var a = r.delegate;
									if (a) {
										var s = _(a, r);
										if (s) {
											if (s === u) continue;
											return s;
										}
									}
									if ("next" === r.method) r.sent = r._sent = r.arg;
									else if ("throw" === r.method) {
										if ("suspendedStart" === n)
											throw ((n = "completed"), r.arg);
										r.dispatchException(r.arg);
									} else "return" === r.method && r.abrupt("return", r.arg);
									n = "executing";
									var l = c(e, t, r);
									if ("normal" === l.type) {
										if (
											((n = r.done ? "completed" : "suspendedYield"),
											l.arg === u)
										)
											continue;
										return { value: l.arg, done: r.done };
									}
									"throw" === l.type &&
										((n = "completed"), (r.method = "throw"), (r.arg = l.arg));
								}
							};
						})(e, r, a)),
						o
					);
				}
				function c(e, t, r) {
					try {
						return { type: "normal", arg: e.call(t, r) };
					} catch (e) {
						return { type: "throw", arg: e };
					}
				}
				e.wrap = s;
				var u = {};
				function l() {}
				function f() {}
				function h() {}
				var p = {};
				p[i] = function () {
					return this;
				};
				var d = Object.getPrototypeOf,
					v = d && d(d(k([])));
				v && v !== t && r.call(v, i) && (p = v);
				var m = (h.prototype = l.prototype = Object.create(p));
				function g(e) {
					["next", "throw", "return"].forEach(function (t) {
						e[t] = function (e) {
							return this._invoke(t, e);
						};
					});
				}
				function y(e) {
					var t;
					this._invoke = function (n, i) {
						function o() {
							return new Promise(function (t, o) {
								!(function t(n, i, o, a) {
									var s = c(e[n], e, i);
									if ("throw" !== s.type) {
										var u = s.arg,
											l = u.value;
										return l && "object" == typeof l && r.call(l, "__await")
											? Promise.resolve(l.__await).then(
													function (e) {
														t("next", e, o, a);
													},
													function (e) {
														t("throw", e, o, a);
													}
											  )
											: Promise.resolve(l).then(
													function (e) {
														(u.value = e), o(u);
													},
													function (e) {
														return t("throw", e, o, a);
													}
											  );
									}
									a(s.arg);
								})(n, i, t, o);
							});
						}
						return (t = t ? t.then(o, o) : o());
					};
				}
				function _(e, t) {
					var r = e.iterator[t.method];
					if (void 0 === r) {
						if (((t.delegate = null), "throw" === t.method)) {
							if (
								e.iterator.return &&
								((t.method = "return"),
								(t.arg = void 0),
								_(e, t),
								"throw" === t.method)
							)
								return u;
							(t.method = "throw"),
								(t.arg = new TypeError(
									"The iterator does not provide a 'throw' method"
								));
						}
						return u;
					}
					var n = c(r, e.iterator, t.arg);
					if ("throw" === n.type)
						return (
							(t.method = "throw"), (t.arg = n.arg), (t.delegate = null), u
						);
					var i = n.arg;
					return i
						? i.done
							? ((t[e.resultName] = i.value),
							  (t.next = e.nextLoc),
							  "return" !== t.method &&
									((t.method = "next"), (t.arg = void 0)),
							  (t.delegate = null),
							  u)
							: i
						: ((t.method = "throw"),
						  (t.arg = new TypeError("iterator result is not an object")),
						  (t.delegate = null),
						  u);
				}
				function b(e) {
					var t = { tryLoc: e[0] };
					1 in e && (t.catchLoc = e[1]),
						2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
						this.tryEntries.push(t);
				}
				function w(e) {
					var t = e.completion || {};
					(t.type = "normal"), delete t.arg, (e.completion = t);
				}
				function S(e) {
					(this.tryEntries = [{ tryLoc: "root" }]),
						e.forEach(b, this),
						this.reset(!0);
				}
				function k(e) {
					if (e) {
						var t = e[i];
						if (t) return t.call(e);
						if ("function" == typeof e.next) return e;
						if (!isNaN(e.length)) {
							var n = -1,
								o = function t() {
									for (; ++n < e.length; )
										if (r.call(e, n)) return (t.value = e[n]), (t.done = !1), t;
									return (t.value = void 0), (t.done = !0), t;
								};
							return (o.next = o);
						}
					}
					return { next: x };
				}
				function x() {
					return { value: void 0, done: !0 };
				}
				(f.prototype = m.constructor = h),
					(h.constructor = f),
					(h[a] = f.displayName = "GeneratorFunction"),
					(e.isGeneratorFunction = function (e) {
						var t = "function" == typeof e && e.constructor;
						return (
							!!t &&
							(t === f || "GeneratorFunction" === (t.displayName || t.name))
						);
					}),
					(e.mark = function (e) {
						return (
							Object.setPrototypeOf
								? Object.setPrototypeOf(e, h)
								: ((e.__proto__ = h), a in e || (e[a] = "GeneratorFunction")),
							(e.prototype = Object.create(m)),
							e
						);
					}),
					(e.awrap = function (e) {
						return { __await: e };
					}),
					g(y.prototype),
					(y.prototype[o] = function () {
						return this;
					}),
					(e.AsyncIterator = y),
					(e.async = function (t, r, n, i) {
						var o = new y(s(t, r, n, i));
						return e.isGeneratorFunction(r)
							? o
							: o.next().then(function (e) {
									return e.done ? e.value : o.next();
							  });
					}),
					g(m),
					(m[a] = "Generator"),
					(m[i] = function () {
						return this;
					}),
					(m.toString = function () {
						return "[object Generator]";
					}),
					(e.keys = function (e) {
						var t = [];
						for (var r in e) t.push(r);
						return (
							t.reverse(),
							function r() {
								for (; t.length; ) {
									var n = t.pop();
									if (n in e) return (r.value = n), (r.done = !1), r;
								}
								return (r.done = !0), r;
							}
						);
					}),
					(e.values = k),
					(S.prototype = {
						constructor: S,
						reset: function (e) {
							if (
								((this.prev = 0),
								(this.next = 0),
								(this.sent = this._sent = void 0),
								(this.done = !1),
								(this.delegate = null),
								(this.method = "next"),
								(this.arg = void 0),
								this.tryEntries.forEach(w),
								!e)
							)
								for (var t in this)
									"t" === t.charAt(0) &&
										r.call(this, t) &&
										!isNaN(+t.slice(1)) &&
										(this[t] = void 0);
						},
						stop: function () {
							this.done = !0;
							var e = this.tryEntries[0].completion;
							if ("throw" === e.type) throw e.arg;
							return this.rval;
						},
						dispatchException: function (e) {
							if (this.done) throw e;
							var t = this;
							function n(r, n) {
								return (
									(a.type = "throw"),
									(a.arg = e),
									(t.next = r),
									n && ((t.method = "next"), (t.arg = void 0)),
									!!n
								);
							}
							for (var i = this.tryEntries.length - 1; i >= 0; --i) {
								var o = this.tryEntries[i],
									a = o.completion;
								if ("root" === o.tryLoc) return n("end");
								if (o.tryLoc <= this.prev) {
									var s = r.call(o, "catchLoc"),
										c = r.call(o, "finallyLoc");
									if (s && c) {
										if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
										if (this.prev < o.finallyLoc) return n(o.finallyLoc);
									} else if (s) {
										if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
									} else {
										if (!c)
											throw new Error("try statement without catch or finally");
										if (this.prev < o.finallyLoc) return n(o.finallyLoc);
									}
								}
							}
						},
						abrupt: function (e, t) {
							for (var n = this.tryEntries.length - 1; n >= 0; --n) {
								var i = this.tryEntries[n];
								if (
									i.tryLoc <= this.prev &&
									r.call(i, "finallyLoc") &&
									this.prev < i.finallyLoc
								) {
									var o = i;
									break;
								}
							}
							o &&
								("break" === e || "continue" === e) &&
								o.tryLoc <= t &&
								t <= o.finallyLoc &&
								(o = null);
							var a = o ? o.completion : {};
							return (
								(a.type = e),
								(a.arg = t),
								o
									? ((this.method = "next"), (this.next = o.finallyLoc), u)
									: this.complete(a)
							);
						},
						complete: function (e, t) {
							if ("throw" === e.type) throw e.arg;
							return (
								"break" === e.type || "continue" === e.type
									? (this.next = e.arg)
									: "return" === e.type
									? ((this.rval = this.arg = e.arg),
									  (this.method = "return"),
									  (this.next = "end"))
									: "normal" === e.type && t && (this.next = t),
								u
							);
						},
						finish: function (e) {
							for (var t = this.tryEntries.length - 1; t >= 0; --t) {
								var r = this.tryEntries[t];
								if (r.finallyLoc === e)
									return this.complete(r.completion, r.afterLoc), w(r), u;
							}
						},
						catch: function (e) {
							for (var t = this.tryEntries.length - 1; t >= 0; --t) {
								var r = this.tryEntries[t];
								if (r.tryLoc === e) {
									var n = r.completion;
									if ("throw" === n.type) {
										var i = n.arg;
										w(r);
									}
									return i;
								}
							}
							throw new Error("illegal catch attempt");
						},
						delegateYield: function (e, t, r) {
							return (
								(this.delegate = { iterator: k(e), resultName: t, nextLoc: r }),
								"next" === this.method && (this.arg = void 0),
								u
							);
						}
					});
			})(e.exports);
		}),
		Ks = r(function (e, t) {
			fa(t, "__esModule", { value: !0 }),
				(t.createFilter = void 0),
				(t.createFilter = function (e) {
					var t = Ms(e)[0],
						r = Ms(e[t])[0];
					return { fieldId: t, matcher: r, value: e[t][r] };
				});
		});
	t(Ks);
	Ks.createFilter;
	var Zs = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.createFacets = void 0),
			(t.createFacets = function (e) {
				return e
					? Os(e).call(e, function (e) {
							return {
								fieldId: e.fieldId,
								displayName: e.displayName,
								options:
									((t = e.options),
									Os(t).call(t, function (e) {
										var t = Ks.createFilter(Da(e));
										return {
											displayName: e.displayName,
											count: e.count,
											selected: e.selected,
											matcher: t.matcher,
											value: t.value
										};
									}))
							};
							var t;
					  })
					: [];
			});
	});
	t(Zs);
	Zs.createFacets;
	var Qs = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.createLocationBias = void 0),
			(t.createLocationBias = function (e) {
				return {
					latitude: e.latitude,
					longitude: e.longitude,
					displayName: e.locationDisplayName,
					method: e.accuracy
				};
			});
	});
	t(Qs);
	Qs.createLocationBias;
	var Ws = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.createSpellCheck = void 0),
			(t.createSpellCheck = function (e) {
				return {
					originalQuery: e.originalQuery,
					correctedQuery: e.correctedQuery.value,
					type: e.type
				};
			});
	});
	t(Ws);
	Ws.createSpellCheck;
	var Gs = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.Source = void 0),
			(function (e) {
				(e.KnowledgeManager = "KNOWLEDGE_MANAGER"),
					(e.Google = "GOOGLE_CSE"),
					(e.Bing = "BING_CSE"),
					(e.Zendesk = "ZENDESK"),
					(e.Algolia = "ALGOLIA"),
					(e.Generic = "GENERIC");
			})(t.Source || (t.Source = {}));
	});
	t(Gs);
	Gs.Source;
	var $s = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }), (t.ResultsFactory = void 0);
		var r = (function () {
			function e() {}
			return (
				(e.create = function (e, t) {
					var r = this;
					return e
						? Os(e).call(e, function (e, n) {
								var i = n + 1;
								switch (t) {
									case Gs.Source.KnowledgeManager:
										return r.fromKnowledgeManager(e, i);
									case Gs.Source.Google:
										return r.fromGoogleCustomSearchEngine(e, i);
									case Gs.Source.Bing:
										return r.fromBingCustomSearchEngine(e, i);
									case Gs.Source.Zendesk:
										return r.fromZendeskSearchEngine(e, i);
									case Gs.Source.Algolia:
										return r.fromAlgoliaSearchEngine(e, i);
									default:
										return r.fromGeneric(e, i);
								}
						  })
						: [];
				}),
				(e.fromKnowledgeManager = function (e, t) {
					var r,
						n = null !== (r = e.data) && void 0 !== r ? r : e;
					return {
						rawData: n,
						source: Gs.Source.KnowledgeManager,
						index: t,
						name: n.name,
						description: n.description,
						link: n.website,
						id: n.id,
						distance: e.distance,
						distanceFromFilter: e.distanceFromFilter,
						highlightedFields: e.highlightedFields,
						entityType: n.type
					};
				}),
				(e.fromGoogleCustomSearchEngine = function (e, t) {
					var r,
						n = null !== (r = e.data) && void 0 !== r ? r : e;
					return {
						rawData: n,
						source: Gs.Source.Google,
						index: t,
						name: n.htmlTitle.replace(/(<([^>]+)>)/gi, ""),
						description: n.htmlSnippet,
						link: n.link
					};
				}),
				(e.fromBingCustomSearchEngine = function (e, t) {
					var r,
						n = null !== (r = e.data) && void 0 !== r ? r : e;
					return {
						rawData: n,
						source: Gs.Source.Bing,
						index: t,
						name: n.name,
						description: n.snippet,
						link: n.url
					};
				}),
				(e.fromZendeskSearchEngine = function (e, t) {
					var r,
						n = null !== (r = e.data) && void 0 !== r ? r : e;
					return {
						rawData: n,
						source: Gs.Source.Zendesk,
						index: t,
						name: n.title,
						description: n.snippet,
						link: n.html_url
					};
				}),
				(e.fromAlgoliaSearchEngine = function (e, t) {
					var r,
						n = null !== (r = e.data) && void 0 !== r ? r : e;
					return {
						rawData: n,
						source: Gs.Source.Algolia,
						index: t,
						name: n.name,
						id: n.objectID
					};
				}),
				(e.fromGeneric = function (e, t) {
					var r,
						n = null !== (r = e.data) && void 0 !== r ? r : e;
					return {
						rawData: n,
						source: Gs.Source.Generic,
						index: t,
						name: n.name,
						description: n.description,
						link: n.website,
						id: n.id
					};
				}),
				(e.fromDirectAnswer = function (e) {
					var t,
						r = null !== (t = e.fieldValues) && void 0 !== t ? t : {};
					return {
						rawData: r,
						source: Gs.Source.KnowledgeManager,
						name: r.name,
						description: r.description,
						link: e.website,
						id: e.id,
						entityType: e.type
					};
				}),
				e
			);
		})();
		t.ResultsFactory = r;
	});
	t($s);
	$s.ResultsFactory;
	var Js = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.createAppliedQueryFilter = void 0),
			(t.createAppliedQueryFilter = function (e) {
				return {
					displayKey: e.displayKey,
					displayValue: e.displayValue,
					filter: Ks.createFilter(Da(e))
				};
			});
	});
	t(Js);
	Js.createAppliedQueryFilter;
	var Ys = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.createVerticalResults = void 0),
			(t.createVerticalResults = function (e) {
				var t;
				return {
					appliedQueryFilters: e.appliedQueryFilters
						? Os((t = e.appliedQueryFilters)).call(
								t,
								Js.createAppliedQueryFilter
						  )
						: [],
					queryDurationMillis: e.queryDurationMillis,
					results: $s.ResultsFactory.create(e.results, e.source),
					resultsCount: e.resultsCount,
					source: e.source,
					verticalKey: e.verticalConfigId
				};
			});
	});
	t(Ys);
	Ys.createVerticalResults;
	var Xs = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.createVerticalSearchResponse = void 0),
			(t.createVerticalSearchResponse = function e(t) {
				var r, n;
				if (!t.response)
					throw new Error(
						"The search data does not contain a response property"
					);
				return {
					verticalResults: Ys.createVerticalResults(t.response),
					queryId: t.response.queryId,
					searchIntents: t.response.searchIntents,
					facets: Zs.createFacets(t.response.facets),
					spellCheck:
						t.response.spellCheck && Ws.createSpellCheck(t.response.spellCheck),
					locationBias:
						t.response.locationBias &&
						Qs.createLocationBias(t.response.locationBias),
					allResultsForVertical:
						t.response.allResultsForVertical &&
						e({ response: t.response.allResultsForVertical }),
					alternativeVerticals:
						t.response.alternativeVerticals &&
						t.response.alternativeVerticals.modules &&
						Os((r = t.response.alternativeVerticals.modules)).call(
							r,
							Ys.createVerticalResults
						),
					uuid: null === (n = t.meta) || void 0 === n ? void 0 : n.uuid
				};
			});
	});
	t(Xs);
	Xs.createVerticalSearchResponse;
	var ec = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.defaultEndpoints = t.defaultApiVersion = void 0),
			(t.defaultApiVersion = 20190101),
			(t.defaultEndpoints = {
				universalSearch:
					"https://liveapi.yext.com/v2/accounts/me/answers/query",
				verticalSearch:
					"https://liveapi.yext.com/v2/accounts/me/answers/vertical/query",
				questionSubmission:
					"https://api.yext.com/v2/accounts/me/createQuestion",
				status: "https://answersstatus.pagescdn.com",
				universalAutocomplete:
					"https://liveapi-cached.yext.com/v2/accounts/me/answers/autocomplete",
				verticalAutocomplete:
					"https://liveapi-cached.yext.com/v2/accounts/me/answers/vertical/autocomplete",
				filterSearch:
					"https://liveapi-cached.yext.com/v2/accounts/me/answers/filtersearch"
			});
	});
	t(ec);
	ec.defaultEndpoints, ec.defaultApiVersion;
	var tc = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.QuerySource = void 0),
			(function (e) {
				(e.Standard = "STANDARD"), (e.Overlay = "OVERLAY");
			})(t.QuerySource || (t.QuerySource = {}));
	});
	t(tc);
	tc.QuerySource;
	var rc = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.DirectAnswerType = void 0),
			(function (e) {
				(e.FeaturedSnippet = "FEATURED_SNIPPET"),
					(e.FieldValue = "FIELD_VALUE");
			})(t.DirectAnswerType || (t.DirectAnswerType = {}));
	});
	t(rc);
	rc.DirectAnswerType;
	var nc = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.createDirectAnswer = void 0),
			(t.createDirectAnswer = function (e) {
				var t =
						(null == e ? void 0 : e.type) === rc.DirectAnswerType.FieldValue,
					r =
						(null == e ? void 0 : e.type) ===
						rc.DirectAnswerType.FeaturedSnippet;
				if (t)
					return {
						type: rc.DirectAnswerType.FieldValue,
						value: e.answer.value,
						relatedResult: $s.ResultsFactory.fromDirectAnswer(
							e.relatedItem.data
						),
						verticalKey: e.relatedItem.verticalConfigId,
						entityName: e.answer.entityName,
						fieldName: e.answer.fieldName,
						fieldApiName: e.answer.fieldApiName,
						fieldType: e.answer.fieldType
					};
				if (r)
					return {
						type: rc.DirectAnswerType.FeaturedSnippet,
						value: e.answer.value,
						relatedResult: $s.ResultsFactory.fromDirectAnswer(
							e.relatedItem.data
						),
						verticalKey: e.relatedItem.verticalConfigId,
						snippet: e.answer.snippet
					};
				throw new Error(
					"The Answers API returned an unknown direct answer type"
				);
			});
	});
	t(nc);
	nc.createDirectAnswer;
	var ic = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.createUniversalSearchResponse = void 0),
			(t.createUniversalSearchResponse = function (e) {
				var t;
				return {
					verticalResults: As(e.response.modules)
						? Os((t = e.response.modules)).call(t, Ys.createVerticalResults)
						: [],
					queryId: e.response.queryId,
					directAnswer:
						e.response.directAnswer &&
						nc.createDirectAnswer(e.response.directAnswer),
					searchIntents: e.response.searchIntents,
					spellCheck:
						e.response.spellCheck && Ws.createSpellCheck(e.response.spellCheck),
					locationBias:
						e.response.locationBias &&
						Qs.createLocationBias(e.response.locationBias),
					uuid: e.meta.uuid
				};
			});
	});
	t(ic);
	ic.createUniversalSearchResponse;
	var oc = [].slice,
		ac = {},
		sc = function (e, t, r) {
			if (!(t in ac)) {
				for (var n = [], i = 0; i < t; i++) n[i] = "a[" + i + "]";
				ac[t] = Function("C,a", "return new C(" + n.join(",") + ")");
			}
			return ac[t](e, r);
		},
		cc =
			Function.bind ||
			function (e) {
				var t = N(this),
					r = oc.call(arguments, 1),
					n = function () {
						var i = r.concat(oc.call(arguments));
						return this instanceof n ? sc(t, i.length, i) : t.apply(e, i);
					};
				return y(t.prototype) && (n.prototype = t.prototype), n;
			};
	z({ target: "Function", proto: !0 }, { bind: cc });
	var uc = Jo("Function").bind,
		lc = Function.prototype,
		fc = function (e) {
			var t = e.bind;
			return e === lc || (e instanceof Function && t === lc.bind) ? uc : t;
		},
		hc = fc,
		pc = gr,
		dc = ir,
		vc = Je("isConcatSpreadable"),
		mc =
			Ke >= 51 ||
			!a(function () {
				var e = [];
				return (e[vc] = !1), e.concat()[0] !== e;
			}),
		gc = La("concat"),
		yc = function (e) {
			if (!y(e)) return !1;
			var t = e[vc];
			return void 0 !== t ? !!t : ga(e);
		};
	z(
		{ target: "Array", proto: !0, forced: !mc || !gc },
		{
			concat: function (e) {
				var t,
					r,
					n,
					i,
					o,
					a = Te(this),
					s = _a(a, 0),
					c = 0;
				for (t = -1, n = arguments.length; t < n; t++)
					if (yc((o = -1 === t ? a : arguments[t]))) {
						if (c + (i = it(o.length)) > 9007199254740991)
							throw TypeError("Maximum allowed index exceeded");
						for (r = 0; r < i; r++, c++) r in o && rr(s, c, o[r]);
					} else {
						if (c >= 9007199254740991)
							throw TypeError("Maximum allowed index exceeded");
						rr(s, c++, o);
					}
				return (s.length = c), s;
			}
		}
	),
		Za("asyncIterator");
	var _c = Object.freeze({ __proto__: null });
	Za("hasInstance"),
		Za("isConcatSpreadable"),
		Za("iterator"),
		Za("match"),
		Za("matchAll"),
		Za("replace"),
		Za("search"),
		Za("species"),
		Za("split"),
		Za("toPrimitive"),
		Za("toStringTag"),
		Za("unscopables"),
		It(o.JSON, "JSON", !0);
	var bc = Object.freeze({ __proto__: null });
	n(_c), n(bc);
	var wc = j.Symbol,
		Sc = !ki(function (e) {
			Array.from(e);
		});
	z({ target: "Array", stat: !0, forced: Sc }, { from: or });
	var kc = j.Array.from,
		xc = La("slice"),
		Mc = Je("species"),
		Ac = [].slice,
		Ec = Math.max;
	z(
		{ target: "Array", proto: !0, forced: !xc },
		{
			slice: function (e, t) {
				var r,
					n,
					i,
					o = g(this),
					a = it(o.length),
					s = st(e, a),
					c = st(void 0 === t ? a : t, a);
				if (
					ga(o) &&
					("function" != typeof (r = o.constructor) ||
					(r !== Array && !ga(r.prototype))
						? y(r) && null === (r = r[Mc]) && (r = void 0)
						: (r = void 0),
					r === Array || void 0 === r)
				)
					return Ac.call(o, s, c);
				for (
					n = new (void 0 === r ? Array : r)(Ec(c - s, 0)), i = 0;
					s < c;
					s++, i++
				)
					s in o && rr(n, i, o[s]);
				return (n.length = i), n;
			}
		}
	);
	var Cc = Jo("Array").slice,
		Ic = Array.prototype,
		Tc = function (e) {
			var t = e.slice;
			return e === Ic || (e instanceof Array && t === Ic.slice) ? Cc : t;
		};
	function Oc(e, t) {
		var r, n;
		if (void 0 === wc || null == dc(e)) {
			if (
				As(e) ||
				(n = (function (e, t) {
					var r;
					if (!e) return;
					if ("string" == typeof e) return Rc(e, t);
					var n = Tc((r = Object.prototype.toString.call(e))).call(r, 8, -1);
					"Object" === n && e.constructor && (n = e.constructor.name);
					if ("Map" === n || "Set" === n) return kc(e);
					if (
						"Arguments" === n ||
						/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
					)
						return Rc(e, t);
				})(e)) ||
				(t && e && "number" == typeof e.length)
			) {
				n && (e = n);
				var i = 0;
				return function () {
					return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
				};
			}
			throw new TypeError(
				"Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
			);
		}
		return (n = pc(e)), hc((r = n.next)).call(r, n);
	}
	function Rc(e, t) {
		(null == t || t > e.length) && (t = e.length);
		for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
		return n;
	}
	var Fc = r(function (e, t) {
		function r(e) {
			var t, r;
			return ((r = {})[e.fieldId] = (((t = {})[e.matcher] = e.value), t)), r;
		}
		function n(e) {
			return void 0 !== e.filters && void 0 !== e.combinator;
		}
		fa(t, "__esModule", { value: !0 }),
			(t.shapeFilterForApi = t.serializeStaticFilters = void 0),
			(t.serializeStaticFilters = function (e) {
				return n(e)
					? Go(
							(function e(t) {
								for (var i, o, a = [], s = Oc(t.filters); !(o = s()).done; ) {
									var c = o.value;
									n(c) ? a.push(e(c)) : a.push(r(c));
								}
								return 1 === a.length
									? a[0]
									: (((i = {})[t.combinator] = a), i);
							})(e)
					  )
					: Go(r(e));
			}),
			(t.shapeFilterForApi = r);
	});
	t(Fc);
	Fc.shapeFilterForApi, Fc.serializeStaticFilters;
	var Lc = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.serializeFacets = void 0),
			(t.serializeFacets = function (e) {
				return Go(
					Ps(e).call(
						e,
						function (e, t) {
							var r = t.fieldId,
								n = (function (e, t) {
									return Os(e).call(e, function (e) {
										return Fc.shapeFilterForApi(ca(ca({}, e), { fieldId: t }));
									});
								})(t.options, r);
							return (e[r] = n), e;
						},
						{}
					)
				);
			});
	});
	t(Lc);
	Lc.serializeFacets;
	var jc = r(function (t, r) {
		var n =
			(e && e.__awaiter) ||
			function (e, t, r, n) {
				return new (r || (r = Vo))(function (i, o) {
					function a(e) {
						try {
							c(n.next(e));
						} catch (e) {
							o(e);
						}
					}
					function s(e) {
						try {
							c(n.throw(e));
						} catch (e) {
							o(e);
						}
					}
					function c(e) {
						var t;
						e.done
							? i(e.value)
							: ((t = e.value),
							  t instanceof r
									? t
									: new r(function (e) {
											e(t);
									  })).then(a, s);
					}
					c((n = n.apply(e, t || [])).next());
				});
			};
		fa(r, "__esModule", { value: !0 }), (r.SearchServiceImpl = void 0);
		var i = (function () {
			function e(e, t, r) {
				var n, i, o, a;
				(this.config = e),
					(this.httpService = t),
					(this.apiResponseValidator = r),
					(this.universalSearchEndpoint =
						null !==
							(i =
								null === (n = e.endpoints) || void 0 === n
									? void 0
									: n.universalSearch) && void 0 !== i
							? i
							: ec.defaultEndpoints.universalSearch),
					(this.verticalSearchEndpoint =
						null !==
							(a =
								null === (o = e.endpoints) || void 0 === o
									? void 0
									: o.verticalSearch) && void 0 !== a
							? a
							: ec.defaultEndpoints.verticalSearch);
			}
			var t = e.prototype;
			return (
				(t.universalSearch = function (e) {
					var t;
					return n(
						this,
						void 0,
						void 0,
						zs.mark(function r() {
							var n, i, o;
							return zs.wrap(
								function (r) {
									for (;;)
										switch ((r.prev = r.next)) {
											case 0:
												return (
													this.injectToStringMethods(e),
													(n = {
														input: e.query,
														experienceKey: this.config.experienceKey,
														api_key: this.config.apiKey,
														v: ec.defaultApiVersion,
														version: this.config.experienceVersion,
														location:
															null === (t = e.location) || void 0 === t
																? void 0
																: t.toString(),
														locale: this.config.locale,
														skipSpellCheck: e.skipSpellCheck,
														sessionTrackingEnabled: e.sessionTrackingEnabled,
														queryTrigger: e.queryTrigger,
														context: Go(e.context || void 0),
														referrerPageUrl: e.referrerPageUrl,
														source: e.querySource || tc.QuerySource.Standard
													}),
													(r.next = 4),
													this.httpService.get(this.universalSearchEndpoint, n)
												);
											case 4:
												if (
													((i = r.sent),
													!(
														(o = this.apiResponseValidator.validate(
															i
														)) instanceof Error
													))
												) {
													r.next = 8;
													break;
												}
												return r.abrupt("return", Vo.reject(o));
											case 8:
												return r.abrupt(
													"return",
													ic.createUniversalSearchResponse(i)
												);
											case 9:
											case "end":
												return r.stop();
										}
								},
								r,
								this
							);
						})
					);
				}),
				(t.verticalSearch = function (e) {
					var t, r;
					return n(
						this,
						void 0,
						void 0,
						zs.mark(function n() {
							var i, o, a;
							return zs.wrap(
								function (n) {
									for (;;)
										switch ((n.prev = n.next)) {
											case 0:
												return (
													this.injectToStringMethods(e),
													(i = {
														experienceKey: this.config.experienceKey,
														api_key: this.config.apiKey,
														v: ec.defaultApiVersion,
														version: this.config.experienceVersion,
														locale: this.config.locale,
														input: e.query,
														location:
															null === (t = e.location) || void 0 === t
																? void 0
																: t.toString(),
														verticalKey: e.verticalKey,
														filters:
															e.staticFilters &&
															Fc.serializeStaticFilters(e.staticFilters),
														limit: e.limit,
														offset: e.offset,
														retrieveFacets: e.retrieveFacets,
														facetFilters:
															e.facets && Lc.serializeFacets(e.facets),
														skipSpellCheck: e.skipSpellCheck,
														queryTrigger: e.queryTrigger,
														sessionTrackingEnabled: e.sessionTrackingEnabled,
														sortBys: Go(e.sortBys || []),
														context: Go(e.context || void 0),
														referrerPageUrl: e.referrerPageUrl,
														source: e.querySource || tc.QuerySource.Standard,
														locationRadius:
															null === (r = e.locationRadius) || void 0 === r
																? void 0
																: r.toString(),
														queryId: e.queryId
													}),
													(n.next = 4),
													this.httpService.get(this.verticalSearchEndpoint, i)
												);
											case 4:
												if (
													((o = n.sent),
													!(
														(a = this.apiResponseValidator.validate(
															o
														)) instanceof Error
													))
												) {
													n.next = 8;
													break;
												}
												return n.abrupt("return", Vo.reject(a));
											case 8:
												return n.abrupt(
													"return",
													Xs.createVerticalSearchResponse(o)
												);
											case 9:
											case "end":
												return n.stop();
										}
								},
								n,
								this
							);
						})
					);
				}),
				(t.injectToStringMethods = function (e) {
					e.location &&
						(e.location.toString = function () {
							return this.latitude + "," + this.longitude;
						});
				}),
				e
			);
		})();
		r.SearchServiceImpl = i;
	});
	t(jc);
	jc.SearchServiceImpl;
	var Nc = r(function (t, r) {
		var n =
			(e && e.__awaiter) ||
			function (e, t, r, n) {
				return new (r || (r = Vo))(function (i, o) {
					function a(e) {
						try {
							c(n.next(e));
						} catch (e) {
							o(e);
						}
					}
					function s(e) {
						try {
							c(n.throw(e));
						} catch (e) {
							o(e);
						}
					}
					function c(e) {
						var t;
						e.done
							? i(e.value)
							: ((t = e.value),
							  t instanceof r
									? t
									: new r(function (e) {
											e(t);
									  })).then(a, s);
					}
					c((n = n.apply(e, t || [])).next());
				});
			};
		fa(r, "__esModule", { value: !0 }),
			(r.QuestionSubmissionServiceImpl = void 0);
		var i = (function () {
			function e(e, t, r) {
				var n, i;
				(this.config = e),
					(this.httpService = t),
					(this.apiResponseValidator = r),
					(this.endpoint =
						null !==
							(i =
								null === (n = this.config.endpoints) || void 0 === n
									? void 0
									: n.questionSubmission) && void 0 !== i
							? i
							: ec.defaultEndpoints.questionSubmission);
			}
			return (
				(e.prototype.submitQuestion = function (e) {
					return n(
						this,
						void 0,
						void 0,
						zs.mark(function t() {
							var r, n, i, o, a;
							return zs.wrap(
								function (t) {
									for (;;)
										switch ((t.prev = t.next)) {
											case 0:
												return (
													(r = {
														v: ec.defaultApiVersion,
														api_key: this.config.apiKey,
														sessionTrackingEnabled: e.sessionTrackingEnabled
													}),
													(n = {
														email: e.email,
														entityId: e.entityId,
														name: e.name,
														questionDescription: e.questionDescription,
														questionLanguage: this.config.locale,
														questionText: e.questionText,
														site: "FIRSTPARTY"
													}),
													(i = {
														mode: "cors",
														headers: { "Content-Type": "application/json" }
													}),
													(t.next = 5),
													this.httpService.post(this.endpoint, r, n, i)
												);
											case 5:
												if (
													((o = t.sent),
													!(
														(a = this.apiResponseValidator.validate(
															o
														)) instanceof Error
													))
												) {
													t.next = 9;
													break;
												}
												return t.abrupt("return", Vo.reject(a));
											case 9:
												return t.abrupt("return", { uuid: o.meta.uuid });
											case 10:
											case "end":
												return t.stop();
										}
								},
								t,
								this
							);
						})
					);
				}),
				e
			);
		})();
		r.QuestionSubmissionServiceImpl = i;
	});
	t(Nc);
	Nc.QuestionSubmissionServiceImpl;
	var Pc,
		qc = $.trim;
	z(
		{
			target: "String",
			proto: !0,
			forced:
				((Pc = "trim"),
				a(function () {
					return (
						!!K[Pc]() || "â€‹Â…á Ž" != "â€‹Â…á Ž"[Pc]() || K[Pc].name !== Pc
					);
				}))
		},
		{
			trim: function () {
				return qc(this);
			}
		}
	);
	var Dc = Jo("String").trim,
		Bc = String.prototype,
		Uc = function (e) {
			var t = e.trim;
			return "string" == typeof e ||
				e === Bc ||
				(e instanceof String && t === Bc.trim)
				? Dc
				: t;
		},
		Vc = j.URLSearchParams,
		Hc = Jo("Array").entries,
		zc = Array.prototype,
		Kc = { DOMTokenList: !0, NodeList: !0 },
		Zc = function (e) {
			var t = e.entries;
			return e === zc ||
				(e instanceof Array && t === zc.entries) ||
				Kc.hasOwnProperty(Mt(e))
				? Hc
				: t;
		},
		Qc = Ha.f,
		Wc = a(function () {
			return !Object.getOwnPropertyNames(1);
		});
	z({ target: "Object", stat: !0, forced: Wc }, { getOwnPropertyNames: Qc });
	var Gc = j.Object,
		$c = function (e) {
			return Gc.getOwnPropertyNames(e);
		},
		Jc = za.f("iterator"),
		Yc = ut.indexOf,
		Xc = [].indexOf,
		eu = !!Xc && 1 / [1].indexOf(1, -0) < 0,
		tu = ka("indexOf");
	z(
		{ target: "Array", proto: !0, forced: eu || !tu },
		{
			indexOf: function (e) {
				return eu
					? Xc.apply(this, arguments) || 0
					: Yc(this, e, arguments.length > 1 ? arguments[1] : void 0);
			}
		}
	);
	var ru = Jo("Array").indexOf,
		nu = Array.prototype,
		iu = function (e) {
			var t = e.indexOf;
			return e === nu || (e instanceof Array && t === nu.indexOf) ? ru : t;
		},
		ou = iu,
		au = r(function (t, r) {
			var n = (function (e) {
				function t() {
					(this.fetch = !1), (this.DOMException = e.DOMException);
				}
				return (t.prototype = e), new t();
			})("undefined" != typeof self ? self : e);
			!(function (e) {
				!(function (t) {
					var r = "URLSearchParams" in e,
						n = "Symbol" in e && "iterator" in wc,
						i =
							"FileReader" in e &&
							"Blob" in e &&
							(function () {
								try {
									return new Blob(), !0;
								} catch (e) {
									return !1;
								}
							})(),
						o = "FormData" in e,
						a = "ArrayBuffer" in e;
					if (a)
						var s = [
								"[object Int8Array]",
								"[object Uint8Array]",
								"[object Uint8ClampedArray]",
								"[object Int16Array]",
								"[object Uint16Array]",
								"[object Int32Array]",
								"[object Uint32Array]",
								"[object Float32Array]",
								"[object Float64Array]"
							],
							c =
								ArrayBuffer.isView ||
								function (e) {
									return (
										e && ou(s).call(s, Object.prototype.toString.call(e)) > -1
									);
								};
					function u(e) {
						if (
							("string" != typeof e && (e = String(e)),
							/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e))
						)
							throw new TypeError("Invalid character in header field name");
						return e.toLowerCase();
					}
					function l(e) {
						return "string" != typeof e && (e = String(e)), e;
					}
					function f(e) {
						var t = {
							next: function () {
								var t = e.shift();
								return { done: void 0 === t, value: t };
							}
						};
						return (
							n &&
								(t[Jc] = function () {
									return t;
								}),
							t
						);
					}
					function h(e) {
						if (((this.map = {}), e instanceof h))
							Ia(e).call(
								e,
								function (e, t) {
									this.append(t, e);
								},
								this
							);
						else if (As(e))
							Ia(e).call(
								e,
								function (e) {
									this.append(e[0], e[1]);
								},
								this
							);
						else if (e) {
							var t;
							Ia((t = $c(e))).call(
								t,
								function (t) {
									this.append(t, e[t]);
								},
								this
							);
						}
					}
					function p(e) {
						if (e.bodyUsed) return Vo.reject(new TypeError("Already read"));
						e.bodyUsed = !0;
					}
					function d(e) {
						return new Vo(function (t, r) {
							(e.onload = function () {
								t(e.result);
							}),
								(e.onerror = function () {
									r(e.error);
								});
						});
					}
					function v(e) {
						var t = new FileReader(),
							r = d(t);
						return t.readAsArrayBuffer(e), r;
					}
					function m(e) {
						if (Tc(e)) return Tc(e).call(e, 0);
						var t = new Uint8Array(e.byteLength);
						return t.set(new Uint8Array(e)), t.buffer;
					}
					function g() {
						return (
							(this.bodyUsed = !1),
							(this._initBody = function (e) {
								var t;
								(this._bodyInit = e),
									e
										? "string" == typeof e
											? (this._bodyText = e)
											: i && Blob.prototype.isPrototypeOf(e)
											? (this._bodyBlob = e)
											: o && FormData.prototype.isPrototypeOf(e)
											? (this._bodyFormData = e)
											: r && Vc.prototype.isPrototypeOf(e)
											? (this._bodyText = e.toString())
											: a && i && (t = e) && DataView.prototype.isPrototypeOf(t)
											? ((this._bodyArrayBuffer = m(e.buffer)),
											  (this._bodyInit = new Blob([this._bodyArrayBuffer])))
											: a && (ArrayBuffer.prototype.isPrototypeOf(e) || c(e))
											? (this._bodyArrayBuffer = m(e))
											: (this._bodyText = e = Object.prototype.toString.call(e))
										: (this._bodyText = ""),
									this.headers.get("content-type") ||
										("string" == typeof e
											? this.headers.set(
													"content-type",
													"text/plain;charset=UTF-8"
											  )
											: this._bodyBlob && this._bodyBlob.type
											? this.headers.set("content-type", this._bodyBlob.type)
											: r &&
											  Vc.prototype.isPrototypeOf(e) &&
											  this.headers.set(
													"content-type",
													"application/x-www-form-urlencoded;charset=UTF-8"
											  ));
							}),
							i &&
								((this.blob = function () {
									var e = p(this);
									if (e) return e;
									if (this._bodyBlob) return Vo.resolve(this._bodyBlob);
									if (this._bodyArrayBuffer)
										return Vo.resolve(new Blob([this._bodyArrayBuffer]));
									if (this._bodyFormData)
										throw new Error("could not read FormData body as blob");
									return Vo.resolve(new Blob([this._bodyText]));
								}),
								(this.arrayBuffer = function () {
									return this._bodyArrayBuffer
										? p(this) || Vo.resolve(this._bodyArrayBuffer)
										: this.blob().then(v);
								})),
							(this.text = function () {
								var e = p(this);
								if (e) return e;
								if (this._bodyBlob)
									return (function (e) {
										var t = new FileReader(),
											r = d(t);
										return t.readAsText(e), r;
									})(this._bodyBlob);
								if (this._bodyArrayBuffer)
									return Vo.resolve(
										(function (e) {
											for (
												var t = new Uint8Array(e),
													r = new Array(t.length),
													n = 0;
												n < t.length;
												n++
											)
												r[n] = String.fromCharCode(t[n]);
											return r.join("");
										})(this._bodyArrayBuffer)
									);
								if (this._bodyFormData)
									throw new Error("could not read FormData body as text");
								return Vo.resolve(this._bodyText);
							}),
							o &&
								(this.formData = function () {
									return this.text().then(b);
								}),
							(this.json = function () {
								return this.text().then(JSON.parse);
							}),
							this
						);
					}
					(h.prototype.append = function (e, t) {
						(e = u(e)), (t = l(t));
						var r = Os(this)[e];
						Os(this)[e] = r ? r + ", " + t : t;
					}),
						(h.prototype.delete = function (e) {
							delete Os(this)[u(e)];
						}),
						(h.prototype.get = function (e) {
							return (e = u(e)), this.has(e) ? Os(this)[e] : null;
						}),
						(h.prototype.has = function (e) {
							return Os(this).hasOwnProperty(u(e));
						}),
						(h.prototype.set = function (e, t) {
							Os(this)[u(e)] = l(t);
						}),
						(h.prototype.forEach = function (e, t) {
							for (var r in Os(this))
								Os(this).hasOwnProperty(r) && e.call(t, Os(this)[r], r, this);
						}),
						(h.prototype.keys = function () {
							var e,
								t = [];
							return (
								Ia((e = this)).call(e, function (e, r) {
									t.push(r);
								}),
								f(t)
							);
						}),
						(h.prototype.values = function () {
							var e,
								t = [];
							return (
								Ia((e = this)).call(e, function (e) {
									t.push(e);
								}),
								f(t)
							);
						}),
						(h.prototype.entries = function () {
							var e,
								t = [];
							return (
								Ia((e = this)).call(e, function (e, r) {
									t.push([r, e]);
								}),
								f(t)
							);
						}),
						n && (h.prototype[Jc] = Zc(h.prototype));
					var y = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
					function _(e, t) {
						var r,
							n,
							i = (t = t || {}).body;
						if (e instanceof _) {
							if (e.bodyUsed) throw new TypeError("Already read");
							(this.url = e.url),
								(this.credentials = e.credentials),
								t.headers || (this.headers = new h(e.headers)),
								(this.method = e.method),
								(this.mode = e.mode),
								(this.signal = e.signal),
								i ||
									null == e._bodyInit ||
									((i = e._bodyInit), (e.bodyUsed = !0));
						} else this.url = String(e);
						if (
							((this.credentials =
								t.credentials || this.credentials || "same-origin"),
							(!t.headers && this.headers) || (this.headers = new h(t.headers)),
							(this.method =
								((r = t.method || this.method || "GET"),
								(n = r.toUpperCase()),
								ou(y).call(y, n) > -1 ? n : r)),
							(this.mode = t.mode || this.mode || null),
							(this.signal = t.signal || this.signal),
							(this.referrer = null),
							("GET" === this.method || "HEAD" === this.method) && i)
						)
							throw new TypeError("Body not allowed for GET or HEAD requests");
						this._initBody(i);
					}
					function b(e) {
						var t,
							r = new FormData();
						return (
							Ia((t = Uc(e).call(e).split("&"))).call(t, function (e) {
								if (e) {
									var t = e.split("="),
										n = t.shift().replace(/\+/g, " "),
										i = t.join("=").replace(/\+/g, " ");
									r.append(decodeURIComponent(n), decodeURIComponent(i));
								}
							}),
							r
						);
					}
					function w(e, t) {
						t || (t = {}),
							(this.type = "default"),
							(this.status = void 0 === t.status ? 200 : t.status),
							(this.ok = this.status >= 200 && this.status < 300),
							(this.statusText = "statusText" in t ? t.statusText : "OK"),
							(this.headers = new h(t.headers)),
							(this.url = t.url || ""),
							this._initBody(e);
					}
					(_.prototype.clone = function () {
						return new _(this, { body: this._bodyInit });
					}),
						g.call(_.prototype),
						g.call(w.prototype),
						(w.prototype.clone = function () {
							return new w(this._bodyInit, {
								status: this.status,
								statusText: this.statusText,
								headers: new h(this.headers),
								url: this.url
							});
						}),
						(w.error = function () {
							var e = new w(null, { status: 0, statusText: "" });
							return (e.type = "error"), e;
						});
					var S = [301, 302, 303, 307, 308];
					(w.redirect = function (e, t) {
						if (-1 === ou(S).call(S, t))
							throw new RangeError("Invalid status code");
						return new w(null, { status: t, headers: { location: e } });
					}),
						(t.DOMException = e.DOMException);
					try {
						new t.DOMException();
					} catch (e) {
						(t.DOMException = function (e, t) {
							(this.message = e), (this.name = t);
							var r = Error(e);
							this.stack = r.stack;
						}),
							(t.DOMException.prototype = Vs(Error.prototype)),
							(t.DOMException.prototype.constructor = t.DOMException);
					}
					function k(e, r) {
						return new Vo(function (n, o) {
							var a,
								s = new _(e, r);
							if (s.signal && s.signal.aborted)
								return o(new t.DOMException("Aborted", "AbortError"));
							var c = new XMLHttpRequest();
							function u() {
								c.abort();
							}
							(c.onload = function () {
								var e,
									t,
									r,
									i,
									o = {
										status: c.status,
										statusText: c.statusText,
										headers:
											((e = c.getAllResponseHeaders() || ""),
											(r = new h()),
											(i = e.replace(/\r?\n[\t ]+/g, " ")),
											Ia((t = i.split(/\r?\n/))).call(t, function (e) {
												var t,
													n = e.split(":"),
													i = Uc((t = n.shift())).call(t);
												if (i) {
													var o,
														a = Uc((o = n.join(":"))).call(o);
													r.append(i, a);
												}
											}),
											r)
									};
								o.url =
									"responseURL" in c
										? c.responseURL
										: o.headers.get("X-Request-URL");
								var a = "response" in c ? c.response : c.responseText;
								n(new w(a, o));
							}),
								(c.onerror = function () {
									o(new TypeError("Network request failed"));
								}),
								(c.ontimeout = function () {
									o(new TypeError("Network request failed"));
								}),
								(c.onabort = function () {
									o(new t.DOMException("Aborted", "AbortError"));
								}),
								c.open(s.method, s.url, !0),
								"include" === s.credentials
									? (c.withCredentials = !0)
									: "omit" === s.credentials && (c.withCredentials = !1),
								"responseType" in c && i && (c.responseType = "blob"),
								Ia((a = s.headers)).call(a, function (e, t) {
									c.setRequestHeader(t, e);
								}),
								s.signal &&
									(s.signal.addEventListener("abort", u),
									(c.onreadystatechange = function () {
										4 === c.readyState &&
											s.signal.removeEventListener("abort", u);
									})),
								c.send(void 0 === s._bodyInit ? null : s._bodyInit);
						});
					}
					(k.polyfill = !0),
						e.fetch ||
							((e.fetch = k),
							(e.Headers = h),
							(e.Request = _),
							(e.Response = w)),
						(t.Headers = h),
						(t.Request = _),
						(t.Response = w),
						(t.fetch = k);
				})({});
			})(n),
				delete n.fetch.polyfill,
				((r = n.fetch).default = n.fetch),
				(r.fetch = n.fetch),
				(r.Headers = n.Headers),
				(r.Request = n.Request),
				(r.Response = n.Response),
				(t.exports = r);
		}),
		su = au.fetch,
		cu =
			(au.Headers,
			au.Request,
			au.Response,
			r(function (e, t) {
				function r(e) {
					var t;
					return (
						Ia((t = Ms(e))).call(t, function (t) {
							(void 0 !== e[t] && null !== e[t]) || delete e[t];
						}),
						e
					);
				}
				fa(t, "__esModule", { value: !0 }),
					(t.sanitizeQueryParams = t.addParamsToURL = void 0),
					(t.addParamsToURL = function (e, t) {
						var n = new ui(e),
							i = new Vc(n.search.substring(1)),
							o = r(t);
						for (var a in o) i.append(a, o[a].toString());
						var s = n.origin + n.pathname,
							c = i.toString();
						return c && (s += "?" + c), s;
					}),
					(t.sanitizeQueryParams = r);
			}));
	t(cu);
	cu.sanitizeQueryParams, cu.addParamsToURL;
	var uu = r(function (t, r) {
		var n =
			(e && e.__importDefault) ||
			function (e) {
				return e && e.__esModule ? e : { default: e };
			};
		fa(r, "__esModule", { value: !0 }), (r.HttpServiceImpl = void 0);
		var i,
			o = n(au);
		!(function (e) {
			(e.GET = "get"), (e.POST = "post");
		})(i || (i = {}));
		var a = (function () {
			function e() {}
			var t = e.prototype;
			return (
				(t.get = function (e, t, r) {
					var n = ca({ method: i.GET }, r);
					return this.fetch(e, t, n).then(function (e) {
						return e.json();
					});
				}),
				(t.post = function (e, t, r, n) {
					var o = cu.sanitizeQueryParams(r),
						a = ca({ method: i.POST, body: Go(o) }, n);
					return this.fetch(e, t, a).then(function (e) {
						return e.json();
					});
				}),
				(t.fetch = function (e, t, r) {
					var n = cu.addParamsToURL(e, t);
					return o.default(n, r);
				}),
				e
			);
		})();
		r.HttpServiceImpl = a;
	});
	t(uu);
	uu.HttpServiceImpl;
	var lu = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.createAutocompleteResult = void 0),
			(t.createAutocompleteResult = function (e) {
				var t = e.relatedItem
					? $s.ResultsFactory.create(
							[e.relatedItem],
							Gs.Source.KnowledgeManager
					  )[0]
					: e.relatedItem;
				return {
					filter: Da(e) && Ks.createFilter(Da(e)),
					key: e.key,
					matchedSubstrings: e.matchedSubstrings || [],
					value: e.value,
					relatedItem: t
				};
			});
	});
	t(lu);
	lu.createAutocompleteResult;
	var fu = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.createFilterSearchResponse = t.createAutocompleteResponse = void 0),
			(t.createAutocompleteResponse = function (e) {
				var t;
				if (!e.response)
					throw new Error(
						"The autocomplete data does not contain a response property"
					);
				if (!Ms(e.response).length)
					throw new Error("The autocomplete response is empty");
				var r = e.response,
					n = Os((t = r.results)).call(t, lu.createAutocompleteResult),
					i = r.input ? r.input.queryIntents : [];
				return {
					results: n,
					queryId: r.queryId,
					inputIntents: i || [],
					uuid: e.meta.uuid
				};
			}),
			(t.createFilterSearchResponse = function (e) {
				if (!e.response)
					throw new Error(
						"The autocomplete data does not contain a response property"
					);
				if (!Ms(e.response).length)
					throw new Error("The autocomplete response is empty");
				var t,
					r,
					n = e.response,
					i = !1,
					o = [],
					a = [];
				n.sections
					? ((i = !0),
					  (o = Os((t = n.sections)).call(t, function (e) {
							var t;
							return {
								label: e.label,
								results: Os((t = e.results)).call(
									t,
									lu.createAutocompleteResult
								)
							};
					  })))
					: (a = Os((r = n.results)).call(r, lu.createAutocompleteResult));
				var s = n.input ? n.input.queryIntents : [];
				return {
					sectioned: i,
					sections: o,
					results: a,
					queryId: n.queryId,
					inputIntents: s || [],
					uuid: e.meta.uuid
				};
			});
	});
	t(fu);
	fu.createFilterSearchResponse, fu.createAutocompleteResponse;
	var hu = r(function (t, r) {
		var n =
			(e && e.__awaiter) ||
			function (e, t, r, n) {
				return new (r || (r = Vo))(function (i, o) {
					function a(e) {
						try {
							c(n.next(e));
						} catch (e) {
							o(e);
						}
					}
					function s(e) {
						try {
							c(n.throw(e));
						} catch (e) {
							o(e);
						}
					}
					function c(e) {
						var t;
						e.done
							? i(e.value)
							: ((t = e.value),
							  t instanceof r
									? t
									: new r(function (e) {
											e(t);
									  })).then(a, s);
					}
					c((n = n.apply(e, t || [])).next());
				});
			};
		fa(r, "__esModule", { value: !0 }), (r.AutocompleteServiceImpl = void 0);
		var i = (function () {
			function e(e, t, r) {
				var n, i, o, a, s, c;
				(this.config = e),
					(this.httpService = t),
					(this.apiResponseValidator = r),
					(this.universalEndpoint =
						null !==
							(i =
								null === (n = this.config.endpoints) || void 0 === n
									? void 0
									: n.universalAutocomplete) && void 0 !== i
							? i
							: ec.defaultEndpoints.universalAutocomplete),
					(this.verticalEndpoint =
						null !==
							(a =
								null === (o = this.config.endpoints) || void 0 === o
									? void 0
									: o.verticalAutocomplete) && void 0 !== a
							? a
							: ec.defaultEndpoints.verticalAutocomplete),
					(this.filterEndpoint =
						null !==
							(c =
								null === (s = this.config.endpoints) || void 0 === s
									? void 0
									: s.filterSearch) && void 0 !== c
							? c
							: ec.defaultEndpoints.filterSearch);
			}
			var t = e.prototype;
			return (
				(t.universalAutocomplete = function (e) {
					return n(
						this,
						void 0,
						void 0,
						zs.mark(function t() {
							var r, n, i;
							return zs.wrap(
								function (t) {
									for (;;)
										switch ((t.prev = t.next)) {
											case 0:
												return (
													(r = {
														input: e.input,
														experienceKey: this.config.experienceKey,
														api_key: this.config.apiKey,
														v: ec.defaultApiVersion,
														version: this.config.experienceVersion,
														locale: this.config.locale,
														sessionTrackingEnabled: e.sessionTrackingEnabled
													}),
													(t.next = 3),
													this.httpService.get(this.universalEndpoint, r)
												);
											case 3:
												if (
													((n = t.sent),
													!(
														(i = this.apiResponseValidator.validate(
															n
														)) instanceof Error
													))
												) {
													t.next = 7;
													break;
												}
												return t.abrupt("return", Vo.reject(i));
											case 7:
												return t.abrupt(
													"return",
													fu.createAutocompleteResponse(n)
												);
											case 8:
											case "end":
												return t.stop();
										}
								},
								t,
								this
							);
						})
					);
				}),
				(t.verticalAutocomplete = function (e) {
					return n(
						this,
						void 0,
						void 0,
						zs.mark(function t() {
							var r, n, i;
							return zs.wrap(
								function (t) {
									for (;;)
										switch ((t.prev = t.next)) {
											case 0:
												return (
													(r = {
														input: e.input,
														experienceKey: this.config.experienceKey,
														api_key: this.config.apiKey,
														v: ec.defaultApiVersion,
														version: this.config.experienceVersion,
														locale: this.config.locale,
														verticalKey: e.verticalKey,
														sessionTrackingEnabled: e.sessionTrackingEnabled
													}),
													(t.next = 3),
													this.httpService.get(this.verticalEndpoint, r)
												);
											case 3:
												if (
													((n = t.sent),
													!(
														(i = this.apiResponseValidator.validate(
															n
														)) instanceof Error
													))
												) {
													t.next = 7;
													break;
												}
												return t.abrupt("return", Vo.reject(i));
											case 7:
												return t.abrupt(
													"return",
													fu.createAutocompleteResponse(n)
												);
											case 8:
											case "end":
												return t.stop();
										}
								},
								t,
								this
							);
						})
					);
				}),
				(t.filterSearch = function (e) {
					return n(
						this,
						void 0,
						void 0,
						zs.mark(function t() {
							var r, n, i, o;
							return zs.wrap(
								function (t) {
									for (;;)
										switch ((t.prev = t.next)) {
											case 0:
												return (
													(r = {
														sectioned: e.sectioned,
														fields: this.serializeSearchParameterFields(
															e.fields
														)
													}),
													(n = {
														input: e.input,
														experienceKey: this.config.experienceKey,
														api_key: this.config.apiKey,
														v: ec.defaultApiVersion,
														version: this.config.experienceVersion,
														locale: this.config.locale,
														search_parameters: Go(r),
														verticalKey: e.verticalKey,
														sessionTrackingEnabled: e.sessionTrackingEnabled
													}),
													(t.next = 4),
													this.httpService.get(this.filterEndpoint, n)
												);
											case 4:
												if (
													((i = t.sent),
													!(
														(o = this.apiResponseValidator.validate(
															i
														)) instanceof Error
													))
												) {
													t.next = 8;
													break;
												}
												return t.abrupt("return", Vo.reject(o));
											case 8:
												return t.abrupt(
													"return",
													fu.createFilterSearchResponse(i)
												);
											case 9:
											case "end":
												return t.stop();
										}
								},
								t,
								this
							);
						})
					);
				}),
				(t.serializeSearchParameterFields = function (e) {
					return Os(e).call(e, function (e) {
						return {
							fieldId: e.fieldApiName,
							entityTypeId: e.entityType,
							shouldFetchEntities: e.fetchEntities
						};
					});
				}),
				e
			);
		})();
		r.AutocompleteServiceImpl = i;
	});
	t(hu);
	hu.AutocompleteServiceImpl;
	var pu = Sa.find,
		du = !0;
	"find" in [] &&
		Array(1).find(function () {
			du = !1;
		}),
		z(
			{ target: "Array", proto: !0, forced: du },
			{
				find: function (e) {
					return pu(this, e, arguments.length > 1 ? arguments[1] : void 0);
				}
			}
		);
	var vu = Jo("Array").find,
		mu = Array.prototype,
		gu = function (e) {
			var t = e.find;
			return e === mu || (e instanceof Array && t === mu.find) ? vu : t;
		},
		yu = Us;
	z({ target: "Object", stat: !0 }, { setPrototypeOf: Lt });
	var _u = j.Object.setPrototypeOf,
		bu = r(function (e) {
			function t(r, n) {
				return (
					(e.exports = t =
						_u ||
						function (e, t) {
							return (e.__proto__ = t), e;
						}),
					(e.exports.default = e.exports),
					(e.exports.__esModule = !0),
					t(r, n)
				);
			}
			(e.exports = t),
				(e.exports.default = e.exports),
				(e.exports.__esModule = !0);
		});
	t(bu);
	var wu = t(
			r(function (e) {
				(e.exports = function (e, t) {
					(e.prototype = yu(t.prototype)),
						(e.prototype.constructor = e),
						bu(e, t);
				}),
					(e.exports.default = e.exports),
					(e.exports.__esModule = !0);
			})
		),
		Su = !a(function () {
			return Object.isExtensible(Object.preventExtensions({}));
		}),
		ku = r(function (e) {
			var t = B.f,
				r = ge("meta"),
				n = 0,
				i =
					Object.isExtensible ||
					function () {
						return !0;
					},
				o = function (e) {
					t(e, r, { value: { objectID: "O" + ++n, weakData: {} } });
				},
				a = (e.exports = {
					REQUIRED: !1,
					fastKey: function (e, t) {
						if (!y(e))
							return "symbol" == typeof e
								? e
								: ("string" == typeof e ? "S" : "P") + e;
						if (!w(e, r)) {
							if (!i(e)) return "F";
							if (!t) return "E";
							o(e);
						}
						return e[r].objectID;
					},
					getWeakData: function (e, t) {
						if (!w(e, r)) {
							if (!i(e)) return !0;
							if (!t) return !1;
							o(e);
						}
						return e[r].weakData;
					},
					onFreeze: function (e) {
						return Su && a.REQUIRED && i(e) && !w(e, r) && o(e), e;
					}
				});
			be[r] = !0;
		}),
		xu = (ku.REQUIRED, ku.fastKey, ku.getWeakData, ku.onFreeze, B.f),
		Mu = Sa.forEach,
		Au = Ie.set,
		Eu = Ie.getterFor,
		Cu = function (e, t, r) {
			var n,
				i = -1 !== e.indexOf("Map"),
				c = -1 !== e.indexOf("Weak"),
				u = i ? "set" : "add",
				l = o[e],
				f = l && l.prototype,
				h = {};
			if (
				s &&
				"function" == typeof l &&
				(c ||
					(f.forEach &&
						!a(function () {
							new l().entries().next();
						})))
			) {
				n = t(function (t, r) {
					Au(Zt(t, n, e), { type: e, collection: new l() }),
						null != r && fi(r, t[u], { that: t, AS_ENTRIES: i });
				});
				var p = Eu(e);
				Mu(
					[
						"add",
						"clear",
						"delete",
						"forEach",
						"get",
						"has",
						"set",
						"keys",
						"values",
						"entries"
					],
					function (e) {
						var t = "add" == e || "set" == e;
						!(e in f) ||
							(c && "clear" == e) ||
							U(n.prototype, e, function (r, n) {
								var i = p(this).collection;
								if (!t && c && !y(r)) return "get" == e && void 0;
								var o = i[e](0 === r ? 0 : r, n);
								return t ? this : o;
							});
					}
				),
					c ||
						xu(n.prototype, "size", {
							configurable: !0,
							get: function () {
								return p(this).collection.size;
							}
						});
			} else (n = r.getConstructor(t, e, i, u)), (ku.REQUIRED = !0);
			return (
				It(n, e, !1, !0),
				(h[e] = n),
				z({ global: !0, forced: !0 }, h),
				c || r.setStrong(n, e, i),
				n
			);
		},
		Iu = B.f,
		Tu = ku.fastKey,
		Ou = Ie.set,
		Ru = Ie.getterFor,
		Fu = {
			getConstructor: function (e, t, r, n) {
				var i = e(function (e, o) {
						Zt(e, i, t),
							Ou(e, {
								type: t,
								index: bt(null),
								first: void 0,
								last: void 0,
								size: 0
							}),
							s || (e.size = 0),
							null != o && fi(o, e[n], { that: e, AS_ENTRIES: r });
					}),
					o = Ru(t),
					a = function (e, t, r) {
						var n,
							i,
							a = o(e),
							u = c(e, t);
						return (
							u
								? (u.value = r)
								: ((a.last = u = {
										index: (i = Tu(t, !0)),
										key: t,
										value: r,
										previous: (n = a.last),
										next: void 0,
										removed: !1
								  }),
								  a.first || (a.first = u),
								  n && (n.next = u),
								  s ? a.size++ : e.size++,
								  "F" !== i && (a.index[i] = u)),
							e
						);
					},
					c = function (e, t) {
						var r,
							n = o(e),
							i = Tu(t);
						if ("F" !== i) return n.index[i];
						for (r = n.first; r; r = r.next) if (r.key == t) return r;
					};
				return (
					mr(i.prototype, {
						clear: function () {
							for (var e = o(this), t = e.index, r = e.first; r; )
								(r.removed = !0),
									r.previous && (r.previous = r.previous.next = void 0),
									delete t[r.index],
									(r = r.next);
							(e.first = e.last = void 0), s ? (e.size = 0) : (this.size = 0);
						},
						delete: function (e) {
							var t = o(this),
								r = c(this, e);
							if (r) {
								var n = r.next,
									i = r.previous;
								delete t.index[r.index],
									(r.removed = !0),
									i && (i.next = n),
									n && (n.previous = i),
									t.first == r && (t.first = n),
									t.last == r && (t.last = i),
									s ? t.size-- : this.size--;
							}
							return !!r;
						},
						forEach: function (e) {
							for (
								var t,
									r = o(this),
									n = P(e, arguments.length > 1 ? arguments[1] : void 0, 3);
								(t = t ? t.next : r.first);

							)
								for (n(t.value, t.key, this); t && t.removed; ) t = t.previous;
						},
						has: function (e) {
							return !!c(this, e);
						}
					}),
					mr(
						i.prototype,
						r
							? {
									get: function (e) {
										var t = c(this, e);
										return t && t.value;
									},
									set: function (e, t) {
										return a(this, 0 === e ? 0 : e, t);
									}
							  }
							: {
									add: function (e) {
										return a(this, (e = 0 === e ? 0 : e), e);
									}
							  }
					),
					s &&
						Iu(i.prototype, "size", {
							get: function () {
								return o(this).size;
							}
						}),
					i
				);
			},
			setStrong: function (e, t, r) {
				var n = t + " Iterator",
					i = Ru(t),
					o = Ru(n);
				Bt(
					e,
					t,
					function (e, t) {
						Ou(this, {
							type: n,
							target: e,
							state: i(e),
							kind: t,
							last: void 0
						});
					},
					function () {
						for (var e = o(this), t = e.kind, r = e.last; r && r.removed; )
							r = r.previous;
						return e.target && (e.last = r = r ? r.next : e.state.first)
							? "keys" == t
								? { value: r.key, done: !1 }
								: "values" == t
								? { value: r.value, done: !1 }
								: { value: [r.key, r.value], done: !1 }
							: ((e.target = void 0), { value: void 0, done: !0 });
					},
					r ? "entries" : "values",
					!r,
					!0
				),
					vi(t);
			}
		},
		Lu =
			(Cu(
				"Map",
				function (e) {
					return function () {
						return e(this, arguments.length ? arguments[0] : void 0);
					};
				},
				Fu
			),
			j.Map);
	z(
		{ target: "Map", stat: !0 },
		{
			from: function (e) {
				var t,
					r,
					n,
					i,
					o = arguments.length,
					a = o > 1 ? arguments[1] : void 0;
				return (
					N(this),
					(t = void 0 !== a) && N(a),
					null == e
						? new this()
						: ((r = []),
						  t
								? ((n = 0),
								  (i = P(a, o > 2 ? arguments[2] : void 0, 2)),
								  fi(e, function (e) {
										r.push(i(e, n++));
								  }))
								: fi(e, r.push, { that: r }),
						  new this(r))
				);
			}
		}
	);
	z(
		{ target: "Map", stat: !0 },
		{
			of: function () {
				for (var e = arguments.length, t = new Array(e); e--; )
					t[e] = arguments[e];
				return new this(t);
			}
		}
	);
	var ju = function () {
		for (
			var e, t = q(this), r = N(t.delete), n = !0, i = 0, o = arguments.length;
			i < o;
			i++
		)
			(e = r.call(t, arguments[i])), (n = n && e);
		return !!n;
	};
	z(
		{ target: "Map", proto: !0, real: !0, forced: !0 },
		{
			deleteAll: function () {
				return ju.apply(this, arguments);
			}
		}
	);
	z(
		{ target: "Map", proto: !0, real: !0, forced: !0 },
		{
			emplace: function (e, t) {
				var r = q(this),
					n =
						r.has(e) && "update" in t
							? t.update(r.get(e), e, r)
							: t.insert(e, r);
				return r.set(e, n), n;
			}
		}
	);
	var Nu = gr;
	z(
		{ target: "Map", proto: !0, real: !0, forced: !0 },
		{
			every: function (e) {
				var t = q(this),
					r = Nu(t),
					n = P(e, arguments.length > 1 ? arguments[1] : void 0, 3);
				return !fi(
					r,
					function (e, r, i) {
						if (!n(r, e, t)) return i();
					},
					{ AS_ENTRIES: !0, IS_ITERATOR: !0, INTERRUPTED: !0 }
				).stopped;
			}
		}
	),
		z(
			{ target: "Map", proto: !0, real: !0, forced: !0 },
			{
				filter: function (e) {
					var t = q(this),
						r = Nu(t),
						n = P(e, arguments.length > 1 ? arguments[1] : void 0, 3),
						i = new (Mi(t, Pe("Map")))(),
						o = N(i.set);
					return (
						fi(
							r,
							function (e, r) {
								n(r, e, t) && o.call(i, e, r);
							},
							{ AS_ENTRIES: !0, IS_ITERATOR: !0 }
						),
						i
					);
				}
			}
		),
		z(
			{ target: "Map", proto: !0, real: !0, forced: !0 },
			{
				find: function (e) {
					var t = q(this),
						r = Nu(t),
						n = P(e, arguments.length > 1 ? arguments[1] : void 0, 3);
					return fi(
						r,
						function (e, r, i) {
							if (n(r, e, t)) return i(r);
						},
						{ AS_ENTRIES: !0, IS_ITERATOR: !0, INTERRUPTED: !0 }
					).result;
				}
			}
		),
		z(
			{ target: "Map", proto: !0, real: !0, forced: !0 },
			{
				findKey: function (e) {
					var t = q(this),
						r = Nu(t),
						n = P(e, arguments.length > 1 ? arguments[1] : void 0, 3);
					return fi(
						r,
						function (e, r, i) {
							if (n(r, e, t)) return i(e);
						},
						{ AS_ENTRIES: !0, IS_ITERATOR: !0, INTERRUPTED: !0 }
					).result;
				}
			}
		),
		z(
			{ target: "Map", stat: !0 },
			{
				groupBy: function (e, t) {
					var r = new this();
					N(t);
					var n = N(r.has),
						i = N(r.get),
						o = N(r.set);
					return (
						fi(e, function (e) {
							var a = t(e);
							n.call(r, a) ? i.call(r, a).push(e) : o.call(r, a, [e]);
						}),
						r
					);
				}
			}
		);
	z(
		{ target: "Map", proto: !0, real: !0, forced: !0 },
		{
			includes: function (e) {
				return fi(
					Nu(q(this)),
					function (t, r, n) {
						if ((i = r) === (o = e) || (i != i && o != o)) return n();
						var i, o;
					},
					{ AS_ENTRIES: !0, IS_ITERATOR: !0, INTERRUPTED: !0 }
				).stopped;
			}
		}
	),
		z(
			{ target: "Map", stat: !0 },
			{
				keyBy: function (e, t) {
					var r = new this();
					N(t);
					var n = N(r.set);
					return (
						fi(e, function (e) {
							n.call(r, t(e), e);
						}),
						r
					);
				}
			}
		),
		z(
			{ target: "Map", proto: !0, real: !0, forced: !0 },
			{
				keyOf: function (e) {
					return fi(
						Nu(q(this)),
						function (t, r, n) {
							if (r === e) return n(t);
						},
						{ AS_ENTRIES: !0, IS_ITERATOR: !0, INTERRUPTED: !0 }
					).result;
				}
			}
		),
		z(
			{ target: "Map", proto: !0, real: !0, forced: !0 },
			{
				mapKeys: function (e) {
					var t = q(this),
						r = Nu(t),
						n = P(e, arguments.length > 1 ? arguments[1] : void 0, 3),
						i = new (Mi(t, Pe("Map")))(),
						o = N(i.set);
					return (
						fi(
							r,
							function (e, r) {
								o.call(i, n(r, e, t), r);
							},
							{ AS_ENTRIES: !0, IS_ITERATOR: !0 }
						),
						i
					);
				}
			}
		),
		z(
			{ target: "Map", proto: !0, real: !0, forced: !0 },
			{
				mapValues: function (e) {
					var t = q(this),
						r = Nu(t),
						n = P(e, arguments.length > 1 ? arguments[1] : void 0, 3),
						i = new (Mi(t, Pe("Map")))(),
						o = N(i.set);
					return (
						fi(
							r,
							function (e, r) {
								o.call(i, e, n(r, e, t));
							},
							{ AS_ENTRIES: !0, IS_ITERATOR: !0 }
						),
						i
					);
				}
			}
		),
		z(
			{ target: "Map", proto: !0, real: !0, forced: !0 },
			{
				merge: function (e) {
					for (var t = q(this), r = N(t.set), n = 0; n < arguments.length; )
						fi(arguments[n++], r, { that: t, AS_ENTRIES: !0 });
					return t;
				}
			}
		),
		z(
			{ target: "Map", proto: !0, real: !0, forced: !0 },
			{
				reduce: function (e) {
					var t = q(this),
						r = Nu(t),
						n = arguments.length < 2,
						i = n ? void 0 : arguments[1];
					if (
						(N(e),
						fi(
							r,
							function (r, o) {
								n ? ((n = !1), (i = o)) : (i = e(i, o, r, t));
							},
							{ AS_ENTRIES: !0, IS_ITERATOR: !0 }
						),
						n)
					)
						throw TypeError("Reduce of empty map with no initial value");
					return i;
				}
			}
		),
		z(
			{ target: "Map", proto: !0, real: !0, forced: !0 },
			{
				some: function (e) {
					var t = q(this),
						r = Nu(t),
						n = P(e, arguments.length > 1 ? arguments[1] : void 0, 3);
					return fi(
						r,
						function (e, r, i) {
							if (n(r, e, t)) return i();
						},
						{ AS_ENTRIES: !0, IS_ITERATOR: !0, INTERRUPTED: !0 }
					).stopped;
				}
			}
		),
		z(
			{ target: "Map", proto: !0, real: !0, forced: !0 },
			{
				update: function (e, t) {
					var r = q(this),
						n = arguments.length;
					N(t);
					var i = r.has(e);
					if (!i && n < 3) throw TypeError("Updating absent value");
					var o = i ? r.get(e) : N(n > 2 ? arguments[2] : void 0)(e, r);
					return r.set(e, t(o, e, r)), r;
				}
			}
		);
	var Pu = function (e, t) {
		var r,
			n = q(this),
			i = arguments.length > 2 ? arguments[2] : void 0;
		if ("function" != typeof t && "function" != typeof i)
			throw TypeError("At least one callback required");
		return (
			n.has(e)
				? ((r = n.get(e)), "function" == typeof t && ((r = t(r)), n.set(e, r)))
				: "function" == typeof i && ((r = i()), n.set(e, r)),
			r
		);
	};
	z({ target: "Map", proto: !0, real: !0, forced: !0 }, { upsert: Pu }),
		z(
			{ target: "Map", proto: !0, real: !0, forced: !0 },
			{ updateOrInsert: Pu }
		);
	var qu = Lu,
		Du = a(function () {
			Le(1);
		});
	z(
		{ target: "Object", stat: !0, forced: Du, sham: !Oe },
		{
			getPrototypeOf: function (e) {
				return Le(Te(e));
			}
		}
	);
	var Bu = j.Object.getPrototypeOf,
		Uu = r(function (e) {
			function t(r) {
				return (
					(e.exports = t = _u
						? Bu
						: function (e) {
								return e.__proto__ || Bu(e);
						  }),
					(e.exports.default = e.exports),
					(e.exports.__esModule = !0),
					t(r)
				);
			}
			(e.exports = t),
				(e.exports.default = e.exports),
				(e.exports.__esModule = !0);
		});
	t(Uu);
	var Vu = iu,
		Hu = r(function (e) {
			(e.exports = function (e) {
				var t;
				return (
					-1 !== Vu((t = Function.toString.call(e))).call(t, "[native code]")
				);
			}),
				(e.exports.default = e.exports),
				(e.exports.__esModule = !0);
		});
	t(Hu);
	var zu = Pe("Reflect", "construct"),
		Ku = a(function () {
			function e() {}
			return !(zu(function () {}, [], e) instanceof e);
		}),
		Zu = !a(function () {
			zu(function () {});
		}),
		Qu = Ku || Zu;
	z(
		{ target: "Reflect", stat: !0, forced: Qu, sham: Qu },
		{
			construct: function (e, t) {
				N(e), q(t);
				var r = arguments.length < 3 ? e : N(arguments[2]);
				if (Zu && !Ku) return zu(e, t, r);
				if (e == r) {
					switch (t.length) {
						case 0:
							return new e();
						case 1:
							return new e(t[0]);
						case 2:
							return new e(t[0], t[1]);
						case 3:
							return new e(t[0], t[1], t[2]);
						case 4:
							return new e(t[0], t[1], t[2], t[3]);
					}
					var n = [null];
					return n.push.apply(n, t), new (cc.apply(e, n))();
				}
				var i = r.prototype,
					o = bt(y(i) ? i : Object.prototype),
					a = Function.apply.call(e, o, t);
				return y(a) ? a : o;
			}
		}
	);
	var Wu = j.Reflect.construct,
		Gu = fc,
		$u = r(function (e) {
			(e.exports = function () {
				if ("undefined" == typeof Reflect || !Wu) return !1;
				if (Wu.sham) return !1;
				if ("function" == typeof Proxy) return !0;
				try {
					return (
						Boolean.prototype.valueOf.call(Wu(Boolean, [], function () {})), !0
					);
				} catch (e) {
					return !1;
				}
			}),
				(e.exports.default = e.exports),
				(e.exports.__esModule = !0);
		});
	t($u);
	var Ju = r(function (e) {
		function t(r, n, i) {
			return (
				$u()
					? ((e.exports = t = Wu),
					  (e.exports.default = e.exports),
					  (e.exports.__esModule = !0))
					: ((e.exports = t = function (e, t, r) {
							var n = [null];
							n.push.apply(n, t);
							var i = new (Gu(Function).apply(e, n))();
							return r && bu(i, r.prototype), i;
					  }),
					  (e.exports.default = e.exports),
					  (e.exports.__esModule = !0)),
				t.apply(null, arguments)
			);
		}
		(e.exports = t),
			(e.exports.default = e.exports),
			(e.exports.__esModule = !0);
	});
	t(Ju);
	var Yu = t(
			r(function (e) {
				function t(r) {
					var n = "function" == typeof qu ? new qu() : void 0;
					return (
						(e.exports = t = function (e) {
							if (null === e || !Hu(e)) return e;
							if ("function" != typeof e)
								throw new TypeError(
									"Super expression must either be null or a function"
								);
							if (void 0 !== n) {
								if (n.has(e)) return n.get(e);
								n.set(e, t);
							}
							function t() {
								return Ju(e, arguments, Uu(this).constructor);
							}
							return (
								(t.prototype = yu(e.prototype, {
									constructor: {
										value: t,
										enumerable: !1,
										writable: !0,
										configurable: !0
									}
								})),
								bu(t, e)
							);
						}),
						(e.exports.default = e.exports),
						(e.exports.__esModule = !0),
						t(r)
					);
				}
				(e.exports = t),
					(e.exports.default = e.exports),
					(e.exports.__esModule = !0);
			})
		),
		Xu = r(function (e, t) {
			fa(t, "__esModule", { value: !0 }), (t.AnswersError = void 0);
			var r = (function (e) {
				function t(t, r, n) {
					var i;
					return (
						((i = e.call(this, t) || this).message = t),
						(i.code = r),
						(i.type = n),
						i
					);
				}
				return wu(t, e), t;
			})(Yu(Error));
			t.AnswersError = r;
		});
	t(Xu);
	Xu.AnswersError;
	var el = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }), (t.ApiResponseValidator = void 0);
		var r = (function () {
			function e() {}
			var t = e.prototype;
			return (
				(t.validate = function (e) {
					var t = [
							this.validateResponseProp,
							this.validateMetaProp,
							this.checkForApiErrors
						],
						r = Os(t).call(t, function (t) {
							return t(e);
						});
					return gu(r).call(r, function (e) {
						return e instanceof Xu.AnswersError;
					});
				}),
				(t.validateResponseProp = function (e) {
					if (!e.response)
						return new Xu.AnswersError(
							"Malformed Answers API response: missing response property."
						);
				}),
				(t.validateMetaProp = function (e) {
					if (!e.meta)
						return new Xu.AnswersError(
							"Malformed Answers API response: missing meta property."
						);
				}),
				(t.checkForApiErrors = function (e) {
					var t, r;
					if (
						(null ===
							(r = null === (t = e.meta) || void 0 === t ? void 0 : t.errors) ||
						void 0 === r
							? void 0
							: r.length) >= 1
					) {
						var n = e.meta.errors[0];
						return new Xu.AnswersError(n.message, n.code, n.type);
					}
				}),
				e
			);
		})();
		t.ApiResponseValidator = r;
	});
	t(el);
	el.ApiResponseValidator;
	var tl = r(function (e, t) {
		fa(t, "__esModule", { value: !0 });
	});
	t(tl);
	var rl = r(function (e, t) {
		fa(t, "__esModule", { value: !0 });
	});
	t(rl);
	var nl = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.Matcher = void 0),
			(function (e) {
				(e.Equals = "$eq"),
					(e.NotEquals = "!$eq"),
					(e.LessThan = "$lt"),
					(e.LessThanOrEqualTo = "$le"),
					(e.GreaterThan = "$gt"),
					(e.GreaterThanOrEqualTo = "$ge"),
					(e.Near = "$near");
			})(t.Matcher || (t.Matcher = {}));
	});
	t(nl);
	nl.Matcher;
	var il = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.FilterCombinator = void 0),
			(function (e) {
				(e.AND = "$and"), (e.OR = "$or");
			})(t.FilterCombinator || (t.FilterCombinator = {}));
	});
	t(il);
	il.FilterCombinator;
	var ol = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.QueryTrigger = void 0),
			(function (e) {
				(e.Initialize = "initialize"), (e.Suggest = "suggest");
			})(t.QueryTrigger || (t.QueryTrigger = {}));
	});
	t(ol);
	ol.QueryTrigger;
	var al = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.SortType = void 0),
			(function (e) {
				(e.Field = "FIELD"),
					(e.EntityDistance = "ENTITY_DISTANCE"),
					(e.Relevance = "RELEVANCE");
			})(t.SortType || (t.SortType = {}));
	});
	t(al);
	al.SortType;
	var sl = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.Direction = void 0),
			(function (e) {
				(e.Ascending = "ASC"), (e.Descending = "DESC");
			})(t.Direction || (t.Direction = {}));
	});
	t(sl);
	sl.Direction;
	var cl = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.LocationBiasMethod = void 0),
			(function (e) {
				(e.Ip = "IP"), (e.Device = "DEVICE"), (e.Unknown = "UNKNOWN");
			})(t.LocationBiasMethod || (t.LocationBiasMethod = {}));
	});
	t(cl);
	cl.LocationBiasMethod;
	var ul = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.SearchIntent = void 0),
			(function (e) {
				e.NearMe = "NEAR_ME";
			})(t.SearchIntent || (t.SearchIntent = {}));
	});
	t(ul);
	ul.SearchIntent;
	var ll = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.SpellCheckType = void 0),
			(function (e) {
				(e.Suggest = "SUGGEST"),
					(e.AutoCorrect = "AUTOCORRECT"),
					(e.Combine = "COMBINE");
			})(t.SpellCheckType || (t.SpellCheckType = {}));
	});
	t(ll);
	ll.SpellCheckType;
	var fl = r(function (t, r) {
		var n =
				(e && e.__createBinding) ||
				(Vs
					? function (e, t, r, n) {
							void 0 === n && (n = r),
								fa(e, n, {
									enumerable: !0,
									get: function () {
										return t[r];
									}
								});
					  }
					: function (e, t, r, n) {
							void 0 === n && (n = r), (e[n] = t[r]);
					  }),
			i =
				(e && e.__exportStar) ||
				function (e, t) {
					for (var r in e)
						"default" === r ||
							Object.prototype.hasOwnProperty.call(t, r) ||
							n(t, e, r);
				};
		fa(r, "__esModule", { value: !0 }),
			(r.SpellCheckType = r.Source = r.SearchIntent = r.LocationBiasMethod = r.DirectAnswerType = r.Direction = r.SortType = r.QueryTrigger = r.QuerySource = r.FilterCombinator = r.Matcher = r.AnswersError = void 0),
			fa(r, "AnswersError", {
				enumerable: !0,
				get: function () {
					return Xu.AnswersError;
				}
			}),
			i(tl, r),
			i(rl, r),
			fa(r, "Matcher", {
				enumerable: !0,
				get: function () {
					return nl.Matcher;
				}
			}),
			fa(r, "FilterCombinator", {
				enumerable: !0,
				get: function () {
					return il.FilterCombinator;
				}
			}),
			fa(r, "QuerySource", {
				enumerable: !0,
				get: function () {
					return tc.QuerySource;
				}
			}),
			fa(r, "QueryTrigger", {
				enumerable: !0,
				get: function () {
					return ol.QueryTrigger;
				}
			}),
			fa(r, "SortType", {
				enumerable: !0,
				get: function () {
					return al.SortType;
				}
			}),
			fa(r, "Direction", {
				enumerable: !0,
				get: function () {
					return sl.Direction;
				}
			}),
			fa(r, "DirectAnswerType", {
				enumerable: !0,
				get: function () {
					return rc.DirectAnswerType;
				}
			}),
			fa(r, "LocationBiasMethod", {
				enumerable: !0,
				get: function () {
					return cl.LocationBiasMethod;
				}
			}),
			fa(r, "SearchIntent", {
				enumerable: !0,
				get: function () {
					return ul.SearchIntent;
				}
			}),
			fa(r, "Source", {
				enumerable: !0,
				get: function () {
					return Gs.Source;
				}
			}),
			fa(r, "SpellCheckType", {
				enumerable: !0,
				get: function () {
					return ll.SpellCheckType;
				}
			});
	});
	t(fl);
	fl.SpellCheckType,
		fl.Source,
		fl.SearchIntent,
		fl.LocationBiasMethod,
		fl.DirectAnswerType,
		fl.Direction,
		fl.SortType,
		fl.QueryTrigger,
		fl.QuerySource,
		fl.FilterCombinator,
		fl.Matcher,
		fl.AnswersError;
	var hl = r(function (t, r) {
		var n =
				(e && e.__createBinding) ||
				(Vs
					? function (e, t, r, n) {
							void 0 === n && (n = r),
								fa(e, n, {
									enumerable: !0,
									get: function () {
										return t[r];
									}
								});
					  }
					: function (e, t, r, n) {
							void 0 === n && (n = r), (e[n] = t[r]);
					  }),
			i =
				(e && e.__exportStar) ||
				function (e, t) {
					for (var r in e)
						"default" === r ||
							Object.prototype.hasOwnProperty.call(t, r) ||
							n(t, e, r);
				};
		fa(r, "__esModule", { value: !0 }),
			(r.AnswersCore = r.provideCore = void 0),
			fa(r, "AnswersCore", {
				enumerable: !0,
				get: function () {
					return Hs.AnswersCore;
				}
			}),
			(r.provideCore = function (e) {
				var t = new uu.HttpServiceImpl(),
					r = new el.ApiResponseValidator(),
					n = new jc.SearchServiceImpl(e, t, r),
					i = new Nc.QuestionSubmissionServiceImpl(e, t, r),
					o = new hu.AutocompleteServiceImpl(e, t, r);
				return new Hs.AnswersCore(n, i, o);
			}),
			i(fl, r);
	});
	t(hl);
	hl.AnswersCore;
	var pl = hl.provideCore,
		dl = "search-loading",
		vl = "search-complete",
		ml = Jo("Array").concat,
		gl = Array.prototype,
		yl = function (e) {
			var t = e.concat;
			return e === gl || (e instanceof Array && t === gl.concat) ? ml : t;
		},
		_l = ku.onFreeze,
		bl = Object.freeze,
		wl = a(function () {
			bl(1);
		});
	z(
		{ target: "Object", stat: !0, forced: wl, sham: !Su },
		{
			freeze: function (e) {
				return bl && y(e) ? bl(_l(e)) : e;
			}
		}
	);
	var Sl = j.Object.freeze,
		kl = (function (e) {
			function t(r, n, i, o) {
				var a;
				return (
					void 0 === i && (i = "unknown"),
					((a = e.call(this, n) || this).errorCode = r),
					(a.errorMessage = n),
					(a.boundary = i),
					(a.reported = !1),
					o &&
						((a.causedBy = o instanceof t ? o : t.from(o)),
						(a.stack = a.stack + "\nCaused By: " + a.causedBy.stack)),
					a
				);
			}
			wu(t, e);
			var r = t.prototype;
			return (
				(r.toJson = function () {
					return Go(this);
				}),
				(r.toString = function () {
					var e = this.errorMessage + " (" + this.boundary + ")";
					return (
						this.causedBy &&
							(e += "\n  Caused By: " + this.causedBy.toString()),
						e
					);
				}),
				(t.from = function (e, t) {
					var r = new xl(e.message, t);
					return (r.stack = e.stack), r;
				}),
				t
			);
		})(Yu(Error)),
		xl = (function (e) {
			function t(t, r, n) {
				return e.call(this, 100, t, r, n) || this;
			}
			return wu(t, e), t;
		})(kl),
		Ml = (function (e) {
			function t(t, r, n) {
				return e.call(this, 101, t, r, n) || this;
			}
			return wu(t, e), t;
		})(kl),
		Al = (function (e) {
			function t(t, r, n) {
				return e.call(this, 201, t, r, n) || this;
			}
			return wu(t, e), t;
		})(kl),
		El = (function (e) {
			function t(t, r, n) {
				return e.call(this, 400, t, r, n) || this;
			}
			return wu(t, e), t;
		})(kl),
		Cl = (function (e) {
			function t(t, r, n, i) {
				var o;
				return (
					((o = e.call(this, 401, t, "Storage", i) || this).storageKey = r),
					(o.data = n),
					o
				);
			}
			return wu(t, e), t;
		})(kl),
		Il = (function (e) {
			function t(t, r, n) {
				var i;
				return (
					((i = e.call(this, 402, t, "Analytics", n) || this).event = r), i
				);
			}
			return wu(t, e), t;
		})(kl),
		Tl = (function () {
			function e(t, r, n) {
				void 0 === t && (t = {}),
					(this.searchState = vl),
					(this.verticalConfigId = t.verticalConfigId || null),
					(this.resultsCount = t.resultsCount || 0),
					(this.encodedState = t.encodedState || ""),
					(this.appliedQueryFilters = t.appliedQueryFilters),
					(this.facets = t.facets || null),
					(this.results = t.results),
					(this.map = e.parseMap(t.results)),
					(this.verticalURL = r || null),
					(this.resultsContext = n);
			}
			return (
				(e.parseMap = function (e) {
					if (!e) return {};
					for (var t = [], r = {}, n = 0; n < e.length; n++) {
						var i = e[n]._raw;
						i &&
							i.yextDisplayCoordinate &&
							(r.latitude ||
								(r = {
									latitude: i.yextDisplayCoordinate.latitude,
									longitude: i.yextDisplayCoordinate.longitude
								}),
							t.push({
								item: i,
								label: t.length + 1,
								latitude: i.yextDisplayCoordinate.latitude,
								longitude: i.yextDisplayCoordinate.longitude
							}));
					}
					return { mapCenter: r, mapMarkers: t };
				}),
				e
			);
		})(),
		Ol = Sa.every,
		Rl = ka("every");
	z(
		{ target: "Array", proto: !0, forced: !Rl },
		{
			every: function (e) {
				return Ol(this, e, arguments.length > 1 ? arguments[1] : void 0);
			}
		}
	);
	var Fl = Jo("Array").every,
		Ll = Array.prototype,
		jl = function (e) {
			var t = e.every;
			return e === Ll || (e instanceof Array && t === Ll.every) ? Fl : t;
		},
		Nl =
			(Cu(
				"Set",
				function (e) {
					return function () {
						return e(this, arguments.length ? arguments[0] : void 0);
					};
				},
				Fu
			),
			j.Set),
		Pl = "$and",
		ql = "$or",
		Dl = "$eq",
		Bl = "$lt",
		Ul = "$le",
		Vl = "$gt",
		Hl = "$ge",
		zl = "$near",
		Kl = new Nl([Vl, Hl, Ul, Bl]),
		Zl = (function () {
			function e(e) {
				void 0 === e && (e = {}), ca(this, e), Sl(this);
			}
			var t = e.prototype;
			return (
				(t.getFilterKey = function () {
					if (Ms(this).length > 0) return Ms(this)[0];
				}),
				(t.isRangeFilter = function () {
					var e = this.getFilterKey();
					if (!e) return !1;
					var t = Ms(this[e]);
					return jl(t).call(t, function (e) {
						return Kl.has(e);
					});
				}),
				(e.empty = function () {
					return new e();
				}),
				(e.from = function (t) {
					return new e(t);
				}),
				(e.fromCoreSimpleFilter = function (t) {
					var r, n;
					return t
						? new e(
								(((n = {})[t.fieldId] = (((r = {})[t.matcher] = t.value), r)),
								n)
						  )
						: this.empty();
				}),
				(e.fromResponse = function (t) {
					return new e(JSON.parse(t));
				}),
				(e.or = function () {
					for (var t, r = arguments.length, n = new Array(r), i = 0; i < r; i++)
						n[i] = arguments[i];
					return new e((((t = {})[ql] = n), t));
				}),
				(e.and = function () {
					for (var t, r = arguments.length, n = new Array(r), i = 0; i < r; i++)
						n[i] = arguments[i];
					return new e((((t = {})[Pl] = n), t));
				}),
				(e.range = function (t, r, n, i) {
					var o = null == r || "" === r,
						a = null == n || "" === n;
					return o && a
						? e.empty()
						: a
						? i
							? e.greaterThan(t, r)
							: e.greaterThanEqual(t, r)
						: o
						? i
							? e.lessThan(t, n)
							: e.lessThanEqual(t, n)
						: r === n
						? i
							? e.empty()
							: e.equal(t, r)
						: i
						? e.exclusiveRange(t, r, n)
						: e.inclusiveRange(t, r, n);
				}),
				(e.equal = function (t, r) {
					return e._fromMatcher(t, Dl, r);
				}),
				(e.lessThan = function (t, r) {
					return e._fromMatcher(t, Bl, r);
				}),
				(e.lessThanEqual = function (t, r) {
					return e._fromMatcher(t, Ul, r);
				}),
				(e.greaterThan = function (t, r) {
					return e._fromMatcher(t, Vl, r);
				}),
				(e.greaterThanEqual = function (t, r) {
					return e._fromMatcher(t, Hl, r);
				}),
				(e.inclusiveRange = function (t, r, n) {
					var i, o;
					return new e(
						(((o = {})[t] = (((i = {})[Hl] = r), (i[Ul] = n), i)), o)
					);
				}),
				(e.exclusiveRange = function (t, r, n) {
					var i, o;
					return new e(
						(((o = {})[t] = (((i = {})[Vl] = r), (i[Bl] = n), i)), o)
					);
				}),
				(e.position = function (t, r, n) {
					return e._fromMatcher("builtin.location", zl, {
						lat: t,
						lng: r,
						radius: n
					});
				}),
				(e._fromMatcher = function (t, r, n) {
					var i, o;
					return new e((((o = {})[t] = (((i = {})[r] = n), i)), o));
				}),
				e
			);
		})(),
		Ql = (function () {
			function e(e) {
				void 0 === e && (e = {}),
					(this.key = e.key),
					(this.value = e.value),
					(this.filter = Da(e)),
					(this.fieldId = e.fieldId);
			}
			return (
				(e.fromCore = function (t) {
					return t
						? new e({
								key: t.displayKey,
								value: t.displayValue,
								filter: Zl.fromCoreSimpleFilter(Da(t)),
								fieldId: Da(t).fieldId
						  })
						: new e();
				}),
				e
			);
		})(),
		Wl = l.f,
		Gl = function (e) {
			return function (t) {
				for (var r, n = g(t), i = pt(n), o = i.length, a = 0, c = []; o > a; )
					(r = i[a++]), (s && !Wl.call(n, r)) || c.push(e ? [r, n[r]] : n[r]);
				return c;
			};
		},
		$l = { entries: Gl(!0), values: Gl(!1) }.entries;
	z(
		{ target: "Object", stat: !0 },
		{
			entries: function (e) {
				return $l(e);
			}
		}
	);
	var Jl = j.Object.entries,
		Yl = [],
		Xl = Yl.sort,
		ef = a(function () {
			Yl.sort(void 0);
		}),
		tf = a(function () {
			Yl.sort(null);
		}),
		rf = ka("sort");
	z(
		{ target: "Array", proto: !0, forced: ef || !tf || !rf },
		{
			sort: function (e) {
				return void 0 === e ? Xl.call(Te(this)) : Xl.call(Te(this), N(e));
			}
		}
	);
	var nf = Jo("Array").sort,
		of = Array.prototype,
		af = function (e) {
			var t = e.sort;
			return e === of || (e instanceof Array && t === of.sort) ? nf : t;
		},
		sf = (function () {
			function e(e) {
				void 0 === e && (e = {}),
					(this.value = e.value || e.shortValue || ""),
					(this.matchedSubstrings = e.matchedSubstrings || []);
			}
			var t = e.prototype;
			return (
				(t.get = function () {
					return (
						this._sortMatchedSubstrings(),
						this.buildHighlightedValue(this.value, this.matchedSubstrings)
					);
				}),
				(t.getWithTransformFunction = function (e) {
					return (
						this._sortMatchedSubstrings(),
						this.buildHighlightedValue(this.value, this.matchedSubstrings, e)
					);
				}),
				(t.getInverted = function () {
					this._sortMatchedSubstrings();
					var e = this._getInvertedSubstrings(
						this.matchedSubstrings,
						this.value.length
					);
					return this.buildHighlightedValue(this.value, e);
				}),
				(t.getInvertedWithTransformFunction = function (e) {
					this._sortMatchedSubstrings();
					var t = this._getInvertedSubstrings(
						this.matchedSubstrings,
						this.value.length
					);
					return this.buildHighlightedValue(this.value, t, e);
				}),
				(t.buildHighlightedValue = function (e, t, r) {
					void 0 === r &&
						(r = function (e) {
							return e;
						});
					var n = "",
						i = 0;
					if (0 === t.length) return r(e);
					for (var o = 0; o < t.length; o++) {
						var a = Number(t[o].offset),
							s = a + t[o].length;
						(n += [
							r(Tc(e).call(e, i, a)),
							"<strong>",
							r(Tc(e).call(e, a, s)),
							"</strong>"
						].join("")),
							o === t.length - 1 && s < e.length && (n += r(Tc(e).call(e, s))),
							(i = s);
					}
					return n;
				}),
				(t._sortMatchedSubstrings = function () {
					var e;
					af((e = this.matchedSubstrings)).call(e, function (e, t) {
						return e.offset < t.offset ? -1 : e.offset > t.offset ? 1 : 0;
					});
				}),
				(t._getInvertedSubstrings = function (e, t) {
					for (var r = [], n = 0; n < e.length; n++) {
						var i = e[n],
							o = i.offset + i.length;
						0 === n &&
							0 !== i.offset &&
							r.push({ offset: 0, length: i.offset }),
							t > o &&
								r.push({
									offset: o,
									length: n < e.length - 1 ? e[n + 1].offset - o : t - o
								});
					}
					return r;
				}),
				e
			);
		})(),
		cf = (function () {
			function e(e) {
				void 0 === e && (e = {}), ca(this, e);
			}
			return (
				(e.fromCore = function (t) {
					return t && "object" == typeof t
						? new e(this.computeHighlightedDataRecursively(t))
						: {};
				}),
				(e.computeHighlightedDataRecursively = function (e) {
					var t,
						r = this;
					if (this.isHighlightedFieldLeafNode(e)) {
						var n = e.value,
							i = e.matchedSubstrings;
						return new sf().buildHighlightedValue(n, i);
					}
					return As(e)
						? Os(e).call(e, function (e) {
								return r.computeHighlightedDataRecursively(e);
						  })
						: Ps((t = Jl(e))).call(
								t,
								function (e, t) {
									var n = t[0],
										i = t[1];
									return (e[n] = r.computeHighlightedDataRecursively(i)), e;
								},
								{}
						  );
				}),
				(e.isHighlightedFieldLeafNode = function (e) {
					var t = e.matchedSubstrings,
						r = e.value;
					return void 0 !== t && void 0 !== r;
				}),
				e
			);
		})(),
		uf = function (e) {
			void 0 === e && (e = {}), ca(this, e);
		};
	var lf = (function () {
			function e(e) {
				void 0 === e && (e = {}),
					(this._raw = e.raw || null),
					(this._formatted = e.formatted),
					(this._highlighted = e.highlighted),
					(this.highlightedFields = e.highlightedFields),
					(this.ordinal = e.ordinal || null),
					(this.title = e.title || null),
					(this.details = e.details || null),
					(this.link = e.link || null),
					(this.id = e.id || null),
					(this.subtitle = e.subtitle || null),
					(this.modifier = e.modifier || null),
					(this.bigDate = e.bigDate || null),
					(this.image = e.image || null),
					(this.callsToAction = e.callsToAction || []),
					(this.collapsed = void 0 === e.collapsed || e.collapsed),
					(this.distance = e.distance || null),
					(this.distanceFromFilter = e.distanceFromFilter || null);
			}
			return (
				(e.fromCore = function (t, r, n) {
					var i = new uf(t.highlightedFields),
						o = cf.fromCore(t.highlightedFields),
						a = (function (e, t, r, n) {
							if (
								(void 0 === t && (t = 250),
								void 0 === r && (r = "..."),
								void 0 === n && (n = " "),
								!e || e.length <= t)
							)
								return e;
							for (
								var i = e.split(n), o = t - r.length, a = "", s = 0;
								s < i.length;
								s++
							) {
								var c = i[s];
								if (
									a.length + c.length > o ||
									(0 !== s && a.length + c.length + n.length > o)
								) {
									a += r;
									break;
								}
								a += 0 === s ? c : n + c;
							}
							return a;
						})(o.description || t.description),
						s = {
							raw: t.rawData,
							ordinal: t.index,
							title: t.name,
							details: a,
							link: t.link,
							id: t.id,
							distance: t.distance,
							distanceFromFilter: t.distanceFromFilter,
							highlighted: o,
							highlightedFields: i
						};
					if ("KNOWLEDGE_MANAGER" !== t.source) return new e(s);
					var c = this._getFormattedData(s, r, n);
					return (
						(s.formatted = c),
						void 0 !== c.description && (s.details = c.description),
						new e(s)
					);
				}),
				(e._getFormattedData = function (e, t, r) {
					var n,
						i = {};
					return t && e.raw
						? (0 === Ms(t).length ||
								Ia((n = Jl(e.raw))).call(n, function (n) {
									var o = n[0],
										a = n[1];
									if (void 0 !== t[o]) {
										if ("function" != typeof t[o])
											throw new El(
												"Field formatter is not of expected type function",
												"Result"
											);
										var s = null;
										e.highlighted && e.highlighted[o] && (s = e.highlighted[o]),
											(i[o] = t[o]({
												entityProfileData: e.raw,
												entityFieldValue: a,
												highlightedEntityFieldValue: s,
												verticalId: r,
												isDirectAnswer: !1
											}));
									}
								}),
						  i)
						: i;
				}),
				e
			);
		})(),
		ff = "normal",
		hf = "no-results";
	function pf(e, t) {
		var r = Ms(e);
		if (Ss) {
			var n = Ss(e);
			t &&
				(n = Da(n).call(n, function (t) {
					return Ra(e, t).enumerable;
				})),
				r.push.apply(r, n);
		}
		return r;
	}
	var df = (function () {
			function e(e) {
				void 0 === e && (e = {}),
					ca(this, { searchState: vl }, e),
					(this.resultsContext = e.resultsContext),
					Sl(this);
			}
			return (
				(e.prototype.append = function (t) {
					var r, n;
					if (t.resultsContext !== this.resultsContext)
						throw new El(
							"Cannot merge results with different contexts",
							"VerticalResults"
						);
					var i = (function (e) {
						for (var t = 1; t < arguments.length; t++) {
							var r,
								n = null != arguments[t] ? arguments[t] : {};
							if (t % 2)
								Ia((r = pf(Object(n), !0))).call(r, function (t) {
									Ds(e, t, n[t]);
								});
							else if (ma) ha(e, ma(n));
							else {
								var i;
								Ia((i = pf(Object(n)))).call(i, function (t) {
									fa(e, t, Ra(n, t));
								});
							}
						}
						return e;
					})({}, this);
					return (
						(i.resultsContext = this.resultsContext),
						(i.results = yl((r = this.results)).call(r, t.results)),
						(Os(i).mapMarkers = yl((n = Os(this).mapMarkers)).call(
							n,
							Os(t).mapMarkers
						)),
						new e(i)
					);
				}),
				(e.fromCore = function (e, t, r, n, i) {
					var o, a;
					if ((void 0 === t && (t = {}), void 0 === n && (n = ff), !e))
						return new Tl();
					var s = e.verticalKey || i;
					return new Tl(
						{
							verticalConfigId: s,
							resultsCount: e.resultsCount,
							appliedQueryFilters: Os((o = e.appliedQueryFilters)).call(
								o,
								Ql.fromCore
							),
							results: Os((a = e.results)).call(a, function (e) {
								return lf.fromCore(e, r, s);
							})
						},
						t[s],
						n
					);
				}),
				(e.searchLoading = function () {
					return new e({ searchState: dl });
				}),
				(e.areDuplicateNamesAllowed = function () {
					return !0;
				}),
				e
			);
		})(),
		vf = (function () {
			function e(e) {
				(this.queryId = e.queryId || null),
					(this.sections = e.sections || []),
					(this.searchState = e.searchState || vl);
			}
			return (
				(e.searchLoading = function () {
					return new e({ searchState: dl });
				}),
				(e.fromCore = function (t, r, n) {
					var i;
					return t
						? new e({
								queryId: t.queryId,
								sections: Os((i = t.verticalResults)).call(i, function (e) {
									return df.fromCore(e, r, n);
								})
						  })
						: new e();
				}),
				e
			);
		})(),
		mf = (function () {
			function e(e) {
				void 0 === e && (e = {}), ca(this, e), Sl(this);
			}
			return (
				(e.fromCore = function (t, r) {
					if (!t) return new e();
					var n = t.relatedResult || {},
						i = {
							answer: {
								snippet: t.snippet,
								entityName: t.entityName,
								fieldName: t.fieldName,
								fieldApiName: t.fieldApiName,
								value: t.value,
								fieldType: t.fieldType
							},
							relatedItem: {
								data: {
									fieldValues: n.rawData,
									id: n.id,
									type: n.type,
									website: n.link
								},
								verticalConfigId: t.verticalKey
							},
							type: t.type
						},
						o = i.answer.fieldApiName;
					if (r && o in r) {
						var a = this._getFormattedValue(i, r[o]);
						i.answer.value = a || i.answer.value;
					}
					return new e(i);
				}),
				(e._getFormattedValue = function (e, t) {
					return e.answer && e.relatedItem
						? t(
								e.answer.value,
								e.relatedItem.data.fieldValues,
								e.relatedItem.verticalConfigId,
								!0
						  )
						: null;
				}),
				e
			);
		})(),
		gf = (function () {
			function e(e) {
				(this.tabOrder = e || []), Sl(this);
			}
			return (
				(e.from = function (t) {
					var r = [];
					if (!t || !As(t)) return r;
					for (var n = 0; n < t.length; n++) r.push(t[n].verticalConfigId);
					return new e(r);
				}),
				(e.fromCore = function (t) {
					return new e(
						Os(t).call(t, function (e) {
							return e.verticalKey;
						})
					);
				}),
				e
			);
		})(),
		yf = (function () {
			function e(e) {
				(this.query = e.query || null),
					(this.correctedQuery = e.correctedQuery || null),
					(this.type = e.type || null),
					(this.shouldShow = null !== this.correctedQuery);
			}
			return (
				(e.fromCore = function (t) {
					return t
						? new e({
								query: t.originalQuery,
								correctedQuery: { value: t.correctedQuery },
								type: t.type
						  })
						: {};
				}),
				e
			);
		})(),
		_f = "navigation",
		bf = "universal-results",
		wf = "vertical-results",
		Sf = "alternative-verticals",
		kf = "autocomplete",
		xf = "direct-answer",
		Mf = "filters",
		Af = "static-filter-nodes",
		Ef = "location-radius-filter-node",
		Cf = "locationRadius",
		If = "query",
		Tf = "query-id",
		Of = "facet-filter-nodes",
		Rf = "facetFilters",
		Ff = "dynamic-filters",
		Lf = "geolocation",
		jf = "question-submission",
		Nf = "search-config",
		Pf = "search-offset",
		qf = "spell-check",
		Df = "skipSpellCheck",
		Bf = "location-bias",
		Uf = "sessions-opt-in",
		Vf = "locale",
		Hf = "sortBys",
		zf = "no-results-config",
		Kf = "results-header",
		Zf = "context",
		Qf = "referrerPageUrl",
		Wf = "queryTrigger",
		Gf = "query-source",
		$f = (function () {
			function e(e) {
				(this.filters = e.filters || []),
					(this.resultsContext = e.resultsContext),
					Sl(this);
			}
			return (
				(e.fromCore = function (t, r) {
					return (
						void 0 === t && (t = []),
						void 0 === r && (r = ff),
						new e({ filters: t, resultsContext: r })
					);
				}),
				e
			);
		})(),
		Jf = (function () {
			function e(e) {
				(this.accuracy = e.accuracy || null),
					(this.latitude = e.latitude || null),
					(this.longitude = e.longitude || null),
					(this.locationDisplayName = e.locationDisplayName || null),
					(this.searchState = e.searchState);
			}
			return (
				(e.searchLoading = function () {
					return new e({ searchState: dl });
				}),
				(e.fromCore = function (t) {
					return new e(
						t
							? {
									accuracy: t.method,
									latitude: t.latitude,
									longitude: t.longitude,
									locationDisplayName: t.displayName,
									searchState: vl
							  }
							: { accuracy: "UNKNOWN" }
					);
				}),
				e
			);
		})(),
		Yf = (function () {
			function e(e) {
				this.alternativeVerticals = e || [];
			}
			return (
				(e.fromCore = function (t, r) {
					return t && 0 !== t.length
						? new e(
								Os(t).call(t, function (e) {
									return df.fromCore(e, {}, r);
								})
						  )
						: new e();
				}),
				e
			);
		})();
	function Xf(e, t) {
		var r = Ms(e);
		if (Ss) {
			var n = Ss(e);
			t &&
				(n = Da(n).call(n, function (t) {
					return Ra(e, t).enumerable;
				})),
				r.push.apply(r, n);
		}
		return r;
	}
	function eh(e) {
		for (var t = 1; t < arguments.length; t++) {
			var r,
				n = null != arguments[t] ? arguments[t] : {};
			if (t % 2)
				Ia((r = Xf(Object(n), !0))).call(r, function (t) {
					Ds(e, t, n[t]);
				});
			else if (ma) ha(e, ma(n));
			else {
				var i;
				Ia((i = Xf(Object(n)))).call(i, function (t) {
					fa(e, t, Ra(n, t));
				});
			}
		}
		return e;
	}
	var th = (function () {
			function e() {}
			return (
				(e.transformUniversal = function (e, t, r) {
					var n;
					return (
						void 0 === t && (t = {}),
						((n = {})[Tf] = e.queryId),
						(n[_f] = gf.fromCore(e.verticalResults)),
						(n[xf] = mf.fromCore(e.directAnswer, r)),
						(n[bf] = vf.fromCore(e, t, r)),
						(n[qf] = yf.fromCore(e.spellCheck)),
						(n[Bf] = Jf.fromCore(e.locationBias)),
						n
					);
				}),
				(e.transformVertical = function (t, r, n) {
					var i,
						o =
							t.verticalResults &&
							t.verticalResults.results &&
							t.verticalResults.resultsCount > 0,
						a = ff,
						s = t;
					return (
						o || ((a = hf), (s = e._reshapeForNoResults(t))),
						((i = {})[Tf] = s.queryId),
						(i[_f] = new gf()),
						(i[wf] = df.fromCore(s.verticalResults, {}, r, a, n)),
						(i[Ff] = $f.fromCore(s.facets, a)),
						(i[qf] = yf.fromCore(s.spellCheck)),
						(i[Sf] = Yf.fromCore(s.alternativeVerticals, r)),
						(i[Bf] = Jf.fromCore(s.locationBias)),
						i
					);
				}),
				(e._reshapeForNoResults = function (e) {
					var t = e.allResultsForVertical || {},
						r = t.verticalResults || {},
						n = r.results,
						i = r.resultsCount;
					return eh(
						eh({}, e),
						{},
						{
							results: n || [],
							resultsCount: i || 0,
							verticalResults: t.verticalResults,
							facets: t.facets
						}
					);
				}),
				e
			);
		})(),
		rh = (function () {
			function e(e, t) {
				void 0 === e && (e = {}),
					(this.name = e.name || null),
					(this.email = e.email || null),
					(this.privacyPolicy = e.privacyPolicy || null),
					(this.questionText = e.questionText || null),
					(this.questionDescription = e.questionDescription || null),
					(this.questionExpanded =
						"boolean" != typeof e.expanded || e.expanded),
					(this.errors = t || null),
					(this.questionSubmitted = e.submitted || !1),
					Sl(this);
			}
			return (
				(e.submitted = function () {
					return { questionSubmitted: !0, questionExpanded: !0 };
				}),
				(e.errors = function (t, r) {
					return e(t, r);
				}),
				e
			);
		})(),
		nh = "initialize",
		ih = "query-parameter",
		oh = "suggest",
		ah = "filter-component",
		sh = "pagination",
		ch = "search-bar",
		uh = xs,
		lh = t(
			r(function (e) {
				(e.exports = function (e, t) {
					if (null == e) return {};
					var r,
						n,
						i = {},
						o = uh(e);
					for (n = 0; n < o.length; n++)
						(r = o[n]), Vu(t).call(t, r) >= 0 || (i[r] = e[r]);
					return i;
				}),
					(e.exports.default = e.exports),
					(e.exports.__esModule = !0);
			})
		),
		fh = (function () {
			function e(e, t) {
				(this.eventType = e.toUpperCase()), t && (this.label = t);
			}
			var t = e.prototype;
			return (
				(t.addOptions = function (e) {
					return ca(this, e), this;
				}),
				(t.toApiEvent = function () {
					return ca({}, this);
				}),
				(e.fromData = function (t) {
					var r = t.type,
						n = t.label,
						i = lh(t, ["type", "label"]),
						o = new e(r, n);
					return o.addOptions(i), o;
				}),
				e
			);
		})(),
		hh = function (e, t, r, n, i, o, a, s) {
			for (var c, u = i, l = 0, f = !!a && P(a, s, 3); l < n; ) {
				if (l in r) {
					if (((c = f ? f(r[l], l, t) : r[l]), o > 0 && ga(c)))
						u = hh(e, t, c, it(c.length), u, o - 1) - 1;
					else {
						if (u >= 9007199254740991)
							throw TypeError("Exceed the acceptable array length");
						e[u] = c;
					}
					u++;
				}
				l++;
			}
			return u;
		},
		ph = hh;
	z(
		{ target: "Array", proto: !0 },
		{
			flatMap: function (e) {
				var t,
					r = Te(this),
					n = it(r.length);
				return (
					N(e),
					((t = _a(r, 0)).length = ph(
						t,
						r,
						r,
						n,
						0,
						1,
						e,
						arguments.length > 1 ? arguments[1] : void 0
					)),
					t
				);
			}
		}
	);
	var dh = Jo("Array").flatMap,
		vh = Array.prototype,
		mh = function (e) {
			var t = e.flatMap;
			return e === vh || (e instanceof Array && t === vh.flatMap) ? dh : t;
		},
		gh = "".startsWith,
		yh = Math.min,
		_h = ra("startsWith");
	z(
		{ target: "String", proto: !0, forced: !_h },
		{
			startsWith: function (e) {
				var t = String(m(this));
				ea(e);
				var r = it(yh(arguments.length > 1 ? arguments[1] : void 0, t.length)),
					n = String(e);
				return gh ? gh.call(t, n, r) : t.slice(r, r + n.length) === n;
			}
		}
	);
	var bh = Jo("String").startsWith,
		wh = String.prototype,
		Sh = function (e) {
			var t = e.startsWith;
			return "string" == typeof e ||
				e === wh ||
				(e instanceof String && t === wh.startsWith)
				? bh
				: t;
		},
		kh = (function () {
			function e(e) {
				void 0 === e && (e = {}), ca(this, e), Sl(this);
			}
			return (
				(e.fromFilters = function (t) {
					var r = {};
					Ia(t).call(t, function (e) {
						r[e] = [];
					});
					for (
						var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), o = 1;
						o < n;
						o++
					)
						i[o - 1] = arguments[o];
					var a = mh(i).call(i, function (e) {
						return e.$or || e;
					});
					return (
						Ia(a).call(a, function (e) {
							var t = e.getFilterKey();
							r[t] || (r[t] = []), r[t].push(e);
						}),
						new e(r)
					);
				}),
				(e.fromCore = function (t) {
					var r;
					return (
						void 0 === t && (t = []),
						Os(
							(r = Os(t).call(t, function (e) {
								var t;
								return {
									label: e.displayName,
									fieldId: e.fieldId,
									options: Os((t = e.options)).call(t, function (t) {
										var r, n;
										return {
											label: t.displayName,
											countLabel: t.count,
											selected: t.selected,
											filter:
												((n = {}),
												(n[e.fieldId] =
													((r = {}), (r[t.matcher] = t.value), r)),
												n)
										};
									})
								};
							}))
						).call(r, function (t) {
							return new e(t);
						})
					);
				}),
				e
			);
		})(),
		xh = t(
			r(function (e) {
				(e.exports = function (e) {
					if (void 0 === e)
						throw new ReferenceError(
							"this hasn't been initialised - super() hasn't been called"
						);
					return e;
				}),
					(e.exports.default = e.exports),
					(e.exports.__esModule = !0);
			})
		),
		Mh = "filter-type-static",
		Ah = function (e) {
			void 0 === e && (e = {});
			var t = e,
				r = t.fieldName,
				n = t.displayValue,
				i = t.filterType;
			(this.fieldName = r),
				(this.displayValue = n),
				(this.filterType = i || Mh),
				Sl(this);
		},
		Eh = (function () {
			function e() {}
			var t = e.prototype;
			return (
				(t.getFilter = function () {}),
				(t.getMetadata = function () {}),
				(t.getChildren = function () {}),
				(t.getSimpleDescendants = function () {}),
				(t.remove = function () {}),
				e
			);
		})(),
		Ch = (function (e) {
			function t(t) {
				var r;
				void 0 === t && (t = {}), (r = e.call(this) || this);
				var n = t,
					i = Da(n),
					o = n.metadata,
					a = n.remove;
				return (
					(r.filter = Zl.from(i)),
					(r.metadata = new Ah(o)),
					(r._remove = a || function () {}),
					Sl(xh(r)),
					r
				);
			}
			wu(t, e);
			var r = t.prototype;
			return (
				(r.getFilter = function () {
					return Da(this);
				}),
				(r.getChildren = function () {
					return [];
				}),
				(r.getMetadata = function () {
					return this.metadata;
				}),
				(r.getSimpleDescendants = function () {
					return this;
				}),
				(r.remove = function () {
					this._remove();
				}),
				(r.hasSameFilterAs = function (e) {
					var t = this.getFilter(),
						r = e.getFilter(),
						n = t.getFilterKey(),
						i = r.getFilterKey();
					if (n !== i) return !1;
					var o = t[n],
						a = r[i],
						s = Ms(o),
						c = Ms(a);
					return (
						s.length === c.length &&
						jl(s).call(s, function (e) {
							return a.hasOwnProperty(e) && a[e] === o[e];
						})
					);
				}),
				t
			);
		})(Eh),
		Ih = (function (e) {
			function t(t) {
				var r;
				void 0 === t && (t = {}), (r = e.call(this) || this);
				var n = t,
					i = n.combinator,
					o = n.children;
				return (r.combinator = i), (r.children = o || []), Sl(xh(r)), r;
			}
			wu(t, e);
			var r = t.prototype;
			return (
				(r.getFilter = function () {
					var e,
						t = Os((e = this.children)).call(e, function (e) {
							return e.getFilter();
						});
					switch (this.combinator) {
						case Pl:
							return Zl.and.apply(Zl, t);
						case ql:
							return Zl.or.apply(Zl, t);
					}
					return Zl.empty();
				}),
				(r.getMetadata = function () {
					return null;
				}),
				(r.getChildren = function () {
					return this.children;
				}),
				(r.getSimpleDescendants = function () {
					var e;
					return mh((e = this.getChildren())).call(e, function (e) {
						return e.getSimpleDescendants();
					});
				}),
				(r.remove = function () {
					var e;
					Ia((e = this.children)).call(e, function (e) {
						e.remove();
					});
				}),
				t
			);
		})(Eh),
		Th = (function () {
			function e() {}
			return (
				(e.and = function () {
					for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
						r[n] = arguments[n];
					return e._combine(Pl, r);
				}),
				(e.or = function () {
					for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
						r[n] = arguments[n];
					return e._combine(ql, r);
				}),
				(e._combine = function (e, t) {
					var r = Da(t).call(t, function (e) {
						return e.getFilter().getFilterKey();
					});
					return r.length
						? 1 === r.length
							? r[0]
							: new Ih({ combinator: e, children: r })
						: new Ch();
				}),
				(e.from = function (e) {
					return (
						void 0 === e && (e = {}),
						e.children && e.children.length ? new Ih(e) : new Ch(e)
					);
				}),
				e
			);
		})(),
		Oh = (function () {
			function e(e, t) {
				void 0 === t && (t = []),
					(this.storage = e),
					(this.availableFieldIds = t);
			}
			var t = e.prototype;
			return (
				(t.getAllFilterNodes = function () {
					var e,
						t = yl((e = [])).call(
							e,
							this.getStaticFilterNodes(),
							this.getFacetFilterNodes()
						),
						r = this.getFilterNodeByKey(Ef);
					return r && t.push(r), t;
				}),
				(t.getStaticFilterNodes = function () {
					var e,
						t = [];
					return (
						Ia((e = this.storage.getAll())).call(e, function (e, r) {
							Sh(r).call(r, Af) && t.push(e);
						}),
						t
					);
				}),
				(t.getFacetFilterNodes = function () {
					return this.storage.get(Of) || [];
				}),
				(t.getStaticFilterPayload = function () {
					var e,
						t = Da((e = this.getStaticFilterNodes())).call(e, function (e) {
							return e.getChildren().length > 0 || e.getFilter().getFilterKey();
						});
					return t.length > 0 ? this._transformFilterNodes(t, Pl) : null;
				}),
				(t.getAllStaticFilterNodesCombined = function () {
					var e = this.getStaticFilterNodes();
					return Th.and.apply(Th, e);
				}),
				(t._transformFilterNodes = function (e, t) {
					var r = this,
						n = mh(e).call(e, function (e) {
							return e.children
								? r._transformFilterNodes(e.children, e.combinator)
								: r._transformSimpleFilterNode(e);
						});
					return 1 === n.length ? n[0] : { filters: n, combinator: t };
				}),
				(t._transformSimpleFilterNode = function (e) {
					var t = Ms(Da(e))[0],
						r = Da(e)[t],
						n = Ms(r);
					if (1 === n.length) {
						var i = n[0],
							o = r[i];
						return { fieldId: t, matcher: i, value: o };
					}
					if (n.length > 1) {
						var a = Os(n).call(n, function (e) {
							return { fieldId: t, matcher: e, value: r[e] };
						});
						return { combinator: Pl, filters: a };
					}
				}),
				(t._transformSimpleFilterNodeIntoFacetOption = function (e) {
					var t = e[Ms(e)[0]],
						r = Ms(t)[0];
					return { matcher: r, value: t[r] };
				}),
				(t.createFacetsFromFilterNodes = function () {
					var e,
						t,
						r = mh((e = this.getFacetFilterNodes())).call(e, function e(t) {
							var r;
							return t.getChildren().length
								? mh((r = t.getChildren())).call(r, e)
								: t.getFilter();
						});
					return kh.fromFilters.apply(
						kh,
						yl((t = [this.availableFieldIds])).call(t, r)
					);
				}),
				(t.getFacetsPayload = function () {
					var e,
						t = this,
						r = this.storage.has(Of)
							? this.createFacetsFromFilterNodes()
							: this.storage.get(Rf) || {};
					return Os((e = Jl(r))).call(e, function (e) {
						var r = e[0],
							n = e[1];
						return {
							fieldId: r,
							options: Os(n).call(
								n,
								t._transformSimpleFilterNodeIntoFacetOption
							)
						};
					});
				}),
				(t.getFilterNodeByKey = function (e) {
					return this.storage.get(e);
				}),
				(t.setStaticFilterNodes = function (e, t) {
					this.storage.set(Af + "." + e, t);
				}),
				(t.setFacetFilterNodes = function (e, t) {
					void 0 === e && (e = []),
						void 0 === t && (t = []),
						(this.availableFieldIds = e),
						this.storage.set(Of, t);
				}),
				(t.setLocationRadiusFilterNode = function (e) {
					this.storage.set(Ef, e);
				}),
				(t.clearStaticFilterNode = function (e) {
					this.storage.delete(Af + "." + e);
				}),
				(t.clearFacetFilterNodes = function () {
					this.storage.delete(Of);
				}),
				(t.clearAllFilterNodes = function () {
					var e,
						t = this;
					this.storage.delete(Ef),
						this.clearFacetFilterNodes(),
						Ia((e = this.storage.getAll())).call(e, function (e, r) {
							Sh(r).call(r, Af) && t.storage.delete(r);
						});
				}),
				e
			);
		})(),
		Rh = function (e) {
			void 0 === e && (e = {}),
				(this.sections = e.sections || []),
				(this.queryId = e.queryId || ""),
				(this.inputIntents = e.inputIntents || []),
				Sl(this);
		},
		Fh = function (e) {
			void 0 === e && (e = {}),
				(this.filter = Da(e) || {}),
				(this.key = e.key || ""),
				(this.matchedSubstrings = e.matchedSubstrings || []),
				(this.value = e.value || ""),
				(this.shortValue = e.shortValue || this.value),
				(this.intents = e.queryIntents || []),
				Sl(this);
		},
		Lh = (function () {
			function e() {}
			return (
				(e.transformAutoCompleteResponse = function (e) {
					var t,
						r = this,
						n = [
							{
								results: Os((t = e.results)).call(t, function (e) {
									return r._transformAutoCompleteResult(e);
								}),
								resultsCount: e.results.length
							}
						];
					return new Rh({
						sections: n,
						queryId: e.queryId,
						inputIntents: e.inputIntents
					});
				}),
				(e.transformFilterSearchResponse = function (e) {
					var t = this;
					if (e.sectioned && e.sections) {
						var r,
							n = Os((r = e.sections)).call(r, function (e) {
								var r;
								return {
									label: e.label,
									results: Os((r = e.results)).call(r, function (e) {
										return t._transformAutoCompleteResult(e);
									}),
									resultsCount: e.results.length
								};
							});
						return new Rh({
							sections: n,
							queryId: e.queryId,
							inputIntents: e.inputIntents
						});
					}
					return this.transformAutoCompleteResponse(e);
				}),
				(e._transformAutoCompleteResult = function (e) {
					var t = Da(e) ? this._transformFilter(Da(e)) : {};
					return new Fh({
						filter: t,
						key: e.key,
						matchedSubstrings: e.matchedSubstrings,
						value: e.value
					});
				}),
				(e._transformFilter = function (e) {
					var t,
						r,
						n = e.fieldId,
						i = e.matcher,
						o = e.value;
					return ((r = {})[n] = (((t = {})[i] = o), t)), r;
				}),
				e
			);
		})(),
		jh = "/v2/accounts/me/answers/query",
		Nh = "/v2/accounts/me/answers/vertical/query",
		Ph = "/v2/accounts/me/createQuestion",
		qh = "/v2/accounts/me/answers/autocomplete",
		Dh = "/v2/accounts/me/answers/vertical/autocomplete",
		Bh = "/v2/accounts/me/answers/filtersearch",
		Uh = (function () {
			function e(e) {
				if (((this._params = {}), window && window.URLSearchParams))
					return new Vc(e);
				this._params = this.parse(e);
			}
			var t = e.prototype;
			return (
				(t.parse = function (t) {
					var r = {},
						n = t;
					if (!n) return r;
					ou(t).call(t, "?") > -1 &&
						(n = Tc(t).call(t, ou(t).call(t, "?") + 1));
					for (var i = n.split("&"), o = 0; o < i.length; o++) {
						var a = i[o].split("=");
						a.length > 1 ? (r[a[0]] = e.decode(a[1])) : (r[a[0]] = "");
					}
					return r;
				}),
				(t.get = function (e) {
					return void 0 === this._params[String(e)] ? null : this._params[e];
				}),
				(t.set = function (e, t) {
					this._params[String(e)] = String(t);
				}),
				(t.has = function (e) {
					return e in this._params;
				}),
				(t.delete = function (e) {
					delete this._params[String(e)];
				}),
				(t.toString = function () {
					var t = [];
					for (var r in this._params)
						t.push(r + "=" + e.encode(this._params[r]));
					return t.join("&");
				}),
				(t.entries = function () {
					var e = [];
					for (var t in this._params) e.push([t, this._params[t]]);
					return e;
				}),
				(e.decode = function (e) {
					return decodeURIComponent(e.replace(/[ +]/g, "%20"));
				}),
				(e.encode = function (e) {
					var t = {
						"!": "%21",
						"'": "%27",
						"(": "%28",
						")": "%29",
						"%20": "+"
					};
					return encodeURIComponent(e).replace(/[!'()]|%20/g, function (e) {
						return t[e];
					});
				}),
				e
			);
		})();
	function Vh(e) {
		return (
			void 0 === e && (e = "production"),
			"sandbox" === e
				? "https://liveapi-sandbox.yext.com"
				: "https://liveapi.yext.com"
		);
	}
	function Hh(e) {
		return (
			void 0 === e && (e = "production"),
			"sandbox" === e
				? "https://liveapi-sandbox.yext.com"
				: "https://liveapi-cached.yext.com"
		);
	}
	function zh(e, t) {
		return (
			void 0 === e && (e = "production"),
			void 0 === t && (t = !1),
			t
				? "sandbox" === e
					? "https://sandbox-realtimeanalytics.yext.com"
					: "https://realtimeanalytics.yext.com"
				: "sandbox" === e
				? "https://sandbox-answers.yext-pixel.com"
				: "https://answers.yext-pixel.com"
		);
	}
	function Kh(e, t) {
		var r = Ms(e);
		if (Ss) {
			var n = Ss(e);
			t &&
				(n = Da(n).call(n, function (t) {
					return Ra(e, t).enumerable;
				})),
				r.push.apply(r, n);
		}
		return r;
	}
	var Zh = window.document,
		Qh = (function () {
			function e() {}
			return (
				(e.setup = function (e, t) {
					Zh = e;
				}),
				(e.create = function (e) {
					if ("createRange" in Zh) {
						var t = Zh.createElement("div"),
							r = Zh.createRange().createContextualFragment(e);
						return t.appendChild(r), t;
					}
					return new DOMParser().parseFromString(e, "text/html").body;
				}),
				(e.query = function (e, t) {
					return (
						void 0 === t && ((t = e), (e = Zh)),
						t instanceof HTMLElement ||
						t instanceof Window ||
						t instanceof HTMLDocument
							? t
							: e.querySelector(t)
					);
				}),
				(e.queryAll = function (e, t) {
					return (
						void 0 === t && ((t = e), (e = Zh)),
						null == e && (e = Zh),
						t instanceof HTMLElement ||
						t instanceof HTMLDocument ||
						t instanceof Window
							? [t]
							: kc(e.querySelectorAll(t))
					);
				}),
				(e.onReady = function (t) {
					"complete" !== Zh.readyState &&
					"loaded" !== Zh.readyState &&
					"interactive" !== Zh.readyState
						? e.on(Zh, "DOMContentLoaded", t)
						: t();
				}),
				(e.createEl = function (t, r) {
					void 0 === r && (r = {});
					for (var n = Zh.createElement(t), i = Ms(r), o = 0; o < i.length; o++)
						"class" !== i[o] ? (n[i[o]] = r[i[o]]) : e.addClass(n, r[i[o]]);
					return n;
				}),
				(e.append = function (t, r) {
					void 0 === r && ((r = t), (t = Zh)),
						"string" == typeof t && (t = e.query(t)),
						"string" == typeof r
							? t.insertAdjacentHTML("afterBegin", r)
							: t.appendChild(r);
				}),
				(e.addClass = function (e, t) {
					if (e)
						for (var r = t.split(","), n = r.length, i = 0; i < n; i++)
							e.classList.add(r[i]);
				}),
				(e.removeClass = function (e, t) {
					e && e.classList.remove(t);
				}),
				(e.empty = function (e) {
					e.innerHTML = "";
				}),
				(e.css = function (t, r) {
					var n = e.query(t);
					for (var i in r) n.style[i] = r[i];
				}),
				(e.attr = function (t, r, n) {
					e.query(t).setAttribute(r, n);
				}),
				(e.attributes = function (e, t) {
					var r,
						n = this;
					Ia((r = Jl(t))).call(r, function (t) {
						var r = t[0],
							i = t[1];
						return n.attr(e, r, i);
					});
				}),
				(e.trigger = function (t, r, n) {
					var i = e._customEvent(r, n);
					e.query(t).dispatchEvent(i);
				}),
				(e._customEvent = function (e, t) {
					var r = (function (e) {
							for (var t = 1; t < arguments.length; t++) {
								var r,
									n = null != arguments[t] ? arguments[t] : {};
								if (t % 2)
									Ia((r = Kh(Object(n), !0))).call(r, function (t) {
										Ds(e, t, n[t]);
									});
								else if (ma) ha(e, ma(n));
								else {
									var i;
									Ia((i = Kh(Object(n)))).call(i, function (t) {
										fa(e, t, Ra(n, t));
									});
								}
							}
							return e;
						})({ bubbles: !0, cancelable: !0, detail: null }, t),
						n = Zh.createEvent("CustomEvent");
					return n.initCustomEvent(e, r.bubbles, r.cancelable, r.detail), n;
				}),
				(e.on = function (t, r, n) {
					e.query(t).addEventListener(r, n);
				}),
				(e.once = function (t, r, n) {
					e.query(t).addEventListener(r, n, { once: !0 });
				}),
				(e.off = function (t, r, n) {
					e.query(t).removeEventListener(r, n);
				}),
				(e.delegate = function (t, r, n, i) {
					var o = e.query(t);
					o.addEventListener(n, function (t) {
						for (var n = t.target; !n.isEqualNode(o); ) {
							if (e.matches(n, r)) {
								i(t, n);
								break;
							}
							n = n.parentNode;
						}
					});
				}),
				(e.matches = function (e, t) {
					return Element.prototype.matches
						? e.matches(t)
						: Element.prototype.msMatchesSelector
						? e.msMatchesSelector(t)
						: Element.prototype.webkitMatchesSelector
						? e.webkitMatchesSelector(t)
						: void 0;
				}),
				e
			);
		})(),
		Wh = (function () {
			function e() {}
			var t = e.prototype;
			return (
				(t.render = function (e, t) {
					return e;
				}),
				(t.registerHelper = function (e, t) {}),
				(t.registerTemplate = function (e, t) {}),
				(t.compile = function (e) {}),
				e
			);
		})(),
		Gh = $.trim,
		$h = o.parseInt,
		Jh = /^[+-]?0[Xx]/,
		Yh =
			8 !== $h(K + "08") || 22 !== $h(K + "0x16")
				? function (e, t) {
						var r = Gh(String(e));
						return $h(r, t >>> 0 || (Jh.test(r) ? 16 : 10));
				  }
				: $h;
	z({ global: !0, forced: parseInt != Yh }, { parseInt: Yh });
	var Xh = j.parseInt,
		ep = Sa.some,
		tp = ka("some");
	z(
		{ target: "Array", proto: !0, forced: !tp },
		{
			some: function (e) {
				return ep(this, e, arguments.length > 1 ? arguments[1] : void 0);
			}
		}
	);
	var rp = Jo("Array").some,
		np = Array.prototype,
		ip = function (e) {
			var t = e.some;
			return e === np || (e instanceof Array && t === np.some) ? rp : t;
		},
		op = (function () {
			function e(e) {
				(this.name = e.name),
					(this.path = e.path),
					(this.complexContents = e.complexContents),
					(this.viewBox = e.viewBox || "0 0 24 24"),
					(this.contents = this.pathDefinition());
			}
			var t = e.prototype;
			return (
				(t.pathDefinition = function () {
					return this.complexContents
						? this.complexContents
						: '<path d="' + this.path + '"></path>';
				}),
				(t.parseContents = function (e) {
					var t = this.contents;
					return (
						"function" == typeof t && (t = t(e)),
						'<svg viewBox="' +
							this.viewBox +
							'" xmlns="http://www.w3.org/2000/svg">' +
							t +
							"</svg>"
					);
				}),
				(t.markup = function () {
					var e = this;
					return "function" == typeof this.contents
						? function (t) {
								return e.parseContents(t);
						  }
						: this.parseContents();
				}),
				e
			);
		})(),
		ap = new op({
			name: "thumb",
			viewBox: "0 0 24 22",
			path:
				"M15.273 1H5.455c-.906 0-1.68.55-2.008 1.342L.153 10.097A2.19 2.19 0 000 10.9v2.2c0 1.21.982 2.2 2.182 2.2h6.883L8.03 20.327l-.033.352c0 .451.186.869.48 1.166L9.633 23l7.178-7.249a2.16 2.16 0 00.644-1.551v-11c0-1.21-.982-2.2-2.182-2.2zm0 13.2l-4.735 4.774L11.75 13.1H2.182v-2.2l3.273-7.7h9.818v11zM19.636 1H24v13.2h-4.364V1z"
		}),
		sp = new op({
			name: "receipt",
			path:
				"M14.606 9.5c-.671-.515-1.591-.833-2.606-.833 1.015 0 1.935.318 2.606.833zm-7.985 0H1.655A1.66 1.66 0 010 7.833V3.667C0 2.747.741 2 1.655 2h20.69A1.66 1.66 0 0124 3.667v4.166A1.66 1.66 0 0122.345 9.5h-4.966V22H6.621V9.5h2.773H6.62zm10.758-1.667h4.966V3.667H1.655v4.166h4.966v-2.5h10.758v2.5z"
		}),
		cp = new op({
			name: "pantheon",
			path:
				"M9.947 16.598h.252V9.412h-.252a.432.432 0 01-.23-.065c-.07-.043-.106-.093-.106-.15L9.15 7.82v-.15c0-.044.028-.08.084-.109a.691.691 0 01.105-.086.254.254 0 01.146-.043H13.6c.056 0 .104.015.146.043.042.03.091.058.147.086a.271.271 0 01.063.108c.014.043.007.093-.02.15l-.42 1.378a.374.374 0 01-.147.15.37.37 0 01-.19.065h-.251v7.186h.252a.37.37 0 01.189.065c.07.043.119.093.147.15l.42 1.378c.027.028.034.071.02.129a.275.275 0 01-.063.129 1.364 1.364 0 00-.147.086.254.254 0 01-.146.043H9.485a.254.254 0 01-.146-.043.691.691 0 01-.105-.086c-.056-.029-.084-.072-.084-.13v-.128l.461-1.377c0-.058.035-.108.105-.151a.432.432 0 01.231-.065zm5.792 0h.252V9.412h-.252a.432.432 0 01-.23-.065.374.374 0 01-.148-.15l-.42-1.377c-.027-.029-.034-.072-.02-.13a.275.275 0 01.063-.129c.056-.028.105-.057.146-.086a.254.254 0 01.147-.043h4.114c.055 0 .104.015.146.043a.691.691 0 01.105.086c.056.03.084.072.084.13v.129l-.42 1.377a.374.374 0 01-.146.15.432.432 0 01-.231.065h-.21v7.186h.21a.43.43 0 01.23.065c.07.043.12.093.148.15l.42 1.378v.15c0 .043-.029.08-.085.108a.691.691 0 01-.105.086.254.254 0 01-.146.043h-4.114a.254.254 0 01-.147-.043 1.364 1.364 0 00-.146-.086.271.271 0 01-.063-.108c-.014-.043-.007-.093.02-.15l.42-1.377a.374.374 0 01.147-.151.432.432 0 01.231-.065zm-11.794-.086h.252V9.498h-.252a.334.334 0 01-.21-.065.386.386 0 01-.126-.193l-.42-1.377a.248.248 0 01-.02-.172.854.854 0 01.063-.173c.028-.057.07-.1.126-.129a.365.365 0 01.168-.043h4.07c.057 0 .113.015.169.043a.278.278 0 01.126.13.854.854 0 01.062.172.248.248 0 01-.02.172l-.42 1.377a.386.386 0 01-.126.193.334.334 0 01-.21.065h-.21v7.014h.21c.084 0 .154.029.21.086a.673.673 0 01.126.172l.42 1.378a.248.248 0 01.02.172.854.854 0 01-.062.172.278.278 0 01-.126.129.365.365 0 01-.168.043H3.526a.365.365 0 01-.168-.043.278.278 0 01-.126-.13.854.854 0 01-.063-.171.248.248 0 01.02-.172l.42-1.378a.673.673 0 01.126-.172.281.281 0 01.21-.086zM1.763 6.658a.717.717 0 01-.504-.194.644.644 0 01-.21-.495v-.43a.73.73 0 01.105-.387.68.68 0 01.273-.259C4.309 3.402 6.54 2.276 8.121 1.515 9.702.755 10.493.361 10.493.332c.531-.258.972-.366 1.322-.323.35.043.734.165 1.154.366l8.31 4.518c.14.058.245.144.315.259a.73.73 0 01.105.387v.43c0 .201-.07.366-.21.495a.717.717 0 01-.504.194H1.763zm-.714 13.34a.54.54 0 01.168-.387.516.516 0 01.378-.172h19.642c.168 0 .308.057.42.172a.541.541 0 01.168.387v.818a.522.522 0 01-.168.408.605.605 0 01-.42.151H1.595a.551.551 0 01-.378-.15.522.522 0 01-.168-.41v-.817zm21.405 2.022c.14 0 .266.058.378.173a.592.592 0 01.168.43v.818a.541.541 0 01-.168.387.516.516 0 01-.378.172L.546 23.957a.516.516 0 01-.378-.172.541.541 0 01-.168-.387v-.818a.59.59 0 01.168-.43.516.516 0 01.378-.173l21.908.043z"
		}),
		up = new op({
			name: "mic",
			path:
				"M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.41 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
		}),
		lp = new op({
			name: "directions",
			path:
				"M23.649 11.154L12.846.35a1.195 1.195 0 00-1.692 0L.35 11.154a1.195 1.195 0 000 1.692L11.154 23.65a1.195 1.195 0 001.692 0L23.65 12.846c.468-.456.468-1.212 0-1.692zm-9.254 3.853v-3.001H9.593v3.6h-2.4v-4.8c0-.66.54-1.2 1.2-1.2h6.002V6.604l4.2 4.2-4.2 4.202z"
		}),
		fp = new op({
			name: "calendar",
			path:
				"M18.111 13.2H12v6h6.111v-6zM16.89 0v2.4H7.11V0H4.667v2.4H3.444c-1.356 0-2.432 1.08-2.432 2.4L1 21.6C1 22.92 2.088 24 3.444 24h17.112C21.9 24 23 22.92 23 21.6V4.8c0-1.32-1.1-2.4-2.444-2.4h-1.223V0H16.89zm3.667 21.6H3.444V8.4h17.112v13.2z"
		}),
		hp = new op({
			name: "callout",
			path:
				"M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z"
		}),
		pp = new op({
			name: "info",
			path:
				"M12 8.4A1.2 1.2 0 1012 6a1.2 1.2 0 000 2.4zM12 0c6.624 0 12 5.376 12 12s-5.376 12-12 12S0 18.624 0 12 5.376 0 12 0zm0 18c.66 0 1.2-.54 1.2-1.2V12c0-.66-.54-1.2-1.2-1.2-.66 0-1.2.54-1.2 1.2v4.8c0 .66.54 1.2 1.2 1.2z"
		}),
		dp = new op({
			name: "briefcase",
			path:
				"M20 7h-4V5c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 20c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V9c0-1.11-.89-2-2-2zm-6 0h-4V5h4v2z"
		}),
		vp = new op({
			name: "kabob",
			viewBox: "0 0 3 11",
			complexContents:
				'<circle cx="1.5" cy="1.5" r="1.5"/><circle cx="1.5" cy="5.5" r="1.5"/><circle cx="1.5" cy="9.5" r="1.5"/>'
		}),
		mp = new op({
			name: "person",
			viewBox: "0 0 18 18",
			path:
				"M9 9c2.486 0 4.5-2.014 4.5-4.5S11.486 0 9 0a4.499 4.499 0 00-4.5 4.5C4.5 6.986 6.514 9 9 9zm0 2.25c-3.004 0-9 1.508-9 4.5v1.125C0 17.494.506 18 1.125 18h15.75c.619 0 1.125-.506 1.125-1.125V15.75c0-2.992-5.996-4.5-9-4.5z"
		}),
		gp = new op({
			name: "magnifying_glass",
			path:
				"M16.124 13.051a5.154 5.154 0 110-10.308 5.154 5.154 0 010 10.308M16.114 0a7.886 7.886 0 00-6.46 12.407L0 22.06 1.94 24l9.653-9.653A7.886 7.886 0 1016.113 0"
		}),
		yp = new op({
			name: "office",
			path:
				"M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
		}),
		_p = new op({
			name: "link",
			path:
				"M2.28 12A3.723 3.723 0 016 8.28h4.8V6H6c-3.312 0-6 2.688-6 6s2.688 6 6 6h4.8v-2.28H6A3.723 3.723 0 012.28 12zm4.92 1.2h9.6v-2.4H7.2v2.4zM18 6h-4.8v2.28H18A3.723 3.723 0 0121.72 12 3.723 3.723 0 0118 15.72h-4.8V18H18c3.312 0 6-2.688 6-6s-2.688-6-6-6z"
		}),
		bp = new op({
			name: "window",
			path: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
		}),
		wp = new op({
			name: "phone",
			path:
				"M4.827 10.387a20.198 20.198 0 008.786 8.786l2.934-2.933c.36-.36.893-.48 1.36-.32a15.21 15.21 0 004.76.76c.733 0 1.333.6 1.333 1.333v4.654C24 23.4 23.4 24 22.667 24 10.147 24 0 13.853 0 1.333 0 .6.6 0 1.333 0H6c.733 0 1.333.6 1.333 1.333 0 1.667.267 3.267.76 4.76.147.467.04.987-.333 1.36l-2.933 2.934z"
		}),
		Sp = new op({
			name: "tag",
			viewBox: "0 0 18 18",
			path:
				"M17.469 8.622l-8.1-8.1A1.789 1.789 0 008.1 0H1.8C.81 0 0 .81 0 1.8v6.3c0 .495.198.945.531 1.278l8.1 8.1c.324.324.774.522 1.269.522a1.76 1.76 0 001.269-.531l6.3-6.3A1.76 1.76 0 0018 9.9c0-.495-.207-.954-.531-1.278zM3.15 4.5c-.747 0-1.35-.603-1.35-1.35 0-.747.603-1.35 1.35-1.35.747 0 1.35.603 1.35 1.35 0 .747-.603 1.35-1.35 1.35z"
		}),
		kp = new op({
			name: "document",
			path:
				"M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"
		}),
		xp = new op({
			name: "chevron",
			viewBox: "0 0 7 9",
			complexContents:
				'<g fill-rule="evenodd" transform="translate(-1 -8)"><path d="m2.6417004 8-1.1417004 1.0575 3.70850202 3.4425-3.70850202 3.4425 1.1417004 1.0575 4.8582996-4.5z"/></g>'
		}),
		Mp = new op({
			name: "support",
			path:
				"M12,0 C5.376,0 0,5.376 0,12 C0,18.624 5.376,24 12,24 C18.624,24 24,18.624 24,12 C24,5.376 18.624,0 12,0 Z M13,19 L11,19 L11,17 L13,17 L13,19 Z M15.07,11.25 L14.17,12.17 C13.45,12.9 13,13.5 13,15 L11,15 L11,14.5 C11,13.4 11.45,12.4 12.17,11.67 L13.41,10.41 C13.78,10.05 14,9.55 14,9 C14,7.9 13.1,7 12,7 C10.9,7 10,7.9 10,9 L8,9 C8,6.79 9.79,5 12,5 C14.21,5 16,6.79 16,9 C16,9.88 15.64,10.68 15.07,11.25 Z"
		}),
		Ap = new op({
			name: "yext",
			viewBox: "0 0 30 30",
			path:
				"M25.517 28.142v.095h-.204v.905h-.066v-.905h-.197v-.095h.467zm.667 0h.066v1h-.066v-.825l-.24.595h-.013l-.24-.595v.825h-.066v-1h.066l.247.61.246-.61zM15 28.8c7.622 0 13.8-6.178 13.8-13.8 0-7.622-6.178-13.8-13.8-13.8C7.378 1.2 1.2 7.378 1.2 15c0 7.622 6.178 13.8 13.8 13.8zM15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0zm.45 16.65v-1.2h6.6v1.2h-2.7v5.4h-1.2v-5.4h-2.7zm-1.599-1.35l.849.849-2.601 2.601 2.601 2.601-.849.849-2.601-2.601L8.649 22.2l-.849-.849 2.601-2.601L7.8 16.149l.849-.849 2.601 2.601 2.601-2.601zM18.675 9a2.175 2.175 0 00-1.847 3.323l2.995-2.995A2.163 2.163 0 0018.675 9zm0 5.55a3.375 3.375 0 112.833-5.209l-3.789 3.788a2.175 2.175 0 003.13-1.954h1.201a3.375 3.375 0 01-3.375 3.375zm-7.425-3.734L13.78 7.8l.92.771-2.85 3.397v2.582h-1.2v-2.582L7.8 8.57l.92-.771 2.53 3.016z"
		}),
		Ep = new op({
			name: "pin",
			viewBox: "5 0 9 18",
			path:
				"m9.375 0c-3.52446429 0-6.375 2.817-6.375 6.3 0 4.725 6.375 11.7 6.375 11.7s6.375-6.975 6.375-11.7c0-3.483-2.8505357-6.3-6.375-6.3zm.00000018 8.55000007c-1.25678576 0-2.27678579-1.008-2.27678579-2.25s1.02000003-2.25 2.27678579-2.25c1.25678572 0 2.27678582 1.008 2.27678582 2.25s-1.0200001 2.25-2.27678582 2.25z"
		}),
		Cp = new op({
			name: "gear",
			path:
				"M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42a.353.353 0 01.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16a.353.353 0 01-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z"
		}),
		Ip = new op({
			name: "light_bulb",
			viewBox: "0 0 32 35",
			path:
				"M11.585 31.056l8.38-.493v-.986l-8.38.493zM11.585 33.028L15.775 35l4.19-1.972V31.55l-8.38.493v.986zm6.926-.407l-2.736 1.29-2.13-1.004 4.866-.286zM15.775 7.394c-4.63 0-8.38 3.205-8.38 8.38 0 5.177 4.19 6.902 4.19 12.818v.493l8.38-.493c0-5.916 4.19-8.188 4.19-12.817a8.38 8.38 0 00-8.38-8.38zm5.617 13.48c-1.025 1.837-2.174 3.892-2.381 6.786l-6.44.38c-.129-3.01-1.29-5.021-2.32-6.808-.493-.8-.928-1.636-1.299-2.5h13.556c-.325.708-.704 1.403-1.116 2.142zm1.479-3.128H8.627a7.793 7.793 0 01-.247-1.971c0-4.353 3.042-7.395 7.395-7.395a7.394 7.394 0 017.394 7.395 6.739 6.739 0 01-.3 1.971h.002zM26.62 15.282h4.93v1h-4.93zM23.094 7.756l2.091-2.091.698.697-2.092 2.092zM15.282 0h1v4.93h-1zM5.666 6.362l.697-.697 2.091 2.091-.697.697zM0 15.282h4.93v1H0z"
		}),
		Tp = new op({
			name: "star",
			viewBox: "0 0 18 18",
			path:
				"M8.991 0C4.023 0 0 4.032 0 9s4.023 9 8.991 9C13.968 18 18 13.968 18 9s-4.032-9-9.009-9zm3.816 14.4L9 12.105 5.193 14.4l1.008-4.329-3.357-2.907 4.428-.378L9 2.7l1.728 4.077 4.428.378-3.357 2.907z"
		}),
		Op = new op({
			name: "close",
			viewBox: "0 1 24 24",
			complexContents:
				'\n    <path d="M7 8l9.716 9.716m0-9.716L7 17.716"\n          stroke="currentColor"\n          stroke-width="2"/>\n  '
		}),
		Rp = [
			ap,
			sp,
			cp,
			up,
			lp,
			fp,
			hp,
			pp,
			dp,
			vp,
			mp,
			gp,
			yp,
			_p,
			bp,
			wp,
			Sp,
			kp,
			xp,
			Mp,
			Ap,
			Ep,
			Cp,
			Ip,
			new op({
				name: "elements",
				path:
					"M13,15 L13,17 L21,17 L21,19 L13,19 L13,21 L11,21 L11,15 L13,15 Z M9,17 L9,19 L3,19 L3,17 L9,17 Z M9,15 L7,15 L7,13 L3,13 L3,11 L7,11 L7,9 L9,9 L9,15 Z M21,11 L21,13 L11,13 L11,11 L21,11 Z M17,3 L17,5 L21,5 L21,7 L17,7 L17,9 L15,9 L15,3 L17,3 Z M13,5 L13,7 L3,7 L3,5 L13,5 Z"
			}),
			Op,
			new op({
				name: "yext_animated_reverse",
				viewBox: "0 0 72 72",
				complexContents: function (e) {
					void 0 === e && (e = {});
					var t = e.iconPrefix || "yxt";
					return (
						'<defs>\n      <mask id="' +
						t +
						'_reverse_Mask-1">\n        <rect fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-2">\n        <rect x="-144.3" y="144.3" fill="#fff" width="720" height="720" />\n        <path d="M-0.3 .1c0 0 1.3 1.2 1.3 1.2c0 0 .3-1.6 .3-1.6c0 0-1.6 .4-1.6 .4" />\n        <path fill="#fff" d="M.3 .7c0 0-0.3 .3-0.3 .3c0 0 0 0 0 0c0 0 .3-0.3 .3-0.3c0 0 0 0 0 0" />\n        <path d="M.3 .7c0 0-0.1 0-0.1 0c0 0 .1 .1 .1 .1c0 0 .1-0.1 .1-0.1c0 0-0.1 0-0.1 0m222.8 469.1c0 0-70.5 69.4-70.5 69.4c0 0 34.1 33.5 34.1 33.5c0 0 67-72.9 67-72.9c0 0-30.6-30-30.6-30" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-3">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M489.8 277.4c0 0 78 18.8 78 18.8c0 0-96.1 61.5-96.1 61.5c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-13.9 14-13.9 14m-67.8-108.1c0 0 73.9 1.3 73.9 1.3c0 0-33.8 54.5-33.8 54.5c0 0 18.6-3.2 18.6-3.2c0 0 35.4-36.5 35.4-36.5c0 0-62-25.9-62-25.9c0 0-32.1 9.8-32.1 9.8" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-4">\n        <rect x="-91.1" y="91.1" fill="#fff" width="720" height="720" />\n        <path d="M-0.3 .1c0 0 1.3 1.2 1.3 1.2c0 0 .3-1.6 .3-1.6c0 0-1.6 .4-1.6 .4" />\n        <path fill="#fff" d="M.3 .7c0 0-0.3 .3-0.3 .3c0 0 0 0 0 0c0 0 .3-0.3 .3-0.3c0 0 0 0 0 0" />\n        <path d="M.3 .7c0 0-0.1 0-0.1 0c0 0 .1 .1 .1 .1c0 0 .1-0.1 .1-0.1c0 0-0.1 0-0.1 0m222.8 469.1c0 0-70.5 69.4-70.5 69.4c0 0 34.1 33.5 34.1 33.5c0 0 67-72.9 67-72.9c0 0-30.6-30-30.6-30" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-5">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M488.4 291.4c0 0 40.5 39.3 40.5 39.3c0 0-57.2 27-57.2 27c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-15.3 28-15.3 28m-90.5-97.4c0 0 52-11.3 52-11.3c0 0-6 45.2-6 45.2c0 0 36.8-6 36.8-6c0 0 39.3-31.9 39.3-31.9c0 0-65.9-30.5-65.9-30.5c0 0-56.2 34.5-56.2 34.5" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-6">\n        <rect x="-61.3" y="61.3" fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-7">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M481.8 298.4c0 0 27.5 39.8 27.5 39.8c0 0-37.6 19.5-37.6 19.5c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-21.9 35-21.9 35m-108.1-79.7c0 0 30.2-23.8 30.2-23.8c0 0 21.7 35.9 21.7 35.9c0 0 55.1-8.9 55.1-8.9c0 0 35.4-36.5 35.4-36.5c0 0-62-25.9-62-25.9c0 0-80.4 59.2-80.4 59.2" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-8">\n        <rect x="-42.6" y="42.6" fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-9">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M475.2 305.4c0 0 14.5 40.3 14.5 40.3c0 0-18 12-18 12c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-28.5 42-28.5 42m-113.6-74.3c0 0 17.9-18.5 17.9-18.5c0 0 36.4 25.3 36.4 25.3c0 0 64.8-16 64.8-16c0 0 39.3-31.9 39.3-31.9c0 0-65.9-30.5-65.9-30.5c0 0-92.5 71.6-92.5 71.6" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-10">\n        <rect x="-29.6" y="29.6" fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-11">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M468.6 312.4c0 0 1.5 40.8 1.5 40.8c0 0 1.6 4.5 1.6 4.5c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-35.1 49-35.1 49m-107-81.3c0 0 15.1 4.9 15.1 4.9c0 0 38.2 13.3 38.2 13.3c0 0 65.8-27.4 65.8-27.4c0 0 39.3-21.9 39.3-21.9c0 0-65.9-40.5-65.9-40.5c0 0-92.5 71.6-92.5 71.6" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-12">\n        <rect x="-20.3" y="20.3" fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-13">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M456.6 311.9c0 0-7 35.6-7 35.6c0 0 22.1 10.2 22.1 10.2c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-47.1 48.5-47.1 48.5m-95-80.8c0 0 12.3 28.3 12.3 28.3c0 0 39.9 1.3 39.9 1.3c0 0 66.9-38.8 66.9-38.8c0 0 39.3-21.9 39.3-21.9c0 0-65.9-40.5-65.9-40.5c0 0-92.5 71.6-92.5 71.6" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-14">\n        <rect x="-13.4" y="13.4" fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-15">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M444.6 311.4c0 0-15.6 30.5-15.6 30.5c0 0 42.7 15.8 42.7 15.8c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-59.1 48-59.1 48m-83-80.3c0 0 9.5 51.7 9.5 51.7c0 0 41.7-10.8 41.7-10.8c0 0 67.9-50.1 67.9-50.1c0 0 50.6-31.9 50.6-31.9c0 0-77.2-30.5-77.2-30.5c0 0-92.5 71.6-92.5 71.6" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-16">\n        <rect x="-7.3" y="7.3" fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-17">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M432.6 310.9c0 0-24.2 25.3-24.2 25.3c0 0 63.3 21.5 63.3 21.5c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-71.1 47.5-71.1 47.5m-71-79.8c0 0 20.3 90.4 20.3 90.4c0 0 29-29.5 29-29.5c0 0 69.8-70.1 69.8-70.1c0 0 35.4-36.5 35.4-36.5c0 0-62-25.9-62-25.9c0 0-92.5 71.6-92.5 71.6" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-18">\n        <rect x="-4" y="4" fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-19">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M432.6 310.9c0 0-24.2 25.3-24.2 25.3c0 0 63.3 21.5 63.3 21.5c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-71.1 47.5-71.1 47.5m-71-79.8c0 0 20.3 90.4 20.3 90.4c0 0 29-29.5 29-29.5c0 0 69.8-70.1 69.8-70.1c0 0 39.3-31.9 39.3-31.9c0 0-65.9-30.5-65.9-30.5c0 0-92.5 71.6-92.5 71.6" />\n      </mask>\n      <mask id="' +
						t +
						'_reverse_Mask-20">\n        <rect fill="#fff" width="720" height="720" />\n      </mask>\n      <clipPath id="' +
						t +
						'_reverse_ClipPath-1">\n        <rect width="720" height="720" />\n      </clipPath>\n    </defs>\n    <g transform="translate(0,0) scale(.1,.1)">\n      <g mask="url(#' +
						t +
						'_reverse_Mask-1)">\n        <path d="M377.5 395.3c0 0 64.8 0 64.8 0c0 0 0 129.6 0 129.6c0 0 28.8 0 28.8 0c0 0 0-129.6 0-129.6c0 0 64.8 0 64.8 0c0 0 0-28.8 0-28.8c0 0-158.4 0-158.4 0c0 0 0 28.8 0 28.8Z" />\n        <path d="M338.9 363.6c0 0-62.5 62.4-62.5 62.4c0 0-62.4-62.4-62.4-62.4c0 0-20.4 20.4-20.4 20.4c0 0 62.5 62.4 62.5 62.4c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 62.5 62.4 62.5 62.4c0 0 20.3-20.4 20.3-20.4c0 0-62.4-62.4-62.4-62.4c0 0 62.4-62.4 62.4-62.4c0 0-20.3-20.4-20.3-20.4Z" />\n        <path d="M454.7 345.8c44.8 0 81-36.3 81-81c0 0-28.8 0-28.8 0c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3c0 0 69.8-69.9 69.8-69.9c0 0 21.1-21 21.1-21c-14.4-22.3-39.5-37-68-37c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81Zm0-133.2c10.2 0 19.6 2.9 27.6 7.9c0 0-71.9 71.8-71.9 71.8c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2Z" />\n        <path d="M276.4 255.9c0 0-60.7-72.8-60.7-72.8c0 0-22.1 18.6-22.1 18.6c0 0 68.4 82 68.4 82c0 0 0 62.4 0 62.4c0 0 28.8 0 28.8 0c0 0 0-62.6 0-62.6c0 0 68.4-81.8 68.4-81.8c0 0-22-18.6-22-18.6c0 0-60.8 72.8-60.8 72.8Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-353.7c195.2 0 353.7 158.5 353.7 353.7c0 195.2-158.5 353.7-353.7 353.7c-195.2 0-353.7-158.5-353.7-353.7c0-195.2 158.5-353.7 353.7-353.7Z" fill="none" transform="translate(359.8,360.4) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_reverse_Mask-2)" transform="translate(144.3,-144.3)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g display="block" mask="url(#' +
						t +
						'_reverse_Mask-3)">\n        <path d="M390.6 395.2c0 0 51.7 .1 51.7 .1c0 0 .1 103.6 .1 103.6c0 0 28.7 0 28.7 0c0 0 0-103.6 0-103.6c0 0 52-0.1 52-0.1c0 0 0-28.4 0-28.4c0 0-132.5 0-132.5 0c0 0 0 28.4 0 28.4Z" />\n        <path d="M329 373.4c0 .1-52.6 52.6-52.6 52.6c0 0-62.4-62.4-62.4-62.4c0 0-20.4 20.4-20.4 20.4c0 0 62.5 62.4 62.5 62.4c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 62.5 62.4 62.5 62.4c0 0 20.3-20.4 20.3-20.4c0 0-62.4-62.4-62.4-62.4c0 0 52.6-52.6 52.6-52.6c0 0-20.4-20.3-20.4-20.3Z" />\n        <path d="M454.7 345.8c44.8 0 81-36.3 81-81c0 0-28.8 0-28.8 0c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3c0 0 69.8-69.9 69.8-69.9c0 0 21.1-21 21.1-21c-14.4-22.3-39.5-37-68-37c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81Zm0-133.2c10.2 0 19.6 2.9 27.6 7.9c0 0-71.9 71.8-71.9 71.8c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2Z" />\n        <path d="M276.4 255.9c0 0-48.7-58.3-48.7-58.3c0 0-21.1 19-21.1 19c0 0 55.5 67.2 55.5 67.2c0 0 .3 50 .3 50c0 0 28.4 0 28.4 0c0 0 0-50.3 0-50.3c0 0 55.4-66.9 55.4-66.9c0 0-21-18.6-21-18.6c0 0-48.8 57.9-48.8 57.9Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-336.2c185.6 0 336.2 150.6 336.2 336.2c0 185.6-150.6 336.2-336.2 336.2c-185.6 0-336.2-150.6-336.2-336.2c0-185.6 150.6-336.2 336.2-336.2Z" fill="none" display="block" transform="translate(370.8,347.5) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g mask="url(#' +
						t +
						'_reverse_Mask-4)" transform="translate(91.1,-91.1)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g mask="url(#' +
						t +
						'_reverse_Mask-5)">\n        <path d="M409.7 395.1c0 0 32.6 .2 32.6 .2c0 0 .3 65.5 .3 65.5c0 0 28.5 0 28.5 0c0 0 0-65.5 0-65.5c0 0 33.1-0.2 33.1-0.2c0 0 0-27.8 0-27.8c0 0-94.5 0-94.5 0c0 0 0 27.8 0 27.8Z" />\n        <path d="M319.7 382.8c0 0-43.3 43.2-43.3 43.2c0 0-62.4-62.4-62.4-62.4c0 0-20.4 20.4-20.4 20.4c0 0 62.5 62.4 62.5 62.4c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 62.5 62.4 62.5 62.4c0 0 20.3-20.4 20.3-20.4c0 0-62.4-62.4-62.4-62.4c0 0 43.4-43.3 43.4-43.3c0 0-20.5-20.3-20.5-20.3Z" />\n        <path d="M502.8 199.6c-13.4-9.9-30-15.8-48.1-15.8c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81c44.8 0 81-36.3 81-81h-28.8c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3l69.8-69.9l.3-0.2l-20.3-20.4l-71.2 71.1c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2c10.1 0 19.4 2.8 27.4 7.7Z" fill-rule="evenodd" />\n        <path d="M276.4 255.9c0 0-31.1-37-31.1-37c0 0-19.7 19.5-19.7 19.5c0 0 36.7 45.6 36.7 45.6c0 0 .7 31.8 .7 31.8c0 0 27.7 0 27.7 0c0 0 0-32.4 0-32.4c0 0 36.5-44.9 36.5-44.9c0 0-19.6-18.6-19.6-18.6c0 0-31.2 36-31.2 36Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-310c171.1 0 310 138.9 310 310c0 171.1-138.9 310-310 310c-171.1 0-310-138.9-310-310c0-171.1 138.9-310 310-310Z" fill="none" transform="translate(387.8,328.7) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_reverse_Mask-6)" transform="translate(61.3,-61.3)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g mask="url(#' +
						t +
						'_reverse_Mask-7)">\n        <path d="M420.4 395c0 0 21.9 .3 21.9 .3c0 0 .4 44.1 .4 44.1c0 0 28.4 0 28.4 0c0 0 0-44.1 0-44.1c0 0 22.6-0.3 22.6-0.3c0 0 0-27.5 0-27.5c0 0-73.3 0-73.3 0c0 0 0 27.5 0 27.5Z" />\n        <path d="M313.2 389.2c0 0-36.8 36.8-36.8 36.8c0 0-62.4-62.4-62.4-62.4c0 0-20.4 20.4-20.4 20.4c0 0 62.5 62.4 62.5 62.4c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 62.5 62.4 62.5 62.4c0 0 20.3-20.4 20.3-20.4c0 0-62.4-62.4-62.4-62.4c0 0 37-36.9 37-36.9c0 0-20.6-20.3-20.6-20.3Z" />\n        <path d="M500 200c-13.4-9.9-27.2-16.2-45.3-16.2c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81c44.8 0 81-36.3 81-81h-28.8c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3l57.7-57.7l-20.3-20.4l-58.8 58.7c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2c10.1 0 19.4 2.8 27.4 7.7Z" fill-rule="evenodd" />\n        <path d="M276.4 255.9c0 0-21.2-25.1-21.2-25.1c0 0-19 19.8-19 19.8c0 0 26.2 33.5 26.2 33.5c0 0 1 21.6 1 21.6c0 0 27.2 0 27.2 0c0 0 0-22.3 0-22.3c0 0 25.9-32.7 25.9-32.7c0 0-18.8-18.6-18.8-18.6c0 0-21.3 23.8-21.3 23.8Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-294.3c162.4 0 294.3 131.9 294.3 294.3c0 162.4-131.9 294.3-294.3 294.3c-162.4 0-294.3-131.9-294.3-294.3c0-162.4 131.9-294.3 294.3-294.3Z" fill="none" display="block" transform="translate(398.7,318.2) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g mask="url(#' +
						t +
						'_reverse_Mask-8)" transform="translate(42.6,-42.6)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g display="block" mask="url(#' +
						t +
						'_reverse_Mask-9)">\n        <path d="M427.2 394.9c0 0 15.1 .4 15.1 .4c0 0 .4 30.7 .4 30.7c0 0 28.4 0 28.4 0c0 0 0-30.7 0-30.7c0 0 15.9-0.4 15.9-0.4c0 0 0-27.2 0-27.2c0 0-59.8 0-59.8 0c0 0 0 27.2 0 27.2Z" />\n        <path d="M307.4 395c0 0-31 31-31 31c0 0-53.9-54-53.9-54c0 0-20.4 20.4-20.4 20.4c0 0 54 54 54 54c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 54 54 54 54c0 0 20.4-20.3 20.4-20.3c0 0-54-54.1-54-54.1c0 0 31.2-31.1 31.2-31.1c0 0-20.6-20.3-20.6-20.3Z" />\n        <path d="M502.8 199.6c-13.4-9.9-30.1-15.8-48.1-15.8c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81c44.8 0 81-36.3 81-81h-28.8c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3l45.5-45.5l-20.4-20.4l-46.5 46.5c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2c10.1 0 19.4 2.8 27.4 7.7Z" fill-rule="evenodd" />\n        <path d="M276.4 255.9c0 0-15-17.6-15-17.6c0 0-18.4 20-18.4 20c0 0 19.4 25.8 19.4 25.8c0 0 1.2 15.2 1.2 15.2c0 0 27 0 27 0c0 0 0-15.9 0-15.9c0 0 19.1-24.9 19.1-24.9c0 0-18.2-18.7-18.2-18.7c0 0-15.1 16.1-15.1 16.1Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-284.4c157 0 284.4 127.4 284.4 284.4c0 157-127.4 284.4-284.4 284.4c-157 0-284.4-127.4-284.4-284.4c0-157 127.4-284.4 284.4-284.4Z" fill="none" transform="translate(406.1,311.6) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_reverse_Mask-10)" transform="translate(29.6,-29.6)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g display="block" mask="url(#' +
						t +
						'_reverse_Mask-11)">\n        <path d="M436 393.5c0 0 8.7 .4 8.7 .4c0 0 .4 17.8 .4 17.8c0 0 23.6 0 23.6 0c0 0 0-17.8 0-17.8c0 0 9.4-0.4 9.4-0.4c0 0 0-22.6 0-22.6c0 0-42.1 0-42.1 0c0 0 0 22.6 0 22.6Z" />\n        <path d="M297.2 405.2c0 0-20.8 20.8-20.8 20.8c0 0-35.4-35.6-35.4-35.6c0 0-20.3 20.5-20.3 20.5c0 0 35.4 35.5 35.4 35.5c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 35.6 35.5 35.6 35.5c0 0 20.2-20.2 20.2-20.2c0 0-35.4-35.7-35.4-35.7c0 0 21.1-21 21.1-21c0 0-20.7-20.2-20.7-20.2Z" />\n        <path d="M502.8 199.6c-13.4-9.9-30.1-15.8-48.1-15.8c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81c44.8 0 81-36.3 81-81h-28.8c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3l33.7-33.7l-20.4-20.3l-34.7 34.6c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2c10.1 0 19.4 2.8 27.4 7.7Z" fill-rule="evenodd" />\n        <path d="M276.4 255.9c0 0-10.7-12.4-10.7-12.4c0 0-18.1 20.1-18.1 20.1c0 0 14.9 20.6 14.9 20.6c0 0 1.2 10.7 1.2 10.7c0 0 26.8 0 26.8 0c0 0 0-11.5 0-11.5c0 0 14.6-19.6 14.6-19.6c0 0-17.9-18.6-17.9-18.6c0 0-10.8 10.7-10.8 10.7Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-277.5c153.1 0 277.5 124.4 277.5 277.5c0 153.1-124.4 277.5-277.5 277.5c-153.1 0-277.5-124.4-277.5-277.5c0-153.1 124.4-277.5 277.5-277.5Z" fill="none" display="block" transform="translate(411.2,307.1) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_reverse_Mask-12)" transform="translate(20.3,-20.3)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g display="block" mask="url(#' +
						t +
						'_reverse_Mask-13)">\n        <path d="M446 390.8c0 0 3.5 .2 3.5 .2c0 0 .2 7.3 .2 7.3c.1 0 14.2 0 14.2 0c0 0 0-7.3 0-7.3c0 0 4-0.2 4-0.2c0 0 0-13.5 0-13.5c0 0-21.9 0-21.9 0c0 0 0 13.5 0 13.5Z" />\n        <path d="M287.9 414.4c0 0-11.5 11.6-11.5 11.6c0 0-18.5-18.8-18.5-18.8c0 0-20.3 20.5-20.3 20.5c0 0 18.5 18.7 18.5 18.7c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 18.7 18.7 18.7 18.7c0 0 20.2-20 20.2-20c0 0-18.5-19.1-18.5-19.1c0 0 11.9-11.8 11.9-11.8c0 0-20.8-20.2-20.8-20.2Z" />\n        <path d="M502.8 199.6c-13.4-10-30.1-15.8-48.1-15.8c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81c44.8 0 81-36.3 81-81h-28.8c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3l22.4-22.4l-20.4-20.4l-23.4 23.4c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2c10.1 0 19.4 2.8 27.4 7.7Z" fill-rule="evenodd" />\n        <path d="M276.4 259.4c0 0-4.5-5.2-4.5-5.2c0 0-10.7 12.1-10.7 12.1c0 0 6.9 10.1 6.9 10.1c0 0 .8 4.5 .8 4.5c0 0 16 0 16 0c0 0 0-5 0-5c0 0 6.7-9.4 6.7-9.4c0 0-10.6-11.2-10.6-11.2c0 0-4.6 4.1-4.6 4.1Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-272.5c150.4 0 272.5 122.1 272.5 272.5c0 150.4-122.1 272.5-272.5 272.5c-150.4 0-272.5-122.1-272.5-272.5c0-150.4 122.1-272.5 272.5-272.5Z" fill="none" display="block" transform="translate(414.9,303.7) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_reverse_Mask-14)" transform="translate(13.4,-13.4)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g display="block" mask="url(#' +
						t +
						'_reverse_Mask-15)">\n        <path d="M453.6 388.1c0 0 .7 0 .7 0c0 0 .1 1.7 .1 1.7c0 0 4.7 0 4.7 0c0 0 0-1.7 0-1.7c0 0 1 0 1 0c0 0 0-4.5 0-4.5c0 0-6.5 0-6.5 0c0 0 0 4.5 0 4.5Z" />\n        <path d="M280.8 421.5c0 0-4.4 4.5-4.4 4.5c0 0-5.5-5.9-5.5-5.9c0 0-20.3 20.6-20.3 20.6c0 0 5.5 5.7 5.5 5.7c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 5.8 5.7 5.8 5.7c0 0 20.1-19.9 20.1-19.9c0 0-5.5-6.2-5.5-6.2c0 0 4.8-4.6 4.8-4.6c0 0-20.8-20.3-20.8-20.3Z" />\n        <path d="M502.8 199.6c-13.4-10-30.1-15.8-48.1-15.8c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81c44.8 0 81-36.3 81-81h-28.8c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3l11.9-11.9l-20.4-20.3l-12.9 12.8c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2c10.1 0 19.4 2.8 27.4 7.7Z" fill-rule="evenodd" />\n        <path d="M276.4 262.9c0 0-1-1.2-1-1.2c0 0-3.6 4-3.6 4c0 0 1.9 2.8 1.9 2.8c0 0 .2 1.1 .2 1.1c0 0 5.4 0 5.4 0c0 0 0-1.2 0-1.2c0 0 1.7-2.6 1.7-2.6c0 0-3.5-3.7-3.5-3.7c0 0-1.1 .8-1.1 .8Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-268.8c148.4 0 268.8 120.4 268.8 268.8c0 148.4-120.4 268.8-268.8 268.8c-148.4 0-268.8-120.4-268.8-268.8c0-148.4 120.4-268.8 268.8-268.8Z" fill="none" display="block" transform="translate(417.6,301.3) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_reverse_Mask-16)" transform="translate(7.3,-7.3)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g display="block" mask="url(#' +
						t +
						'_reverse_Mask-17)">\n        <path d="M275.4 426.9c0 0-19.3 19.5-19.3 19.5c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 19.9-19.7 19.9-19.7c0 0-20.9-20.2-20.9-20.2Z" />\n        <path d="M411.4 291.3l20.7 20.7l.1-0.1c6.8 3.2 14.5 5.1 22.5 5.1c28.9 0 52.2-23.4 52.2-52.2h28.8c0 44.7-36.2 81-81 81c-44.7 0-81-36.3-81-81c0-44.8 36.3-81 81-81c18 0 21.9 6.3 35.3 16.2l-7.9 20.3c-8-4.9-17.3-7.7-27.4-7.7c-28.8 0-52.2 23.3-52.2 52.2c0 10.1 2.9 19.5 7.9 27.5Z" fill-rule="evenodd" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-265.6c146.6 0 265.6 119 265.6 265.6c0 146.6-119 265.6-265.6 265.6c-146.6 0-265.6-119-265.6-265.6c0-146.6 119-265.6 265.6-265.6Z" fill="none" display="block" transform="translate(420,299.1) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_reverse_Mask-18)" transform="translate(4,-4)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g display="block" mask="url(#' +
						t +
						'_reverse_Mask-19)">\n        <path d="M265.4 437.1c0 0-9.3 9.3-9.3 9.3c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 9.8-9.6 9.8-9.6c0 0-20.8-20.1-20.8-20.1Z" />\n        <path d="M403 299.3l20.9 20.9l8.3-8.3c6.8 3.2 14.5 5.1 22.5 5.1c28.9 0 52.2-23.4 52.2-52.2h28.8c0 44.7-36.2 81-81 81c-44.7 0-81-36.3-81-81c0-44.8 36.3-81 81-81c18 0 34.6 5.8 48.1 15.8l-20.7 20.7c-8-4.9-17.3-7.7-27.4-7.7c-28.8 0-52.2 23.3-52.2 52.2c0 10 2.9 19.3 7.8 27.3Z" fill-rule="evenodd" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-263.8c145.6 0 263.8 118.2 263.8 263.8c0 145.6-118.2 263.8-263.8 263.8c-145.6 0-263.8-118.2-263.8-263.8c0-145.6 118.2-263.8 263.8-263.8Z" fill="none" display="block" transform="translate(421.2,297.8) scale(.977,.977)" />\n    </g>\n    <g clip-path="url(#' +
						t +
						'_reverse_ClipPath-1)" opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_reverse_Mask-20)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-261.7c144.4 0 261.7 117.3 261.7 261.7c0 144.4-117.3 261.7-261.7 261.7c-144.4 0-261.7-117.3-261.7-261.7c0-144.4 117.3-261.7 261.7-261.7Z" fill="none" display="block" transform="translate(422.8,296.4) scale(.977,.977)" />\n    </g>'
					);
				}
			}),
			new op({
				name: "yext_animated_forward",
				viewBox: "0 0 72 72",
				complexContents: function (e) {
					void 0 === e && (e = {});
					var t = e.iconPrefix || "yxt";
					return (
						'<defs>\n      <mask id="' +
						t +
						'_forward_Mask-1">\n        <rect fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-2">\n        <rect x="-144.3" y="144.3" fill="#fff" width="720" height="720" />\n        <path d="M-0.3 .1c0 0 1.3 1.2 1.3 1.2c0 0 .3-1.6 .3-1.6c0 0-1.6 .4-1.6 .4" />\n        <path fill="#fff" d="M.3 .7c0 0-0.3 .3-0.3 .3c0 0 0 0 0 0c0 0 .3-0.3 .3-0.3c0 0 0 0 0 0" />\n        <path d="M.3 .7c0 0-0.1 0-0.1 0c0 0 .1 .1 .1 .1c0 0 .1-0.1 .1-0.1c0 0-0.1 0-0.1 0m222.8 469.1c0 0-70.5 69.4-70.5 69.4c0 0 34.1 33.5 34.1 33.5c0 0 67-72.9 67-72.9c0 0-30.6-30-30.6-30" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-3">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M489.8 277.4c0 0 78 18.8 78 18.8c0 0-96.1 61.5-96.1 61.5c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-13.9 14-13.9 14m-67.8-108.1c0 0 73.9 1.3 73.9 1.3c0 0-33.8 54.5-33.8 54.5c0 0 18.6-3.2 18.6-3.2c0 0 35.4-36.5 35.4-36.5c0 0-62-25.9-62-25.9c0 0-32.1 9.8-32.1 9.8" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-4">\n        <rect x="-91.1" y="91.1" fill="#fff" width="720" height="720" />\n        <path d="M-0.3 .1c0 0 1.3 1.2 1.3 1.2c0 0 .3-1.6 .3-1.6c0 0-1.6 .4-1.6 .4" />\n        <path fill="#fff" d="M.3 .7c0 0-0.3 .3-0.3 .3c0 0 0 0 0 0c0 0 .3-0.3 .3-0.3c0 0 0 0 0 0" />\n        <path d="M.3 .7c0 0-0.1 0-0.1 0c0 0 .1 .1 .1 .1c0 0 .1-0.1 .1-0.1c0 0-0.1 0-0.1 0m222.8 469.1c0 0-70.5 69.4-70.5 69.4c0 0 34.1 33.5 34.1 33.5c0 0 67-72.9 67-72.9c0 0-30.6-30-30.6-30" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-5">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M488.4 291.4c0 0 40.5 39.3 40.5 39.3c0 0-57.2 27-57.2 27c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-15.3 28-15.3 28m-90.5-97.4c0 0 52-11.3 52-11.3c0 0-6 45.2-6 45.2c0 0 36.8-6 36.8-6c0 0 39.3-31.9 39.3-31.9c0 0-65.9-30.5-65.9-30.5c0 0-56.2 34.5-56.2 34.5" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-6">\n        <rect x="-61.3" y="61.3" fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-7">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M481.8 298.4c0 0 27.5 39.8 27.5 39.8c0 0-37.6 19.5-37.6 19.5c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-21.9 35-21.9 35m-108.1-79.7c0 0 30.2-23.8 30.2-23.8c0 0 21.7 35.9 21.7 35.9c0 0 55.1-8.9 55.1-8.9c0 0 35.4-36.5 35.4-36.5c0 0-62-25.9-62-25.9c0 0-80.4 59.2-80.4 59.2" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-8">\n        <rect x="-42.6" y="42.6" fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-9">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M475.2 305.4c0 0 14.5 40.3 14.5 40.3c0 0-18 12-18 12c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-28.5 42-28.5 42m-113.6-74.3c0 0 17.9-18.5 17.9-18.5c0 0 36.4 25.3 36.4 25.3c0 0 64.8-16 64.8-16c0 0 39.3-31.9 39.3-31.9c0 0-65.9-30.5-65.9-30.5c0 0-92.5 71.6-92.5 71.6" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-10">\n        <rect x="-29.6" y="29.6" fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-11">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M468.6 312.4c0 0 1.5 40.8 1.5 40.8c0 0 1.6 4.5 1.6 4.5c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-35.1 49-35.1 49m-107-81.3c0 0 15.1 4.9 15.1 4.9c0 0 38.2 13.3 38.2 13.3c0 0 65.8-27.4 65.8-27.4c0 0 39.3-21.9 39.3-21.9c0 0-65.9-40.5-65.9-40.5c0 0-92.5 71.6-92.5 71.6" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-12">\n        <rect x="-20.3" y="20.3" fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-13">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M456.6 311.9c0 0-7 35.6-7 35.6c0 0 22.1 10.2 22.1 10.2c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-47.1 48.5-47.1 48.5m-95-80.8c0 0 12.3 28.3 12.3 28.3c0 0 39.9 1.3 39.9 1.3c0 0 66.9-38.8 66.9-38.8c0 0 39.3-21.9 39.3-21.9c0 0-65.9-40.5-65.9-40.5c0 0-92.5 71.6-92.5 71.6" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-14">\n        <rect x="-13.4" y="13.4" fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-15">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M444.6 311.4c0 0-15.6 30.5-15.6 30.5c0 0 42.7 15.8 42.7 15.8c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-59.1 48-59.1 48m-83-80.3c0 0 9.5 51.7 9.5 51.7c0 0 41.7-10.8 41.7-10.8c0 0 67.9-50.1 67.9-50.1c0 0 50.6-31.9 50.6-31.9c0 0-77.2-30.5-77.2-30.5c0 0-92.5 71.6-92.5 71.6" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-16">\n        <rect x="-7.3" y="7.3" fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-17">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M432.6 310.9c0 0-24.2 25.3-24.2 25.3c0 0 63.3 21.5 63.3 21.5c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-71.1 47.5-71.1 47.5m-71-79.8c0 0 20.3 90.4 20.3 90.4c0 0 29-29.5 29-29.5c0 0 69.8-70.1 69.8-70.1c0 0 35.4-36.5 35.4-36.5c0 0-62-25.9-62-25.9c0 0-92.5 71.6-92.5 71.6" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-18">\n        <rect x="-4" y="4" fill="#fff" width="720" height="720" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-19">\n        <rect fill="#fff" width="720" height="720" />\n        <path d="M432.6 310.9c0 0-24.2 25.3-24.2 25.3c0 0 63.3 21.5 63.3 21.5c0 0 59.6-41.1 59.6-41.1c0 0 10.6-53.8 10.6-53.8c0 0-38.2 .6-38.2 .6c0 0-71.1 47.5-71.1 47.5m-71-79.8c0 0 20.3 90.4 20.3 90.4c0 0 29-29.5 29-29.5c0 0 69.8-70.1 69.8-70.1c0 0 39.3-31.9 39.3-31.9c0 0-65.9-30.5-65.9-30.5c0 0-92.5 71.6-92.5 71.6" />\n      </mask>\n      <mask id="' +
						t +
						'_forward_Mask-20">\n        <rect fill="#fff" width="720" height="720" />\n      </mask>\n      <clipPath id="' +
						t +
						'_forward_ClipPath-1">\n        <rect width="720" height="720" />\n      </clipPath>\n    </defs>\n    <g transform="translate(0,0) scale(.1,.1)">\n      <g mask="url(#' +
						t +
						'_forward_Mask-1)">\n        <path d="M377.5 395.3c0 0 64.8 0 64.8 0c0 0 0 129.6 0 129.6c0 0 28.8 0 28.8 0c0 0 0-129.6 0-129.6c0 0 64.8 0 64.8 0c0 0 0-28.8 0-28.8c0 0-158.4 0-158.4 0c0 0 0 28.8 0 28.8Z" />\n        <path d="M338.9 363.6c0 0-62.5 62.4-62.5 62.4c0 0-62.4-62.4-62.4-62.4c0 0-20.4 20.4-20.4 20.4c0 0 62.5 62.4 62.5 62.4c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 62.5 62.4 62.5 62.4c0 0 20.3-20.4 20.3-20.4c0 0-62.4-62.4-62.4-62.4c0 0 62.4-62.4 62.4-62.4c0 0-20.3-20.4-20.3-20.4Z" />\n        <path d="M454.7 345.8c44.8 0 81-36.3 81-81c0 0-28.8 0-28.8 0c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3c0 0 69.8-69.9 69.8-69.9c0 0 21.1-21 21.1-21c-14.4-22.3-39.5-37-68-37c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81Zm0-133.2c10.2 0 19.6 2.9 27.6 7.9c0 0-71.9 71.8-71.9 71.8c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2Z" />\n        <path d="M276.4 255.9c0 0-60.7-72.8-60.7-72.8c0 0-22.1 18.6-22.1 18.6c0 0 68.4 82 68.4 82c0 0 0 62.4 0 62.4c0 0 28.8 0 28.8 0c0 0 0-62.6 0-62.6c0 0 68.4-81.8 68.4-81.8c0 0-22-18.6-22-18.6c0 0-60.8 72.8-60.8 72.8Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-353.7c195.2 0 353.7 158.5 353.7 353.7c0 195.2-158.5 353.7-353.7 353.7c-195.2 0-353.7-158.5-353.7-353.7c0-195.2 158.5-353.7 353.7-353.7Z" fill="none" transform="translate(359.8,360.4) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_forward_Mask-2)" transform="translate(144.3,-144.3)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g display="block" mask="url(#' +
						t +
						'_forward_Mask-3)">\n        <path d="M390.6 395.2c0 0 51.7 .1 51.7 .1c0 0 .1 103.6 .1 103.6c0 0 28.7 0 28.7 0c0 0 0-103.6 0-103.6c0 0 52-0.1 52-0.1c0 0 0-28.4 0-28.4c0 0-132.5 0-132.5 0c0 0 0 28.4 0 28.4Z" />\n        <path d="M329 373.4c0 .1-52.6 52.6-52.6 52.6c0 0-62.4-62.4-62.4-62.4c0 0-20.4 20.4-20.4 20.4c0 0 62.5 62.4 62.5 62.4c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 62.5 62.4 62.5 62.4c0 0 20.3-20.4 20.3-20.4c0 0-62.4-62.4-62.4-62.4c0 0 52.6-52.6 52.6-52.6c0 0-20.4-20.3-20.4-20.3Z" />\n        <path d="M454.7 345.8c44.8 0 81-36.3 81-81c0 0-28.8 0-28.8 0c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3c0 0 69.8-69.9 69.8-69.9c0 0 21.1-21 21.1-21c-14.4-22.3-39.5-37-68-37c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81Zm0-133.2c10.2 0 19.6 2.9 27.6 7.9c0 0-71.9 71.8-71.9 71.8c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2Z" />\n        <path d="M276.4 255.9c0 0-48.7-58.3-48.7-58.3c0 0-21.1 19-21.1 19c0 0 55.5 67.2 55.5 67.2c0 0 .3 50 .3 50c0 0 28.4 0 28.4 0c0 0 0-50.3 0-50.3c0 0 55.4-66.9 55.4-66.9c0 0-21-18.6-21-18.6c0 0-48.8 57.9-48.8 57.9Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-336.2c185.6 0 336.2 150.6 336.2 336.2c0 185.6-150.6 336.2-336.2 336.2c-185.6 0-336.2-150.6-336.2-336.2c0-185.6 150.6-336.2 336.2-336.2Z" fill="none" display="block" transform="translate(370.8,347.5) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g mask="url(#' +
						t +
						'_forward_Mask-4)" transform="translate(91.1,-91.1)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g mask="url(#' +
						t +
						'_forward_Mask-5)">\n        <path d="M409.7 395.1c0 0 32.6 .2 32.6 .2c0 0 .3 65.5 .3 65.5c0 0 28.5 0 28.5 0c0 0 0-65.5 0-65.5c0 0 33.1-0.2 33.1-0.2c0 0 0-27.8 0-27.8c0 0-94.5 0-94.5 0c0 0 0 27.8 0 27.8Z" />\n        <path d="M319.7 382.8c0 0-43.3 43.2-43.3 43.2c0 0-62.4-62.4-62.4-62.4c0 0-20.4 20.4-20.4 20.4c0 0 62.5 62.4 62.5 62.4c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 62.5 62.4 62.5 62.4c0 0 20.3-20.4 20.3-20.4c0 0-62.4-62.4-62.4-62.4c0 0 43.4-43.3 43.4-43.3c0 0-20.5-20.3-20.5-20.3Z" />\n        <path d="M502.8 199.6c-13.4-9.9-30-15.8-48.1-15.8c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81c44.8 0 81-36.3 81-81h-28.8c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3l69.8-69.9l.3-0.2l-20.3-20.4l-71.2 71.1c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2c10.1 0 19.4 2.8 27.4 7.7Z" fill-rule="evenodd" />\n        <path d="M276.4 255.9c0 0-31.1-37-31.1-37c0 0-19.7 19.5-19.7 19.5c0 0 36.7 45.6 36.7 45.6c0 0 .7 31.8 .7 31.8c0 0 27.7 0 27.7 0c0 0 0-32.4 0-32.4c0 0 36.5-44.9 36.5-44.9c0 0-19.6-18.6-19.6-18.6c0 0-31.2 36-31.2 36Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-310c171.1 0 310 138.9 310 310c0 171.1-138.9 310-310 310c-171.1 0-310-138.9-310-310c0-171.1 138.9-310 310-310Z" fill="none" transform="translate(387.8,328.7) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_forward_Mask-6)" transform="translate(61.3,-61.3)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g mask="url(#' +
						t +
						'_forward_Mask-7)">\n        <path d="M420.4 395c0 0 21.9 .3 21.9 .3c0 0 .4 44.1 .4 44.1c0 0 28.4 0 28.4 0c0 0 0-44.1 0-44.1c0 0 22.6-0.3 22.6-0.3c0 0 0-27.5 0-27.5c0 0-73.3 0-73.3 0c0 0 0 27.5 0 27.5Z" />\n        <path d="M313.2 389.2c0 0-36.8 36.8-36.8 36.8c0 0-62.4-62.4-62.4-62.4c0 0-20.4 20.4-20.4 20.4c0 0 62.5 62.4 62.5 62.4c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 62.5 62.4 62.5 62.4c0 0 20.3-20.4 20.3-20.4c0 0-62.4-62.4-62.4-62.4c0 0 37-36.9 37-36.9c0 0-20.6-20.3-20.6-20.3Z" />\n        <path d="M500 200c-13.4-9.9-27.2-16.2-45.3-16.2c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81c44.8 0 81-36.3 81-81h-28.8c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3l57.7-57.7l-20.3-20.4l-58.8 58.7c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2c10.1 0 19.4 2.8 27.4 7.7Z" fill-rule="evenodd" />\n        <path d="M276.4 255.9c0 0-21.2-25.1-21.2-25.1c0 0-19 19.8-19 19.8c0 0 26.2 33.5 26.2 33.5c0 0 1 21.6 1 21.6c0 0 27.2 0 27.2 0c0 0 0-22.3 0-22.3c0 0 25.9-32.7 25.9-32.7c0 0-18.8-18.6-18.8-18.6c0 0-21.3 23.8-21.3 23.8Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-294.3c162.4 0 294.3 131.9 294.3 294.3c0 162.4-131.9 294.3-294.3 294.3c-162.4 0-294.3-131.9-294.3-294.3c0-162.4 131.9-294.3 294.3-294.3Z" fill="none" display="block" transform="translate(398.7,318.2) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g mask="url(#' +
						t +
						'_forward_Mask-8)" transform="translate(42.6,-42.6)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g display="block" mask="url(#' +
						t +
						'_forward_Mask-9)">\n        <path d="M427.2 394.9c0 0 15.1 .4 15.1 .4c0 0 .4 30.7 .4 30.7c0 0 28.4 0 28.4 0c0 0 0-30.7 0-30.7c0 0 15.9-0.4 15.9-0.4c0 0 0-27.2 0-27.2c0 0-59.8 0-59.8 0c0 0 0 27.2 0 27.2Z" />\n        <path d="M307.4 395c0 0-31 31-31 31c0 0-53.9-54-53.9-54c0 0-20.4 20.4-20.4 20.4c0 0 54 54 54 54c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 54 54 54 54c0 0 20.4-20.3 20.4-20.3c0 0-54-54.1-54-54.1c0 0 31.2-31.1 31.2-31.1c0 0-20.6-20.3-20.6-20.3Z" />\n        <path d="M502.8 199.6c-13.4-9.9-30.1-15.8-48.1-15.8c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81c44.8 0 81-36.3 81-81h-28.8c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3l45.5-45.5l-20.4-20.4l-46.5 46.5c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2c10.1 0 19.4 2.8 27.4 7.7Z" fill-rule="evenodd" />\n        <path d="M276.4 255.9c0 0-15-17.6-15-17.6c0 0-18.4 20-18.4 20c0 0 19.4 25.8 19.4 25.8c0 0 1.2 15.2 1.2 15.2c0 0 27 0 27 0c0 0 0-15.9 0-15.9c0 0 19.1-24.9 19.1-24.9c0 0-18.2-18.7-18.2-18.7c0 0-15.1 16.1-15.1 16.1Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-284.4c157 0 284.4 127.4 284.4 284.4c0 157-127.4 284.4-284.4 284.4c-157 0-284.4-127.4-284.4-284.4c0-157 127.4-284.4 284.4-284.4Z" fill="none" transform="translate(406.1,311.6) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_forward_Mask-10)" transform="translate(29.6,-29.6)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g display="block" mask="url(#' +
						t +
						'_forward_Mask-11)">\n        <path d="M436 393.5c0 0 8.7 .4 8.7 .4c0 0 .4 17.8 .4 17.8c0 0 23.6 0 23.6 0c0 0 0-17.8 0-17.8c0 0 9.4-0.4 9.4-0.4c0 0 0-22.6 0-22.6c0 0-42.1 0-42.1 0c0 0 0 22.6 0 22.6Z" />\n        <path d="M297.2 405.2c0 0-20.8 20.8-20.8 20.8c0 0-35.4-35.6-35.4-35.6c0 0-20.3 20.5-20.3 20.5c0 0 35.4 35.5 35.4 35.5c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 35.6 35.5 35.6 35.5c0 0 20.2-20.2 20.2-20.2c0 0-35.4-35.7-35.4-35.7c0 0 21.1-21 21.1-21c0 0-20.7-20.2-20.7-20.2Z" />\n        <path d="M502.8 199.6c-13.4-9.9-30.1-15.8-48.1-15.8c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81c44.8 0 81-36.3 81-81h-28.8c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3l33.7-33.7l-20.4-20.3l-34.7 34.6c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2c10.1 0 19.4 2.8 27.4 7.7Z" fill-rule="evenodd" />\n        <path d="M276.4 255.9c0 0-10.7-12.4-10.7-12.4c0 0-18.1 20.1-18.1 20.1c0 0 14.9 20.6 14.9 20.6c0 0 1.2 10.7 1.2 10.7c0 0 26.8 0 26.8 0c0 0 0-11.5 0-11.5c0 0 14.6-19.6 14.6-19.6c0 0-17.9-18.6-17.9-18.6c0 0-10.8 10.7-10.8 10.7Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-277.5c153.1 0 277.5 124.4 277.5 277.5c0 153.1-124.4 277.5-277.5 277.5c-153.1 0-277.5-124.4-277.5-277.5c0-153.1 124.4-277.5 277.5-277.5Z" fill="none" display="block" transform="translate(411.2,307.1) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_forward_Mask-12)" transform="translate(20.3,-20.3)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g display="block" mask="url(#' +
						t +
						'_forward_Mask-13)">\n        <path d="M446 390.8c0 0 3.5 .2 3.5 .2c0 0 .2 7.3 .2 7.3c.1 0 14.2 0 14.2 0c0 0 0-7.3 0-7.3c0 0 4-0.2 4-0.2c0 0 0-13.5 0-13.5c0 0-21.9 0-21.9 0c0 0 0 13.5 0 13.5Z" />\n        <path d="M287.9 414.4c0 0-11.5 11.6-11.5 11.6c0 0-18.5-18.8-18.5-18.8c0 0-20.3 20.5-20.3 20.5c0 0 18.5 18.7 18.5 18.7c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 18.7 18.7 18.7 18.7c0 0 20.2-20 20.2-20c0 0-18.5-19.1-18.5-19.1c0 0 11.9-11.8 11.9-11.8c0 0-20.8-20.2-20.8-20.2Z" />\n        <path d="M502.8 199.6c-13.4-10-30.1-15.8-48.1-15.8c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81c44.8 0 81-36.3 81-81h-28.8c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3l22.4-22.4l-20.4-20.4l-23.4 23.4c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2c10.1 0 19.4 2.8 27.4 7.7Z" fill-rule="evenodd" />\n        <path d="M276.4 259.4c0 0-4.5-5.2-4.5-5.2c0 0-10.7 12.1-10.7 12.1c0 0 6.9 10.1 6.9 10.1c0 0 .8 4.5 .8 4.5c0 0 16 0 16 0c0 0 0-5 0-5c0 0 6.7-9.4 6.7-9.4c0 0-10.6-11.2-10.6-11.2c0 0-4.6 4.1-4.6 4.1Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-272.5c150.4 0 272.5 122.1 272.5 272.5c0 150.4-122.1 272.5-272.5 272.5c-150.4 0-272.5-122.1-272.5-272.5c0-150.4 122.1-272.5 272.5-272.5Z" fill="none" display="block" transform="translate(414.9,303.7) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_forward_Mask-14)" transform="translate(13.4,-13.4)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g display="block" mask="url(#' +
						t +
						'_forward_Mask-15)">\n        <path d="M453.6 388.1c0 0 .7 0 .7 0c0 0 .1 1.7 .1 1.7c0 0 4.7 0 4.7 0c0 0 0-1.7 0-1.7c0 0 1 0 1 0c0 0 0-4.5 0-4.5c0 0-6.5 0-6.5 0c0 0 0 4.5 0 4.5Z" />\n        <path d="M280.8 421.5c0 0-4.4 4.5-4.4 4.5c0 0-5.5-5.9-5.5-5.9c0 0-20.3 20.6-20.3 20.6c0 0 5.5 5.7 5.5 5.7c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 5.8 5.7 5.8 5.7c0 0 20.1-19.9 20.1-19.9c0 0-5.5-6.2-5.5-6.2c0 0 4.8-4.6 4.8-4.6c0 0-20.8-20.3-20.8-20.3Z" />\n        <path d="M502.8 199.6c-13.4-10-30.1-15.8-48.1-15.8c-44.7 0-81 36.2-81 81c0 44.7 36.3 81 81 81c44.8 0 81-36.3 81-81h-28.8c0 28.8-23.3 52.2-52.2 52.2c-8.2 0-16-1.9-22.9-5.3l11.9-11.9l-20.4-20.3l-12.9 12.8c-5-8-7.9-17.4-7.9-27.5c0-28.9 23.4-52.2 52.2-52.2c10.1 0 19.4 2.8 27.4 7.7Z" fill-rule="evenodd" />\n        <path d="M276.4 262.9c0 0-1-1.2-1-1.2c0 0-3.6 4-3.6 4c0 0 1.9 2.8 1.9 2.8c0 0 .2 1.1 .2 1.1c0 0 5.4 0 5.4 0c0 0 0-1.2 0-1.2c0 0 1.7-2.6 1.7-2.6c0 0-3.5-3.7-3.5-3.7c0 0-1.1 .8-1.1 .8Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-268.8c148.4 0 268.8 120.4 268.8 268.8c0 148.4-120.4 268.8-268.8 268.8c-148.4 0-268.8-120.4-268.8-268.8c0-148.4 120.4-268.8 268.8-268.8Z" fill="none" display="block" transform="translate(417.6,301.3) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_forward_Mask-16)" transform="translate(7.3,-7.3)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g display="block" mask="url(#' +
						t +
						'_forward_Mask-17)">\n        <path d="M275.4 426.9c0 0-19.3 19.5-19.3 19.5c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 19.9-19.7 19.9-19.7c0 0-20.9-20.2-20.9-20.2Z" />\n        <path d="M411.4 291.3l20.7 20.7l.1-0.1c6.8 3.2 14.5 5.1 22.5 5.1c28.9 0 52.2-23.4 52.2-52.2h28.8c0 44.7-36.2 81-81 81c-44.7 0-81-36.3-81-81c0-44.8 36.3-81 81-81c18 0 21.9 6.3 35.3 16.2l-7.9 20.3c-8-4.9-17.3-7.7-27.4-7.7c-28.8 0-52.2 23.3-52.2 52.2c0 10.1 2.9 19.5 7.9 27.5Z" fill-rule="evenodd" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-265.6c146.6 0 265.6 119 265.6 265.6c0 146.6-119 265.6-265.6 265.6c-146.6 0-265.6-119-265.6-265.6c0-146.6 119-265.6 265.6-265.6Z" fill="none" display="block" transform="translate(420,299.1) scale(.977,.977)" />\n    </g>\n    <g opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_forward_Mask-18)" transform="translate(4,-4)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <g display="block" mask="url(#' +
						t +
						'_forward_Mask-19)">\n        <path d="M265.4 437.1c0 0-9.3 9.3-9.3 9.3c0 0-62.5 62.4-62.5 62.4c0 0 20.4 20.4 20.4 20.4c0 0 62.4-62.4 62.4-62.4c0 0 9.8-9.6 9.8-9.6c0 0-20.8-20.1-20.8-20.1Z" />\n        <path d="M403 299.3l20.9 20.9l8.3-8.3c6.8 3.2 14.5 5.1 22.5 5.1c28.9 0 52.2-23.4 52.2-52.2h28.8c0 44.7-36.2 81-81 81c-44.7 0-81-36.3-81-81c0-44.8 36.3-81 81-81c18 0 34.6 5.8 48.1 15.8l-20.7 20.7c-8-4.9-17.3-7.7-27.4-7.7c-28.8 0-52.2 23.3-52.2 52.2c0 10 2.9 19.3 7.8 27.3Z" fill-rule="evenodd" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-263.8c145.6 0 263.8 118.2 263.8 263.8c0 145.6-118.2 263.8-263.8 263.8c-145.6 0-263.8-118.2-263.8-263.8c0-145.6 118.2-263.8 263.8-263.8Z" fill="none" display="block" transform="translate(421.2,297.8) scale(.977,.977)" />\n    </g>\n    <g clip-path="url(#' +
						t +
						'_forward_ClipPath-1)" opacity="0" transform="translate(0,0) scale(.1,.1)">\n      <g display="block" mask="url(#' +
						t +
						'_forward_Mask-20)">\n        <path d="M224.2 478.3c0 0-210.6 210.5-210.6 210.5c0 0 20.4 20.4 20.4 20.4c0 0 210.7-210.7 210.7-210.7c-11.7-11-5.9-6-20.5-20.2Z" />\n      </g>\n      <path stroke="#000" stroke-width="30" d="M0-261.7c144.4 0 261.7 117.3 261.7 261.7c0 144.4-117.3 261.7-261.7 261.7c-144.4 0-261.7-117.3-261.7-261.7c0-144.4 117.3-261.7 261.7-261.7Z" fill="none" display="block" transform="translate(422.8,296.4) scale(.977,.977)" />\n    </g>'
					);
				}
			}),
			new op({
				name: "email",
				path:
					"M12,-3.55271368e-15 C8.81712,-3.55271368e-15 5.7648,1.26468 3.5148,3.5148 C1.2648,5.76492 3.55271368e-15,8.81736 3.55271368e-15,12 C3.55271368e-15,15.18264 1.26468,18.2352 3.5148,20.4852 C5.76492,22.7352 8.81736,24 12,24 C15.18264,24 18.2352,22.73532 20.4852,20.4852 C22.7352,18.23508 24,15.18264 24,12 C24,8.81736 22.73532,5.7648 20.4852,3.5148 C18.23508,1.2648 15.18264,-3.55271368e-15 12,-3.55271368e-15 Z M17.28,7.92 L12,11.87064 L6.72,7.92 L17.28,7.92 Z M18,15.64776 C18,15.7743216 17.9446872,15.894312 17.85,15.976824 C17.7543744,16.059324 17.6278128,16.096824 17.503128,16.0799496 L6.479928,16.0799496 C6.352428,16.0940122 6.224928,16.0499496 6.13212,15.961824 C6.0402456,15.8727624 5.9914944,15.7471368 5.9999328,15.618696 L5.9999328,9.047736 L5.9999328,8.441184 L7.9536768,9.90744 L11.6398368,12.67224 C11.839524,12.8681784 12.1601568,12.8681784 12.3598368,12.67224 L17.8939968,8.51736 L17.9849352,8.44986 L17.9858726,8.45079768 C17.9914978,8.48548488 17.9952478,8.52111048 17.9971226,8.55579768 L17.9971226,15.6386777 L18,15.64776 Z"
			}),
			Tp
		],
		Fp = {};
	Ia(Rp).call(Rp, function (e) {
		Fp[e.name] = e.markup();
	}),
		(Fp.default = Tp.markup());
	var Lp = Jo("Array").keys,
		jp = Array.prototype,
		Np = { DOMTokenList: !0, NodeList: !0 },
		Pp = function (e) {
			var t = e.keys;
			return e === jp ||
				(e instanceof Array && t === jp.keys) ||
				Np.hasOwnProperty(Mt(e))
				? Lp
				: t;
		},
		qp = r(function (e, t) {
			Object.defineProperty(t, "__esModule", { value: !0 });
			var r = /(\w+)[-_].*/;
			function n(e, t) {
				if (t[e]) return t[e];
				var n = e.match(r);
				if (!n) throw new Error("Can't find lang or lcale with code " + e);
				return t[n[1]];
			}
			function i(e) {
				return e > 1;
			}
			function o(e) {
				return 1 !== e;
			}
			function a(e) {
				return 0;
			}
			var s = {
				ach: { n: 2, f: i },
				af: { n: 2, f: o },
				ak: { n: 2, f: i },
				am: { n: 2, f: i },
				an: { n: 2, f: o },
				ar: {
					n: 6,
					f: function (e) {
						return 0 === e
							? 0
							: 1 === e
							? 1
							: 2 === e
							? 2
							: e % 100 >= 3 && e % 100 <= 10
							? 3
							: e % 100 >= 11
							? 4
							: 5;
					}
				},
				arn: { n: 2, f: i },
				ast: { n: 2, f: o },
				ay: { n: 1, f: a },
				az: { n: 2, f: o },
				be: {
					n: 3,
					f: function (e) {
						return e % 10 == 1 && e % 100 != 11
							? 0
							: e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20)
							? 1
							: 2;
					}
				},
				bg: { n: 2, f: o },
				bn: { n: 2, f: o },
				bo: { n: 1, f: a },
				br: { n: 2, f: i },
				brx: { n: 2, f: o },
				bs: {
					n: 3,
					f: function (e) {
						return e % 10 == 1 && e % 100 != 11
							? 0
							: e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20)
							? 1
							: 2;
					}
				},
				ca: { n: 2, f: o },
				cgg: { n: 1, f: a },
				cs: {
					n: 3,
					f: function (e) {
						return 1 === e ? 0 : e >= 2 && e <= 4 ? 1 : 2;
					}
				},
				csb: {
					n: 3,
					f: function (e) {
						return 1 === e
							? 0
							: e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20)
							? 1
							: 2;
					}
				},
				cy: {
					n: 4,
					f: function (e) {
						return 1 === e ? 0 : 2 === e ? 1 : 8 !== e && 11 !== e ? 2 : 3;
					}
				},
				da: { n: 2, f: o },
				de: { n: 2, f: o },
				doi: { n: 2, f: o },
				dz: { n: 1, f: a },
				el: { n: 2, f: o },
				en: { n: 2, f: o },
				eo: { n: 2, f: o },
				es: { n: 2, f: o },
				et: { n: 2, f: o },
				eu: { n: 2, f: o },
				fa: { n: 1, f: a },
				ff: { n: 2, f: o },
				fi: { n: 2, f: o },
				fil: { n: 2, f: i },
				fo: { n: 2, f: o },
				fr: { n: 2, f: i },
				fur: { n: 2, f: o },
				fy: { n: 2, f: o },
				ga: {
					n: 5,
					f: function (e) {
						return 1 === e ? 0 : 2 === e ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4;
					}
				},
				gd: {
					n: 4,
					f: function (e) {
						return 1 === e || 11 === e
							? 0
							: 2 === e || 12 === e
							? 1
							: e > 2 && e < 20
							? 2
							: 3;
					}
				},
				gl: { n: 2, f: o },
				gu: { n: 2, f: o },
				gun: { n: 2, f: i },
				ha: { n: 2, f: o },
				he: { n: 2, f: o },
				hi: { n: 2, f: o },
				hne: { n: 2, f: o },
				hr: {
					n: 3,
					f: function (e) {
						return e % 10 == 1 && e % 100 != 11
							? 0
							: e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20)
							? 1
							: 2;
					}
				},
				hu: { n: 2, f: o },
				hy: { n: 2, f: o },
				id: { n: 1, f: a },
				is: {
					n: 2,
					f: function (e) {
						return e % 10 != 1 || e % 100 == 11;
					}
				},
				it: { n: 2, f: o },
				ja: { n: 1, f: a },
				jbo: { n: 1, f: a },
				jv: {
					n: 2,
					f: function (e) {
						return 0 !== e;
					}
				},
				ka: { n: 1, f: a },
				kab: { n: 2, f: o },
				kk: { n: 1, f: a },
				km: { n: 1, f: a },
				kn: { n: 2, f: o },
				ko: { n: 1, f: a },
				ku: { n: 2, f: o },
				kw: {
					n: 4,
					f: function (e) {
						return 1 === e ? 0 : 2 === e ? 1 : 3 === e ? 2 : 3;
					}
				},
				ky: { n: 1, f: a },
				lb: { n: 2, f: o },
				ln: { n: 2, f: i },
				lo: { n: 1, f: a },
				lt: {
					n: 3,
					f: function (e) {
						return e % 10 == 1 && e % 100 != 11
							? 0
							: e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20)
							? 1
							: 2;
					}
				},
				lv: {
					n: 3,
					f: function (e) {
						return e % 10 == 1 && e % 100 != 11 ? 0 : 0 !== e ? 1 : 2;
					}
				},
				mai: { n: 2, f: o },
				mfe: { n: 2, f: i },
				mg: { n: 2, f: i },
				mi: { n: 2, f: i },
				mk: {
					n: 2,
					f: function (e) {
						return 1 === e || e % 10 == 1 ? 0 : 1;
					}
				},
				ml: { n: 2, f: o },
				mn: { n: 2, f: o },
				mni: { n: 2, f: o },
				mnk: {
					n: 3,
					f: function (e) {
						return 0 === e ? 0 : 1 === e ? 1 : 2;
					}
				},
				mr: { n: 2, f: o },
				ms: { n: 1, f: a },
				mt: {
					n: 4,
					f: function (e) {
						return 1 === e
							? 0
							: 0 === e || (e % 100 > 1 && e % 100 < 11)
							? 1
							: e % 100 > 10 && e % 100 < 20
							? 2
							: 3;
					}
				},
				my: { n: 1, f: a },
				nah: { n: 2, f: o },
				nap: { n: 2, f: o },
				nb: { n: 2, f: o },
				ne: { n: 2, f: o },
				nl: { n: 2, f: o },
				nn: { n: 2, f: o },
				no: { n: 2, f: o },
				nso: { n: 2, f: o },
				oc: { n: 2, f: i },
				or: { n: 2, f: o },
				pa: { n: 2, f: o },
				pap: { n: 2, f: o },
				pl: {
					n: 3,
					f: function (e) {
						return 1 === e
							? 0
							: e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20)
							? 1
							: 2;
					}
				},
				pms: { n: 2, f: o },
				ps: { n: 2, f: o },
				pt: { n: 2, f: o },
				rm: { n: 2, f: o },
				ro: {
					n: 3,
					f: function (e) {
						return 1 === e
							? 0
							: 0 === e || (e % 100 > 0 && e % 100 < 20)
							? 1
							: 2;
					}
				},
				ru: {
					n: 3,
					f: function (e) {
						return e % 10 == 1 && e % 100 != 11
							? 0
							: e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20)
							? 1
							: 2;
					}
				},
				rw: { n: 2, f: o },
				sah: { n: 1, f: a },
				sat: { n: 2, f: o },
				sco: { n: 2, f: o },
				sd: { n: 2, f: o },
				se: { n: 2, f: o },
				si: { n: 2, f: o },
				sk: {
					n: 3,
					f: function (e) {
						return 1 === e ? 0 : e >= 2 && e <= 4 ? 1 : 2;
					}
				},
				sl: {
					n: 4,
					f: function (e) {
						return e % 100 == 1
							? 1
							: e % 100 == 2
							? 2
							: e % 100 == 3 || e % 100 == 4
							? 3
							: 0;
					}
				},
				so: { n: 2, f: o },
				son: { n: 2, f: o },
				sq: { n: 2, f: o },
				sr: {
					n: 3,
					f: function (e) {
						return e % 10 == 1 && e % 100 != 11
							? 0
							: e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20)
							? 1
							: 2;
					}
				},
				su: { n: 1, f: a },
				sv: { n: 2, f: o },
				sw: { n: 2, f: o },
				ta: { n: 2, f: o },
				te: { n: 2, f: o },
				tg: { n: 2, f: i },
				th: { n: 1, f: a },
				ti: { n: 2, f: i },
				tk: { n: 2, f: o },
				tr: { n: 2, f: i },
				tt: { n: 1, f: a },
				ug: { n: 1, f: a },
				uk: {
					n: 3,
					f: function (e) {
						return e % 10 == 1 && e % 100 != 11
							? 0
							: e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20)
							? 1
							: 2;
					}
				},
				ur: { n: 2, f: o },
				uz: { n: 2, f: i },
				vi: { n: 1, f: a },
				wa: { n: 2, f: i },
				wo: { n: 1, f: a },
				yo: { n: 2, f: o },
				zh: { n: 1, f: a }
			};
			var c = {};
			(t.getNPlurals = function (e) {
				return n(e, s).n;
			}),
				(t.getPluralFunc = function (e) {
					if (c[e]) return c[e];
					var t = n(e, s),
						r = function (e, r) {
							return r[+t.f(e)];
						};
					return (c[e] = r), r;
				}),
				(t.hasLang = function (e) {
					try {
						return n(e, s), !0;
					} catch (e) {
						return !1;
					}
				}),
				(t.getAvailLangs = function () {
					return Object.keys(s);
				});
		});
	t(qp);
	var Dp = qp.getNPlurals,
		Bp = qp.getPluralFunc,
		Up = qp.hasLang,
		Vp =
			(qp.getAvailLangs,
			(function () {
				function e() {}
				return (
					(e.process = function (e, t, r, n, i) {
						var o = "string" == typeof e ? e : this._selectPluralForm(e, r, n);
						return this._interpolate(o, t, i);
					}),
					(e._selectPluralForm = function (e, t, r) {
						Up(r) || (r = "en");
						var n = this._generateArrayOneToN(r);
						return e[Bp(r)(t, n)];
					}),
					(e._generateArrayOneToN = function (e) {
						var t,
							r = Dp(e);
						return kc(Pp((t = new Array(r))).call(t));
					}),
					(e._interpolate = function (e, t, r) {
						if (t && !r)
							throw new Error(
								"An escapeExpression function must be provided when processing translations with interpolation"
							);
						return e.replace(/\[\[([a-zA-Z0-9]+)\]\]/g, function (e, n) {
							var i = t[n];
							return r(i);
						});
					}),
					e
				);
			})()),
		Hp = {
			SOY: Wh,
			Handlebars: (function (e) {
				function t(t, r) {
					var n;
					return (
						void 0 === t && (t = {}),
						((n = e.call(this) || this)._handlebars = t._hb || null),
						(n._templates = t || {}),
						n
					);
				}
				wu(t, e);
				var r = t.prototype;
				return (
					(r.init = function (e, t) {
						(this._handlebars = e._hb),
							(this._templates = e),
							(this._initLocale = t),
							this._registerCustomHelpers();
					}),
					(r.registerHelper = function (e, t) {
						this._handlebars.registerHelper(e, t);
					}),
					(r.SafeString = function (e) {
						return new this._handlebars.SafeString(e);
					}),
					(r.escapeExpression = function (e) {
						return this._handlebars.escapeExpression(e);
					}),
					(r.compile = function (e) {
						return "string" != typeof e ? "" : this._handlebars.compile(e);
					}),
					(r.registerTemplate = function (e, t) {
						this._templates[e] = this.compile(t);
					}),
					(r.render = function (e, t) {
						if (null !== e.template) return e.template(t);
						if (!(e.templateName in this._templates))
							throw new Error("Can't find template: " + e.templateName);
						try {
							return this._templates[e.templateName](t);
						} catch (t) {
							throw (
								(console.error(
									"Error when trying to render the template: " + e.templateName
								),
								t)
							);
						}
					}),
					(r._registerCustomHelpers = function () {
						this.registerHelper("ifeq", function (e, t, r) {
							return e === t ? r.fn(this) : r.inverse(this);
						}),
							this.registerHelper("ifnoteq", function (e, t, r) {
								return e !== t ? r.fn(this) : r.inverse(this);
							}),
							this.registerHelper({
								eq: function (e, t) {
									return e === t;
								},
								ne: function (e, t) {
									return e !== t;
								},
								lt: function (e, t) {
									return e < t;
								},
								gt: function (e, t) {
									return e > t;
								},
								lte: function (e, t) {
									return e <= t;
								},
								gte: function (e, t) {
									return e >= t;
								},
								and: function () {
									var e;
									return jl((e = Tc(Array.prototype).call(arguments))).call(
										e,
										Boolean
									);
								},
								or: function () {
									var e;
									return ip(
										(e = Tc(Array.prototype).call(arguments, 0, -1))
									).call(e, Boolean);
								}
							}),
							this.registerHelper({
								add: function (e, t) {
									return e + t;
								},
								sub: function (e, t) {
									return e - t;
								},
								mul: function (e, t) {
									return e * t;
								},
								div: function (e, t) {
									return e / t;
								},
								mod: function (e, t) {
									return e % t;
								}
							}),
							this.registerHelper("every", function () {
								for (
									var e = arguments.length, t = new Array(e), r = 0;
									r < e;
									r++
								)
									t[r] = arguments[r];
								var n = Tc(t).call(t, 0, t.length - 1),
									i = t[t.length - 1];
								return jl(n).call(n, function (e) {
									return e;
								})
									? i.fn(this)
									: i.inverse(this);
							}),
							this.registerHelper("formatPhoneNumber", function (e) {
								var t = ("" + e)
									.replace(/\D/g, "")
									.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
								return t
									? [t[1] ? "+1 " : "", "(", t[2], ") ", t[3], "-", t[4]].join(
											""
									  )
									: null;
							}),
							this.registerHelper("assign", function (e, t, r) {
								var n = arguments;
								(r = n[n.length - 1]).data.root || (r.data.root = {});
								for (var i = "", o = 1; o < n.length - 1; o++) i += n[o];
								r.data.root[e] = i;
							}),
							this.registerHelper("json", function (e, t, r) {
								return void 0 === e ? "" : Go(e);
							}),
							this.registerHelper("plural", function (e, t, r) {
								return 1 === e ? t : r;
							});
						var e = this;
						this.registerHelper("processTranslation", function (t) {
							var r,
								n,
								i,
								o = {},
								a = {},
								s = t.hash,
								c = s.phrase,
								u = s.count,
								l = s.locale;
							Ia((r = Jl(t.hash))).call(r, function (e) {
								var t = e[0],
									r = e[1];
								if (Sh(t).call(t, "pluralForm")) {
									var n = Xh(t.substring(10));
									o[n] = r;
								} else a[t] = r;
							});
							var f = "string" != typeof c,
								h = (l = l || e._initLocale).substring(0, 2);
							return f
								? Vp.process(
										o,
										a,
										u,
										h,
										hc((n = e.escapeExpression)).call(n, e)
								  )
								: Vp.process(
										c,
										a,
										null,
										null,
										hc((i = e.escapeExpression)).call(i, e)
								  );
						}),
							e.registerHelper("icon", function (t, r, n) {
								var i = Fp.default;
								return Fp[t]
									? ((i = "function" == typeof Fp[t] ? Fp[t](r) : Fp[t]),
									  e.SafeString(i))
									: e.SafeString(i);
							}),
							e.registerHelper("highlightValue", function (t, r) {
								var n = t.value || t.shortValue,
									i = new sf({
										value: n,
										matchedSubstrings: t.matchedSubstrings
									}),
									o = function (t) {
										return e.escapeExpression(t);
									};
								return r
									? e.SafeString(i.getInvertedWithTransformFunction(o))
									: e.SafeString(i.getWithTransformFunction(o));
							});
					}),
					t
				);
			})(Wh)
		};
	function zp(e, t) {
		var r = Ms(e);
		if (Ss) {
			var n = Ss(e);
			t &&
				(n = Da(n).call(n, function (t) {
					return Ra(e, t).enumerable;
				})),
				r.push.apply(r, n);
		}
		return r;
	}
	function Kp(e) {
		for (var t = 1; t < arguments.length; t++) {
			var r,
				n = null != arguments[t] ? arguments[t] : {};
			if (t % 2)
				Ia((r = zp(Object(n), !0))).call(r, function (t) {
					Ds(e, t, n[t]);
				});
			else if (ma) ha(e, ma(n));
			else {
				var i;
				Ia((i = zp(Object(n)))).call(i, function (t) {
					fa(e, t, Ra(n, t));
				});
			}
		}
		return e;
	}
	var Zp = (function () {
		function e(e) {
			void 0 === e && (e = {}),
				(this._apiKey = e.apiKey),
				(this._experienceKey = e.experienceKey),
				(this._experienceVersion = e.experienceVersion),
				(this._locale = e.locale),
				(this._fieldFormatters = e.fieldFormatters || {}),
				(this.storage = e.storage),
				(this.filterRegistry = new Oh(this.storage)),
				(this._analyticsReporter = e.analyticsReporter),
				(this.onUniversalSearch = e.onUniversalSearch || function () {}),
				(this.onVerticalSearch = e.onVerticalSearch || function () {}),
				(this._environment = e.environment || "production"),
				(this._verticalKey = e.verticalKey),
				(this._componentManager = e.componentManager);
		}
		var t = e.prototype;
		return (
			(t.setQueryUpdateListener = function (e) {
				this.queryUpdateListener = e;
			}),
			(t.init = function () {
				var e = {
					apiKey: this._apiKey,
					experienceKey: this._experienceKey,
					locale: this._locale,
					experienceVersion: this._experienceVersion,
					endpoints: this._getServiceUrls()
				};
				this._coreLibrary = pl(e);
			}),
			(t._getServiceUrls = function () {
				return {
					universalSearch: Vh(this._environment) + jh,
					verticalSearch: Vh(this._environment) + Nh,
					questionSubmission:
						((e = this._environment),
						void 0 === e && (e = "production"),
						("sandbox" === e
							? "https://api-sandbox.yext.com"
							: "https://api.yext.com") + Ph),
					universalAutocomplete: Hh(this._environment) + qh,
					verticalAutocomplete: Hh(this._environment) + Dh,
					filterSearch: Hh(this._environment) + Bh
				};
				var e;
			}),
			(t.isInitialized = function () {
				return !!this._coreLibrary;
			}),
			(t.verticalSearch = function (e, t, r) {
				var n = this;
				if (
					(void 0 === t && (t = {}),
					void 0 === r && (r = {}),
					window.performance.mark("yext.answers.verticalQueryStart"),
					!r.append)
				) {
					var i = this.storage.get(wf);
					(i && i.searchState === dl) ||
						this.storage.set(wf, df.searchLoading()),
						this.storage.set(qf, {}),
						this.storage.set(Bf, Jf.searchLoading());
				}
				var o = t,
					a = o.resetPagination,
					s = o.useFacets,
					c = o.sendQueryId,
					u = o.setQueryParams;
				a && this.storage.delete(Pf),
					s || this.filterRegistry.setFacetFilterNodes([], []);
				var l = this.storage.get(Zf),
					f = this.storage.get(Qf),
					h = this.storage.get(If) || "",
					p = ca({}, { input: h }, r);
				u &&
					(l && this.storage.setWithPersist(Zf, l),
					void 0 !== f && this.storage.setWithPersist(Qf, f));
				var d = this.storage.get(Nf) || {};
				d.verticalKey ||
					this.storage.set(Nf, Kp(Kp({}, d), {}, { verticalKey: e }));
				var v = this._getLocationRadius(),
					m = this.shouldPushState(this.storage.get(Wf)),
					g = this.getQueryTriggerForSearchApi(this.storage.get(Wf));
				return this._coreLibrary
					.verticalSearch({
						verticalKey: e || d.verticalKey,
						limit: this.storage.get(Nf).limit,
						location: this._getLocationPayload(),
						query: p.input,
						queryId: c && this.storage.get(Tf),
						retrieveFacets: this._isDynamicFiltersEnabled,
						facets: this.filterRegistry.getFacetsPayload(),
						staticFilters: this.filterRegistry.getStaticFilterPayload(),
						offset: this.storage.get(Pf) || 0,
						skipSpellCheck: this.storage.get(Df),
						queryTrigger: g,
						sessionTrackingEnabled: this.storage.get(Uf).value,
						sortBys: this.storage.get(Hf),
						locationRadius: 0 === v ? void 0 : v,
						context: l,
						referrerPageUrl: f,
						querySource: this.storage.get(Gf)
					})
					.then(function (t) {
						return th.transformVertical(t, n._fieldFormatters, e);
					})
					.then(function (t) {
						if (
							(n._persistFacets(),
							n._persistFilters(),
							n._persistLocationRadius(),
							n.storage.set(Tf, t[Tf]),
							n.storage.set(_f, t[_f]),
							n.storage.set(Sf, t[Sf]),
							r.append)
						) {
							var i = n.storage.get(wf).append(t[wf]);
							n.storage.set(wf, i);
						} else n.storage.set(wf, t[wf]);
						t[Ff] && (n.storage.set(Ff, t[Ff]), n.storage.set(Kf, t[Ff])),
							t[qf] && n.storage.set(qf, t[qf]),
							t[Bf] && n.storage.set(Bf, t[Bf]),
							n.storage.delete(Df),
							n.storage.delete(Wf);
						var o = {
								verticalKey: e,
								queryString: p.input,
								resultsCount: n.storage.get(wf).resultsCount,
								resultsContext: t[wf].resultsContext
							},
							a = n.onVerticalSearch(o);
						"object" == typeof a && n._analyticsReporter.report(fh.fromData(a)),
							m && n.storage.pushStateToHistory(),
							window.performance.mark(
								"yext.answers.verticalQueryResponseRendered"
							);
					});
			}),
			(t.clearResults = function () {
				this.storage.set(If, null),
					this.storage.set(Tf, ""),
					this.storage.set(Kf, {}),
					this.storage.set(qf, {}),
					this.storage.set(Ff, {}),
					this.storage.set(jf, new rh({})),
					this.storage.set(_f, new gf()),
					this.storage.set(Sf, new Yf({})),
					this.storage.set(xf, new mf({})),
					this.storage.set(Bf, new Jf({})),
					this.storage.set(wf, new df({})),
					this.storage.set(bf, new vf({}));
			}),
			(t.verticalPage = function () {
				this.triggerSearch(sh);
			}),
			(t.search = function (e, t) {
				var r = this;
				void 0 === t && (t = {});
				var n = this._getUrls(e);
				window.performance.mark("yext.answers.universalQueryStart");
				var i = t.setQueryParams,
					o = this.storage.get(Zf),
					a = this.storage.get(Qf);
				i &&
					(o && this.storage.setWithPersist(Zf, o),
					void 0 !== a && this.storage.setWithPersist(Qf, a)),
					this.storage.set(xf, {});
				var s = this.storage.get(bf);
				(s && s.searchState === dl) || this.storage.set(bf, vf.searchLoading()),
					this.storage.set(jf, {}),
					this.storage.set(qf, {}),
					this.storage.set(Bf, Jf.searchLoading());
				var c = this.shouldPushState(this.storage.get(Wf)),
					u = this.getQueryTriggerForSearchApi(this.storage.get(Wf));
				return this._coreLibrary
					.universalSearch({
						query: e,
						location: this._getLocationPayload(),
						skipSpellCheck: this.storage.get(Df),
						queryTrigger: u,
						sessionTrackingEnabled: this.storage.get(Uf).value,
						context: o,
						referrerPageUrl: a,
						querySource: this.storage.get(Gf)
					})
					.then(function (e) {
						return th.transformUniversal(e, n, r._fieldFormatters);
					})
					.then(function (t) {
						r.storage.set(Tf, t[Tf]),
							r.storage.set(_f, t[_f]),
							r.storage.set(xf, t[xf]),
							r.storage.set(bf, t[bf]),
							r.storage.set(qf, t[qf]),
							r.storage.set(Bf, t[Bf]),
							r.storage.delete(Df),
							r.storage.delete(Wf);
						var n = r._getOnUniversalSearchParams(t[bf].sections, e),
							i = r.onUniversalSearch(n);
						"object" == typeof i && r._analyticsReporter.report(fh.fromData(i)),
							c && r.storage.pushStateToHistory(),
							window.performance.mark(
								"yext.answers.universalQueryResponseRendered"
							);
					});
			}),
			(t._getOnUniversalSearchParams = function (e, t) {
				var r = Ps(e).call(
					e,
					function (e, t) {
						var r = t.verticalConfigId,
							n = t.resultsCount,
							i = t.results;
						return (
							(e[r] = {
								totalResultsCount: n,
								displayedResultsCount: i.length
							}),
							e
						);
					},
					{}
				);
				return {
					queryString: t,
					sectionsCount: e.length,
					resultsCountByVertical: r
				};
			}),
			(t.autoCompleteUniversal = function (e, t) {
				var r = this;
				return this._coreLibrary
					.universalAutocomplete({
						input: e,
						sessionTrackingEnabled: this.storage.get(Uf).value
					})
					.then(function (e) {
						return Lh.transformAutoCompleteResponse(e);
					})
					.then(function (e) {
						return r.storage.set(kf + "." + t, e), e;
					});
			}),
			(t.autoCompleteVertical = function (e, t, r) {
				var n = this;
				return this._coreLibrary
					.verticalAutocomplete({
						input: e,
						verticalKey: r,
						sessionTrackingEnabled: this.storage.get(Uf).value
					})
					.then(function (e) {
						return Lh.transformAutoCompleteResponse(e);
					})
					.then(function (e) {
						return n.storage.set(kf + "." + t, e), e;
					});
			}),
			(t.autoCompleteFilter = function (e, t) {
				var r,
					n = this,
					i = Os((r = t.searchParameters.fields)).call(r, function (e) {
						return {
							fieldApiName: e.fieldId,
							entityType: e.entityTypeId,
							fetchEntities: e.shouldFetchEntities
						};
					});
				return this._coreLibrary
					.filterSearch({
						input: e,
						verticalKey: t.verticalKey,
						fields: i,
						sectioned: t.searchParameters.sectioned,
						sessionTrackingEnabled: this.storage.get(Uf).value
					})
					.then(function (e) {
						return Lh.transformFilterSearchResponse(e);
					})
					.then(function (e) {
						n.storage.set(kf + "." + t.namespace, e);
					});
			}),
			(t.submitQuestion = function (e) {
				var t = this;
				return this._coreLibrary
					.submitQuestion(
						Kp(
							Kp({}, e),
							{},
							{ sessionTrackingEnabled: this.storage.get(Uf).value }
						)
					)
					.then(function () {
						t.storage.set(jf, rh.submitted());
					});
			}),
			(t.setSortBys = function () {
				for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
					t[r] = arguments[r];
				var n = Os(t).call(t, function (e) {
					return { type: e.type, field: e.field, direction: e.direction };
				});
				this.storage.setWithPersist(Hf, n);
			}),
			(t.clearSortBys = function () {
				this.storage.delete(Hf);
			}),
			(t.setQuery = function (e) {
				this.storage.setWithPersist(If, e);
			}),
			(t.setQueryId = function (e) {
				this.storage.set(Tf, e);
			}),
			(t.triggerSearch = function (e, t) {
				var r = void 0 !== t ? t : this.storage.get(If) || "";
				e ? this.storage.set(Wf, e) : this.storage.delete(Wf), this.setQuery(r);
			}),
			(t.getStaticFilterNodes = function () {
				return this.filterRegistry.getStaticFilterNodes();
			}),
			(t.getFacetFilterNodes = function () {
				return this.filterRegistry.getFacetFilterNodes();
			}),
			(t.getLocationRadiusFilterNode = function () {
				return this.filterRegistry.getFilterNodeByKey(Ef);
			}),
			(t.setFacetFilterNodes = function (e, t) {
				void 0 === e && (e = []),
					void 0 === t && (t = []),
					this.filterRegistry.setFacetFilterNodes(e, t);
			}),
			(t.setStaticFilterNodes = function (e, t) {
				this.filterRegistry.setStaticFilterNodes(e, t);
			}),
			(t.setLocationRadiusFilterNode = function (e) {
				this.filterRegistry.setLocationRadiusFilterNode(e);
			}),
			(t.clearStaticFilterNode = function (e) {
				this.filterRegistry.clearStaticFilterNode(e);
			}),
			(t.clearFacetFilterNodes = function () {
				this.filterRegistry.clearFacetFilterNodes();
			}),
			(t.clearLocationRadiusFilterNode = function () {
				this.filterRegistry.clearLocationRadiusFilterNode();
			}),
			(t._getLocationPayload = function () {
				var e = this.storage.get(Lf);
				return e && { latitude: e.lat, longitude: e.lng };
			}),
			(t.getQueryTriggerForSearchApi = function (e) {
				var t;
				return aa((t = [nh, oh])).call(t, e) ? e : null;
			}),
			(t.shouldPushState = function (e) {
				return e !== nh && e !== ih && e !== oh;
			}),
			(t._getLocationRadius = function () {
				var e = this.getLocationRadiusFilterNode();
				return e ? e.getFilter().value : null;
			}),
			(t._persistFacets = function () {
				var e = this.filterRegistry.createFacetsFromFilterNodes();
				this.storage.setWithPersist(Rf, e);
			}),
			(t._persistFilters = function () {
				var e = this.filterRegistry
					.getAllStaticFilterNodesCombined()
					.getFilter();
				this.storage.setWithPersist(Mf, e);
			}),
			(t._persistLocationRadius = function () {
				var e = this._getLocationRadius();
				e || 0 === e
					? this.storage.setWithPersist(Cf, e)
					: this.storage.delete(Cf);
			}),
			(t.enableDynamicFilters = function () {
				this._isDynamicFiltersEnabled = !0;
			}),
			(t.on = function (e, t, r) {
				return (
					this.storage.registerListener({
						eventType: e,
						storageKey: t,
						callback: r
					}),
					this.storage
				);
			}),
			(t._getUrls = function (e) {
				var t = this._componentManager.getActiveComponent("Navigation");
				if (t) {
					var r = t.getState("tabs"),
						n = {};
					if (r && As(r))
						for (var i = 0; i < r.length; i++) {
							var o = new Uh(r[i].url.split("?")[1]);
							o.set("query", e);
							var a = r[i].baseUrl;
							o.toString().length > 0 && (a += "?" + o.toString()),
								(n[r[i].configId] = a);
						}
					return n;
				}
			}),
			e
		);
	})();
	/*!
	 * css-vars-ponyfill
	 * v2.4.3
	 * https://jhildenbiddle.github.io/css-vars-ponyfill/
	 * (c) 2018-2021 John Hildenbiddle <http://hildenbiddle.com>
	 * MIT license
	 */ function Qp() {
		return (Qp =
			Object.assign ||
			function (e) {
				for (var t = 1; t < arguments.length; t++) {
					var r = arguments[t];
					for (var n in r)
						Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
				}
				return e;
			}).apply(this, arguments);
	}
	/*!
	 * get-css-data
	 * v2.0.0
	 * https://github.com/jhildenbiddle/get-css-data
	 * (c) 2018-2021 John Hildenbiddle <http://hildenbiddle.com>
	 * MIT license
	 */ function Wp(e) {
		var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
			r = {
				mimeType: t.mimeType || null,
				onBeforeSend: t.onBeforeSend || Function.prototype,
				onSuccess: t.onSuccess || Function.prototype,
				onError: t.onError || Function.prototype,
				onComplete: t.onComplete || Function.prototype
			},
			n = Array.isArray(e) ? e : [e],
			i = Array.apply(null, Array(n.length)).map(function (e) {
				return null;
			});
		function o(e) {
			var t = e && "<" === e.trim().charAt(0);
			return e && !t;
		}
		function a(e, t) {
			r.onError(e, n[t], t);
		}
		function s(e, t) {
			var o = r.onSuccess(e, n[t], t);
			(e = !1 === o ? "" : o || e),
				(i[t] = e),
				-1 === i.indexOf(null) && r.onComplete(i);
		}
		var c = document.createElement("a");
		n.forEach(function (e, t) {
			if (
				(c.setAttribute("href", e),
				(c.href = String(c.href)),
				Boolean(document.all && !window.atob) &&
					c.host.split(":")[0] !== location.host.split(":")[0])
			) {
				if (c.protocol === location.protocol) {
					var n = new XDomainRequest();
					n.open("GET", e),
						(n.timeout = 0),
						(n.onprogress = Function.prototype),
						(n.ontimeout = Function.prototype),
						(n.onload = function () {
							o(n.responseText) ? s(n.responseText, t) : a(n, t);
						}),
						(n.onerror = function (e) {
							a(n, t);
						}),
						setTimeout(function () {
							n.send();
						}, 0);
				} else
					console.warn(
						"Internet Explorer 9 Cross-Origin (CORS) requests must use the same protocol (".concat(
							e,
							")"
						)
					),
						a(null, t);
			} else {
				var i = new XMLHttpRequest();
				i.open("GET", e),
					r.mimeType && i.overrideMimeType && i.overrideMimeType(r.mimeType),
					r.onBeforeSend(i, e, t),
					(i.onreadystatechange = function () {
						4 === i.readyState &&
							((i.status < 400 && o(i.responseText)) ||
							(0 === i.status && o(i.responseText))
								? s(i.responseText, t)
								: a(i, t));
					}),
					i.send();
			}
		});
	}
	/**
	 * Gets CSS data from <style> and <link> nodes (including @imports), then
	 * returns data in order processed by DOM. Allows specifying nodes to
	 * include/exclude and filtering CSS data using RegEx.
	 *
	 * @preserve
	 * @param {object}   [options] The options object
	 * @param {object}   [options.rootElement=document] Root element to traverse for
	 *                   <link> and <style> nodes.
	 * @param {string}   [options.include] CSS selector matching <link> and <style>
	 *                   nodes to include
	 * @param {string}   [options.exclude] CSS selector matching <link> and <style>
	 *                   nodes to exclude
	 * @param {object}   [options.filter] Regular expression used to filter node CSS
	 *                   data. Each block of CSS data is tested against the filter,
	 *                   and only matching data is included.
	 * @param {boolean}  [options.skipDisabled=true] Determines if disabled
	 *                   stylesheets will be skipped while collecting CSS data.
	 * @param {boolean}  [options.useCSSOM=false] Determines if CSS data will be
	 *                   collected from a stylesheet's runtime values instead of its
	 *                   text content. This is required to get accurate CSS data
	 *                   when a stylesheet has been modified using the deleteRule()
	 *                   or insertRule() methods because these modifications will
	 *                   not be reflected in the stylesheet's text content.
	 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
	 *                   1) the XHR object, 2) source node reference, and 3) the
	 *                   source URL as arguments.
	 * @param {function} [options.onSuccess] Callback on each CSS node read. Passes
	 *                   1) CSS text, 2) source node reference, and 3) the source
	 *                   URL as arguments.
	 * @param {function} [options.onError] Callback on each error. Passes 1) the XHR
	 *                   object for inspection, 2) soure node reference, and 3) the
	 *                   source URL that failed (either a <link> href or an @import)
	 *                   as arguments
	 * @param {function} [options.onComplete] Callback after all nodes have been
	 *                   processed. Passes 1) concatenated CSS text, 2) an array of
	 *                   CSS text in DOM order, and 3) an array of nodes in DOM
	 *                   order as arguments.
	 *
	 * @example
	 *
	 *   getCssData({
	 *     rootElement : document,
	 *     include     : 'style,link[rel="stylesheet"]',
	 *     exclude     : '[href="skip.css"]',
	 *     filter      : /red/,
	 *     skipDisabled: true,
	 *     useCSSOM    : false,
	 *     onBeforeSend(xhr, node, url) {
	 *       // ...
	 *     }
	 *     onSuccess(cssText, node, url) {
	 *       // ...
	 *     }
	 *     onError(xhr, node, url) {
	 *       // ...
	 *     },
	 *     onComplete(cssText, cssArray, nodeArray) {
	 *       // ...
	 *     }
	 *   });
	 */ function Gp(e) {
		var t = /\/\*[\s\S]+?\*\//g,
			r = /(?:@import\s*)(?:url\(\s*)?(?:['"])([^'"]*)(?:['"])(?:\s*\))?(?:[^;]*;)/g,
			n = {
				rootElement: e.rootElement || document,
				include: e.include || 'style,link[rel="stylesheet"]',
				exclude: e.exclude || null,
				filter: e.filter || null,
				skipDisabled: !1 !== e.skipDisabled,
				useCSSOM: e.useCSSOM || !1,
				onBeforeSend: e.onBeforeSend || Function.prototype,
				onSuccess: e.onSuccess || Function.prototype,
				onError: e.onError || Function.prototype,
				onComplete: e.onComplete || Function.prototype
			},
			i = Array.apply(null, n.rootElement.querySelectorAll(n.include)).filter(
				function (e) {
					return (
						(t = e),
						(r = n.exclude),
						!(
							t.matches ||
							t.matchesSelector ||
							t.webkitMatchesSelector ||
							t.mozMatchesSelector ||
							t.msMatchesSelector ||
							t.oMatchesSelector
						).call(t, r)
					);
					var t, r;
				}
			),
			o = Array.apply(null, Array(i.length)).map(function (e) {
				return null;
			});
		function a() {
			if (-1 === o.indexOf(null)) {
				o.reduce(function (e, t, r) {
					return "" === t && e.push(r), e;
				}, [])
					.reverse()
					.forEach(function (e) {
						return [i, o].forEach(function (t) {
							return t.splice(e, 1);
						});
					});
				var e = o.join("");
				n.onComplete(e, o, i);
			}
		}
		function s(e, t, r, i) {
			var s = n.onSuccess(e, r, i);
			(function e(t, r, i, o) {
				var a =
						arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [],
					s =
						arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : [],
					u = c(t, i, s);
				u.rules.length
					? Wp(u.absoluteUrls, {
							onBeforeSend: function (e, t, i) {
								n.onBeforeSend(e, r, t);
							},
							onSuccess: function (e, t, i) {
								var o = n.onSuccess(e, r, t),
									a = c((e = !1 === o ? "" : o || e), t, s);
								return (
									a.rules.forEach(function (t, r) {
										e = e.replace(t, a.absoluteRules[r]);
									}),
									e
								);
							},
							onError: function (n, c, l) {
								a.push({ xhr: n, url: c }),
									s.push(u.rules[l]),
									e(t, r, i, o, a, s);
							},
							onComplete: function (n) {
								n.forEach(function (e, r) {
									t = t.replace(u.rules[r], e);
								}),
									e(t, r, i, o, a, s);
							}
					  })
					: o(t, a);
			})((e = void 0 !== s && !1 === Boolean(s) ? "" : s || e), r, i, function (
				e,
				i
			) {
				null === o[t] &&
					(i.forEach(function (e) {
						return n.onError(e.xhr, r, e.url);
					}),
					!n.filter || n.filter.test(e) ? (o[t] = e) : (o[t] = ""),
					a());
			});
		}
		function c(e, n) {
			var i =
					arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
				o = {};
			return (
				(o.rules = (e.replace(t, "").match(r) || []).filter(function (e) {
					return -1 === i.indexOf(e);
				})),
				(o.urls = o.rules.map(function (e) {
					return e.replace(r, "$1");
				})),
				(o.absoluteUrls = o.urls.map(function (e) {
					return $p(e, n);
				})),
				(o.absoluteRules = o.rules.map(function (e, t) {
					var r = o.urls[t],
						i = $p(o.absoluteUrls[t], n);
					return e.replace(r, i);
				})),
				o
			);
		}
		i.length
			? i.forEach(function (e, t) {
					var r = e.getAttribute("href"),
						i = e.getAttribute("rel"),
						c =
							"link" === e.nodeName.toLowerCase() &&
							r &&
							i &&
							-1 !== i.toLowerCase().indexOf("stylesheet"),
						u = !1 !== n.skipDisabled && e.disabled,
						l = "style" === e.nodeName.toLowerCase();
					if (c && !u)
						Wp(r, {
							mimeType: "text/css",
							onBeforeSend: function (t, r, i) {
								n.onBeforeSend(t, e, r);
							},
							onSuccess: function (n, i, o) {
								var a = $p(r);
								s(n, t, e, a);
							},
							onError: function (r, i, s) {
								(o[t] = ""), n.onError(r, e, i), a();
							}
						});
					else if (l && !u) {
						var f = e.textContent;
						n.useCSSOM &&
							(f = Array.apply(null, e.sheet.cssRules)
								.map(function (e) {
									return e.cssText;
								})
								.join("")),
							s(f, t, e, location.href);
					} else (o[t] = ""), a();
			  })
			: n.onComplete("", []);
	}
	function $p(e, t) {
		var r = document.implementation.createHTMLDocument(""),
			n = r.createElement("base"),
			i = r.createElement("a");
		return (
			r.head.appendChild(n),
			r.body.appendChild(i),
			(n.href =
				t ||
				document.baseURI ||
				(document.querySelector("base") || {}).href ||
				location.href),
			(i.href = e),
			i.href
		);
	}
	var Jp = Yp;
	function Yp(e, t, r) {
		e instanceof RegExp && (e = Xp(e, r)),
			t instanceof RegExp && (t = Xp(t, r));
		var n = ed(e, t, r);
		return (
			n && {
				start: n[0],
				end: n[1],
				pre: r.slice(0, n[0]),
				body: r.slice(n[0] + e.length, n[1]),
				post: r.slice(n[1] + t.length)
			}
		);
	}
	function Xp(e, t) {
		var r = t.match(e);
		return r ? r[0] : null;
	}
	function ed(e, t, r) {
		var n,
			i,
			o,
			a,
			s,
			c = r.indexOf(e),
			u = r.indexOf(t, c + 1),
			l = c;
		if (c >= 0 && u > 0) {
			for (n = [], o = r.length; l >= 0 && !s; )
				l == c
					? (n.push(l), (c = r.indexOf(e, l + 1)))
					: 1 == n.length
					? (s = [n.pop(), u])
					: ((i = n.pop()) < o && ((o = i), (a = u)),
					  (u = r.indexOf(t, l + 1))),
					(l = c < u && c >= 0 ? c : u);
			n.length && (s = [o, a]);
		}
		return s;
	}
	function td(e) {
		var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
			r = { preserveStatic: !0, removeComments: !1 },
			n = Qp({}, r, t),
			i = [];
		function o(e) {
			throw new Error("CSS parse error: ".concat(e));
		}
		function a(t) {
			var r = t.exec(e);
			if (r) return (e = e.slice(r[0].length)), r;
		}
		function s() {
			return a(/^{\s*/);
		}
		function c() {
			return a(/^}/);
		}
		function u() {
			a(/^\s*/);
		}
		function l() {
			if ((u(), "/" === e[0] && "*" === e[1])) {
				for (var t = 2; e[t] && ("*" !== e[t] || "/" !== e[t + 1]); ) t++;
				if (!e[t]) return o("end of comment is missing");
				var r = e.slice(2, t);
				return (e = e.slice(t + 2)), { type: "comment", comment: r };
			}
		}
		function f() {
			for (var e, t = []; (e = l()); ) t.push(e);
			return n.removeComments ? [] : t;
		}
		function h() {
			for (u(); "}" === e[0]; ) o("extra closing bracket");
			var t = a(/^(("(?:\\"|[^"])*"|'(?:\\'|[^'])*'|[^{])+)/);
			if (t)
				return t[0]
					.trim()
					.replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*\/+/g, "")
					.replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function (e) {
						return e.replace(/,/g, "â€Œ");
					})
					.split(/\s*(?![^(]*\)),\s*/)
					.map(function (e) {
						return e.replace(/\u200C/g, ",");
					});
		}
		function p() {
			if ("@" === e[0]) return A();
			a(/^([;\s]*)+/);
			var t = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g,
				r = a(/^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
			if (r) {
				if (((r = r[0].trim()), !a(/^:\s*/))) return o("property missing ':'");
				var n = a(
						/^((?:\/\*.*?\*\/|'(?:\\'|.)*?'|"(?:\\"|.)*?"|\((\s*'(?:\\'|.)*?'|"(?:\\"|.)*?"|[^)]*?)\s*\)|[^};])+)/
					),
					i = {
						type: "declaration",
						property: r.replace(t, ""),
						value: n ? n[0].replace(t, "").trim() : ""
					};
				return a(/^[;\s]*/), i;
			}
		}
		function d() {
			if (!s()) return o("missing '{'");
			for (var e, t = f(); (e = p()); ) t.push(e), (t = t.concat(f()));
			return c() ? t : o("missing '}'");
		}
		function v() {
			u();
			for (var e, t = []; (e = a(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/)); )
				t.push(e[1]), a(/^,\s*/);
			if (t.length) return { type: "keyframe", values: t, declarations: d() };
		}
		function m() {
			var e = a(/^@([-\w]+)?keyframes\s*/);
			if (e) {
				var t = e[1];
				if (!(e = a(/^([-\w]+)\s*/))) return o("@keyframes missing name");
				var r,
					n = e[1];
				if (!s()) return o("@keyframes missing '{'");
				for (var i = f(); (r = v()); ) i.push(r), (i = i.concat(f()));
				return c()
					? { type: "keyframes", name: n, vendor: t, keyframes: i }
					: o("@keyframes missing '}'");
			}
		}
		function g() {
			if (a(/^@page */))
				return { type: "page", selectors: h() || [], declarations: d() };
		}
		function y() {
			var e = a(
				/@(top|bottom|left|right)-(left|center|right|top|middle|bottom)-?(corner)?\s*/
			);
			if (e)
				return {
					type: "page-margin-box",
					name:
						"".concat(e[1], "-").concat(e[2]) + (e[3] ? "-".concat(e[3]) : ""),
					declarations: d()
				};
		}
		function _() {
			if (a(/^@font-face\s*/)) return { type: "font-face", declarations: d() };
		}
		function b() {
			var e = a(/^@supports *([^{]+)/);
			if (e) return { type: "supports", supports: e[1].trim(), rules: C() };
		}
		function w() {
			if (a(/^@host\s*/)) return { type: "host", rules: C() };
		}
		function S() {
			var e = a(/^@media([^{]+)*/);
			if (e) return { type: "media", media: (e[1] || "").trim(), rules: C() };
		}
		function k() {
			var e = a(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
			if (e)
				return { type: "custom-media", name: e[1].trim(), media: e[2].trim() };
		}
		function x() {
			var e = a(/^@([-\w]+)?document *([^{]+)/);
			if (e)
				return {
					type: "document",
					document: e[2].trim(),
					vendor: e[1] ? e[1].trim() : null,
					rules: C()
				};
		}
		function M() {
			var e = a(/^@(import|charset|namespace)\s*([^;]+);/);
			if (e) return { type: e[1], name: e[2].trim() };
		}
		function A() {
			if ((u(), "@" === e[0])) {
				var t =
					M() || _() || S() || m() || b() || x() || k() || w() || g() || y();
				if (t && !n.preserveStatic) {
					var r = !1;
					if (t.declarations)
						r = t.declarations.some(function (e) {
							return /var\(/.test(e.value);
						});
					else
						r = (t.keyframes || t.rules || []).some(function (e) {
							return (e.declarations || []).some(function (e) {
								return /var\(/.test(e.value);
							});
						});
					return r ? t : {};
				}
				return t;
			}
		}
		function E() {
			if (!n.preserveStatic) {
				var t = Jp("{", "}", e);
				if (t) {
					var r =
							/:(?:root|host)(?![.:#(])/.test(t.pre) &&
							/--\S*\s*:/.test(t.body),
						i = /var\(/.test(t.body);
					if (!r && !i) return (e = e.slice(t.end + 1)), {};
				}
			}
			var a = h() || [],
				s = n.preserveStatic
					? d()
					: d().filter(function (e) {
							var t =
									a.some(function (e) {
										return /:(?:root|host)(?![.:#(])/.test(e);
									}) && /^--\S/.test(e.property),
								r = /var\(/.test(e.value);
							return t || r;
					  });
			return (
				a.length || o("selector missing"),
				{ type: "rule", selectors: a, declarations: s }
			);
		}
		function C(t) {
			if (!t && !s()) return o("missing '{'");
			for (
				var r, n = f();
				e.length && (t || "}" !== e[0]) && (r = A() || E());

			)
				r.type && n.push(r), (n = n.concat(f()));
			return t || c() ? n : o("missing '}'");
		}
		return { type: "stylesheet", stylesheet: { rules: C(!0), errors: i } };
	}
	function rd(e) {
		var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
			r = { parseHost: !1, store: {}, onWarning: function () {} },
			n = Qp({}, r, t),
			i = new RegExp(":".concat(n.parseHost ? "host" : "root", "$"));
		return (
			"string" == typeof e && (e = td(e, n)),
			e.stylesheet.rules.forEach(function (e) {
				"rule" === e.type &&
					e.selectors.some(function (e) {
						return i.test(e);
					}) &&
					e.declarations.forEach(function (e, t) {
						var r = e.property,
							i = e.value;
						r && 0 === r.indexOf("--") && (n.store[r] = i);
					});
			}),
			n.store
		);
	}
	function nd(e) {
		var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
			r = arguments.length > 2 ? arguments[2] : void 0,
			n = {
				charset: function (e) {
					return "@charset " + e.name + ";";
				},
				comment: function (e) {
					return 0 === e.comment.indexOf("__CSSVARSPONYFILL")
						? "/*" + e.comment + "*/"
						: "";
				},
				"custom-media": function (e) {
					return "@custom-media " + e.name + " " + e.media + ";";
				},
				declaration: function (e) {
					return e.property + ":" + e.value + ";";
				},
				document: function (e) {
					return (
						"@" +
						(e.vendor || "") +
						"document " +
						e.document +
						"{" +
						i(e.rules) +
						"}"
					);
				},
				"font-face": function (e) {
					return "@font-face{" + i(e.declarations) + "}";
				},
				host: function (e) {
					return "@host{" + i(e.rules) + "}";
				},
				import: function (e) {
					return "@import " + e.name + ";";
				},
				keyframe: function (e) {
					return e.values.join(",") + "{" + i(e.declarations) + "}";
				},
				keyframes: function (e) {
					return (
						"@" +
						(e.vendor || "") +
						"keyframes " +
						e.name +
						"{" +
						i(e.keyframes) +
						"}"
					);
				},
				media: function (e) {
					return "@media " + e.media + "{" + i(e.rules) + "}";
				},
				namespace: function (e) {
					return "@namespace " + e.name + ";";
				},
				page: function (e) {
					return (
						"@page " +
						(e.selectors.length ? e.selectors.join(", ") : "") +
						"{" +
						i(e.declarations) +
						"}"
					);
				},
				"page-margin-box": function (e) {
					return "@" + e.name + "{" + i(e.declarations) + "}";
				},
				rule: function (e) {
					var t = e.declarations;
					if (t.length) return e.selectors.join(",") + "{" + i(t) + "}";
				},
				supports: function (e) {
					return "@supports " + e.supports + "{" + i(e.rules) + "}";
				}
			};
		function i(e) {
			for (var i = "", o = 0; o < e.length; o++) {
				var a = e[o];
				r && r(a);
				var s = n[a.type](a);
				s && ((i += s), s.length && a.selectors && (i += t));
			}
			return i;
		}
		return i(e.stylesheet.rules);
	}
	function id(e, t) {
		e.rules.forEach(function (r) {
			r.rules
				? id(r, t)
				: r.keyframes
				? r.keyframes.forEach(function (e) {
						"keyframe" === e.type && t(e.declarations, r);
				  })
				: r.declarations && t(r.declarations, e);
		});
	}
	Yp.range = ed;
	function od(e) {
		var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
			r = {
				preserveStatic: !0,
				preserveVars: !1,
				variables: {},
				onWarning: function () {}
			},
			n = Qp({}, r, t);
		return (
			"string" == typeof e && (e = td(e, n)),
			id(e.stylesheet, function (e, t) {
				for (var r = 0; r < e.length; r++) {
					var i = e[r],
						o = i.type,
						a = i.property,
						s = i.value;
					if ("declaration" === o)
						if (n.preserveVars || !a || 0 !== a.indexOf("--")) {
							if (-1 !== s.indexOf("var(")) {
								var c = sd(s, n);
								c !== i.value &&
									((c = ad(c)),
									n.preserveVars
										? (e.splice(r, 0, { type: o, property: a, value: c }), r++)
										: (i.value = c));
							}
						} else e.splice(r, 1), r--;
				}
			}),
			nd(e)
		);
	}
	function ad(e) {
		return (
			(e.match(/calc\(([^)]+)\)/g) || []).forEach(function (t) {
				var r = "calc".concat(t.split("calc").join(""));
				e = e.replace(t, r);
			}),
			e
		);
	}
	function sd(e) {
		var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
			r = arguments.length > 2 ? arguments[2] : void 0;
		if (-1 === e.indexOf("var(")) return e;
		var n = Jp("(", ")", e);
		function i(e) {
			var n = e.split(",")[0].replace(/[\s\n\t]/g, ""),
				i = (e.match(/(?:\s*,\s*){1}(.*)?/) || [])[1],
				o = Object.prototype.hasOwnProperty.call(t.variables, n)
					? String(t.variables[n])
					: void 0,
				a = o || (i ? String(i) : void 0),
				s = r || e;
			return (
				o || t.onWarning('variable "'.concat(n, '" is undefined')),
				a && "undefined" !== a && a.length > 0
					? sd(a, t, s)
					: "var(".concat(s, ")")
			);
		}
		if (n) {
			if ("var" === n.pre.slice(-3)) {
				var o = 0 === n.body.trim().length;
				return o
					? (t.onWarning("var() must contain a non-whitespace string"), e)
					: n.pre.slice(0, -3) + i(n.body) + sd(n.post, t);
			}
			return n.pre + "(".concat(sd(n.body, t), ")") + sd(n.post, t);
		}
		return (
			-1 !== e.indexOf("var(") &&
				t.onWarning('missing closing ")" in the value "'.concat(e, '"')),
			e
		);
	}
	var cd = "undefined" != typeof window,
		ud =
			cd &&
			window.CSS &&
			window.CSS.supports &&
			window.CSS.supports("(--a: 0)"),
		ld = { group: 0, job: 0 },
		fd = {
			rootElement: cd ? document : null,
			shadowDOM: !1,
			include: "style,link[rel=stylesheet]",
			exclude: "",
			variables: {},
			onlyLegacy: !0,
			preserveStatic: !0,
			preserveVars: !1,
			silent: !1,
			updateDOM: !0,
			updateURLs: !0,
			watch: null,
			onBeforeSend: function () {},
			onError: function () {},
			onWarning: function () {},
			onSuccess: function () {},
			onComplete: function () {},
			onFinally: function () {}
		},
		hd = {
			cssComments: /\/\*[\s\S]+?\*\//g,
			cssKeyframes: /@(?:-\w*-)?keyframes/,
			cssMediaQueries: /@media[^{]+\{([\s\S]+?})\s*}/g,
			cssUrls: /url\((?!['"]?(?:data|http|\/\/):)['"]?([^'")]*)['"]?\)/g,
			cssVarDeclRules: /(?::(?:root|host)(?![.:#(])[\s,]*[^{]*{\s*[^}]*})/g,
			cssVarDecls: /(?:[\s;]*)(-{2}\w[\w-]*)(?:\s*:\s*)([^;]*);/g,
			cssVarFunc: /var\(\s*--[\w-]/,
			cssVars: /(?:(?::(?:root|host)(?![.:#(])[\s,]*[^{]*{\s*[^;]*;*\s*)|(?:var\(\s*))(--[^:)]+)(?:\s*[:)])/
		},
		pd = { dom: {}, job: {}, user: {} },
		dd = !1,
		vd = null,
		md = 0,
		gd = null,
		yd = !1;
	/**
	 * Fetches, parses, and transforms CSS custom properties from specified
	 * <style> and <link> elements into static values, then appends a new <style>
	 * element with static values to the DOM to provide CSS custom property
	 * compatibility for legacy browsers. Also provides a single interface for
	 * live updates of runtime values in both modern and legacy browsers.
	 *
	 * @preserve
	 * @param {object}   [options] Options object
	 * @param {object}   [options.rootElement=document] Root element to traverse for
	 *                   <link> and <style> nodes
	 * @param {boolean}  [options.shadowDOM=false] Determines if shadow DOM <link>
	 *                   and <style> nodes will be processed.
	 * @param {string}   [options.include="style,link[rel=stylesheet]"] CSS selector
	 *                   matching <link re="stylesheet"> and <style> nodes to
	 *                   process
	 * @param {string}   [options.exclude] CSS selector matching <link
	 *                   rel="stylehseet"> and <style> nodes to exclude from those
	 *                   matches by options.include
	 * @param {object}   [options.variables] A map of custom property name/value
	 *                   pairs. Property names can omit or include the leading
	 *                   double-hyphen (â€”), and values specified will override
	 *                   previous values
	 * @param {boolean}  [options.onlyLegacy=true] Determines if the ponyfill will
	 *                   only generate legacy-compatible CSS in browsers that lack
	 *                   native support (i.e., legacy browsers)
	 * @param {boolean}  [options.preserveStatic=true] Determines if CSS
	 *                   declarations that do not reference a custom property will
	 *                   be preserved in the transformed CSS
	 * @param {boolean}  [options.preserveVars=false] Determines if CSS custom
	 *                   property declarations will be preserved in the transformed
	 *                   CSS
	 * @param {boolean}  [options.silent=false] Determines if warning and error
	 *                   messages will be displayed on the console
	 * @param {boolean}  [options.updateDOM=true] Determines if the ponyfill will
	 *                   update the DOM after processing CSS custom properties
	 * @param {boolean}  [options.updateURLs=true] Determines if relative url()
	 *                   paths will be converted to absolute urls in external CSS
	 * @param {boolean}  [options.watch=false] Determines if a MutationObserver will
	 *                   be created that will execute the ponyfill when a <link> or
	 *                   <style> DOM mutation is observed
	 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
	 *                   1) the XHR object, 2) source node reference, and 3) the
	 *                   source URL as arguments
	 * @param {function} [options.onError] Callback after a CSS parsing error has
	 *                   occurred or an XHR request has failed. Passes 1) an error
	 *                   message, and 2) source node reference, 3) xhr, and 4 url as
	 *                   arguments.
	 * @param {function} [options.onWarning] Callback after each CSS parsing warning
	 *                   has occurred. Passes 1) a warning message as an argument.
	 * @param {function} [options.onSuccess] Callback after CSS data has been
	 *                   collected from each node and before CSS custom properties
	 *                   have been transformed. Allows modifying the CSS data before
	 *                   it is transformed by returning any string value (or false
	 *                   to skip). Passes 1) CSS text, 2) source node reference, and
	 *                   3) the source URL as arguments.
	 * @param {function} [options.onComplete] Callback after all CSS has been
	 *                   processed, legacy-compatible CSS has been generated, and
	 *                   (optionally) the DOM has been updated. Passes 1) a CSS
	 *                   string with CSS variable values resolved, 2) an array of
	 *                   output <style> node references that have been appended to
	 *                   the DOM, 3) an object containing all custom properies names
	 *                   and values, and 4) the ponyfill execution time in
	 *                   milliseconds.
	 * @param {function} [options.onFinally] Callback in modern and legacy browsers
	 *                   after the ponyfill has finished all tasks. Passes 1) a
	 *                   boolean indicating if the last ponyfill call resulted in a
	 *                   style change, 2) a boolean indicating if the current
	 *                   browser provides native support for CSS custom properties,
	 *                   and 3) the ponyfill execution time in milliseconds.
	 * @example
	 *
	 *   cssVars({
	 *     rootElement   : document,
	 *     shadowDOM     : false,
	 *     include       : 'style,link[rel="stylesheet"]',
	 *     exclude       : '',
	 *     variables     : {},
	 *     onlyLegacy    : true,
	 *     preserveStatic: true,
	 *     preserveVars  : false,
	 *     silent        : false,
	 *     updateDOM     : true,
	 *     updateURLs    : true,
	 *     watch         : false,
	 *     onBeforeSend(xhr, node, url) {},
	 *     onError(message, node, xhr, url) {},
	 *     onWarning(message) {},
	 *     onSuccess(cssText, node, url) {},
	 *     onComplete(cssText, styleNode, cssVariables, benchmark) {},
	 *     onFinally(hasChanged, hasNativeSupport, benchmark)
	 *   });
	 */
	function _d() {
		var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
			t = "cssVars(): ",
			r = Qp({}, fd, e);
		function n(e, n, i, o) {
			!r.silent &&
				window.console &&
				console.error("".concat(t).concat(e, "\n"), n),
				r.onError(e, n, i, o);
		}
		function i(e) {
			!r.silent && window.console && console.warn("".concat(t).concat(e)),
				r.onWarning(e);
		}
		function o(e) {
			r.onFinally(Boolean(e), ud, Ad() - r.__benchmark);
		}
		if (cd) {
			if (r.watch) return (r.watch = fd.watch), bd(r), void _d(r);
			if (
				(!1 === r.watch && vd && (vd.disconnect(), (vd = null)), !r.__benchmark)
			) {
				if (dd === r.rootElement) return void wd(e);
				var a = Array.apply(
					null,
					r.rootElement.querySelectorAll(
						'[data-cssvars]:not([data-cssvars="out"])'
					)
				);
				if (
					((r.__benchmark = Ad()),
					(r.exclude = [
						vd
							? '[data-cssvars]:not([data-cssvars=""])'
							: '[data-cssvars="out"]',
						"link[disabled]:not([data-cssvars])",
						r.exclude
					]
						.filter(function (e) {
							return e;
						})
						.join(",")),
					(r.variables = xd(r.variables)),
					a.forEach(function (e) {
						var t = "style" === e.nodeName.toLowerCase() && e.__cssVars.text,
							r = t && e.textContent !== e.__cssVars.text;
						t &&
							r &&
							(e.sheet && (e.sheet.disabled = !1),
							e.setAttribute("data-cssvars", ""));
					}),
					!vd)
				) {
					var s = Array.apply(
						null,
						r.rootElement.querySelectorAll('[data-cssvars="out"]')
					);
					s.forEach(function (e) {
						var t = e.getAttribute("data-cssvars-group");
						(t
							? r.rootElement.querySelector(
									'[data-cssvars="src"][data-cssvars-group="'.concat(t, '"]')
							  )
							: null) || e.parentNode.removeChild(e);
					}),
						md && a.length < md && ((md = a.length), (pd.dom = {}));
				}
			}
			if ("loading" !== document.readyState)
				if (ud && r.onlyLegacy) {
					var c = !1;
					if (r.updateDOM) {
						var u =
							r.rootElement.host ||
							(r.rootElement === document
								? document.documentElement
								: r.rootElement);
						Object.keys(r.variables).forEach(function (e) {
							var t = r.variables[e];
							(c = c || t !== getComputedStyle(u).getPropertyValue(e)),
								u.style.setProperty(e, t);
						});
					}
					o(c);
				} else
					!yd && (r.shadowDOM || r.rootElement.shadowRoot || r.rootElement.host)
						? Gp({
								rootElement: fd.rootElement,
								include: fd.include,
								exclude: r.exclude,
								skipDisabled: !1,
								onSuccess: function (e, t, r) {
									return (
										!((t.sheet || {}).disabled && !t.__cssVars) &&
										((e = (
											(e = e
												.replace(hd.cssComments, "")
												.replace(hd.cssMediaQueries, "")).match(
												hd.cssVarDeclRules
											) || []
										).join("")) ||
											!1)
									);
								},
								onComplete: function (e, t, n) {
									rd(e, { store: pd.dom, onWarning: i }), (yd = !0), _d(r);
								}
						  })
						: ((dd = r.rootElement),
						  Gp({
								rootElement: r.rootElement,
								include: r.include,
								exclude: r.exclude,
								skipDisabled: !1,
								onBeforeSend: r.onBeforeSend,
								onError: function (e, t, r) {
									var i = e.responseURL || Md(r, location.href),
										o = e.statusText
											? "(".concat(e.statusText, ")")
											: "Unspecified Error" +
											  (0 === e.status ? " (possibly CORS related)" : "");
									n(
										"CSS XHR Error: "
											.concat(i, " ")
											.concat(e.status, " ")
											.concat(o),
										t,
										e,
										i
									);
								},
								onSuccess: function (e, t, n) {
									if ((t.sheet || {}).disabled && !t.__cssVars) return !1;
									var i = "link" === t.nodeName.toLowerCase(),
										o =
											"style" === t.nodeName.toLowerCase() &&
											e !== t.textContent,
										a = r.onSuccess(e, t, n);
									return (
										(e = void 0 !== a && !1 === Boolean(a) ? "" : a || e),
										r.updateURLs && (i || o) && (e = kd(e, n)),
										e
									);
								},
								onComplete: function (e, t) {
									var a =
											arguments.length > 2 && void 0 !== arguments[2]
												? arguments[2]
												: [],
										s = Qp({}, pd.dom, pd.user);
									if (
										((pd.job = {}),
										a.forEach(function (e, o) {
											var a = t[o];
											if (
												((e.__cssVars = e.__cssVars || {}),
												(e.__cssVars.text = a),
												hd.cssVars.test(a))
											)
												try {
													var s = td(a, {
														preserveStatic: r.preserveStatic,
														removeComments: !0
													});
													rd(s, {
														parseHost: Boolean(r.rootElement.host),
														store: pd.dom,
														onWarning: i
													}),
														(e.__cssVars.tree = s);
												} catch (t) {
													n(t.message, e);
												}
										}),
										Qp(pd.job, pd.dom),
										r.updateDOM
											? (Qp(pd.user, r.variables), Qp(pd.job, pd.user))
											: (Qp(pd.job, pd.user, r.variables), Qp(s, r.variables)),
										ld.job > 0 &&
											Boolean(
												Object.keys(pd.job).length > Object.keys(s).length ||
													Boolean(
														Object.keys(s).length &&
															Object.keys(pd.job).some(function (e) {
																return pd.job[e] !== s[e];
															})
													)
											))
									)
										Ed(r.rootElement), _d(r);
									else {
										var c = [],
											u = [],
											l = !1;
										if (
											(r.updateDOM && ld.job++,
											a.forEach(function (e, o) {
												var a = !e.__cssVars.tree;
												if (e.__cssVars.tree)
													try {
														od(
															e.__cssVars.tree,
															Qp({}, r, { variables: pd.job, onWarning: i })
														);
														var s = nd(e.__cssVars.tree);
														if (r.updateDOM) {
															var f = t[o],
																h = hd.cssVarFunc.test(f);
															if (
																(e.getAttribute("data-cssvars") ||
																	e.setAttribute("data-cssvars", "src"),
																s.length && h)
															) {
																var p =
																		e.getAttribute("data-cssvars-group") ||
																		++ld.group,
																	d = s.replace(/\s/g, ""),
																	v =
																		r.rootElement.querySelector(
																			'[data-cssvars="out"][data-cssvars-group="'.concat(
																				p,
																				'"]'
																			)
																		) || document.createElement("style");
																(l = l || hd.cssKeyframes.test(s)),
																	r.preserveStatic &&
																		e.sheet &&
																		(e.sheet.disabled = !0),
																	v.hasAttribute("data-cssvars") ||
																		v.setAttribute("data-cssvars", "out"),
																	d === e.textContent.replace(/\s/g, "")
																		? ((a = !0),
																		  v &&
																				v.parentNode &&
																				(e.removeAttribute(
																					"data-cssvars-group"
																				),
																				v.parentNode.removeChild(v)))
																		: d !== v.textContent.replace(/\s/g, "") &&
																		  ([e, v].forEach(function (e) {
																				e.setAttribute(
																					"data-cssvars-job",
																					ld.job
																				),
																					e.setAttribute(
																						"data-cssvars-group",
																						p
																					);
																		  }),
																		  (v.textContent = s),
																		  c.push(s),
																		  u.push(v),
																		  v.parentNode ||
																				e.parentNode.insertBefore(
																					v,
																					e.nextSibling
																				));
															}
														} else
															e.textContent.replace(/\s/g, "") !== s &&
																c.push(s);
													} catch (t) {
														n(t.message, e);
													}
												a && e.setAttribute("data-cssvars", "skip"),
													e.hasAttribute("data-cssvars-job") ||
														e.setAttribute("data-cssvars-job", ld.job);
											}),
											(md = r.rootElement.querySelectorAll(
												'[data-cssvars]:not([data-cssvars="out"])'
											).length),
											r.shadowDOM)
										)
											for (
												var f,
													h = []
														.concat(r.rootElement)
														.concat(
															Array.apply(
																null,
																r.rootElement.querySelectorAll("*")
															)
														),
													p = 0;
												(f = h[p]);
												++p
											)
												if (
													f.shadowRoot &&
													f.shadowRoot.querySelector("style")
												) {
													var d = Qp({}, r, { rootElement: f.shadowRoot });
													_d(d);
												}
										r.updateDOM && l && Sd(r.rootElement),
											(dd = !1),
											r.onComplete(
												c.join(""),
												u,
												JSON.parse(JSON.stringify(pd.job)),
												Ad() - r.__benchmark
											),
											o(u.length);
									}
								}
						  }));
			else
				document.addEventListener("DOMContentLoaded", function t(r) {
					_d(e), document.removeEventListener("DOMContentLoaded", t);
				});
		}
	}
	function bd(e) {
		function t(e) {
			var t = r(e) && e.hasAttribute("disabled"),
				n = (e.sheet || {}).disabled;
			return t || n;
		}
		function r(e) {
			return (
				"link" === e.nodeName.toLowerCase() &&
				-1 !== (e.getAttribute("rel") || "").indexOf("stylesheet")
			);
		}
		function n(e) {
			return "style" === e.nodeName.toLowerCase();
		}
		window.MutationObserver &&
			(vd && (vd.disconnect(), (vd = null)),
			(vd = new MutationObserver(function (i) {
				i.some(function (i) {
					return (
						(function (n) {
							var i = !1;
							if ("attributes" === n.type && r(n.target) && !t(n.target)) {
								var o = "disabled" === n.attributeName,
									a = "href" === n.attributeName,
									s = "skip" === n.target.getAttribute("data-cssvars"),
									c = "src" === n.target.getAttribute("data-cssvars");
								o
									? (i = !s && !c)
									: a &&
									  (s
											? n.target.setAttribute("data-cssvars", "")
											: c && Ed(e.rootElement, !0),
									  (i = !0));
							}
							return i;
						})(i) ||
						(function (e) {
							var t = !1;
							if ("childList" === e.type) {
								var r = n(e.target),
									i = "out" === e.target.getAttribute("data-cssvars");
								t = r && !i;
							}
							return t;
						})(i) ||
						(function (e) {
							var i = !1;
							return (
								"childList" === e.type &&
									(i = Array.apply(null, e.addedNodes).some(function (e) {
										var i = 1 === e.nodeType && e.hasAttribute("data-cssvars"),
											o = n(e) && hd.cssVars.test(e.textContent);
										return !i && (r(e) || o) && !t(e);
									})),
								i
							);
						})(i) ||
						(function (t) {
							var r = !1;
							return (
								"childList" === t.type &&
									(r = Array.apply(null, t.removedNodes).some(function (t) {
										var r = 1 === t.nodeType,
											n = r && "out" === t.getAttribute("data-cssvars"),
											i = r && "src" === t.getAttribute("data-cssvars"),
											o = i;
										if (i || n) {
											var a = t.getAttribute("data-cssvars-group"),
												s = e.rootElement.querySelector(
													'[data-cssvars-group="'.concat(a, '"]')
												);
											i && Ed(e.rootElement, !0),
												s && s.parentNode.removeChild(s);
										}
										return o;
									})),
								r
							);
						})(i)
					);
				}) && _d(e);
			})).observe(document.documentElement, {
				attributes: !0,
				attributeFilter: ["disabled", "href"],
				childList: !0,
				subtree: !0
			}));
	}
	function wd(e) {
		var t =
			arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 100;
		clearTimeout(gd),
			(gd = setTimeout(function () {
				(e.__benchmark = null), _d(e);
			}, t));
	}
	function Sd(e) {
		var t = [
			"animation-name",
			"-moz-animation-name",
			"-webkit-animation-name"
		].filter(function (e) {
			return getComputedStyle(document.body)[e];
		})[0];
		if (t) {
			for (
				var r = e.getElementsByTagName("*"), n = [], i = 0, o = r.length;
				i < o;
				i++
			) {
				var a = r[i];
				"none" !== getComputedStyle(a)[t] &&
					((a.style[t] += "__CSSVARSPONYFILL-KEYFRAMES__"), n.push(a));
			}
			document.body.offsetHeight;
			for (var s = 0, c = n.length; s < c; s++) {
				var u = n[s].style;
				u[t] = u[t].replace("__CSSVARSPONYFILL-KEYFRAMES__", "");
			}
		}
	}
	function kd(e, t) {
		return (
			(e.replace(hd.cssComments, "").match(hd.cssUrls) || []).forEach(function (
				r
			) {
				var n = r.replace(hd.cssUrls, "$1"),
					i = Md(n, t);
				e = e.replace(r, r.replace(n, i));
			}),
			e
		);
	}
	function xd() {
		var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
			t = /^-{2}/;
		return Object.keys(e).reduce(function (r, n) {
			return (r[t.test(n) ? n : "--".concat(n.replace(/^-+/, ""))] = e[n]), r;
		}, {});
	}
	function Md(e) {
		var t =
				arguments.length > 1 && void 0 !== arguments[1]
					? arguments[1]
					: location.href,
			r = document.implementation.createHTMLDocument(""),
			n = r.createElement("base"),
			i = r.createElement("a");
		return (
			r.head.appendChild(n),
			r.body.appendChild(i),
			(n.href = t),
			(i.href = e),
			i.href
		);
	}
	function Ad() {
		return cd && (window.performance || {}).now
			? window.performance.now()
			: new Date().getTime();
	}
	function Ed(e) {
		var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
			r = Array.apply(
				null,
				e.querySelectorAll('[data-cssvars="skip"],[data-cssvars="src"]')
			);
		r.forEach(function (e) {
			return e.setAttribute("data-cssvars", "");
		}),
			t && (pd.dom = {});
	}
	_d.reset = function () {
		for (var e in ((ld.job = 0),
		(ld.group = 0),
		(dd = !1),
		vd && (vd.disconnect(), (vd = null)),
		(md = 0),
		(gd = null),
		(yd = !1),
		pd))
			pd[e] = {};
	};
	var Cd = "get",
		Id = "post",
		Td = (function () {
			function e() {}
			var t = e.prototype;
			return (
				(t.get = function (e, t, r) {
					return this.request(Cd, this.encodeParams(e, t), r);
				}),
				(t.post = function (e, t, r, n) {
					return this.request(
						Id,
						this.encodeParams(e, t),
						ca({}, { body: Go(r), credentials: void 0 }, n)
					);
				}),
				(t.request = function (e, t, r) {
					var n = ca({}, { method: e, credentials: "include" }, r);
					return this._fetch(t, n);
				}),
				(t._fetch = function (e, t) {
					return window.fetch ? fetch(e, t) : su(e, t);
				}),
				(t.beacon = function (e, t) {
					return this._sendBeacon(e, Go(t));
				}),
				(t._sendBeacon = function (e, t) {
					if (window.navigator && window.navigator.sendBeacon)
						return window.navigator.sendBeacon(e, t);
					var r = window.event && window.event.type,
						n = "unload" === r || "beforeunload" === r,
						i =
							"XMLHttpRequest" in window
								? new XMLHttpRequest()
								: new ActiveXObject("Microsoft.XMLHTTP");
					return (
						i.open("POST", e, !n),
						i.setRequestHeader("Accept", "*/*"),
						"string" == typeof t
							? i.setRequestHeader("Content-Type", "text/plain;charset=UTF-8")
							: "[object Blob]" === Object.prototype.toString.call(t) &&
							  t.type &&
							  i.setRequestHeader("Content-Type", t.type),
						i.send(t),
						!0
					);
				}),
				(t.encodeParams = function (e, t) {
					if ("object" == typeof t) {
						var r = ou(e).call(e, "?") > -1,
							n = "";
						for (var i in t)
							r ? (n += "&") : ((r = !0), (n += "?")),
								(n += i + "=" + encodeURIComponent(t[i]));
						return e + n;
					}
				}),
				e
			);
		})(),
		Od = (function () {
			function e(e, t) {
				if (
					(void 0 === e && (e = {}),
					(this._requester = new Td()),
					(this._environment = e.environment || "production"),
					(this._baseUrl = e.baseUrl || Vh(this._environment)),
					(this._endpoint = e.endpoint || null),
					(this._apiKey = e.apiKey || null),
					(this._version = e.version || 20190101),
					(this._params = e.params || {}),
					!t)
				)
					throw new xl("Must include storage", "ApiRequest");
				this._storage = t;
			}
			var t = e.prototype;
			return (
				(t.get = function (e) {
					return this._requester.get(
						this._baseUrl + this._endpoint,
						ca({}, this.baseParams(), this.sanitizeParams(this._params)),
						e
					);
				}),
				(t.post = function (e) {
					return this._requester.post(
						this._baseUrl + this._endpoint,
						this.baseParams(),
						this.sanitizeParams(this._params),
						e
					);
				}),
				(t.baseParams = function () {
					var e = {
							v: this._version,
							api_key: this._apiKey,
							jsLibVersion: "searchbar-v1.0.2",
							sessionTrackingEnabled: this._storage.get(Uf).value
						},
						t = new Uh(this._storage.getCurrentStateUrlMerged());
					return t.has("beta") && (e.beta = t.get("beta")), e;
				}),
				(t.sanitizeParams = function (e) {
					var t;
					return (
						void 0 === e && (e = {}),
						Ia((t = Ms(e))).call(t, function (t) {
							(void 0 !== e[t] && null !== e[t]) || delete e[t];
						}),
						e
					);
				}),
				e
			);
		})(),
		Rd = (function () {
			function e(e, t) {
				var r = this;
				if (
					((this.apiKey = e.apiKey),
					(this.experienceKey = e.experienceKey),
					(this.experienceVersion = e.experienceVersion || "config1.0"),
					(this.printVerbose = e.printVerbose),
					(this.sendToServer = e.sendToServer),
					this.sendToServer && !t)
				)
					throw new xl(
						"Must include storage to send errors to server",
						"ErrorReporter"
					);
				(this.storage = t),
					(this.environment = e.environment),
					window.addEventListener("error", function (e) {
						return r.report(e.error);
					}),
					window.addEventListener("unhandledrejection", function (e) {
						return r.report(e.error);
					});
			}
			var t = e.prototype;
			return (
				(t.report = function (e) {
					if (e instanceof kl && !e.reported) {
						if (((e.reported = !0), this.printError(e), this.sendToServer)) {
							var t = {
								endpoint: "/v2/accounts/me/answers/errors",
								apiKey: this.apiKey,
								version: 20190301,
								environment: this.environment,
								params: {
									libVersion: "searchbar-v1.0.2",
									experienceVersion: this.experienceVersion,
									experienceKey: this.experienceKey,
									error: e.toJson()
								}
							};
							new Od(t, this.storage).get().catch(console.err);
						}
						return e;
					}
				}),
				(t.printError = function (e) {
					this.printVerbose
						? console.error(
								"error: " +
									e.errorMessage +
									"\ncode: " +
									e.errorCode +
									"\nboundary: " +
									e.boundary +
									"\nstack: " +
									e.stack
						  )
						: console.error(e.toString());
				}),
				e
			);
		})();
	function Fd(e, t) {
		var r = Ms(e);
		if (Ss) {
			var n = Ss(e);
			t &&
				(n = Da(n).call(n, function (t) {
					return Ra(e, t).enumerable;
				})),
				r.push.apply(r, n);
		}
		return r;
	}
	var Ld = (function () {
			function e(e, t, r, n, i) {
				void 0 === n && (n = {}),
					void 0 === i && (i = "production"),
					(this._businessId = r),
					(this._globalOptions = ca({}, n, { experienceKey: e })),
					(this._environment = i),
					(this._baseUrl = zh(this._environment)),
					(this._conversionTrackingEnabled = !1),
					t && (this._globalOptions.experienceVersion = t);
			}
			var t = e.prototype;
			return (
				(t.getQueryId = function () {
					return this._globalOptions.queryId;
				}),
				(t.setQueryId = function (e) {
					this._globalOptions.queryId = e;
				}),
				(t.report = function (e) {
					var t = {};
					if (this._conversionTrackingEnabled && "function" == typeof ytag)
						ytag("optin", !0), (t = ytag("yfpc", null));
					else if (this._conversionTrackingEnabled)
						throw new Il(
							"Tried to enable conversion tracking without including ytag"
						);
					if (!(e instanceof fh))
						throw new Il("Tried to send invalid analytics event", e);
					return (
						e.addOptions(this._globalOptions),
						new Td().beacon(
							this._baseUrl +
								"/realtimeanalytics/data/answers/" +
								this._businessId,
							(function (e) {
								for (var t = 1; t < arguments.length; t++) {
									var r,
										n = null != arguments[t] ? arguments[t] : {};
									if (t % 2)
										Ia((r = Fd(Object(n), !0))).call(r, function (t) {
											Ds(e, t, n[t]);
										});
									else if (ma) ha(e, ma(n));
									else {
										var i;
										Ia((i = Fd(Object(n)))).call(i, function (t) {
											fa(e, t, Ra(n, t));
										});
									}
								}
								return e;
							})({ data: e.toApiEvent() }, t)
						)
					);
				}),
				(t.setConversionTrackingEnabled = function (e) {
					(this._conversionTrackingEnabled = e),
						(this._baseUrl = zh(this._environment, e));
				}),
				e
			);
		})(),
		jd = (function () {
			function e() {
				this._listeners = {};
			}
			var t = e.prototype;
			return (
				(t.on = function (e, t, r) {
					if ("function" != typeof t)
						throw new Error("callback handler should be of type {function}");
					return (
						void 0 === this._listeners[e] && (this._listeners[e] = []),
						this._listeners[e].push({ event: e, cb: t, once: r || !1 }),
						this
					);
				}),
				(t.once = function (e, t) {
					return this.on(e, t, !0);
				}),
				(t.off = function (e) {
					return delete this._listeners[e], this;
				}),
				(t.emit = function (e, t) {
					var r = this._listeners[e];
					if (void 0 !== r) {
						for (var n = [], i = 0; i < r.length; i++)
							r[i].cb(t), !0 !== r[i].once && n.push(r[i]);
						return (this._listeners[e] = n), this;
					}
				}),
				e
			);
		})(),
		Nd = Lu;
	function Pd(e, t) {
		var r, n;
		if (void 0 === wc || null == dc(e)) {
			if (
				As(e) ||
				(n = (function (e, t) {
					var r;
					if (!e) return;
					if ("string" == typeof e) return qd(e, t);
					var n = Tc((r = Object.prototype.toString.call(e))).call(r, 8, -1);
					"Object" === n && e.constructor && (n = e.constructor.name);
					if ("Map" === n || "Set" === n) return kc(e);
					if (
						"Arguments" === n ||
						/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
					)
						return qd(e, t);
				})(e)) ||
				(t && e && "number" == typeof e.length)
			) {
				n && (e = n);
				var i = 0;
				return function () {
					return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
				};
			}
			throw new TypeError(
				"Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
			);
		}
		return (n = pc(e)), hc((r = n.next)).call(r, n);
	}
	function qd(e, t) {
		(null == t || t > e.length) && (t = e.length);
		for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
		return n;
	}
	var Dd = r(function (e, t) {
		fa(t, "__esModule", { value: !0 }),
			(t.areEquivalentParams = void 0),
			(t.areEquivalentParams = function (e, t) {
				var r = kc(Zc(e).call(e)),
					n = kc(Zc(t).call(t));
				if (r.length !== n.length) return !1;
				for (var i, o = Pd(Zc(e).call(e)); !(i = o()).done; ) {
					var a = i.value,
						s = a[0];
					if (a[1] !== t.get(s)) return !1;
				}
				return !0;
			});
	});
	t(Dd);
	Dd.areEquivalentParams;
	var Bd = r(function (e, t) {
		fa(t, "__esModule", { value: !0 });
		var r = (function () {
			function e(e) {
				void 0 === e && (e = ""), (this.params = this.parse(e));
			}
			var t = e.prototype;
			return (
				(t.parse = function (t) {
					var r = new Nd(),
						n = t;
					if (!n) return r;
					ou(t).call(t, "?") > -1 &&
						(n = Tc(t).call(t, ou(t).call(t, "?") + 1));
					for (var i = n.split("&"), o = 0; o < i.length; o++) {
						var a = i[o].split("=");
						a.length > 1 ? r.set(a[0], e.decode(a[1])) : r.set(a[0], "");
					}
					return r;
				}),
				(t.get = function (e) {
					return this.params.get(e);
				}),
				(t.set = function (e, t) {
					this.params.set(e, t);
				}),
				(t.has = function (e) {
					return e in this.params;
				}),
				(t.delete = function (e) {
					this.params.delete(e);
				}),
				(t.toString = function () {
					var t,
						r = [];
					return (
						Ia((t = this.params)).call(t, function (t, n) {
							var i = t || "";
							r.push(n + "=" + e.encode(i));
						}),
						r.join("&")
					);
				}),
				(t.entries = function () {
					var e,
						t = [];
					return (
						Ia((e = this.params)).call(e, function (e, r) {
							t.push([r, e]);
						}),
						t
					);
				}),
				(e.decode = function (e) {
					return decodeURIComponent(e.replace(/[ +]/g, "%20"));
				}),
				(e.encode = function (e) {
					var t = {
						"!": "%21",
						"'": "%27",
						"(": "%28",
						")": "%29",
						"%20": "+"
					};
					return encodeURIComponent(e).replace(/[!'()]|%20/g, function (e) {
						return t[e];
					});
				}),
				e
			);
		})();
		t.default = r;
	});
	function Ud(e, t) {
		var r, n;
		if (void 0 === wc || null == dc(e)) {
			if (
				As(e) ||
				(n = (function (e, t) {
					var r;
					if (!e) return;
					if ("string" == typeof e) return Vd(e, t);
					var n = Tc((r = Object.prototype.toString.call(e))).call(r, 8, -1);
					"Object" === n && e.constructor && (n = e.constructor.name);
					if ("Map" === n || "Set" === n) return kc(e);
					if (
						"Arguments" === n ||
						/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
					)
						return Vd(e, t);
				})(e)) ||
				(t && e && "number" == typeof e.length)
			) {
				n && (e = n);
				var i = 0;
				return function () {
					return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
				};
			}
			throw new TypeError(
				"Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
			);
		}
		return (n = pc(e)), hc((r = n.next)).call(r, n);
	}
	function Vd(e, t) {
		(null == t || t > e.length) && (t = e.length);
		for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
		return n;
	}
	t(Bd);
	var Hd = t(
			r(function (t, r) {
				var n =
					(e && e.__importDefault) ||
					function (e) {
						return e && e.__esModule ? e : { default: e };
					};
				fa(r, "__esModule", { value: !0 });
				var i = n(Bd),
					o = (function () {
						function e(e) {
							var t = this;
							(this.popListener = e),
								(this.params = new i.default()),
								window.addEventListener("popstate", function () {
									(t.params = new i.default(
										window.location.search.substring(1)
									)),
										t.popListener(t.getAll(), t.getUrlWithCurrentState());
								});
						}
						var t = e.prototype;
						return (
							(t.init = function (e) {
								this.params = new i.default(e);
							}),
							(t.set = function (e, t) {
								if ("string" != typeof e)
									throw new Error("Storage data key must be a string: " + e);
								if ("string" != typeof t)
									throw new Error("Storage data value must be a string: " + t);
								this.params.set(e, t);
							}),
							(t.pushStateToHistory = function () {
								var e = new i.default(window.location.search.substring(1));
								Dd.areEquivalentParams(this.params, e) ||
									window.history.pushState(
										null,
										"",
										"?" + this.params.toString()
									);
							}),
							(t.get = function (e) {
								if ("string" != typeof e)
									throw new Error("Storage data key must be a string: " + e);
								return this.params.get(e);
							}),
							(t.delete = function (e) {
								if ("string" != typeof e)
									throw new Error("Storage data key must be a string: " + e);
								this.params.delete(e);
							}),
							(t.getAll = function () {
								for (
									var e, t = new Nd(), r = Ud(Zc((n = this.params)).call(n));
									!(e = r()).done;

								) {
									var n,
										i = e.value,
										o = i[0],
										a = i[1];
									t.set(o, a);
								}
								return t;
							}),
							(t.getUrlWithCurrentState = function () {
								return this.params.toString();
							}),
							e
						);
					})();
				r.default = o;
			})
		),
		zd = (function () {
			function e(e) {
				var t = this;
				void 0 === e && (e = {}),
					(this.persistedStateListeners = {
						update: e.updateListener || function () {},
						reset: e.resetListener || function () {}
					}),
					(this.persistedValueParser = e.persistedValueParser),
					(this.popListener = function (e, r) {
						t.persistedStateListeners.update(e, r),
							t.persistedStateListeners.reset(e, r);
					}),
					(this.storage = new Nd()),
					(this.persistentStorage = new Hd(this.popListener)),
					(this.listeners = []);
			}
			var t = e.prototype;
			return (
				(t.init = function (e) {
					var t,
						r = this;
					return (
						this.persistentStorage.init(e),
						Ia((t = this.persistentStorage.getAll())).call(t, function (e, t) {
							var n = r.persistedValueParser ? r.persistedValueParser(t, e) : e;
							r.set(t, n);
						}),
						this
					);
				}),
				(t.set = function (e, t) {
					if (null == e || "string" != typeof e)
						throw new Cl("Storage key must be of type string", e, t);
					if (void 0 === t)
						throw new Cl("Data cannot be of type undefined", e, t);
					this.storage.set(e, t), this._callListeners("update", e);
				}),
				(t.setWithPersist = function (e, t) {
					this.set(e, t);
					var r = t;
					"string" != typeof t && (r = Go(t)), this.persistentStorage.set(e, r);
				}),
				(t.pushStateToHistory = function () {
					this.persistentStorage.pushStateToHistory(),
						this.persistedStateListeners.update(
							this.persistentStorage.getAll(),
							this.getCurrentStateUrlMerged()
						);
				}),
				(t.get = function (e) {
					return this.storage.get(e);
				}),
				(t.getAll = function () {
					return new Nd(this.storage);
				}),
				(t.delete = function (e) {
					if (null == e || "string" != typeof e)
						throw new Cl("Storage key must be of type string", e);
					this.storage.delete(e), this.persistentStorage.delete(e);
				}),
				(t.has = function (e) {
					return this.storage.has(e);
				}),
				(t.getCurrentStateUrlMerged = function () {
					var e,
						t = new Uh(window.location.search.substring(1));
					return (
						Ia((e = this.persistentStorage.getAll())).call(e, function (e, r) {
							t.set(r, e);
						}),
						t.toString()
					);
				}),
				(t.getUrlWithCurrentState = function () {
					return this.persistentStorage.getUrlWithCurrentState();
				}),
				(t.registerListener = function (e) {
					if (
						!e.eventType ||
						!e.storageKey ||
						!e.callback ||
						"function" != typeof e.callback
					)
						throw new Cl("Invalid listener applied in storage: " + e);
					this.listeners.push(e);
				}),
				(t.removeListener = function (e) {
					var t;
					this.listeners = Da((t = this.listeners)).call(t, function (t) {
						return t !== e;
					});
				}),
				(t._callListeners = function (e, t) {
					var r,
						n = this;
					Ia((r = this.listeners)).call(r, function (r) {
						r.storageKey === t && r.eventType === e && r.callback(n.get(t));
					});
				}),
				e
			);
		})(),
		Kd = (function () {
			function e(e) {
				void 0 === e && (e = {}),
					(this.limit = e.limit || 20),
					(this.verticalKey = e.verticalKey || null),
					(this.defaultInitialSearch = e.defaultInitialSearch),
					this.validate(),
					Sl(this);
			}
			return (
				(e.prototype.validate = function () {
					if (
						"number" != typeof this.limit ||
						this.limit < 1 ||
						this.limit > 50
					)
						throw new Ml(
							"Search Limit must be between 1 and 50",
							"SearchConfig"
						);
				}),
				e
			);
		})(),
		Zd = La("splice"),
		Qd = Math.max,
		Wd = Math.min;
	z(
		{ target: "Array", proto: !0, forced: !Zd },
		{
			splice: function (e, t) {
				var r,
					n,
					i,
					o,
					a,
					s,
					c = Te(this),
					u = it(c.length),
					l = st(e, u),
					f = arguments.length;
				if (
					(0 === f
						? (r = n = 0)
						: 1 === f
						? ((r = 0), (n = u - l))
						: ((r = f - 2), (n = Wd(Qd(ne(t), 0), u - l))),
					u + r - n > 9007199254740991)
				)
					throw TypeError("Maximum allowed length exceeded");
				for (i = _a(c, n), o = 0; o < n; o++)
					(a = l + o) in c && rr(i, o, c[a]);
				if (((i.length = n), r < n)) {
					for (o = l; o < u - n; o++)
						(s = o + r), (a = o + n) in c ? (c[s] = c[a]) : delete c[s];
					for (o = u; o > u - n + r; o--) delete c[o - 1];
				} else if (r > n)
					for (o = u - n; o > l; o--)
						(s = o + r - 1), (a = o + n - 1) in c ? (c[s] = c[a]) : delete c[s];
				for (o = 0; o < r; o++) c[o + l] = arguments[o + 2];
				return (c.length = u - n + r), i;
			}
		}
	);
	var Gd = Jo("Array").splice,
		$d = Array.prototype,
		Jd = function (e) {
			var t = e.splice;
			return e === $d || (e instanceof Array && t === $d.splice) ? Gd : t;
		},
		Yd = Sa.findIndex,
		Xd = !0;
	"findIndex" in [] &&
		Array(1).findIndex(function () {
			Xd = !1;
		}),
		z(
			{ target: "Array", proto: !0, forced: Xd },
			{
				findIndex: function (e) {
					return Yd(this, e, arguments.length > 1 ? arguments[1] : void 0);
				}
			}
		);
	var ev = Jo("Array").findIndex,
		tv = Array.prototype,
		rv = function (e) {
			var t = e.findIndex;
			return e === tv || (e instanceof Array && t === tv.findIndex) ? ev : t;
		};
	function nv(e, t) {
		var r = Ms(e);
		if (Ss) {
			var n = Ss(e);
			t &&
				(n = Da(n).call(n, function (t) {
					return Ra(e, t).enumerable;
				})),
				r.push.apply(r, n);
		}
		return r;
	}
	var iv = (function () {
		function e(e) {
			(this._activeComponents = []),
				(this._componentRegistry = e),
				(this._componentIdCounter = 0),
				(this._core = null),
				(this._renderer = null),
				(this._analyticsReporter = null),
				(this._componentTypeToComponentNames = {}),
				(this._componentToModuleIdListener = new Nd());
		}
		var t = e.prototype;
		return (
			(t.setRenderer = function (e) {
				return (this._renderer = e), this;
			}),
			(t.setCore = function (e) {
				return (this._core = e), this;
			}),
			(t.setAnalyticsReporter = function (e) {
				return (this._analyticsReporter = e), this;
			}),
			(t.register = function (e) {
				return (this._componentRegistry[e.type] = e), this;
			}),
			(t.getSimilarComponents = function (e) {
				var t,
					r = Da((t = Ms(this._componentRegistry))).call(t, function (t) {
						return Sh(t).call(t, e.substring(0, 2));
					});
				return 0 === r.length && (r = Ms(this._componentRegistry)), r;
			}),
			(t.create = function (e, t) {
				var r,
					n,
					i = {
						core: this._core,
						renderer: this._renderer,
						analyticsReporter: this._analyticsReporter,
						componentManager: this,
						uniqueId: this._componentIdCounter
					};
				this._componentIdCounter++;
				var o = this._componentRegistry[e];
				if (!o)
					throw new Al(
						"Component type " +
							e +
							" is not recognized as a valid component. You might have meant " +
							this.getSimilarComponents(e).join(", ") +
							"?"
					);
				if (
					!o.areDuplicateNamesAllowed() &&
					ip((r = this._activeComponents)).call(r, function (e) {
						return e.name === t.name;
					})
				)
					throw new Al(
						"Another component with name " + t.name + " already exists",
						e
					);
				var a = (function (e) {
						for (var t = 1; t < arguments.length; t++) {
							var r,
								n = null != arguments[t] ? arguments[t] : {};
							if (t % 2)
								Ia((r = nv(Object(n), !0))).call(r, function (t) {
									Ds(e, t, n[t]);
								});
							else if (ma) ha(e, ma(n));
							else {
								var i;
								Ia((i = nv(Object(n)))).call(i, function (t) {
									fa(e, t, Ra(n, t));
								});
							}
						}
						return e;
					})(
						{
							isTwin: ip((n = this._activeComponents)).call(n, function (t) {
								return t.constructor.type === e;
							})
						},
						t
					),
					s = new this._componentRegistry[e](a, i).init(a);
				if (
					(this._activeComponents.push(s),
					this._componentTypeToComponentNames[e] ||
						(this._componentTypeToComponentNames[e] = []),
					this._componentTypeToComponentNames[e].push(s.name),
					this._core && null !== this._core.storage)
				) {
					if (void 0 === s.moduleId || null === s.moduleId) return s;
					var c = {
						eventType: "update",
						storageKey: s.moduleId,
						callback: function (e) {
							return s.setState(e);
						}
					};
					this._core.storage.registerListener(c),
						this._componentToModuleIdListener.set(s, c);
				}
				return s;
			}),
			(t.remove = function (e) {
				var t;
				this._core.storage.removeListener(
					this._componentToModuleIdListener.get(e)
				);
				var r,
					n = rv((t = this._activeComponents)).call(t, function (t) {
						return t.uniqueId === e.uniqueId;
					});
				-1 !== n && Jd((r = this._activeComponents)).call(r, n, 1);
			}),
			(t.removeByName = function (e) {
				var t,
					r = gu((t = this._activeComponents)).call(t, function (t) {
						return t.name === e;
					});
				r.remove(), Qh.empty(r._container);
			}),
			(t.getActiveComponent = function (e) {
				var t;
				return gu((t = this._activeComponents)).call(t, function (t) {
					return t.constructor.type === e;
				});
			}),
			(t.getComponentNamesForComponentTypes = function (e) {
				var t = this;
				return Ps(e).call(
					e,
					function (e, r) {
						return yl(e).call(e, t._componentTypeToComponentNames[r] || []);
					},
					[]
				);
			}),
			e
		);
	})();
	function ov(e) {
		var t;
		try {
			t = JSON.parse(e);
		} catch (e) {
			return !1;
		}
		return !!t && "object" == typeof t && !As(t);
	}
	var av = [].reverse,
		sv = [1, 2];
	z(
		{ target: "Array", proto: !0, forced: String(sv) === String(sv.reverse()) },
		{
			reverse: function () {
				return ga(this) && (this.length = this.length), av.call(this);
			}
		}
	);
	var cv = Jo("Array").reverse,
		uv = Array.prototype,
		lv = function (e) {
			var t = e.reverse;
			return e === uv || (e instanceof Array && t === uv.reverse) ? cv : t;
		},
		fv = t(
			r(function (e) {
				function t(e, t) {
					for (var r = 0; r < t.length; r++) {
						var n = t[r];
						(n.enumerable = n.enumerable || !1),
							(n.configurable = !0),
							"value" in n && (n.writable = !0),
							qs(e, n.key, n);
					}
				}
				(e.exports = function (e, r, n) {
					return r && t(e.prototype, r), n && t(e, n), e;
				}),
					(e.exports.default = e.exports),
					(e.exports.__esModule = !0);
			})
		),
		hv = r(function (t, r) {
			var n = "[object Arguments]",
				i = "[object Function]",
				o = "[object GeneratorFunction]",
				a = "[object Map]",
				s = "[object Set]",
				c = /\w*$/,
				u = /^\[object .+?Constructor\]$/,
				l = /^(?:0|[1-9]\d*)$/,
				f = {};
			(f[n] = f["[object Array]"] = f["[object ArrayBuffer]"] = f[
				"[object DataView]"
			] = f["[object Boolean]"] = f["[object Date]"] = f[
				"[object Float32Array]"
			] = f["[object Float64Array]"] = f["[object Int8Array]"] = f[
				"[object Int16Array]"
			] = f["[object Int32Array]"] = f[a] = f["[object Number]"] = f[
				"[object Object]"
			] = f["[object RegExp]"] = f[s] = f["[object String]"] = f[
				"[object Symbol]"
			] = f["[object Uint8Array]"] = f["[object Uint8ClampedArray]"] = f[
				"[object Uint16Array]"
			] = f["[object Uint32Array]"] = !0),
				(f["[object Error]"] = f[i] = f["[object WeakMap]"] = !1);
			var h = "object" == typeof e && e && e.Object === Object && e,
				p = "object" == typeof self && self && self.Object === Object && self,
				d = h || p || Function("return this")(),
				v = r && !r.nodeType && r,
				m = v && t && !t.nodeType && t,
				g = m && m.exports === v;
			function y(e, t) {
				return e.set(t[0], t[1]), e;
			}
			function _(e, t) {
				return e.add(t), e;
			}
			function b(e, t, r, n) {
				var i = -1,
					o = e ? e.length : 0;
				for (n && o && (r = e[++i]); ++i < o; ) r = t(r, e[i], i, e);
				return r;
			}
			function w(e) {
				var t = !1;
				if (null != e && "function" != typeof e.toString)
					try {
						t = !!(e + "");
					} catch (e) {}
				return t;
			}
			function S(e) {
				var t = -1,
					r = Array(e.size);
				return (
					e.forEach(function (e, n) {
						r[++t] = [n, e];
					}),
					r
				);
			}
			function k(e, t) {
				return function (r) {
					return e(t(r));
				};
			}
			function x(e) {
				var t = -1,
					r = Array(e.size);
				return (
					e.forEach(function (e) {
						r[++t] = e;
					}),
					r
				);
			}
			var M = Array.prototype,
				A = Function.prototype,
				E = Object.prototype,
				C = d["__core-js_shared__"],
				I = (function () {
					var e = /[^.]+$/.exec((C && C.keys && C.keys.IE_PROTO) || "");
					return e ? "Symbol(src)_1." + e : "";
				})(),
				T = A.toString,
				O = E.hasOwnProperty,
				R = E.toString,
				F = RegExp(
					"^" +
						T.call(O)
							.replace(/[\\^$.*+?()[\]{}|]/g, "\\$&")
							.replace(
								/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
								"$1.*?"
							) +
						"$"
				),
				L = g ? d.Buffer : void 0,
				j = d.Symbol,
				N = d.Uint8Array,
				P = k(Object.getPrototypeOf, Object),
				q = Object.create,
				D = E.propertyIsEnumerable,
				B = M.splice,
				U = Object.getOwnPropertySymbols,
				V = L ? L.isBuffer : void 0,
				H = k(Object.keys, Object),
				z = ve(d, "DataView"),
				K = ve(d, "Map"),
				Z = ve(d, "Promise"),
				Q = ve(d, "Set"),
				W = ve(d, "WeakMap"),
				G = ve(Object, "create"),
				$ = be(z),
				J = be(K),
				Y = be(Z),
				X = be(Q),
				ee = be(W),
				te = j ? j.prototype : void 0,
				re = te ? te.valueOf : void 0;
			function ne(e) {
				var t = -1,
					r = e ? e.length : 0;
				for (this.clear(); ++t < r; ) {
					var n = e[t];
					this.set(n[0], n[1]);
				}
			}
			function ie(e) {
				var t = -1,
					r = e ? e.length : 0;
				for (this.clear(); ++t < r; ) {
					var n = e[t];
					this.set(n[0], n[1]);
				}
			}
			function oe(e) {
				var t = -1,
					r = e ? e.length : 0;
				for (this.clear(); ++t < r; ) {
					var n = e[t];
					this.set(n[0], n[1]);
				}
			}
			function ae(e) {
				this.__data__ = new ie(e);
			}
			function se(e, t) {
				var r =
						Se(e) ||
						(function (e) {
							return (
								(function (e) {
									return (
										(function (e) {
											return !!e && "object" == typeof e;
										})(e) && ke(e)
									);
								})(e) &&
								O.call(e, "callee") &&
								(!D.call(e, "callee") || R.call(e) == n)
							);
						})(e)
							? (function (e, t) {
									for (var r = -1, n = Array(e); ++r < e; ) n[r] = t(r);
									return n;
							  })(e.length, String)
							: [],
					i = r.length,
					o = !!i;
				for (var a in e)
					(!t && !O.call(e, a)) ||
						(o && ("length" == a || ye(a, i))) ||
						r.push(a);
				return r;
			}
			function ce(e, t, r) {
				var n = e[t];
				(O.call(e, t) && we(n, r) && (void 0 !== r || t in e)) || (e[t] = r);
			}
			function ue(e, t) {
				for (var r = e.length; r--; ) if (we(e[r][0], t)) return r;
				return -1;
			}
			function le(e, t, r, u, l, h, p) {
				var d;
				if ((u && (d = h ? u(e, l, h, p) : u(e)), void 0 !== d)) return d;
				if (!Ae(e)) return e;
				var v = Se(e);
				if (v) {
					if (
						((d = (function (e) {
							var t = e.length,
								r = e.constructor(t);
							t &&
								"string" == typeof e[0] &&
								O.call(e, "index") &&
								((r.index = e.index), (r.input = e.input));
							return r;
						})(e)),
						!t)
					)
						return (function (e, t) {
							var r = -1,
								n = e.length;
							t || (t = Array(n));
							for (; ++r < n; ) t[r] = e[r];
							return t;
						})(e, d);
				} else {
					var m = ge(e),
						g = m == i || m == o;
					if (xe(e))
						return (function (e, t) {
							if (t) return e.slice();
							var r = new e.constructor(e.length);
							return e.copy(r), r;
						})(e, t);
					if ("[object Object]" == m || m == n || (g && !h)) {
						if (w(e)) return h ? e : {};
						if (
							((d = (function (e) {
								return "function" != typeof e.constructor || _e(e)
									? {}
									: ((t = P(e)), Ae(t) ? q(t) : {});
								var t;
							})(g ? {} : e)),
							!t)
						)
							return (function (e, t) {
								return pe(e, me(e), t);
							})(
								e,
								(function (e, t) {
									return e && pe(t, Ee(t), e);
								})(d, e)
							);
					} else {
						if (!f[m]) return h ? e : {};
						d = (function (e, t, r, n) {
							var i = e.constructor;
							switch (t) {
								case "[object ArrayBuffer]":
									return he(e);
								case "[object Boolean]":
								case "[object Date]":
									return new i(+e);
								case "[object DataView]":
									return (function (e, t) {
										var r = t ? he(e.buffer) : e.buffer;
										return new e.constructor(r, e.byteOffset, e.byteLength);
									})(e, n);
								case "[object Float32Array]":
								case "[object Float64Array]":
								case "[object Int8Array]":
								case "[object Int16Array]":
								case "[object Int32Array]":
								case "[object Uint8Array]":
								case "[object Uint8ClampedArray]":
								case "[object Uint16Array]":
								case "[object Uint32Array]":
									return (function (e, t) {
										var r = t ? he(e.buffer) : e.buffer;
										return new e.constructor(r, e.byteOffset, e.length);
									})(e, n);
								case a:
									return (function (e, t, r) {
										return b(t ? r(S(e), !0) : S(e), y, new e.constructor());
									})(e, n, r);
								case "[object Number]":
								case "[object String]":
									return new i(e);
								case "[object RegExp]":
									return (function (e) {
										var t = new e.constructor(e.source, c.exec(e));
										return (t.lastIndex = e.lastIndex), t;
									})(e);
								case s:
									return (function (e, t, r) {
										return b(t ? r(x(e), !0) : x(e), _, new e.constructor());
									})(e, n, r);
								case "[object Symbol]":
									return (function (e) {
										return re ? Object(re.call(e)) : {};
									})(e);
							}
						})(e, m, le, t);
					}
				}
				p || (p = new ae());
				var k = p.get(e);
				if (k) return k;
				if ((p.set(e, d), !v))
					var M = r
						? (function (e) {
								return (function (e, t, r) {
									var n = t(e);
									return Se(e)
										? n
										: (function (e, t) {
												for (var r = -1, n = t.length, i = e.length; ++r < n; )
													e[i + r] = t[r];
												return e;
										  })(n, r(e));
								})(e, Ee, me);
						  })(e)
						: Ee(e);
				return (
					(function (e, t) {
						for (
							var r = -1, n = e ? e.length : 0;
							++r < n && !1 !== t(e[r], r, e);

						);
					})(M || e, function (n, i) {
						M && (n = e[(i = n)]), ce(d, i, le(n, t, r, u, i, e, p));
					}),
					d
				);
			}
			function fe(e) {
				return (
					!(!Ae(e) || ((t = e), I && I in t)) &&
					(Me(e) || w(e) ? F : u).test(be(e))
				);
				var t;
			}
			function he(e) {
				var t = new e.constructor(e.byteLength);
				return new N(t).set(new N(e)), t;
			}
			function pe(e, t, r, n) {
				r || (r = {});
				for (var i = -1, o = t.length; ++i < o; ) {
					var a = t[i],
						s = n ? n(r[a], e[a], a, r, e) : void 0;
					ce(r, a, void 0 === s ? e[a] : s);
				}
				return r;
			}
			function de(e, t) {
				var r,
					n,
					i = e.__data__;
				return (
					"string" == (n = typeof (r = t)) ||
					"number" == n ||
					"symbol" == n ||
					"boolean" == n
						? "__proto__" !== r
						: null === r
				)
					? i["string" == typeof t ? "string" : "hash"]
					: i.map;
			}
			function ve(e, t) {
				var r = (function (e, t) {
					return null == e ? void 0 : e[t];
				})(e, t);
				return fe(r) ? r : void 0;
			}
			(ne.prototype.clear = function () {
				this.__data__ = G ? G(null) : {};
			}),
				(ne.prototype.delete = function (e) {
					return this.has(e) && delete this.__data__[e];
				}),
				(ne.prototype.get = function (e) {
					var t = this.__data__;
					if (G) {
						var r = t[e];
						return "__lodash_hash_undefined__" === r ? void 0 : r;
					}
					return O.call(t, e) ? t[e] : void 0;
				}),
				(ne.prototype.has = function (e) {
					var t = this.__data__;
					return G ? void 0 !== t[e] : O.call(t, e);
				}),
				(ne.prototype.set = function (e, t) {
					return (
						(this.__data__[e] =
							G && void 0 === t ? "__lodash_hash_undefined__" : t),
						this
					);
				}),
				(ie.prototype.clear = function () {
					this.__data__ = [];
				}),
				(ie.prototype.delete = function (e) {
					var t = this.__data__,
						r = ue(t, e);
					return (
						!(r < 0) && (r == t.length - 1 ? t.pop() : B.call(t, r, 1), !0)
					);
				}),
				(ie.prototype.get = function (e) {
					var t = this.__data__,
						r = ue(t, e);
					return r < 0 ? void 0 : t[r][1];
				}),
				(ie.prototype.has = function (e) {
					return ue(this.__data__, e) > -1;
				}),
				(ie.prototype.set = function (e, t) {
					var r = this.__data__,
						n = ue(r, e);
					return n < 0 ? r.push([e, t]) : (r[n][1] = t), this;
				}),
				(oe.prototype.clear = function () {
					this.__data__ = {
						hash: new ne(),
						map: new (K || ie)(),
						string: new ne()
					};
				}),
				(oe.prototype.delete = function (e) {
					return de(this, e).delete(e);
				}),
				(oe.prototype.get = function (e) {
					return de(this, e).get(e);
				}),
				(oe.prototype.has = function (e) {
					return de(this, e).has(e);
				}),
				(oe.prototype.set = function (e, t) {
					return de(this, e).set(e, t), this;
				}),
				(ae.prototype.clear = function () {
					this.__data__ = new ie();
				}),
				(ae.prototype.delete = function (e) {
					return this.__data__.delete(e);
				}),
				(ae.prototype.get = function (e) {
					return this.__data__.get(e);
				}),
				(ae.prototype.has = function (e) {
					return this.__data__.has(e);
				}),
				(ae.prototype.set = function (e, t) {
					var r = this.__data__;
					if (r instanceof ie) {
						var n = r.__data__;
						if (!K || n.length < 199) return n.push([e, t]), this;
						r = this.__data__ = new oe(n);
					}
					return r.set(e, t), this;
				});
			var me = U
					? k(U, Object)
					: function () {
							return [];
					  },
				ge = function (e) {
					return R.call(e);
				};
			function ye(e, t) {
				return (
					!!(t = null == t ? 9007199254740991 : t) &&
					("number" == typeof e || l.test(e)) &&
					e > -1 &&
					e % 1 == 0 &&
					e < t
				);
			}
			function _e(e) {
				var t = e && e.constructor;
				return e === (("function" == typeof t && t.prototype) || E);
			}
			function be(e) {
				if (null != e) {
					try {
						return T.call(e);
					} catch (e) {}
					try {
						return e + "";
					} catch (e) {}
				}
				return "";
			}
			function we(e, t) {
				return e === t || (e != e && t != t);
			}
			((z && "[object DataView]" != ge(new z(new ArrayBuffer(1)))) ||
				(K && ge(new K()) != a) ||
				(Z && "[object Promise]" != ge(Z.resolve())) ||
				(Q && ge(new Q()) != s) ||
				(W && "[object WeakMap]" != ge(new W()))) &&
				(ge = function (e) {
					var t = R.call(e),
						r = "[object Object]" == t ? e.constructor : void 0,
						n = r ? be(r) : void 0;
					if (n)
						switch (n) {
							case $:
								return "[object DataView]";
							case J:
								return a;
							case Y:
								return "[object Promise]";
							case X:
								return s;
							case ee:
								return "[object WeakMap]";
						}
					return t;
				});
			var Se = Array.isArray;
			function ke(e) {
				return (
					null != e &&
					(function (e) {
						return (
							"number" == typeof e &&
							e > -1 &&
							e % 1 == 0 &&
							e <= 9007199254740991
						);
					})(e.length) &&
					!Me(e)
				);
			}
			var xe =
				V ||
				function () {
					return !1;
				};
			function Me(e) {
				var t = Ae(e) ? R.call(e) : "";
				return t == i || t == o;
			}
			function Ae(e) {
				var t = typeof e;
				return !!e && ("object" == t || "function" == t);
			}
			function Ee(e) {
				return ke(e)
					? se(e)
					: (function (e) {
							if (!_e(e)) return H(e);
							var t = [];
							for (var r in Object(e))
								O.call(e, r) && "constructor" != r && t.push(r);
							return t;
					  })(e);
			}
			t.exports = function (e) {
				return le(e, !0, !0);
			};
		}),
		pv = (function (e) {
			function t(t) {
				var r;
				return ((r = e.call(this) || this)._state = t || {}), r;
			}
			wu(t, e);
			var r = t.prototype;
			return (
				(r.init = function (e, t) {
					this._set(e, t);
				}),
				(r.set = function (e, t) {
					this._set(e, t), this.emit("update");
				}),
				(r._set = function (e, t) {
					void 0 === t ? (this._state = e) : (this._state[e] = t);
				}),
				(r.update = function (e) {
					(this._state = e), this.emit("update");
				}),
				(r.get = function (e) {
					return void 0 === e ? this._state : this._state[e];
				}),
				(r.has = function (e) {
					return void 0 !== this._state[e];
				}),
				(r.asJSON = function () {
					return this._state;
				}),
				t
			);
		})(jd);
	function dv(e, t) {
		var r = Ms(e);
		if (Ss) {
			var n = Ss(e);
			t &&
				(n = Da(n).call(n, function (t) {
					return Ra(e, t).enumerable;
				})),
				r.push.apply(r, n);
		}
		return r;
	}
	function vv(e) {
		for (var t = 1; t < arguments.length; t++) {
			var r,
				n = null != arguments[t] ? arguments[t] : {};
			if (t % 2)
				Ia((r = dv(Object(n), !0))).call(r, function (t) {
					Ds(e, t, n[t]);
				});
			else if (ma) ha(e, ma(n));
			else {
				var i;
				Ia((i = dv(Object(n)))).call(i, function (t) {
					fa(e, t, Ra(n, t));
				});
			}
		}
		return e;
	}
	var mv = (function () {
			function e(e, t) {
				var r, n, i;
				if (
					(void 0 === e && (e = {}),
					void 0 === t && (t = {}),
					(this.moduleId = null),
					(this.uniqueId = t.uniqueId),
					(this.name = e.name || this.constructor.type),
					(this._config = e),
					(this._type = this.constructor.name),
					(this._parentContainer = e.parentContainer || null),
					(this._children = []),
					(this._state = new pv(e.state)),
					(this.core = t.core || null),
					(this.componentManager = t.componentManager || null),
					(this.analyticsReporter = t.analyticsReporter || null),
					(this._analyticsOptions = e.analyticsOptions || {}),
					null === this._parentContainer)
				) {
					if (
						"string" == typeof e.container &&
						((this._container = Qh.query(e.container) || null),
						null === this._container)
					)
						throw new Error("Cannot find container DOM node: " + e.container);
				} else
					(this._container = Qh.query(this._parentContainer, e.container)),
						null === this._container &&
							((this._container = Qh.createEl("div", {
								class: e.container.substring(1, e.container.length)
							})),
							Qh.append(this._parentContainer, this._container));
				(this._className = e.class || "component"),
					(this._render = e.render || null),
					(this._renderer = t.renderer || Hp.Handlebars),
					(this._template = e.template
						? this._renderer.compile(e.template)
						: null),
					(this._templateName =
						e.templateName || this.constructor.defaultTemplateName(e)),
					(this._isMounted = !1),
					(this.transformData =
						e.transformData || this.transformData || function () {}),
					(this.onCreate =
						e.onCreateOverride || this.onCreate || function () {}),
					(this.onCreate = hc((r = this.onCreate)).call(r, this)),
					(this.onMount = e.onMountOverride || this.onMount || function () {}),
					(this.onMount = hc((n = this.onMount)).call(n, this)),
					(this.onUpdate =
						e.onUpdateOverride || this.onUpdate || function () {}),
					(this.onUpdate = hc((i = this.onUpdate)).call(i, this)),
					(this.userOnCreate = e.onCreate || function () {}),
					(this.userOnMount = e.onMount || function () {}),
					(this.userOnUpdate = e.onUpdate || function () {});
			}
			(e.defaultTemplateName = function (e) {
				return "default";
			}),
				(e.areDuplicateNamesAllowed = function () {
					return !1;
				});
			var t = e.prototype;
			return (
				(t.init = function (e) {
					var t = this;
					try {
						this.setState(e.data || e.state || {}),
							this.onCreate(),
							this.userOnCreate();
					} catch (e) {
						throw new Al(
							"Error initializing component",
							this.constructor.type,
							e
						);
					}
					return (
						this._state.on("update", function () {
							try {
								t.onUpdate(), t.userOnUpdate(), t.unMount(), t.mount();
							} catch (e) {
								throw new Al("Error updating component", t.constructor.type, e);
							}
						}),
						Qh.addClass(this._container, this._className),
						Qh.addClass(this._container, "yxt-Answers-component"),
						this
					);
				}),
				(t.addContainerClass = function (e) {
					Qh.addClass(this._container, e);
				}),
				(t.removeContainerClass = function (e) {
					Qh.removeClass(this._container, e);
				}),
				(t.setState = function (e) {
					var t = ca({}, { _config: this._config }, e);
					return this._state.set(t), this;
				}),
				(t.getState = function (e) {
					return this._state.get(e);
				}),
				(t.hasState = function (e) {
					return this._state.has(e);
				}),
				(t.transformData = function (e) {
					return e;
				}),
				(t.addChild = function (e, t, r) {
					var n = this.componentManager.create(
						t,
						ca(
							{ name: e.name, parentContainer: this._container, data: e },
							r || {},
							{ _parentOpts: this._config }
						)
					);
					return this._children.push(n), n;
				}),
				(t.remove = function () {
					var e;
					Ia((e = this._children)).call(e, function (e) {
						return e.remove();
					}),
						this.componentManager.remove(this);
				}),
				(t.setRender = function (e) {
					return (this._render = e), this;
				}),
				(t.setRenderer = function (e) {
					return (this._renderer = Hp[e]), this;
				}),
				(t.setTemplate = function (e) {
					this._template = this._renderer.compile(e);
				}),
				(t.unMount = function () {
					var e, t;
					if (!this._container) return this;
					Ia((e = this._children)).call(e, function (e) {
						e.unMount();
					}),
						Qh.empty(this._container),
						Ia((t = this._children)).call(t, function (e) {
							return e.remove();
						}),
						(this._children = []),
						this.onUnMount();
				}),
				(t.mount = function (e) {
					var t,
						r = this;
					if ((e && (this._container = e), !this._container)) return this;
					if (!1 === this.beforeMount()) return this;
					Qh.append(this._container, this.render(this._state.asJSON()));
					var n = Qh.queryAll(
							this._container,
							"[data-component]:not([data-is-component-mounted])"
						),
						i = this.transformData(hv(this._state.get()));
					if (
						(Ia(n).call(n, function (e) {
							return r._createSubcomponent(e, i);
						}),
						Ia((t = this._children)).call(t, function (e) {
							e.mount();
						}),
						this.analyticsReporter)
					) {
						var o,
							a = Qh.queryAll(
								this._container,
								"[data-eventtype]:not([data-is-analytics-attached])"
							);
						Ia(a).call(a, hc((o = this._createAnalyticsHook)).call(o, this));
					}
					return (
						(this._isMounted = !0),
						this.onMount(this),
						this.userOnMount(this),
						this
					);
				}),
				(t.render = function (e) {
					void 0 === e && (e = this._state.get()),
						this.beforeRender(),
						(e = this.transformData(hv(e)));
					var t = "";
					if ("function" == typeof this._render) {
						if ("string" != typeof (t = this._render(e)))
							throw new Error(
								"Render method must return HTML as type {string}"
							);
					} else
						t = this._renderer.render(
							{ template: this._template, templateName: this._templateName },
							e
						);
					var r = Qh.create(t);
					return this.afterRender(), r.innerHTML;
				}),
				(t._createSubcomponent = function (e, t) {
					var r = this;
					e.dataset.isComponentMounted = !0;
					var n = e.dataset,
						i = n.component,
						o = n.prop,
						a = n.opts ? JSON.parse(n.opts) : {},
						s = t[o] || {};
					(a = vv(vv({}, a), {}, { container: e })),
						As(s)
							? (lv(s).call(s),
							  Ia(s).call(s, function (e) {
									r.addChild(e, i, a);
							  }))
							: this.addChild(s, i, a);
				}),
				(t._createAnalyticsHook = function (e) {
					var t = this;
					e.dataset.isAnalyticsAttached = !0;
					var r = e.dataset,
						n = r.eventtype,
						i = r.eventlabel,
						o = r.middleclick,
						a = r.eventoptions ? JSON.parse(r.eventoptions) : {};
					Qh.on(e, "mousedown", function (e) {
						if (0 === e.button || (o && 1 === e.button)) {
							var r = new fh(n, i);
							r.addOptions(t._analyticsOptions),
								r.addOptions(a),
								t.analyticsReporter.report(r);
						}
					});
				}),
				(t.onCreate = function (e) {}),
				(t.onUpdate = function (e) {}),
				(t.beforeRender = function (e) {}),
				(t.afterRender = function (e) {}),
				(t.onMount = function (e) {}),
				(t.onUnMount = function (e) {}),
				(t.beforeMount = function (e) {}),
				(t.onDestroy = function (e) {}),
				fv(e, null, [
					{
						key: "type",
						get: function () {
							return "Component";
						}
					}
				]),
				e
			);
		})(),
		gv = [].slice,
		yv = /MSIE .\./.test(qe),
		_v = function (e) {
			return function (t, r) {
				var n = arguments.length > 2,
					i = n ? gv.call(arguments, 2) : void 0;
				return e(
					n
						? function () {
								("function" == typeof t ? t : Function(t)).apply(this, i);
						  }
						: t,
					r
				);
			};
		};
	z(
		{ global: !0, bind: !0, forced: yv },
		{ setTimeout: _v(o.setTimeout), setInterval: _v(o.setInterval) }
	);
	var bv = j.setTimeout,
		wv = (function () {
			function e() {}
			return (
				(e.prototype.create = function (e) {
					switch (e) {
						case ah:
							return { setQueryParams: !0, resetPagination: !0, useFacets: !0 };
						case sh:
							return {
								setQueryParams: !0,
								resetPagination: !1,
								useFacets: !0,
								sendQueryId: !0
							};
						case ih:
						case nh:
							return { setQueryParams: !0, resetPagination: !1, useFacets: !0 };
						case oh:
							return { setQueryParams: !0, resetPagination: !0, useFacets: !0 };
						default:
							return { setQueryParams: !0, resetPagination: !0 };
					}
				}),
				e
			);
		})();
	function Sv(e, t) {
		var r = Ms(e);
		if (Ss) {
			var n = Ss(e);
			t &&
				(n = Da(n).call(n, function (t) {
					return Ra(e, t).enumerable;
				})),
				r.push.apply(r, n);
		}
		return r;
	}
	var kv = (function () {
		function e(e, t) {
			var r = this;
			(this.core = e),
				(this.config = (function (e) {
					for (var t = 1; t < arguments.length; t++) {
						var r,
							n = null != arguments[t] ? arguments[t] : {};
						if (t % 2)
							Ia((r = Sv(Object(n), !0))).call(r, function (t) {
								Ds(e, t, n[t]);
							});
						else if (ma) ha(e, ma(n));
						else {
							var i;
							Ia((i = Sv(Object(n)))).call(i, function (t) {
								fa(e, t, Ra(n, t));
							});
						}
					}
					return e;
				})(
					{
						searchCooldown: 300,
						verticalKey: void 0,
						allowEmptySearch: !0,
						defaultInitialSearch: void 0
					},
					t
				)),
				(this.middleware = []),
				(this.searchOptionsFactory = new wv()),
				this.core.storage.registerListener({
					storageKey: If,
					eventType: "update",
					callback: function (e) {
						return r._handleQueryUpdate(e);
					}
				});
		}
		var t = e.prototype;
		return (
			(t.registerMiddleware = function (e) {
				this.middleware.push(e);
			}),
			(t._handleQueryUpdate = function (e) {
				null !== e
					? this._debouncedSearch(e)
					: (this.config.defaultInitialSearch ||
							"" === this.config.defaultInitialSearch) &&
					  (this.core.storage.set(Wf, nh),
					  this.core.storage.set(If, this.config.defaultInitialSearch));
			}),
			(t._debouncedSearch = function (e) {
				var t = this;
				if (
					!this._throttled &&
					(e ||
						this.config.allowEmptySearch ||
						this.core.storage.get(Wf) === ah)
				)
					return (
						this._setSearchLoadingState(),
						(this._throttled = !0),
						bv(function () {
							t._throttled = !1;
						}, this._searchCooldown),
						this._search(e)
					);
			}),
			(t._setSearchLoadingState = function () {
				this.config.verticalKey
					? this.core.storage.set(wf, df.searchLoading())
					: this.core.storage.set(bf, vf.searchLoading());
			}),
			(t._search = function (e) {
				var t,
					r = this,
					n = Os((t = this.middleware)).call(t, function (t) {
						return t(e);
					}),
					i = this.core.storage.get(Wf);
				return Vo.all(n).then(function () {
					return r.config.verticalKey
						? r.core.verticalSearch(
								r.config.verticalKey,
								r.searchOptionsFactory.create(i),
								{ input: e }
						  )
						: r.core.search(e, r.searchOptionsFactory.create(i));
				});
			}),
			e
		);
	})();
	function xv(e, t) {
		var r = Ms(e);
		if (Ss) {
			var n = Ss(e);
			t &&
				(n = Da(n).call(n, function (t) {
					return Ra(e, t).enumerable;
				})),
				r.push.apply(r, n);
		}
		return r;
	}
	function Mv(e) {
		for (var t = 1; t < arguments.length; t++) {
			var r,
				n = null != arguments[t] ? arguments[t] : {};
			if (t % 2)
				Ia((r = xv(Object(n), !0))).call(r, function (t) {
					Ds(e, t, n[t]);
				});
			else if (ma) ha(e, ma(n));
			else {
				var i;
				Ia((i = xv(Object(n)))).call(i, function (t) {
					fa(e, t, Ra(n, t));
				});
			}
		}
		return e;
	}
	var Av = 0,
		Ev = 1,
		Cv = 9,
		Iv = 13,
		Tv = 16,
		Ov = 17,
		Rv = 18,
		Fv = 27,
		Lv = 37,
		jv = 39,
		Nv = 38,
		Pv = 40,
		qv = 91,
		Dv = 92,
		Bv = 93,
		Uv = [
			mv,
			(function (e) {
				function t(t, r) {
					var n;
					return (
						void 0 === t && (t = {}),
						void 0 === r && (r = {}),
						((n = e.call(this, t, r) || this)._verticalKey =
							t.verticalKey || null),
						(n._useForm = void 0 === t.useForm || t.useForm),
						(n._formEl = t.formSelector || "form"),
						(n._inputEl = t.inputEl || ".js-yext-query"),
						(n.title = t.title),
						(n.labelText = t.labelText || "Conduct a search"),
						(n.submitText = t.submitText || "Submit"),
						(n.clearText = t.clearText || "Clear"),
						(n.submitIcon = t.submitIcon || null),
						(n.promptHeader = t.promptHeader || null),
						(n.autoFocus = !0 === t.autoFocus),
						(n.clearButton = void 0 === t.clearButton || t.clearButton),
						(n.autocompleteOnLoad = t.autocompleteOnLoad || !1),
						(n.redirectUrl = t.redirectUrl || null),
						(n.redirectUrlTarget = t.redirectUrlTarget || "_self"),
						(n._isTwin = t.isTwin),
						(n._globalSearchConfig = n.core.storage.get(Nf) || {}),
						(n._defaultInitialSearch =
							n._globalSearchConfig.defaultInitialSearch),
						(n.query = t.query || n.core.storage.get(If)),
						n.core.storage.registerListener({
							eventType: "update",
							storageKey: If,
							callback: function (e) {
								(n.query = e),
									n.queryEl && (n.queryEl.value = e),
									null !== e && n._updateClearButtonVisibility(e);
							}
						}),
						(n._searchCooldown = t.searchCooldown || 300),
						(n._promptForLocation =
							void 0 === t.promptForLocation || Boolean(t.promptForLocation)),
						(n._showClearButton = n.clearButton && n.query),
						(n._allowEmptySearch = !!t.allowEmptySearch),
						(n._autoCompleteName = n.name + ".autocomplete"),
						(n._geolocationOptions = Mv(
							{ enableHighAccuracy: !1, timeout: 1e3, maximumAge: 3e5 },
							t.geolocationOptions
						)),
						(n._geolocationTimeoutAlert = Mv(
							{
								enabled: !1,
								message: "We are unable to determine your location"
							},
							t.geolocationTimeoutAlert
						)),
						(n.autocompleteContainerIdName =
							"yxt-SearchBar-autocomplete--" + n.name),
						(n.inputLabelIdName = "yxt-SearchBar-inputLabel--" + n.name),
						(n.inputIdName = "yxt-SearchBar-input--" + n.name),
						(n.customHooks = {
							onClearSearch:
								(t.customHooks && t.customHooks.onClearSearch) ||
								function () {},
							onConductSearch:
								(t.customHooks && t.customHooks.onConductSearch) ||
								function () {}
						}),
						(n._autocompleteConfig = {
							shouldHideOnEmptySearch:
								t.autocomplete && t.autocomplete.shouldHideOnEmptySearch,
							onOpen: t.autocomplete && t.autocomplete.onOpen,
							onClose: t.autocomplete && t.autocomplete.onClose
						}),
						n._isTwin || n.initQueryUpdateListener(),
						n
					);
				}
				wu(t, e);
				var r = t.prototype;
				return (
					(r.initQueryUpdateListener = function () {
						var e = this,
							t = new kv(this.core, {
								searchCooldown: this._searchCooldown,
								verticalKey: this._verticalKey,
								allowEmptySearch: this._allowEmptySearch,
								defaultInitialSearch: this._defaultInitialSearch
							});
						this.core.setQueryUpdateListener(t),
							this.core.queryUpdateListener.registerMiddleware(function (t) {
								return e.promptForLocation(t);
							}),
							this.core.queryUpdateListener.registerMiddleware(function (t) {
								return e.customHooks.onConductSearch(t);
							});
					}),
					(t.defaultTemplateName = function () {
						return "search/search";
					}),
					(r.searchAfterAnswersOnReady = function () {
						null == this.query ||
							this.redirectUrl ||
							this.core.setQuery(this.query);
					}),
					(r.onMount = function () {
						(this.queryEl = Qh.query(this._container, this._inputEl)),
							!this.autoFocus ||
								this.query ||
								this.autocompleteOnLoad ||
								this.focusInputElement(),
							(this.isUsingYextAnimatedIcon =
								!this._config.customIconUrl && !this.submitIcon),
							this.isUsingYextAnimatedIcon && this.initAnimatedIcon(),
							this.initSearch(this._formEl),
							this.initAutoComplete(this._inputEl),
							this.clearButton && this.initClearButton(),
							this.autoFocus &&
								!this.query &&
								this.autocompleteOnLoad &&
								this.focusInputElement();
					}),
					(r.requestIconAnimationFrame = function (e) {
						var t = this;
						this.iconState !== e &&
							((this.iconState = e),
							this.isRequestingAnimationFrame ||
								((this.isRequestingAnimationFrame = !0),
								window.requestAnimationFrame(function () {
									t.forwardIcon.classList.remove(
										"yxt-SearchBar-AnimatedIcon--paused"
									),
										t.reverseIcon.classList.remove(
											"yxt-SearchBar-AnimatedIcon--paused"
										),
										t.iconState === Ev
											? (t.forwardIcon.classList.remove(
													"yxt-SearchBar-AnimatedIcon--inactive"
											  ),
											  t.reverseIcon.classList.add(
													"yxt-SearchBar-AnimatedIcon--inactive"
											  ))
											: t.iconState === Av &&
											  (t.forwardIcon.classList.add(
													"yxt-SearchBar-AnimatedIcon--inactive"
											  ),
											  t.reverseIcon.classList.remove(
													"yxt-SearchBar-AnimatedIcon--inactive"
											  )),
										(t.isRequestingAnimationFrame = !1);
								})));
					}),
					(r.animateIconToMagnifyingGlass = function () {
						this.iconIsFrozen || this.requestIconAnimationFrame(Ev);
					}),
					(r.animateIconToYext = function (e) {
						var t = !1;
						e &&
							e.relatedTarget &&
							(t = this._container.contains(e.relatedTarget)),
							this.iconIsFrozen || t || this.requestIconAnimationFrame(Av);
					}),
					(r.initAnimatedIcon = function () {
						var e = this;
						(this.iconState = this.autoFocus && !this.query ? Ev : Av),
							(this.forwardIcon = Qh.query(
								this._container,
								".js-yxt-AnimatedForward"
							)),
							(this.reverseIcon = Qh.query(
								this._container,
								".js-yxt-AnimatedReverse"
							));
						for (
							var t = 0, r = [".js-yext-submit", ".js-yxt-SearchBar-clear"];
							t < r.length;
							t++
						) {
							var n = r[t],
								i = Qh.query(this._container, n);
							i &&
								(Qh.on(i, "mousedown", function () {
									e.iconIsFrozen = !0;
								}),
								Qh.on(i, "mouseup", function () {
									e.iconIsFrozen = !1;
								}));
						}
						Qh.on(this.queryEl, "focus", function () {
							e.animateIconToMagnifyingGlass();
						}),
							Qh.on(this._container, "focusout", function (t) {
								e.animateIconToYext(t);
							});
					}),
					(r.remove = function () {
						this._autocomplete.remove(), e.prototype.remove.call(this);
					}),
					(r.initClearButton = function () {
						var e = this,
							t = this._getClearButton();
						(this._showClearButton = this._showClearButton || this.query),
							t.classList.toggle(
								"yxt-SearchBar--hidden",
								!this._showClearButton
							),
							Qh.on(t, "click", function () {
								e.customHooks.onClearSearch(),
									(e.query = ""),
									(e._showClearButton = !1),
									t.classList.add("yxt-SearchBar--hidden"),
									(e.queryEl.value = e.query),
									e.core.storage.delete(Pf),
									e.core.triggerSearch(ch, e.query),
									e.focusInputElement();
							}),
							Qh.on(this.queryEl, "input", function (t) {
								var r = t.target.value;
								(e.query = r), e._updateClearButtonVisibility(r);
							});
					}),
					(r.initSearch = function (e) {
						var t = this;
						if (
							((this._formEl = e),
							this._container.classList.add("yxt-SearchBar-wrapper"),
							this._useForm)
						) {
							var r = Qh.query(this._container, e);
							if (!r)
								throw new Error(
									"Could not initialize SearchBar; Can not find {HTMLElement} `",
									this._formEl,
									"`."
								);
							Qh.on(r, "submit", function (e) {
								e.preventDefault();
								var n = r.querySelector(t._inputEl);
								t.onQuerySubmit(n);
							});
						} else {
							var n = Qh.query(this._container, this._inputEl);
							if (!n)
								throw new Error(
									"Could not initialize SearchBar; Can not find {HTMLElement} `",
									this._inputEl,
									"`."
								);
							Qh.on(n, "keydown", function (e) {
								"Enter" === e.key && (e.preventDefault(), t.onQuerySubmit(n));
							});
							var i = Qh.query(this._container, ".js-yext-submit");
							Qh.on(i, "click", function (e) {
								e.preventDefault(), t.onQuerySubmit(n);
							});
						}
					}),
					(r.onQuerySubmit = function (e) {
						var t = e.value;
						this.query = t;
						var r = new Uh(this.core.storage.getCurrentStateUrlMerged());
						r.set("query", t);
						var n = this.core.storage.get(Zf);
						if (
							(n && r.set(Zf, n),
							"string" == typeof this.redirectUrl &&
								(this._allowEmptySearch || t))
						) {
							var i = this.redirectUrl + "?" + r.toString();
							return (
								window.open(i, this.redirectUrlTarget) ||
									(window.location.href = i),
								!1
							);
						}
						if (
							(e.blur(),
							Qh.query(this._container, ".js-yext-submit").blur(),
							this.clearButton)
						) {
							var o = Qh.query(this._container, ".js-yxt-SearchBar-clear");
							this.query
								? ((this._showClearButton = !0),
								  o.classList.remove("yxt-SearchBar--hidden"))
								: ((this._showClearButton = !1),
								  o.classList.add("yxt-SearchBar--hidden"));
						}
						return (
							this.isUsingYextAnimatedIcon && this.animateIconToYext(),
							this.core.storage.delete(Pf),
							this.core.triggerSearch(ch, t),
							!1
						);
					}),
					(r.initAutoComplete = function (e) {
						var t = this;
						(this._inputEl = e),
							this._autocomplete && this._autocomplete.remove(),
							(this._autocomplete = this.componentManager.create(
								"AutoComplete",
								Mv(
									Mv(
										{
											parentContainer: this._container,
											name: this._autoCompleteName,
											container: ".yxt-SearchBar-autocomplete",
											autoFocus: this.autoFocus && !this.autocompleteOnLoad,
											verticalKey: this._verticalKey,
											promptHeader: this.promptHeader,
											originalQuery: this.query,
											inputEl: e,
											listLabelIdName: this.inputLabelIdName
										},
										this._autocompleteConfig
									),
									{},
									{
										onSubmit: function () {
											if (t._useForm)
												Qh.trigger(Qh.query(t._container, t._formEl), "submit");
											else {
												var r = Qh.query(t._container, e);
												t.onQuerySubmit(r);
											}
										},
										onChange: function () {
											Qh.trigger(Qh.query(t._container, e), "input");
										}
									}
								)
							)),
							this._autocomplete.mount();
					}),
					(r.promptForLocation = function (e) {
						var t = this;
						return this._promptForLocation
							? this.fetchQueryIntents(e)
									.then(function (e) {
										return aa(e).call(e, "NEAR_ME");
									})
									.then(function (e) {
										if (e && !t.core.storage.get(Lf))
											return new Vo(function (e, r) {
												return navigator.geolocation.getCurrentPosition(
													function (r) {
														t.core.storage.set(Lf, {
															lat: r.coords.latitude,
															lng: r.coords.longitude,
															radius: r.coords.accuracy
														}),
															e();
													},
													function () {
														e();
														var r = t._geolocationTimeoutAlert,
															n = r.enabled,
															i = r.message;
														n && window.alert(i);
													},
													t._geolocationOptions
												);
											});
									})
							: Vo.resolve();
					}),
					(r.fetchQueryIntents = function (e) {
						var t = this.core.storage.get(kf + "." + this._autoCompleteName);
						if (t) {
							var r,
								n = mh((r = t.sections)).call(r, function (e) {
									return e.results;
								}),
								i = gu(n).call(n, function (t) {
									return t.value === e;
								}),
								o = i ? i.intents : t.inputIntents;
							return Vo.resolve(o);
						}
						return (this._verticalKey
							? this.core.autoCompleteVertical(
									e,
									this._autoCompleteName,
									this._verticalKey
							  )
							: this.core.autoCompleteUniversal(e, this._autoCompleteName)
						).then(function (e) {
							return e.inputIntents;
						});
					}),
					(r.eventOptions = function () {
						var e = this.core.storage.get(Tf),
							t = ca(
								{},
								e && { queryId: e },
								this._verticalKey && { verticalKey: this._verticalKey }
							);
						return Go(t);
					}),
					(r.setState = function (t) {
						var r = {
								iconName: "yext_animated_forward",
								classNames: "Icon--lg",
								complexContentsParams: { iconPrefix: this.name }
							},
							n = {
								iconName: "yext_animated_reverse",
								classNames: "Icon--lg",
								complexContentsParams: { iconPrefix: this.name }
							};
						return e.prototype.setState.call(
							this,
							ca(
								{
									title: this.title,
									inputIdName: this.inputIdName,
									labelText: this.labelText,
									inputLabelIdName: this.inputLabelIdName,
									submitIcon: this.submitIcon,
									submitText: this.submitText,
									clearText: this.clearText,
									showClearButton: this._showClearButton,
									query: this.query || "",
									eventOptions: this.eventOptions(),
									iconId: this.name,
									forwardIconOpts: r,
									reverseIconOpts: n,
									autoFocus: this.autoFocus && !this.query,
									useForm: this._useForm,
									autocompleteContainerIdName: this.autocompleteContainerIdName
								},
								t
							)
						);
					}),
					(r.focusInputElement = function () {
						Qh.query(this._container, this._inputEl).focus();
					}),
					(r._getClearButton = function () {
						return Qh.query(this._container, ".js-yxt-SearchBar-clear");
					}),
					(r._updateClearButtonVisibility = function (e) {
						var t = this._getClearButton();
						!this._showClearButton && e.length > 0
							? ((this._showClearButton = !0),
							  t.classList.remove("yxt-SearchBar--hidden"))
							: this._showClearButton &&
							  0 === e.length &&
							  ((this._showClearButton = !1),
							  t.classList.add("yxt-SearchBar--hidden"));
					}),
					fv(t, null, [
						{
							key: "type",
							get: function () {
								return "SearchBar";
							}
						}
					]),
					t
				);
			})(mv),
			(function (e) {
				function t(t, r) {
					var n;
					return (
						void 0 === t && (t = {}),
						void 0 === r && (r = {}),
						((n = e.call(this, t, r) || this).isFilterSearch =
							t.isFilterSearch || !1),
						(n._verticalKey = t.verticalKey || null),
						(n._inputEl = t.inputEl || ".js-yext-query"),
						(n._autocompleteEls =
							t.autoCompleteEls || ".js-yext-autocomplete-option"),
						(n.moduleId = kf + "." + n.name),
						(n._originalQuery = t.originalQuery || ""),
						(n._sectionIndex = 0),
						(n._resultIndex = -1),
						(n.promptHeader = t.promptHeader || null),
						(n._autoFocus = t.autoFocus || !1),
						(n._onSubmit = t.onSubmit || function () {}),
						(n._onChange = t.onChange || function () {}),
						(n._searchParameters = t.searchParameters || null),
						(n.listLabelIdName =
							t.listLabelIdName || "yxt-SearchBar-listLabel--SearchBar"),
						(n._shouldHideOnEmptySearch = t.shouldHideOnEmptySearch || !1),
						(n._onOpen = t.onOpen || function () {}),
						(n._onClose = t.onClose || function () {}),
						(n._isOpen = !1),
						n
					);
				}
				wu(t, e),
					(t.defaultTemplateName = function (e) {
						return "search/autocomplete";
					});
				var r = t.prototype;
				return (
					(r.setState = function (t) {
						var r = Qh.query(this._parentContainer, this._inputEl),
							n = this._shouldHideOnEmptySearch && !r.value,
							i = this._isOpen;
						!this.isQueryInputFocused() || n
							? ((this._isOpen = !1),
							  (this._sectionIndex = 0),
							  (this._resultIndex = -1),
							  (t = {}))
							: (this._isOpen = !0),
							i && !this._isOpen
								? this._onClose()
								: !i && this._isOpen && this._onOpen(),
							e.prototype.setState.call(
								this,
								ca({}, t, {
									hasResults: this.hasResults(t),
									sectionIndex: this._sectionIndex,
									resultIndex: this._resultIndex,
									promptHeader:
										0 === this._originalQuery.length ? this.promptHeader : null,
									listLabelIdName: this.listLabelIdName
								})
							);
					}),
					(r.isQueryInputFocused = function () {
						var e;
						return (
							document.activeElement &&
							aa((e = document.activeElement.className)).call(
								e,
								this._inputEl.substring(1)
							)
						);
					}),
					(r.updateState = function () {
						this.setState(this._state.get());
					}),
					(r.onCreate = function () {
						var e = this,
							t = Qh.query(this._parentContainer, this._inputEl);
						if (!t)
							throw new Error(
								"Could not initialize AutoComplete. Can not find {HTMLElement} `",
								this._inputEl,
								"`."
							);
						Qh.attributes(t, {
							autocomplete: "off",
							autocorrect: "off",
							spellcheck: "false"
						}),
							Qh.on(document, "click", function (t) {
								Qh.matches(t.target, ".js-yxt-AutoComplete-wrapper *") ||
									Qh.matches(t.target, e._inputEl) ||
									e.close();
							}),
							Qh.on(t, "focus", function () {
								e.reset(), e.autoComplete(t.value);
							}),
							Qh.on(t, "keydown", function (r) {
								e.handleNavigateResults(r.keyCode, r),
									e.handleSubmitResult(r.keyCode, t.value, r);
							}),
							this._autoFocus &&
								Qh.once(t, "click", function () {
									e.autoComplete(t.value);
								}),
							Qh.delegate(
								this._container,
								".js-yext-autocomplete-option",
								"click",
								function (t, r) {
									var n = r.dataset,
										i = n.short;
									e.updateQuery(i), e._onSubmit(i, Da(n)), e.close();
								}
							),
							Qh.on(t, "keyup", function (r) {
								e.handleTyping(r.keyCode, t.value, r);
							});
					}),
					(r.close = function () {
						this.setState({}), this.reset();
					}),
					(r.reset = function () {
						(this._sectionIndex = 0),
							(this._resultIndex = -1),
							this.updateState();
					}),
					(r.updateQuery = function (e) {
						void 0 === e &&
							(e = this._state.get("sections")[this._sectionIndex].results[
								this._resultIndex
							].shortValue);
						Qh.query(this._parentContainer, this._inputEl).value = e;
					}),
					(r.handleTyping = function (e, t, r) {
						var n = [Pv, Nv, Ov, Rv, Tv, Lv, jv, qv, Dv, Iv, Cv, Bv];
						if (!(ou(n).call(n, e) > -1)) {
							if (e === Fv)
								return this.updateQuery(this._originalQuery), void this.close();
							(this._originalQuery = t), this.reset(), this.autoComplete(t);
						}
					}),
					(r.autoComplete = function (e) {
						this.isFilterSearch
							? this.core.autoCompleteFilter(e, {
									namespace: this.name,
									verticalKey: this._verticalKey,
									searchParameters: this._searchParameters
							  })
							: this._verticalKey
							? this.core.autoCompleteVertical(e, this.name, this._verticalKey)
							: this.core.autoCompleteUniversal(e, this.name);
					}),
					(r.hasResults = function (e) {
						if (!e) return !1;
						var t = e.sections;
						if (!t) return !1;
						for (var r = 0; r < t.length; r++) {
							var n = t[r];
							if (n) {
								var i = n.results;
								if (i && i.length > 0) return !0;
							}
						}
						return !1;
					}),
					(r.handleNavigateResults = function (e, t) {
						var r = this._state.get("sections");
						if (!(void 0 === r || r.length <= 0))
							if (e !== Cv) {
								var n = r[this._sectionIndex].results;
								if (e === Nv)
									return (
										t.preventDefault(),
										this._resultIndex <= 0
											? this._sectionIndex > 0
												? (this._sectionIndex--,
												  (this._resultIndex =
														r[this._sectionIndex].results.length - 1),
												  this.updateQuery(),
												  void this.updateState())
												: (this.updateQuery(this._originalQuery),
												  void this.reset())
											: (this._resultIndex--,
											  this.updateState(),
											  void this.updateQuery())
									);
								if (e === Pv) {
									if ((t.preventDefault(), this._resultIndex >= n.length - 1))
										return (
											this._sectionIndex < r.length - 1 &&
												(this._sectionIndex++, (this._resultIndex = 0)),
											this.updateQuery(),
											void this.updateState()
										);
									this._resultIndex++, this.updateQuery(), this.updateState();
								}
							} else this.close();
					}),
					(r.handleSubmitResult = function (e, t, r) {
						var n = this._state.get("sections");
						if (void 0 === n || n.length <= 0)
							this.isFilterSearch && this.autoComplete(t);
						else if (e === Iv) {
							if (
								(r.preventDefault(),
								this.isFilterSearch && -1 === this._resultIndex)
							)
								return;
							var i = "";
							this._sectionIndex >= 0 &&
								this._resultIndex >= 0 &&
								(i = Go(Da(n[this._sectionIndex].results[this._resultIndex]))),
								this.updateQuery(t),
								(this._originalQuery = t),
								this._onSubmit(t, i),
								this.close();
						} else this._onChange();
					}),
					fv(t, null, [
						{
							key: "type",
							get: function () {
								return "AutoComplete";
							}
						}
					]),
					t
				);
			})(mv),
			(function (e) {
				function t(t, r) {
					var n;
					return (
						void 0 === t && (t = {}),
						void 0 === r && (r = {}),
						((n = e.call(this, t, r) || this).iconName =
							t.iconName || "default"),
						(n.iconUrl = t.iconUrl || null),
						(n.classNames = t.classNames || null),
						(n.complexContentsParams = t.complexContentsParams || {}),
						n
					);
				}
				return (
					wu(t, e),
					(t.defaultTemplateName = function (e) {
						return "icons/icon";
					}),
					(t.areDuplicateNamesAllowed = function () {
						return !0;
					}),
					(t.prototype.setState = function (t) {
						return e.prototype.setState.call(
							this,
							ca(t, {
								iconUrl: this.iconUrl,
								iconName: this.iconName,
								name: this.iconName ? this.iconName : "custom",
								classNames: this.classNames,
								complexContentsParams: this.complexContentsParams
							})
						);
					}),
					fv(t, null, [
						{
							key: "type",
							get: function () {
								return "IconComponent";
							}
						}
					]),
					t
				);
			})(mv)
		],
		Vv = Ps(Uv).call(
			Uv,
			function (e, t) {
				return (e[t.type] = t), e;
			},
			{}
		),
		Hv = { locale: "en", querySource: "STANDARD" };
	return new ((function () {
		function e() {
			if (!e.setInstance(this)) return e.getInstance();
			(this.renderer = new Hp.Handlebars()),
				(this.components = new iv(Vv)),
				(this.core = null),
				(this._onReady = function () {}),
				(this._eligibleForAnalytics = !1),
				(this._services = null),
				(this._analyticsReporterService = null);
		}
		(e.setInstance = function (e) {
			return !this.instance && ((this.instance = e), !0);
		}),
			(e.getInstance = function () {
				return this.instance;
			});
		var t = e.prototype;
		return (
			(t.init = function (e) {
				var t = this,
					r = this.parseConfig(e);
				this.validateConfig(r), (r.search = new Kd(r.search));
				var n = new zd({
					persistedValueParser: this._parsePersistentStorageValue
				});
				n.init(window.location.search),
					n.set(Nf, r.search),
					n.set(Vf, r.locale),
					n.set(Gf, r.querySource);
				var i = n.get(Uf);
				i
					? n.set(Uf, { value: /^true$/i.test(i), setDynamically: !0 })
					: n.set(Uf, { value: r.sessionTrackingEnabled, setDynamically: !1 }),
					r.noResults && n.set(zf, r.noResults);
				var o = n.get(Wf) === oh;
				n.has(If) && !o && n.set(Wf, ih);
				var a = n.get(Zf);
				a &&
					!ov(a) &&
					(n.delete(Zf),
					console.error(
						'Context parameter "' +
							a +
							'" is invalid, omitting from the search.'
					)),
					void 0 === n.get(Qf) &&
						n.set(
							Qf,
							(function (e) {
								return e.split("?")[0].split("#")[0];
							})(document.referrer)
						),
					(this._services = (function (e, t) {
						return {
							errorReporterService: new Rd(
								{
									apiKey: e.apiKey,
									experienceKey: e.experienceKey,
									experienceVersion: e.experienceVersion,
									printVerbose: e.debug,
									sendToServer: !e.suppressErrorReports,
									environment: e.environment
								},
								t
							)
						};
					})(r, n)),
					(this._eligibleForAnalytics = null != r.businessId),
					this._eligibleForAnalytics &&
						((this._analyticsReporterService = new Ld(
							r.experienceKey,
							r.experienceVersion,
							r.businessId,
							r.analyticsOptions,
							r.environment
						)),
						this.components.setAnalyticsReporter(
							this._analyticsReporterService
						)),
					(this.core = new Zp({
						apiKey: r.apiKey,
						storage: n,
						experienceKey: r.experienceKey,
						fieldFormatters: r.fieldFormatters,
						experienceVersion: r.experienceVersion,
						locale: r.locale,
						analyticsReporter: this._analyticsReporterService,
						onVerticalSearch: r.onVerticalSearch,
						onUniversalSearch: r.onUniversalSearch,
						environment: r.environment,
						componentManager: this.components
					})),
					r.onStateChange &&
						"function" == typeof r.onStateChange &&
						r.onStateChange(
							ua(n.getAll()),
							this.core.storage.getCurrentStateUrlMerged()
						),
					this.components.setCore(this.core).setRenderer(this.renderer),
					this._setDefaultInitialSearch(r.search),
					this.core.init(),
					(this._onReady = r.onReady || function () {}),
					this.renderer.init(r.templateBundle, this._getInitLocale()),
					this._handlePonyfillCssVariables(
						r.disableCssVariablesPonyfill
					).finally(function () {
						return t._onReady();
					});
			}),
			(t.domReady = function (e) {
				Qh.onReady(e);
			}),
			(t.onReady = function (e) {
				return (this._onReady = e), this;
			}),
			(t.parseConfig = function (e) {
				var t,
					r = ca({}, Hv, e),
					n = !0;
				"boolean" == typeof e.sessionTrackingEnabled &&
					(n = e.sessionTrackingEnabled),
					(r.sessionTrackingEnabled = n);
				return (
					aa((t = r.apiKey)).call(t, "sandbox-")
						? (r.environment = "sandbox")
						: (r.environment = "production"),
					(r.apiKey = r.apiKey.replace("sandbox-", "")),
					r
				);
			}),
			(t.validateConfig = function (e) {
				if ("string" != typeof e.apiKey)
					throw new Error("Missing required `apiKey`. Type must be {string}");
				if ("string" != typeof e.experienceKey)
					throw new Error(
						"Missing required `experienceKey`. Type must be {string}"
					);
				if (e.onVerticalSearch && "function" != typeof e.onVerticalSearch)
					throw new Error(
						"onVerticalSearch must be a function. Current type is: " +
							typeof e.onVerticalSearch
					);
				if (e.onUniversalSearch && "function" != typeof e.onUniversalSearch)
					throw new Error(
						"onUniversalSearch must be a function. Current type is: " +
							typeof e.onUniversalSearch
					);
			}),
			(t.addComponent = function (e, t) {
				"string" == typeof t && (t = { container: t });
				try {
					this.components.create(e, t).mount();
				} catch (t) {
					throw new Al("Failed to add component", e, t);
				}
				return this;
			}),
			(t.setConversionsOptIn = function (e) {
				this._eligibleForAnalytics &&
					this._analyticsReporterService.setConversionTrackingEnabled(e);
			}),
			(t.setSessionsOptIn = function (e) {
				this.core.storage.set(Uf, { value: e, setDynamically: !0 });
			}),
			(t._setDefaultInitialSearch = function (e) {
				null != e.defaultInitialSearch &&
					null == this.core.storage.get(If) &&
					(this.core.storage.set(Wf, nh),
					this.core.storage.set(If, e.defaultInitialSearch));
			}),
			(t.setGeolocation = function (e, t) {
				this.core.storage.set(Lf, { lat: e, lng: t, radius: 0 });
			}),
			(t.setContext = function (e) {
				var t = Go(e);
				ov(t)
					? this.core.storage.set(Zf, t)
					: console.error(
							'Context parameter "' +
								e +
								'" is invalid, omitting from the search.'
					  );
			}),
			(t._getInitLocale = function () {
				return this.core.storage.get(Vf);
			}),
			(t._handlePonyfillCssVariables = function (e) {
				var t = this;
				return e
					? Vo.resolve()
					: new Vo(function (e, r) {
							t.ponyfillCssVariables({
								onFinally: function () {
									e();
								}
							});
					  });
			}),
			(t.ponyfillCssVariables = function (e) {
				void 0 === e && (e = {}),
					_d({
						onlyLegacy: !0,
						onError: e.onError || function () {},
						onSuccess: e.onSuccess || function () {},
						onFinally: e.onFinally || function () {},
						onBeforeSend: function (e, t, r) {
							try {
								var n = new ui(r),
									i = new Uh(n.search);
								i.set("_", new Date().getTime()),
									(n.search = i.toString()),
									e.open("GET", n.toString());
							} catch (e) {}
						}
					});
			}),
			(t._parsePersistentStorageValue = function (e, t) {
				switch (e) {
					case Mf:
						return Zl.from(JSON.parse(t));
					case Cf:
						return ee(t);
					case Rf:
					case Hf:
						return JSON.parse(t);
					default:
						return t;
				}
			}),
			e
		);
	})())();
})();
//# sourceMappingURL=answers.min.js.map
